module.exports = {
	"type": "Topology",
	"arcs": [
		[
			[
				3529,
				1843
			],
			[
				68,
				-65
			]
		],
		[
			[
				3597,
				1778
			],
			[
				58,
				-74
			],
			[
				48,
				8
			]
		],
		[
			[
				3703,
				1712
			],
			[
				27,
				-171
			],
			[
				36,
				-39
			]
		],
		[
			[
				3766,
				1502
			],
			[
				-157,
				28
			],
			[
				-79,
				-84
			]
		],
		[
			[
				3530,
				1446
			],
			[
				-124,
				147
			]
		],
		[
			[
				3406,
				1593
			],
			[
				-114,
				31
			]
		],
		[
			[
				3292,
				1624
			],
			[
				-32,
				48
			]
		],
		[
			[
				3260,
				1672
			],
			[
				31,
				150
			]
		],
		[
			[
				3291,
				1822
			],
			[
				90,
				45
			]
		],
		[
			[
				3381,
				1867
			],
			[
				43,
				45
			],
			[
				105,
				-69
			]
		],
		[
			[
				2161,
				2900
			],
			[
				59,
				-85
			],
			[
				60,
				-3
			],
			[
				53,
				-192
			],
			[
				-88,
				-161
			]
		],
		[
			[
				2245,
				2459
			],
			[
				-38,
				-37
			]
		],
		[
			[
				2207,
				2422
			],
			[
				-129,
				29
			]
		],
		[
			[
				2078,
				2451
			],
			[
				69,
				82
			],
			[
				-137,
				161
			]
		],
		[
			[
				2010,
				2694
			],
			[
				41,
				97
			]
		],
		[
			[
				2051,
				2791
			],
			[
				81,
				47
			]
		],
		[
			[
				2132,
				2838
			],
			[
				-22,
				72
			]
		],
		[
			[
				2110,
				2910
			],
			[
				1,
				23
			]
		],
		[
			[
				2111,
				2933
			],
			[
				50,
				-33
			]
		],
		[
			[
				5431,
				3450
			],
			[
				53,
				-85
			]
		],
		[
			[
				5484,
				3365
			],
			[
				-9,
				-58
			]
		],
		[
			[
				5475,
				3307
			],
			[
				-28,
				-22
			]
		],
		[
			[
				5447,
				3285
			],
			[
				20,
				-60
			]
		],
		[
			[
				5467,
				3225
			],
			[
				75,
				26
			]
		],
		[
			[
				5542,
				3251
			],
			[
				41,
				-29
			]
		],
		[
			[
				5583,
				3222
			],
			[
				112,
				-135
			]
		],
		[
			[
				5695,
				3087
			],
			[
				-37,
				-46
			]
		],
		[
			[
				5658,
				3041
			],
			[
				-23,
				-10
			]
		],
		[
			[
				5635,
				3031
			],
			[
				-44,
				97
			]
		],
		[
			[
				5591,
				3128
			],
			[
				-277,
				-69
			],
			[
				-222,
				-160
			]
		],
		[
			[
				5092,
				2899
			],
			[
				-43,
				-2
			]
		],
		[
			[
				5049,
				2897
			],
			[
				-2,
				26
			],
			[
				9,
				16
			],
			[
				-23,
				23
			]
		],
		[
			[
				5033,
				2962
			],
			[
				20,
				66
			]
		],
		[
			[
				5053,
				3028
			],
			[
				74,
				224
			]
		],
		[
			[
				5127,
				3252
			],
			[
				-23,
				30
			]
		],
		[
			[
				5104,
				3282
			],
			[
				7,
				5
			],
			[
				-13,
				27
			],
			[
				190,
				93
			],
			[
				32,
				-16
			]
		],
		[
			[
				5320,
				3391
			],
			[
				111,
				59
			]
		],
		[
			[
				4152,
				3384
			],
			[
				80,
				0
			],
			[
				91,
				-89
			]
		],
		[
			[
				4323,
				3295
			],
			[
				-75,
				-67
			]
		],
		[
			[
				4248,
				3228
			],
			[
				-101,
				-149
			]
		],
		[
			[
				4147,
				3079
			],
			[
				12,
				-8
			]
		],
		[
			[
				4159,
				3071
			],
			[
				-6,
				-2
			],
			[
				-42,
				27
			]
		],
		[
			[
				4111,
				3096
			],
			[
				-158,
				-24
			]
		],
		[
			[
				3953,
				3072
			],
			[
				-50,
				22
			]
		],
		[
			[
				3903,
				3094
			],
			[
				15,
				98
			]
		],
		[
			[
				3918,
				3192
			],
			[
				27,
				43
			]
		],
		[
			[
				3945,
				3235
			],
			[
				34,
				-4
			]
		],
		[
			[
				3979,
				3231
			],
			[
				5,
				59
			]
		],
		[
			[
				3984,
				3290
			],
			[
				24,
				49
			]
		],
		[
			[
				4008,
				3339
			],
			[
				28,
				51
			]
		],
		[
			[
				4036,
				3390
			],
			[
				17,
				-5
			]
		],
		[
			[
				4053,
				3385
			],
			[
				80,
				30
			]
		],
		[
			[
				4133,
				3415
			],
			[
				19,
				-31
			]
		],
		[
			[
				6602,
				5166
			],
			[
				16,
				40
			]
		],
		[
			[
				6618,
				5206
			],
			[
				148,
				-97
			]
		],
		[
			[
				6766,
				5109
			],
			[
				48,
				13
			]
		],
		[
			[
				6814,
				5122
			],
			[
				18,
				-68
			],
			[
				-163,
				-135
			],
			[
				31,
				-91
			],
			[
				-67,
				-115
			],
			[
				21,
				-48
			],
			[
				-24,
				-18
			],
			[
				-3,
				-51
			]
		],
		[
			[
				6627,
				4596
			],
			[
				-44,
				10
			],
			[
				-7,
				11
			],
			[
				-46,
				-19
			],
			[
				-32,
				-46
			]
		],
		[
			[
				6498,
				4552
			],
			[
				-58,
				0
			]
		],
		[
			[
				6440,
				4552
			],
			[
				-66,
				91
			],
			[
				-25,
				136
			],
			[
				-78,
				96
			],
			[
				11,
				74
			]
		],
		[
			[
				6282,
				4949
			],
			[
				21,
				63
			]
		],
		[
			[
				6303,
				5012
			],
			[
				2,
				26
			],
			[
				227,
				109
			]
		],
		[
			[
				6532,
				5147
			],
			[
				-6,
				30
			]
		],
		[
			[
				6526,
				5177
			],
			[
				11,
				2
			],
			[
				-7,
				5
			],
			[
				6,
				12
			],
			[
				44,
				1
			],
			[
				22,
				-31
			]
		],
		[
			[
				4697,
				7537
			],
			[
				68,
				43
			],
			[
				78,
				-68
			]
		],
		[
			[
				4843,
				7512
			],
			[
				104,
				-85
			]
		],
		[
			[
				4947,
				7427
			],
			[
				-149,
				-239
			],
			[
				-56,
				-23
			]
		],
		[
			[
				4742,
				7165
			],
			[
				-160,
				151
			]
		],
		[
			[
				4582,
				7316
			],
			[
				-45,
				53
			]
		],
		[
			[
				4537,
				7369
			],
			[
				-35,
				22
			]
		],
		[
			[
				4502,
				7391
			],
			[
				-52,
				24
			]
		],
		[
			[
				4450,
				7415
			],
			[
				140,
				159
			]
		],
		[
			[
				4590,
				7574
			],
			[
				107,
				-37
			]
		],
		[
			[
				3721,
				5031
			],
			[
				129,
				17
			],
			[
				131,
				-57
			],
			[
				150,
				26
			]
		],
		[
			[
				4131,
				5017
			],
			[
				16,
				-27
			]
		],
		[
			[
				4147,
				4990
			],
			[
				67,
				-99
			]
		],
		[
			[
				4214,
				4891
			],
			[
				21,
				-25
			]
		],
		[
			[
				4235,
				4866
			],
			[
				-4,
				-15
			]
		],
		[
			[
				4231,
				4851
			],
			[
				12,
				-76
			]
		],
		[
			[
				4243,
				4775
			],
			[
				-97,
				-56
			]
		],
		[
			[
				4146,
				4719
			],
			[
				28,
				-121
			]
		],
		[
			[
				4174,
				4598
			],
			[
				-56,
				-56
			]
		],
		[
			[
				4118,
				4542
			],
			[
				-32,
				39
			]
		],
		[
			[
				4086,
				4581
			],
			[
				-72,
				-55
			]
		],
		[
			[
				4014,
				4526
			],
			[
				-8,
				-41
			]
		],
		[
			[
				4006,
				4485
			],
			[
				-65,
				-76
			]
		],
		[
			[
				3941,
				4409
			],
			[
				-14,
				-22
			]
		],
		[
			[
				3927,
				4387
			],
			[
				6,
				-36
			]
		],
		[
			[
				3933,
				4351
			],
			[
				-104,
				-7
			]
		],
		[
			[
				3829,
				4344
			],
			[
				8,
				65
			]
		],
		[
			[
				3837,
				4409
			],
			[
				-17,
				19
			],
			[
				-92,
				-16
			],
			[
				-21,
				70
			]
		],
		[
			[
				3707,
				4482
			],
			[
				-62,
				95
			],
			[
				-84,
				40
			]
		],
		[
			[
				3561,
				4617
			],
			[
				-27,
				-2
			]
		],
		[
			[
				3534,
				4615
			],
			[
				-95,
				83
			],
			[
				26,
				74
			]
		],
		[
			[
				3465,
				4772
			],
			[
				51,
				-6
			]
		],
		[
			[
				3516,
				4766
			],
			[
				69,
				30
			]
		],
		[
			[
				3585,
				4796
			],
			[
				-30,
				156
			],
			[
				48,
				96
			]
		],
		[
			[
				3603,
				5048
			],
			[
				59,
				-14
			]
		],
		[
			[
				3662,
				5034
			],
			[
				9,
				24
			]
		],
		[
			[
				3671,
				5058
			],
			[
				44,
				25
			]
		],
		[
			[
				3715,
				5083
			],
			[
				18,
				-20
			]
		],
		[
			[
				3733,
				5063
			],
			[
				-12,
				-32
			]
		],
		[
			[
				1961,
				809
			],
			[
				162,
				-85
			],
			[
				-16,
				-113
			]
		],
		[
			[
				2107,
				611
			],
			[
				-52,
				-112
			]
		],
		[
			[
				2055,
				499
			],
			[
				-53,
				-24
			]
		],
		[
			[
				2002,
				475
			],
			[
				-26,
				54
			]
		],
		[
			[
				1976,
				529
			],
			[
				-264,
				-49
			],
			[
				-1,
				-56
			]
		],
		[
			[
				1711,
				424
			],
			[
				-16,
				-2
			]
		],
		[
			[
				1695,
				422
			],
			[
				-66,
				68
			]
		],
		[
			[
				1629,
				490
			],
			[
				-11,
				-1
			]
		],
		[
			[
				1618,
				489
			],
			[
				70,
				149
			],
			[
				86,
				70
			]
		],
		[
			[
				1774,
				708
			],
			[
				8,
				47
			]
		],
		[
			[
				1782,
				755
			],
			[
				90,
				-1
			]
		],
		[
			[
				1872,
				754
			],
			[
				32,
				13
			]
		],
		[
			[
				1904,
				767
			],
			[
				57,
				42
			]
		],
		[
			[
				6816,
				5883
			],
			[
				87,
				12
			]
		],
		[
			[
				6903,
				5895
			],
			[
				80,
				-115
			],
			[
				98,
				-60
			],
			[
				146,
				-4
			]
		],
		[
			[
				7227,
				5716
			],
			[
				46,
				23
			]
		],
		[
			[
				7273,
				5739
			],
			[
				18,
				-113
			]
		],
		[
			[
				7291,
				5626
			],
			[
				-61,
				-53
			],
			[
				18,
				-46
			],
			[
				-14,
				-65
			],
			[
				32,
				-15
			]
		],
		[
			[
				7266,
				5447
			],
			[
				-28,
				-28
			]
		],
		[
			[
				7238,
				5419
			],
			[
				-26,
				-16
			]
		],
		[
			[
				7212,
				5403
			],
			[
				-108,
				48
			]
		],
		[
			[
				7104,
				5451
			],
			[
				-28,
				20
			]
		],
		[
			[
				7076,
				5471
			],
			[
				-22,
				-13
			]
		],
		[
			[
				7054,
				5458
			],
			[
				-28,
				-52
			]
		],
		[
			[
				7026,
				5406
			],
			[
				-181,
				9
			],
			[
				-87,
				-56
			]
		],
		[
			[
				6758,
				5359
			],
			[
				-62,
				-52
			]
		],
		[
			[
				6696,
				5307
			],
			[
				-12,
				32
			]
		],
		[
			[
				6684,
				5339
			],
			[
				22,
				10
			]
		],
		[
			[
				6706,
				5349
			],
			[
				-6,
				74
			]
		],
		[
			[
				6700,
				5423
			],
			[
				13,
				104
			]
		],
		[
			[
				6713,
				5527
			],
			[
				-45,
				70
			]
		],
		[
			[
				6668,
				5597
			],
			[
				0,
				200
			],
			[
				94,
				56
			]
		],
		[
			[
				6762,
				5853
			],
			[
				-7,
				8
			]
		],
		[
			[
				6755,
				5861
			],
			[
				61,
				22
			]
		],
		[
			[
				1541,
				1266
			],
			[
				110,
				27
			]
		],
		[
			[
				1651,
				1293
			],
			[
				35,
				-77
			]
		],
		[
			[
				1686,
				1216
			],
			[
				-42,
				-56
			]
		],
		[
			[
				1644,
				1160
			],
			[
				-24,
				-111
			]
		],
		[
			[
				1620,
				1049
			],
			[
				-21,
				31
			]
		],
		[
			[
				1599,
				1080
			],
			[
				-120,
				-24
			],
			[
				-167,
				77
			]
		],
		[
			[
				1312,
				1133
			],
			[
				-38,
				-56
			]
		],
		[
			[
				1274,
				1077
			],
			[
				-26,
				48
			]
		],
		[
			[
				1248,
				1125
			],
			[
				3,
				32
			]
		],
		[
			[
				1251,
				1157
			],
			[
				27,
				13
			]
		],
		[
			[
				1278,
				1170
			],
			[
				25,
				80
			]
		],
		[
			[
				1303,
				1250
			],
			[
				81,
				54
			]
		],
		[
			[
				1384,
				1304
			],
			[
				157,
				-38
			]
		],
		[
			[
				2693,
				5064
			],
			[
				40,
				-25
			],
			[
				24,
				-177
			],
			[
				-26,
				-48
			]
		],
		[
			[
				2731,
				4814
			],
			[
				-28,
				4
			]
		],
		[
			[
				2703,
				4818
			],
			[
				-44,
				49
			]
		],
		[
			[
				2659,
				4867
			],
			[
				-50,
				9
			]
		],
		[
			[
				2609,
				4876
			],
			[
				-67,
				58
			]
		],
		[
			[
				2542,
				4934
			],
			[
				-4,
				91
			],
			[
				120,
				83
			]
		],
		[
			[
				2658,
				5108
			],
			[
				7,
				71
			]
		],
		[
			[
				2665,
				5179
			],
			[
				35,
				-14
			]
		],
		[
			[
				2700,
				5165
			],
			[
				-7,
				-101
			]
		],
		[
			[
				1650,
				2175
			],
			[
				24,
				-125
			],
			[
				96,
				-35
			]
		],
		[
			[
				1770,
				2015
			],
			[
				6,
				-56
			]
		],
		[
			[
				1776,
				1959
			],
			[
				-100,
				-19
			],
			[
				-71,
				-53
			]
		],
		[
			[
				1605,
				1887
			],
			[
				-45,
				50
			]
		],
		[
			[
				1560,
				1937
			],
			[
				-42,
				134
			]
		],
		[
			[
				1518,
				2071
			],
			[
				19,
				15
			]
		],
		[
			[
				1537,
				2086
			],
			[
				15,
				79
			]
		],
		[
			[
				1552,
				2165
			],
			[
				35,
				68
			]
		],
		[
			[
				1587,
				2233
			],
			[
				63,
				-58
			]
		],
		[
			[
				1324,
				5968
			],
			[
				-13,
				-12
			]
		],
		[
			[
				1311,
				5956
			],
			[
				4,
				-42
			]
		],
		[
			[
				1315,
				5914
			],
			[
				24,
				-11
			]
		],
		[
			[
				1339,
				5903
			],
			[
				78,
				8
			],
			[
				60,
				26
			]
		],
		[
			[
				1477,
				5937
			],
			[
				35,
				-103
			],
			[
				72,
				-85
			],
			[
				-102,
				-30
			],
			[
				-8,
				-148
			]
		],
		[
			[
				1474,
				5571
			],
			[
				-31,
				-12
			],
			[
				-38,
				-63
			]
		],
		[
			[
				1405,
				5496
			],
			[
				-33,
				22
			],
			[
				-67,
				19
			]
		],
		[
			[
				1305,
				5537
			],
			[
				8,
				114
			]
		],
		[
			[
				1313,
				5651
			],
			[
				-23,
				51
			],
			[
				-33,
				9
			],
			[
				-94,
				-6
			],
			[
				-60,
				32
			],
			[
				-39,
				118
			],
			[
				-40,
				58
			]
		],
		[
			[
				1024,
				5913
			],
			[
				210,
				113
			]
		],
		[
			[
				1234,
				6026
			],
			[
				90,
				-58
			]
		],
		[
			[
				3788,
				5304
			],
			[
				-11,
				-29
			]
		],
		[
			[
				3777,
				5275
			],
			[
				45,
				-34
			]
		],
		[
			[
				3822,
				5241
			],
			[
				-10,
				-58
			]
		],
		[
			[
				3812,
				5183
			],
			[
				-53,
				-68
			]
		],
		[
			[
				3759,
				5115
			],
			[
				-88,
				-57
			]
		],
		[
			[
				3662,
				5034
			],
			[
				-59,
				14
			]
		],
		[
			[
				3603,
				5048
			],
			[
				-73,
				36
			]
		],
		[
			[
				3530,
				5084
			],
			[
				6,
				21
			]
		],
		[
			[
				3536,
				5105
			],
			[
				-56,
				46
			]
		],
		[
			[
				3480,
				5151
			],
			[
				8,
				14
			]
		],
		[
			[
				3488,
				5165
			],
			[
				10,
				11
			]
		],
		[
			[
				3498,
				5176
			],
			[
				66,
				5
			]
		],
		[
			[
				3564,
				5181
			],
			[
				13,
				100
			],
			[
				117,
				-11
			],
			[
				20,
				66
			]
		],
		[
			[
				3714,
				5336
			],
			[
				74,
				-32
			]
		],
		[
			[
				2368,
				1717
			],
			[
				18,
				-12
			]
		],
		[
			[
				2386,
				1705
			],
			[
				68,
				-61
			]
		],
		[
			[
				2454,
				1644
			],
			[
				20,
				-12
			]
		],
		[
			[
				2474,
				1632
			],
			[
				29,
				-37
			]
		],
		[
			[
				2503,
				1595
			],
			[
				-50,
				-49
			]
		],
		[
			[
				2453,
				1546
			],
			[
				-130,
				-77
			]
		],
		[
			[
				2323,
				1469
			],
			[
				-72,
				-6
			]
		],
		[
			[
				2251,
				1463
			],
			[
				-16,
				-39
			]
		],
		[
			[
				2235,
				1424
			],
			[
				-108,
				-5
			]
		],
		[
			[
				2127,
				1419
			],
			[
				55,
				151
			],
			[
				50,
				77
			]
		],
		[
			[
				2232,
				1647
			],
			[
				-11,
				8
			]
		],
		[
			[
				2221,
				1655
			],
			[
				37,
				60
			]
		],
		[
			[
				2258,
				1715
			],
			[
				75,
				26
			]
		],
		[
			[
				2333,
				1741
			],
			[
				35,
				74
			]
		],
		[
			[
				2368,
				1815
			],
			[
				26,
				-33
			]
		],
		[
			[
				2394,
				1782
			],
			[
				-26,
				-65
			]
		],
		[
			[
				2559,
				1587
			],
			[
				-4,
				-20
			]
		],
		[
			[
				2555,
				1567
			],
			[
				51,
				-52
			]
		],
		[
			[
				2606,
				1515
			],
			[
				47,
				-68
			]
		],
		[
			[
				2653,
				1447
			],
			[
				46,
				-97
			]
		],
		[
			[
				2699,
				1350
			],
			[
				-34,
				-21
			]
		],
		[
			[
				2665,
				1329
			],
			[
				-15,
				-57
			],
			[
				-158,
				30
			],
			[
				-30,
				-104
			]
		],
		[
			[
				2462,
				1198
			],
			[
				-64,
				46
			]
		],
		[
			[
				2398,
				1244
			],
			[
				10,
				174
			],
			[
				-53,
				6
			]
		],
		[
			[
				2355,
				1424
			],
			[
				98,
				122
			]
		],
		[
			[
				2503,
				1595
			],
			[
				56,
				-8
			]
		],
		[
			[
				6683,
				7708
			],
			[
				86,
				-74
			]
		],
		[
			[
				6769,
				7634
			],
			[
				-5,
				-19
			]
		],
		[
			[
				6764,
				7615
			],
			[
				-45,
				-74
			]
		],
		[
			[
				6719,
				7541
			],
			[
				7,
				-48
			]
		],
		[
			[
				6726,
				7493
			],
			[
				25,
				1
			]
		],
		[
			[
				6751,
				7494
			],
			[
				-80,
				-96
			]
		],
		[
			[
				6671,
				7398
			],
			[
				-16,
				28
			]
		],
		[
			[
				6655,
				7426
			],
			[
				-50,
				0
			]
		],
		[
			[
				6605,
				7426
			],
			[
				30,
				130
			],
			[
				-41,
				94
			]
		],
		[
			[
				6594,
				7650
			],
			[
				17,
				83
			]
		],
		[
			[
				6611,
				7733
			],
			[
				72,
				-25
			]
		],
		[
			[
				4537,
				7369
			],
			[
				45,
				-53
			]
		],
		[
			[
				4742,
				7165
			],
			[
				12,
				-61
			]
		],
		[
			[
				4754,
				7104
			],
			[
				3,
				-25
			]
		],
		[
			[
				4757,
				7079
			],
			[
				-81,
				-3
			]
		],
		[
			[
				4676,
				7076
			],
			[
				-51,
				41
			],
			[
				-83,
				-28
			],
			[
				-34,
				5
			],
			[
				-78,
				61
			]
		],
		[
			[
				4430,
				7155
			],
			[
				-11,
				-14
			]
		],
		[
			[
				4419,
				7141
			],
			[
				8,
				166
			],
			[
				-31,
				101
			]
		],
		[
			[
				4396,
				7408
			],
			[
				106,
				-17
			]
		],
		[
			[
				2167,
				1532
			],
			[
				-31,
				-99
			]
		],
		[
			[
				2136,
				1433
			],
			[
				-75,
				27
			]
		],
		[
			[
				2061,
				1460
			],
			[
				-39,
				-190
			]
		],
		[
			[
				2022,
				1270
			],
			[
				-76,
				-30
			]
		],
		[
			[
				1946,
				1240
			],
			[
				-40,
				-63
			],
			[
				-132,
				81
			],
			[
				-69,
				-30
			]
		],
		[
			[
				1705,
				1228
			],
			[
				-19,
				-12
			]
		],
		[
			[
				1686,
				1216
			],
			[
				-25,
				65
			]
		],
		[
			[
				1661,
				1281
			],
			[
				84,
				68
			],
			[
				-12,
				79
			]
		],
		[
			[
				1733,
				1428
			],
			[
				-11,
				27
			]
		],
		[
			[
				1722,
				1455
			],
			[
				92,
				131
			],
			[
				116,
				-70
			],
			[
				53,
				141
			]
		],
		[
			[
				1983,
				1657
			],
			[
				-15,
				17
			]
		],
		[
			[
				1968,
				1674
			],
			[
				7,
				8
			],
			[
				6,
				-9
			],
			[
				12,
				4
			],
			[
				1,
				-9
			],
			[
				27,
				6
			],
			[
				18,
				-29
			],
			[
				128,
				-113
			]
		],
		[
			[
				4757,
				7079
			],
			[
				36,
				-31
			]
		],
		[
			[
				4793,
				7048
			],
			[
				57,
				-14
			],
			[
				77,
				-103
			],
			[
				-41,
				-103
			]
		],
		[
			[
				4886,
				6828
			],
			[
				-64,
				-123
			]
		],
		[
			[
				4822,
				6705
			],
			[
				-25,
				6
			]
		],
		[
			[
				4797,
				6711
			],
			[
				-146,
				2
			],
			[
				-39,
				115
			],
			[
				25,
				63
			],
			[
				-112,
				61
			]
		],
		[
			[
				4525,
				6952
			],
			[
				-72,
				-2
			]
		],
		[
			[
				4453,
				6950
			],
			[
				67,
				139
			]
		],
		[
			[
				4520,
				7089
			],
			[
				113,
				27
			],
			[
				43,
				-40
			]
		],
		[
			[
				2939,
				7429
			],
			[
				-89,
				-125
			],
			[
				-78,
				-59
			]
		],
		[
			[
				2772,
				7245
			],
			[
				-27,
				15
			]
		],
		[
			[
				2745,
				7260
			],
			[
				-151,
				163
			]
		],
		[
			[
				2594,
				7423
			],
			[
				77,
				183
			],
			[
				100,
				2
			],
			[
				94,
				62
			],
			[
				84,
				5
			],
			[
				-11,
				-167
			],
			[
				1,
				-79
			]
		],
		[
			[
				3847,
				5630
			],
			[
				25,
				-24
			]
		],
		[
			[
				3872,
				5606
			],
			[
				-14,
				-25
			]
		],
		[
			[
				3858,
				5581
			],
			[
				97,
				-7
			],
			[
				34,
				-68
			]
		],
		[
			[
				3989,
				5506
			],
			[
				4,
				-47
			]
		],
		[
			[
				3993,
				5459
			],
			[
				25,
				-8
			]
		],
		[
			[
				4018,
				5451
			],
			[
				4,
				-20
			]
		],
		[
			[
				4022,
				5431
			],
			[
				-12,
				-89
			]
		],
		[
			[
				4010,
				5342
			],
			[
				4,
				-71
			]
		],
		[
			[
				4014,
				5271
			],
			[
				-107,
				-4
			]
		],
		[
			[
				3907,
				5267
			],
			[
				-51,
				26
			]
		],
		[
			[
				3856,
				5293
			],
			[
				-1,
				-15
			]
		],
		[
			[
				3855,
				5278
			],
			[
				-78,
				-3
			]
		],
		[
			[
				3788,
				5304
			],
			[
				-14,
				24
			],
			[
				-80,
				17
			]
		],
		[
			[
				3694,
				5345
			],
			[
				73,
				42
			]
		],
		[
			[
				3767,
				5387
			],
			[
				19,
				44
			]
		],
		[
			[
				3786,
				5431
			],
			[
				-64,
				96
			]
		],
		[
			[
				3722,
				5527
			],
			[
				8,
				26
			]
		],
		[
			[
				3730,
				5553
			],
			[
				59,
				36
			]
		],
		[
			[
				3789,
				5589
			],
			[
				58,
				41
			]
		],
		[
			[
				3164,
				5980
			],
			[
				140,
				-70
			],
			[
				35,
				-87
			]
		],
		[
			[
				3339,
				5823
			],
			[
				-8,
				-39
			]
		],
		[
			[
				3331,
				5784
			],
			[
				51,
				-97
			],
			[
				100,
				-51
			]
		],
		[
			[
				3482,
				5636
			],
			[
				-89,
				-65
			]
		],
		[
			[
				3393,
				5571
			],
			[
				-84,
				-56
			]
		],
		[
			[
				3309,
				5515
			],
			[
				-9,
				-15
			]
		],
		[
			[
				3300,
				5500
			],
			[
				-41,
				0
			]
		],
		[
			[
				3259,
				5500
			],
			[
				-71,
				-19
			]
		],
		[
			[
				3188,
				5481
			],
			[
				1,
				14
			]
		],
		[
			[
				3189,
				5495
			],
			[
				-99,
				59
			]
		],
		[
			[
				3090,
				5554
			],
			[
				-54,
				-5
			]
		],
		[
			[
				3036,
				5549
			],
			[
				-109,
				-35
			]
		],
		[
			[
				2927,
				5514
			],
			[
				-106,
				-26
			]
		],
		[
			[
				2821,
				5488
			],
			[
				74,
				55
			]
		],
		[
			[
				2895,
				5543
			],
			[
				3,
				45
			]
		],
		[
			[
				2898,
				5588
			],
			[
				23,
				29
			]
		],
		[
			[
				2921,
				5617
			],
			[
				-11,
				159
			]
		],
		[
			[
				2910,
				5776
			],
			[
				-19,
				35
			]
		],
		[
			[
				2891,
				5811
			],
			[
				88,
				30
			],
			[
				50,
				66
			]
		],
		[
			[
				3029,
				5907
			],
			[
				135,
				73
			]
		],
		[
			[
				6702,
				4603
			],
			[
				156,
				-86
			],
			[
				75,
				27
			]
		],
		[
			[
				6933,
				4544
			],
			[
				13,
				-50
			]
		],
		[
			[
				6946,
				4494
			],
			[
				-135,
				-247
			]
		],
		[
			[
				6811,
				4247
			],
			[
				-116,
				-211
			],
			[
				-38,
				16
			],
			[
				-157,
				-173
			],
			[
				-25,
				72
			]
		],
		[
			[
				6475,
				3951
			],
			[
				6,
				99
			],
			[
				-90,
				29
			],
			[
				-14,
				88
			],
			[
				-79,
				-5
			],
			[
				-26,
				125
			]
		],
		[
			[
				6272,
				4287
			],
			[
				-6,
				25
			]
		],
		[
			[
				6266,
				4312
			],
			[
				-17,
				51
			]
		],
		[
			[
				6249,
				4363
			],
			[
				14,
				38
			],
			[
				-19,
				30
			],
			[
				196,
				121
			]
		],
		[
			[
				6498,
				4552
			],
			[
				39,
				51
			],
			[
				42,
				9
			],
			[
				54,
				-17
			],
			[
				69,
				8
			]
		],
		[
			[
				1340,
				2092
			],
			[
				12,
				-45
			]
		],
		[
			[
				1352,
				2047
			],
			[
				91,
				15
			]
		],
		[
			[
				1443,
				2062
			],
			[
				19,
				-16
			]
		],
		[
			[
				1462,
				2046
			],
			[
				56,
				25
			]
		],
		[
			[
				1560,
				1937
			],
			[
				8,
				-60
			]
		],
		[
			[
				1568,
				1877
			],
			[
				-18,
				-68
			]
		],
		[
			[
				1550,
				1809
			],
			[
				-8,
				-44
			]
		],
		[
			[
				1542,
				1765
			],
			[
				-19,
				-67
			],
			[
				-121,
				-73
			]
		],
		[
			[
				1402,
				1625
			],
			[
				-28,
				38
			]
		],
		[
			[
				1374,
				1663
			],
			[
				-93,
				92
			]
		],
		[
			[
				1281,
				1755
			],
			[
				-20,
				39
			]
		],
		[
			[
				1261,
				1794
			],
			[
				44,
				97
			],
			[
				-79,
				85
			]
		],
		[
			[
				1226,
				1976
			],
			[
				16,
				44
			]
		],
		[
			[
				1242,
				2020
			],
			[
				55,
				47
			]
		],
		[
			[
				1297,
				2067
			],
			[
				43,
				25
			]
		],
		[
			[
				3331,
				3928
			],
			[
				-12,
				-100
			]
		],
		[
			[
				3319,
				3828
			],
			[
				30,
				-13
			]
		],
		[
			[
				3349,
				3815
			],
			[
				27,
				-51
			]
		],
		[
			[
				3376,
				3764
			],
			[
				20,
				-91
			]
		],
		[
			[
				3396,
				3673
			],
			[
				27,
				-13
			]
		],
		[
			[
				3423,
				3660
			],
			[
				26,
				-46
			]
		],
		[
			[
				3449,
				3614
			],
			[
				-18,
				-101
			]
		],
		[
			[
				3431,
				3513
			],
			[
				-26,
				0
			]
		],
		[
			[
				3405,
				3513
			],
			[
				-58,
				-4
			]
		],
		[
			[
				3347,
				3509
			],
			[
				-19,
				42
			]
		],
		[
			[
				3328,
				3551
			],
			[
				-30,
				22
			]
		],
		[
			[
				3298,
				3573
			],
			[
				-28,
				2
			]
		],
		[
			[
				3270,
				3575
			],
			[
				-72,
				-54
			]
		],
		[
			[
				3198,
				3521
			],
			[
				-23,
				17
			]
		],
		[
			[
				3175,
				3538
			],
			[
				-69,
				-21
			]
		],
		[
			[
				3106,
				3517
			],
			[
				-57,
				-82
			],
			[
				27,
				-65
			]
		],
		[
			[
				3076,
				3370
			],
			[
				-76,
				9
			]
		],
		[
			[
				3000,
				3379
			],
			[
				-27,
				52
			]
		],
		[
			[
				2973,
				3431
			],
			[
				-43,
				123
			]
		],
		[
			[
				2930,
				3554
			],
			[
				-110,
				-51
			]
		],
		[
			[
				2820,
				3503
			],
			[
				12,
				100
			]
		],
		[
			[
				2832,
				3603
			],
			[
				-70,
				50
			]
		],
		[
			[
				2762,
				3653
			],
			[
				-19,
				0
			]
		],
		[
			[
				2743,
				3653
			],
			[
				40,
				12
			]
		],
		[
			[
				2783,
				3665
			],
			[
				63,
				33
			]
		],
		[
			[
				2846,
				3698
			],
			[
				59,
				97
			]
		],
		[
			[
				2905,
				3795
			],
			[
				35,
				57
			]
		],
		[
			[
				2940,
				3852
			],
			[
				46,
				43
			]
		],
		[
			[
				2986,
				3895
			],
			[
				124,
				33
			]
		],
		[
			[
				3110,
				3928
			],
			[
				6,
				-60
			]
		],
		[
			[
				3116,
				3868
			],
			[
				27,
				6
			]
		],
		[
			[
				3143,
				3874
			],
			[
				105,
				38
			]
		],
		[
			[
				3248,
				3912
			],
			[
				83,
				16
			]
		],
		[
			[
				7385,
				7760
			],
			[
				58,
				-10
			]
		],
		[
			[
				7443,
				7750
			],
			[
				22,
				18
			]
		],
		[
			[
				7465,
				7768
			],
			[
				145,
				-64
			],
			[
				98,
				-84
			],
			[
				-66,
				-73
			],
			[
				-2,
				-109
			],
			[
				-143,
				44
			]
		],
		[
			[
				7497,
				7482
			],
			[
				12,
				-39
			]
		],
		[
			[
				7509,
				7443
			],
			[
				-45,
				1
			]
		],
		[
			[
				7464,
				7444
			],
			[
				-31,
				-15
			]
		],
		[
			[
				7433,
				7429
			],
			[
				-78,
				12
			]
		],
		[
			[
				7355,
				7441
			],
			[
				-10,
				13
			]
		],
		[
			[
				7345,
				7454
			],
			[
				-38,
				12
			]
		],
		[
			[
				7307,
				7466
			],
			[
				-29,
				11
			]
		],
		[
			[
				7278,
				7477
			],
			[
				-51,
				12
			]
		],
		[
			[
				7227,
				7489
			],
			[
				-26,
				-11
			]
		],
		[
			[
				7201,
				7478
			],
			[
				-33,
				76
			],
			[
				-47,
				27
			],
			[
				-2,
				19
			],
			[
				28,
				37
			],
			[
				46,
				15
			],
			[
				5,
				43
			]
		],
		[
			[
				7198,
				7695
			],
			[
				23,
				7
			]
		],
		[
			[
				7221,
				7702
			],
			[
				36,
				-10
			]
		],
		[
			[
				7257,
				7692
			],
			[
				20,
				76
			],
			[
				77,
				14
			]
		],
		[
			[
				7354,
				7782
			],
			[
				31,
				-22
			]
		],
		[
			[
				1057,
				4608
			],
			[
				18,
				-81
			]
		],
		[
			[
				1075,
				4527
			],
			[
				-10,
				-86
			]
		],
		[
			[
				1065,
				4441
			],
			[
				-125,
				-208
			]
		],
		[
			[
				940,
				4233
			],
			[
				-27,
				-106
			]
		],
		[
			[
				913,
				4127
			],
			[
				-77,
				11
			]
		],
		[
			[
				836,
				4138
			],
			[
				-47,
				139
			],
			[
				44,
				304
			],
			[
				31,
				34
			]
		],
		[
			[
				864,
				4615
			],
			[
				69,
				0
			],
			[
				53,
				-65
			],
			[
				71,
				58
			]
		],
		[
			[
				4930,
				8172
			],
			[
				-31,
				-158
			],
			[
				21,
				-153
			],
			[
				-53,
				-48
			]
		],
		[
			[
				4867,
				7813
			],
			[
				-29,
				-92
			]
		],
		[
			[
				4838,
				7721
			],
			[
				-98,
				34
			]
		],
		[
			[
				4740,
				7755
			],
			[
				-41,
				49
			]
		],
		[
			[
				4699,
				7804
			],
			[
				-44,
				13
			]
		],
		[
			[
				4655,
				7817
			],
			[
				11,
				34
			],
			[
				-11,
				15
			],
			[
				14,
				22
			],
			[
				-20,
				24
			],
			[
				29,
				45
			],
			[
				0,
				62
			]
		],
		[
			[
				4678,
				8019
			],
			[
				-12,
				67
			]
		],
		[
			[
				4666,
				8086
			],
			[
				-43,
				33
			]
		],
		[
			[
				4623,
				8119
			],
			[
				13,
				47
			]
		],
		[
			[
				4636,
				8166
			],
			[
				33,
				27
			]
		],
		[
			[
				4669,
				8193
			],
			[
				71,
				-8
			],
			[
				118,
				47
			],
			[
				72,
				-60
			]
		],
		[
			[
				1305,
				5537
			],
			[
				92,
				-33
			],
			[
				21,
				-28
			],
			[
				33,
				-116
			]
		],
		[
			[
				1451,
				5360
			],
			[
				73,
				-28
			],
			[
				-24,
				-97
			]
		],
		[
			[
				1500,
				5235
			],
			[
				44,
				-20
			]
		],
		[
			[
				1544,
				5215
			],
			[
				-66,
				-50
			]
		],
		[
			[
				1478,
				5165
			],
			[
				8,
				-19
			]
		],
		[
			[
				1486,
				5146
			],
			[
				-29,
				-7
			]
		],
		[
			[
				1457,
				5139
			],
			[
				-19,
				61
			]
		],
		[
			[
				1438,
				5200
			],
			[
				-58,
				8
			]
		],
		[
			[
				1380,
				5208
			],
			[
				-14,
				-9
			]
		],
		[
			[
				1366,
				5199
			],
			[
				-7,
				14
			],
			[
				-24,
				-5
			],
			[
				-29,
				23
			]
		],
		[
			[
				1306,
				5231
			],
			[
				-87,
				73
			]
		],
		[
			[
				1219,
				5304
			],
			[
				-26,
				77
			]
		],
		[
			[
				1193,
				5381
			],
			[
				18,
				36
			]
		],
		[
			[
				1211,
				5417
			],
			[
				-57,
				82
			]
		],
		[
			[
				1154,
				5499
			],
			[
				132,
				155
			],
			[
				-21,
				39
			]
		],
		[
			[
				1265,
				5693
			],
			[
				48,
				-42
			]
		],
		[
			[
				2055,
				499
			],
			[
				36,
				-102
			],
			[
				97,
				-66
			],
			[
				-38,
				-113
			],
			[
				37,
				-72
			],
			[
				-75,
				-83
			],
			[
				-115,
				-46
			],
			[
				-93,
				118
			],
			[
				-42,
				-96
			],
			[
				-64,
				14
			],
			[
				5,
				93
			],
			[
				-55,
				104
			]
		],
		[
			[
				1748,
				250
			],
			[
				-37,
				174
			]
		],
		[
			[
				1976,
				529
			],
			[
				26,
				-54
			]
		],
		[
			[
				2664,
				3250
			],
			[
				33,
				-2
			]
		],
		[
			[
				2697,
				3248
			],
			[
				-13,
				-155
			],
			[
				-3,
				-124
			]
		],
		[
			[
				2681,
				2969
			],
			[
				-70,
				-11
			]
		],
		[
			[
				2611,
				2958
			],
			[
				-51,
				0
			]
		],
		[
			[
				2560,
				2958
			],
			[
				-44,
				134
			]
		],
		[
			[
				2516,
				3092
			],
			[
				-27,
				54
			]
		],
		[
			[
				2489,
				3146
			],
			[
				38,
				71
			]
		],
		[
			[
				2527,
				3217
			],
			[
				61,
				42
			]
		],
		[
			[
				2588,
				3259
			],
			[
				30,
				-13
			]
		],
		[
			[
				2618,
				3246
			],
			[
				46,
				4
			]
		],
		[
			[
				3479,
				1373
			],
			[
				54,
				-31
			]
		],
		[
			[
				3533,
				1342
			],
			[
				39,
				-89
			],
			[
				-61,
				-44
			],
			[
				-186,
				-56
			],
			[
				-95,
				14
			],
			[
				-13,
				81
			],
			[
				-28,
				56
			]
		],
		[
			[
				3189,
				1304
			],
			[
				59,
				41
			],
			[
				155,
				9
			]
		],
		[
			[
				3403,
				1354
			],
			[
				76,
				19
			]
		],
		[
			[
				7104,
				5451
			],
			[
				81,
				-68
			]
		],
		[
			[
				7185,
				5383
			],
			[
				-28,
				-163
			]
		],
		[
			[
				7157,
				5220
			],
			[
				-69,
				-20
			]
		],
		[
			[
				7088,
				5200
			],
			[
				-149,
				-60
			]
		],
		[
			[
				6939,
				5140
			],
			[
				-51,
				-27
			]
		],
		[
			[
				6888,
				5113
			],
			[
				-12,
				13
			]
		],
		[
			[
				6876,
				5126
			],
			[
				-36,
				83
			]
		],
		[
			[
				6840,
				5209
			],
			[
				-16,
				-5
			]
		],
		[
			[
				6824,
				5204
			],
			[
				-37,
				68
			]
		],
		[
			[
				6787,
				5272
			],
			[
				-22,
				20
			]
		],
		[
			[
				6765,
				5292
			],
			[
				-7,
				67
			]
		],
		[
			[
				7026,
				5406
			],
			[
				28,
				52
			]
		],
		[
			[
				7076,
				5471
			],
			[
				28,
				-20
			]
		],
		[
			[
				1262,
				702
			],
			[
				24,
				-33
			]
		],
		[
			[
				1286,
				669
			],
			[
				37,
				-6
			]
		],
		[
			[
				1323,
				663
			],
			[
				18,
				16
			]
		],
		[
			[
				1341,
				679
			],
			[
				74,
				-16
			]
		],
		[
			[
				1415,
				663
			],
			[
				82,
				15
			]
		],
		[
			[
				1497,
				678
			],
			[
				5,
				-16
			]
		],
		[
			[
				1502,
				662
			],
			[
				-16,
				-42
			]
		],
		[
			[
				1486,
				620
			],
			[
				54,
				-50
			]
		],
		[
			[
				1540,
				570
			],
			[
				-28,
				-58
			]
		],
		[
			[
				1512,
				512
			],
			[
				90,
				-25
			]
		],
		[
			[
				1602,
				487
			],
			[
				-5,
				-9
			]
		],
		[
			[
				1597,
				478
			],
			[
				32,
				12
			]
		],
		[
			[
				1695,
				422
			],
			[
				-63,
				-13
			]
		],
		[
			[
				1632,
				409
			],
			[
				-76,
				5
			],
			[
				-181,
				-113
			],
			[
				-29,
				10
			]
		],
		[
			[
				1346,
				311
			],
			[
				-49,
				-45
			],
			[
				22,
				-16
			],
			[
				5,
				-27
			],
			[
				-101,
				-39
			],
			[
				32,
				-155
			],
			[
				-135,
				138
			],
			[
				66,
				117
			],
			[
				19,
				128
			],
			[
				-90,
				88
			],
			[
				3,
				84
			],
			[
				-63,
				55
			]
		],
		[
			[
				1055,
				639
			],
			[
				34,
				33
			]
		],
		[
			[
				1089,
				672
			],
			[
				45,
				9
			]
		],
		[
			[
				1134,
				681
			],
			[
				96,
				27
			]
		],
		[
			[
				1230,
				708
			],
			[
				32,
				-6
			]
		],
		[
			[
				6760,
				3201
			],
			[
				-32,
				88
			],
			[
				-134,
				46
			]
		],
		[
			[
				6594,
				3335
			],
			[
				-14,
				61
			]
		],
		[
			[
				6580,
				3396
			],
			[
				-33,
				51
			]
		],
		[
			[
				6547,
				3447
			],
			[
				-12,
				99
			]
		],
		[
			[
				6535,
				3546
			],
			[
				25,
				117
			]
		],
		[
			[
				6560,
				3663
			],
			[
				74,
				54
			],
			[
				226,
				53
			],
			[
				67,
				-306
			],
			[
				-3,
				-118
			],
			[
				-130,
				-141
			],
			[
				-34,
				-4
			]
		],
		[
			[
				5113,
				5384
			],
			[
				22,
				-17
			]
		],
		[
			[
				5135,
				5367
			],
			[
				83,
				-142
			]
		],
		[
			[
				5218,
				5225
			],
			[
				89,
				-14
			]
		],
		[
			[
				5307,
				5211
			],
			[
				26,
				1
			],
			[
				-5,
				-30
			]
		],
		[
			[
				5328,
				5182
			],
			[
				-14,
				-1
			]
		],
		[
			[
				5314,
				5181
			],
			[
				-97,
				-135
			],
			[
				-32,
				-85
			]
		],
		[
			[
				5185,
				4961
			],
			[
				-86,
				-20
			]
		],
		[
			[
				5099,
				4941
			],
			[
				-37,
				95
			],
			[
				-139,
				-25
			]
		],
		[
			[
				4923,
				5011
			],
			[
				-11,
				57
			]
		],
		[
			[
				4912,
				5068
			],
			[
				-7,
				72
			]
		],
		[
			[
				4905,
				5140
			],
			[
				77,
				98
			],
			[
				25,
				139
			],
			[
				106,
				7
			]
		],
		[
			[
				5884,
				2691
			],
			[
				58,
				-42
			]
		],
		[
			[
				5942,
				2649
			],
			[
				13,
				-44
			],
			[
				-42,
				-33
			]
		],
		[
			[
				5913,
				2572
			],
			[
				-15,
				12
			]
		],
		[
			[
				5898,
				2584
			],
			[
				-6,
				25
			]
		],
		[
			[
				5892,
				2609
			],
			[
				-113,
				-64
			]
		],
		[
			[
				5779,
				2545
			],
			[
				-60,
				-113
			]
		],
		[
			[
				5719,
				2432
			],
			[
				-51,
				-58
			]
		],
		[
			[
				5668,
				2374
			],
			[
				-29,
				50
			]
		],
		[
			[
				5639,
				2424
			],
			[
				-10,
				24
			]
		],
		[
			[
				5629,
				2448
			],
			[
				6,
				110
			]
		],
		[
			[
				5635,
				2558
			],
			[
				5,
				72
			]
		],
		[
			[
				5640,
				2630
			],
			[
				-50,
				71
			]
		],
		[
			[
				5590,
				2701
			],
			[
				-17,
				47
			]
		],
		[
			[
				5573,
				2748
			],
			[
				64,
				7
			]
		],
		[
			[
				5637,
				2755
			],
			[
				17,
				26
			]
		],
		[
			[
				5654,
				2781
			],
			[
				46,
				94
			]
		],
		[
			[
				5700,
				2875
			],
			[
				82,
				-64
			],
			[
				65,
				1
			],
			[
				37,
				-121
			]
		],
		[
			[
				2600,
				2002
			],
			[
				60,
				23
			]
		],
		[
			[
				2660,
				2025
			],
			[
				-2,
				-28
			]
		],
		[
			[
				2658,
				1997
			],
			[
				17,
				-26
			],
			[
				82,
				-27
			],
			[
				19,
				-30
			],
			[
				3,
				-51
			]
		],
		[
			[
				2779,
				1863
			],
			[
				-173,
				13
			]
		],
		[
			[
				2606,
				1876
			],
			[
				-57,
				27
			]
		],
		[
			[
				2549,
				1903
			],
			[
				12,
				5
			]
		],
		[
			[
				2561,
				1908
			],
			[
				-20,
				103
			]
		],
		[
			[
				2541,
				2011
			],
			[
				37,
				33
			]
		],
		[
			[
				2578,
				2044
			],
			[
				22,
				-42
			]
		],
		[
			[
				4231,
				6879
			],
			[
				93,
				6
			],
			[
				35,
				-53
			]
		],
		[
			[
				4359,
				6832
			],
			[
				86,
				-5
			]
		],
		[
			[
				4445,
				6827
			],
			[
				67,
				-142
			],
			[
				-36,
				-68
			],
			[
				37,
				-162
			],
			[
				41,
				-15
			]
		],
		[
			[
				4554,
				6440
			],
			[
				5,
				-65
			]
		],
		[
			[
				4559,
				6375
			],
			[
				-16,
				-47
			],
			[
				-7,
				-42
			]
		],
		[
			[
				4536,
				6286
			],
			[
				-64,
				3
			]
		],
		[
			[
				4472,
				6289
			],
			[
				-32,
				26
			]
		],
		[
			[
				4440,
				6315
			],
			[
				-75,
				-11
			]
		],
		[
			[
				4365,
				6304
			],
			[
				30,
				-132
			]
		],
		[
			[
				4395,
				6172
			],
			[
				-48,
				30
			]
		],
		[
			[
				4347,
				6202
			],
			[
				-103,
				-38
			]
		],
		[
			[
				4244,
				6164
			],
			[
				24,
				-13
			]
		],
		[
			[
				4268,
				6151
			],
			[
				-40,
				-42
			]
		],
		[
			[
				4228,
				6109
			],
			[
				-32,
				12
			]
		],
		[
			[
				4196,
				6121
			],
			[
				-41,
				-54
			]
		],
		[
			[
				4155,
				6067
			],
			[
				-101,
				48
			],
			[
				-57,
				132
			],
			[
				-59,
				20
			],
			[
				-1,
				172
			]
		],
		[
			[
				3937,
				6439
			],
			[
				-72,
				64
			]
		],
		[
			[
				3865,
				6503
			],
			[
				70,
				74
			]
		],
		[
			[
				3935,
				6577
			],
			[
				29,
				32
			],
			[
				-22,
				87
			]
		],
		[
			[
				3942,
				6696
			],
			[
				17,
				3
			]
		],
		[
			[
				3959,
				6699
			],
			[
				-13,
				48
			]
		],
		[
			[
				3946,
				6747
			],
			[
				44,
				82
			]
		],
		[
			[
				3990,
				6829
			],
			[
				93,
				67
			]
		],
		[
			[
				4083,
				6896
			],
			[
				111,
				21
			]
		],
		[
			[
				4194,
				6917
			],
			[
				37,
				-38
			]
		],
		[
			[
				2928,
				2772
			],
			[
				27,
				-16
			]
		],
		[
			[
				2955,
				2756
			],
			[
				41,
				-47
			]
		],
		[
			[
				2996,
				2709
			],
			[
				190,
				31
			]
		],
		[
			[
				3186,
				2740
			],
			[
				82,
				-107
			]
		],
		[
			[
				3268,
				2633
			],
			[
				42,
				-15
			]
		],
		[
			[
				3310,
				2618
			],
			[
				-24,
				-18
			],
			[
				17,
				-33
			],
			[
				-26,
				-48
			],
			[
				-96,
				-58
			]
		],
		[
			[
				3181,
				2461
			],
			[
				-39,
				-67
			]
		],
		[
			[
				3142,
				2394
			],
			[
				-99,
				-51
			]
		],
		[
			[
				3043,
				2343
			],
			[
				-7,
				32
			]
		],
		[
			[
				3036,
				2375
			],
			[
				-50,
				55
			]
		],
		[
			[
				2986,
				2430
			],
			[
				-71,
				67
			]
		],
		[
			[
				2915,
				2497
			],
			[
				32,
				93
			],
			[
				-80,
				53
			],
			[
				-11,
				78
			]
		],
		[
			[
				2856,
				2721
			],
			[
				72,
				51
			]
		],
		[
			[
				3115,
				3113
			],
			[
				-25,
				-29
			]
		],
		[
			[
				3090,
				3084
			],
			[
				-58,
				-156
			],
			[
				-45,
				-8
			]
		],
		[
			[
				2987,
				2920
			],
			[
				-36,
				11
			]
		],
		[
			[
				2951,
				2931
			],
			[
				-79,
				9
			]
		],
		[
			[
				2872,
				2940
			],
			[
				14,
				117
			]
		],
		[
			[
				2886,
				3057
			],
			[
				157,
				42
			],
			[
				47,
				46
			]
		],
		[
			[
				3090,
				3145
			],
			[
				25,
				-32
			]
		],
		[
			[
				5780,
				4748
			],
			[
				150,
				-10
			]
		],
		[
			[
				5930,
				4738
			],
			[
				49,
				-96
			]
		],
		[
			[
				5979,
				4642
			],
			[
				79,
				-49
			],
			[
				50,
				-233
			]
		],
		[
			[
				6108,
				4360
			],
			[
				-136,
				-91
			]
		],
		[
			[
				5972,
				4269
			],
			[
				-133,
				-36
			],
			[
				-54,
				73
			],
			[
				-112,
				-1
			]
		],
		[
			[
				5673,
				4305
			],
			[
				-68,
				61
			]
		],
		[
			[
				5605,
				4366
			],
			[
				24,
				314
			],
			[
				45,
				59
			]
		],
		[
			[
				5674,
				4739
			],
			[
				17,
				36
			]
		],
		[
			[
				5691,
				4775
			],
			[
				89,
				-27
			]
		],
		[
			[
				3850,
				1915
			],
			[
				0,
				-14
			]
		],
		[
			[
				3850,
				1901
			],
			[
				31,
				-120
			],
			[
				72,
				-150
			]
		],
		[
			[
				3953,
				1631
			],
			[
				43,
				-11
			]
		],
		[
			[
				3996,
				1620
			],
			[
				-132,
				-89
			],
			[
				-98,
				-29
			]
		],
		[
			[
				3703,
				1712
			],
			[
				-74,
				29
			],
			[
				24,
				88
			]
		],
		[
			[
				3653,
				1829
			],
			[
				171,
				104
			]
		],
		[
			[
				3824,
				1933
			],
			[
				26,
				-18
			]
		],
		[
			[
				4111,
				1997
			],
			[
				138,
				0
			]
		],
		[
			[
				4249,
				1997
			],
			[
				14,
				-8
			]
		],
		[
			[
				4263,
				1989
			],
			[
				89,
				-148
			],
			[
				-48,
				-89
			],
			[
				-151,
				-30
			],
			[
				-39,
				-112
			],
			[
				-118,
				10
			]
		],
		[
			[
				3996,
				1620
			],
			[
				-43,
				11
			]
		],
		[
			[
				3850,
				1901
			],
			[
				0,
				14
			]
		],
		[
			[
				3850,
				1915
			],
			[
				-1,
				16
			]
		],
		[
			[
				3849,
				1931
			],
			[
				133,
				64
			]
		],
		[
			[
				3982,
				1995
			],
			[
				0,
				-8
			]
		],
		[
			[
				3982,
				1987
			],
			[
				80,
				39
			]
		],
		[
			[
				4062,
				2026
			],
			[
				49,
				-29
			]
		],
		[
			[
				1505,
				3614
			],
			[
				37,
				-29
			]
		],
		[
			[
				1542,
				3585
			],
			[
				12,
				-9
			]
		],
		[
			[
				1554,
				3576
			],
			[
				-80,
				8
			],
			[
				11,
				-137
			],
			[
				69,
				-119
			]
		],
		[
			[
				1554,
				3328
			],
			[
				11,
				-76
			]
		],
		[
			[
				1565,
				3252
			],
			[
				-82,
				20
			]
		],
		[
			[
				1483,
				3272
			],
			[
				-50,
				-66
			]
		],
		[
			[
				1433,
				3206
			],
			[
				-13,
				-14
			]
		],
		[
			[
				1420,
				3192
			],
			[
				9,
				-75
			]
		],
		[
			[
				1429,
				3117
			],
			[
				-60,
				1
			]
		],
		[
			[
				1369,
				3118
			],
			[
				-62,
				-104
			]
		],
		[
			[
				1307,
				3014
			],
			[
				-66,
				51
			],
			[
				-77,
				-13
			]
		],
		[
			[
				1164,
				3052
			],
			[
				-15,
				56
			]
		],
		[
			[
				1149,
				3108
			],
			[
				-14,
				41
			]
		],
		[
			[
				1135,
				3149
			],
			[
				-131,
				193
			]
		],
		[
			[
				1004,
				3342
			],
			[
				-7,
				32
			]
		],
		[
			[
				997,
				3374
			],
			[
				65,
				25
			],
			[
				29,
				99
			]
		],
		[
			[
				1091,
				3498
			],
			[
				0,
				73
			]
		],
		[
			[
				1091,
				3571
			],
			[
				203,
				-20
			],
			[
				58,
				46
			],
			[
				1,
				21
			],
			[
				11,
				-4
			],
			[
				35,
				52
			]
		],
		[
			[
				1399,
				3666
			],
			[
				106,
				-52
			]
		],
		[
			[
				5400,
				1836
			],
			[
				11,
				-16
			]
		],
		[
			[
				5411,
				1820
			],
			[
				110,
				-219
			],
			[
				-58,
				-162
			],
			[
				-105,
				32
			],
			[
				-144,
				-25
			],
			[
				2,
				114
			],
			[
				-72,
				80
			]
		],
		[
			[
				5144,
				1640
			],
			[
				40,
				73
			],
			[
				117,
				60
			]
		],
		[
			[
				5301,
				1773
			],
			[
				7,
				76
			]
		],
		[
			[
				5308,
				1849
			],
			[
				22,
				-3
			]
		],
		[
			[
				5330,
				1846
			],
			[
				70,
				-10
			]
		],
		[
			[
				4999,
				2356
			],
			[
				19,
				-37
			],
			[
				-64,
				-194
			]
		],
		[
			[
				4954,
				2125
			],
			[
				-14,
				-84
			]
		],
		[
			[
				4940,
				2041
			],
			[
				-48,
				13
			],
			[
				-56,
				107
			],
			[
				-129,
				31
			],
			[
				53,
				175
			]
		],
		[
			[
				4760,
				2367
			],
			[
				145,
				-4
			]
		],
		[
			[
				4905,
				2363
			],
			[
				65,
				24
			]
		],
		[
			[
				4970,
				2387
			],
			[
				29,
				-31
			]
		],
		[
			[
				8213,
				6121
			],
			[
				-22,
				32
			]
		],
		[
			[
				8191,
				6153
			],
			[
				-93,
				4
			]
		],
		[
			[
				8098,
				6157
			],
			[
				12,
				89
			]
		],
		[
			[
				8110,
				6246
			],
			[
				-76,
				28
			]
		],
		[
			[
				8034,
				6274
			],
			[
				-19,
				85
			]
		],
		[
			[
				8015,
				6359
			],
			[
				16,
				73
			]
		],
		[
			[
				8031,
				6432
			],
			[
				-51,
				77
			],
			[
				13,
				33
			],
			[
				23,
				16
			],
			[
				23,
				-21
			],
			[
				-3,
				28
			],
			[
				18,
				26
			],
			[
				108,
				13
			],
			[
				39,
				-60
			],
			[
				-14,
				-119
			],
			[
				54,
				-52
			],
			[
				91,
				-9
			],
			[
				32,
				-84
			],
			[
				-23,
				-163
			],
			[
				-71,
				-24
			],
			[
				-19,
				0
			],
			[
				-38,
				28
			]
		],
		[
			[
				1205,
				3894
			],
			[
				24,
				4
			]
		],
		[
			[
				1229,
				3898
			],
			[
				33,
				-24
			],
			[
				59,
				-86
			]
		],
		[
			[
				1321,
				3788
			],
			[
				-34,
				-17
			]
		],
		[
			[
				1287,
				3771
			],
			[
				112,
				-105
			]
		],
		[
			[
				1091,
				3571
			],
			[
				0,
				-32
			]
		],
		[
			[
				1091,
				3539
			],
			[
				-24,
				5
			],
			[
				-13,
				30
			],
			[
				-53,
				62
			],
			[
				-19,
				71
			]
		],
		[
			[
				982,
				3707
			],
			[
				-52,
				41
			]
		],
		[
			[
				930,
				3748
			],
			[
				11,
				47
			]
		],
		[
			[
				941,
				3795
			],
			[
				111,
				33
			]
		],
		[
			[
				1052,
				3828
			],
			[
				12,
				95
			]
		],
		[
			[
				1064,
				3923
			],
			[
				127,
				45
			]
		],
		[
			[
				1191,
				3968
			],
			[
				14,
				-74
			]
		],
		[
			[
				870,
				6003
			],
			[
				-7,
				-85
			]
		],
		[
			[
				863,
				5918
			],
			[
				21,
				-43
			]
		],
		[
			[
				884,
				5875
			],
			[
				-63,
				62
			],
			[
				-91,
				-84
			],
			[
				-49,
				-98
			],
			[
				-87,
				8
			],
			[
				-21,
				-106
			]
		],
		[
			[
				573,
				5657
			],
			[
				-25,
				11
			]
		],
		[
			[
				548,
				5668
			],
			[
				-20,
				-51
			],
			[
				-122,
				52
			]
		],
		[
			[
				406,
				5669
			],
			[
				30,
				77
			]
		],
		[
			[
				436,
				5746
			],
			[
				71,
				210
			],
			[
				-119,
				89
			]
		],
		[
			[
				388,
				6045
			],
			[
				59,
				110
			],
			[
				87,
				-64
			],
			[
				107,
				-14
			],
			[
				132,
				-64
			],
			[
				97,
				-10
			]
		],
		[
			[
				1091,
				3539
			],
			[
				0,
				-41
			]
		],
		[
			[
				997,
				3374
			],
			[
				-58,
				19
			]
		],
		[
			[
				939,
				3393
			],
			[
				-107,
				126
			]
		],
		[
			[
				832,
				3519
			],
			[
				-6,
				84
			]
		],
		[
			[
				826,
				3603
			],
			[
				-25,
				23
			]
		],
		[
			[
				801,
				3626
			],
			[
				67,
				34
			]
		],
		[
			[
				868,
				3660
			],
			[
				39,
				51
			]
		],
		[
			[
				907,
				3711
			],
			[
				23,
				37
			]
		],
		[
			[
				930,
				3748
			],
			[
				52,
				-41
			]
		],
		[
			[
				5205,
				2733
			],
			[
				-1,
				-19
			]
		],
		[
			[
				5204,
				2714
			],
			[
				-58,
				-76
			],
			[
				99,
				-74
			]
		],
		[
			[
				5245,
				2564
			],
			[
				45,
				-44
			]
		],
		[
			[
				5290,
				2520
			],
			[
				-69,
				-37
			]
		],
		[
			[
				5221,
				2483
			],
			[
				0,
				-19
			]
		],
		[
			[
				5221,
				2464
			],
			[
				-46,
				-52
			]
		],
		[
			[
				5175,
				2412
			],
			[
				-135,
				33
			]
		],
		[
			[
				5040,
				2445
			],
			[
				-44,
				-12
			]
		],
		[
			[
				4996,
				2433
			],
			[
				-35,
				-25
			]
		],
		[
			[
				4961,
				2408
			],
			[
				-35,
				10
			]
		],
		[
			[
				4926,
				2418
			],
			[
				44,
				117
			],
			[
				-13,
				95
			]
		],
		[
			[
				4957,
				2630
			],
			[
				89,
				153
			]
		],
		[
			[
				5046,
				2783
			],
			[
				46,
				6
			]
		],
		[
			[
				5092,
				2789
			],
			[
				81,
				49
			]
		],
		[
			[
				5173,
				2838
			],
			[
				32,
				-105
			]
		],
		[
			[
				563,
				2284
			],
			[
				82,
				-54
			]
		],
		[
			[
				645,
				2230
			],
			[
				-39,
				-11
			]
		],
		[
			[
				606,
				2219
			],
			[
				14,
				-47
			]
		],
		[
			[
				620,
				2172
			],
			[
				-17,
				-81
			]
		],
		[
			[
				603,
				2091
			],
			[
				-25,
				-51
			]
		],
		[
			[
				578,
				2040
			],
			[
				-32,
				18
			]
		],
		[
			[
				546,
				2058
			],
			[
				-37,
				-6
			]
		],
		[
			[
				509,
				2052
			],
			[
				26,
				-49
			]
		],
		[
			[
				535,
				2003
			],
			[
				22,
				-33
			]
		],
		[
			[
				557,
				1970
			],
			[
				0,
				-37
			]
		],
		[
			[
				557,
				1933
			],
			[
				-9,
				-20
			]
		],
		[
			[
				548,
				1913
			],
			[
				-69,
				-18
			],
			[
				-44,
				132
			]
		],
		[
			[
				435,
				2027
			],
			[
				72,
				125
			],
			[
				-31,
				85
			],
			[
				87,
				47
			]
		],
		[
			[
				219,
				2860
			],
			[
				10,
				-48
			]
		],
		[
			[
				229,
				2812
			],
			[
				-49,
				-113
			],
			[
				11,
				-93
			]
		],
		[
			[
				191,
				2606
			],
			[
				-145,
				-41
			],
			[
				20,
				110
			],
			[
				-64,
				65
			],
			[
				-2,
				78
			],
			[
				85,
				117
			],
			[
				60,
				-127
			],
			[
				74,
				52
			]
		],
		[
			[
				577,
				3057
			],
			[
				90,
				-69
			],
			[
				-3,
				-45
			],
			[
				36,
				-53
			]
		],
		[
			[
				700,
				2890
			],
			[
				111,
				-136
			]
		],
		[
			[
				811,
				2754
			],
			[
				-22,
				-36
			]
		],
		[
			[
				789,
				2718
			],
			[
				-62,
				-28
			],
			[
				-120,
				21
			]
		],
		[
			[
				607,
				2711
			],
			[
				-61,
				-52
			]
		],
		[
			[
				546,
				2659
			],
			[
				-37,
				9
			]
		],
		[
			[
				509,
				2668
			],
			[
				-19,
				-12
			]
		],
		[
			[
				490,
				2656
			],
			[
				-57,
				110
			]
		],
		[
			[
				433,
				2766
			],
			[
				-7,
				121
			]
		],
		[
			[
				426,
				2887
			],
			[
				-37,
				98
			],
			[
				53,
				78
			]
		],
		[
			[
				442,
				3063
			],
			[
				135,
				-6
			]
		],
		[
			[
				927,
				2425
			],
			[
				6,
				-61
			]
		],
		[
			[
				933,
				2364
			],
			[
				22,
				-9
			]
		],
		[
			[
				955,
				2355
			],
			[
				10,
				-27
			]
		],
		[
			[
				965,
				2328
			],
			[
				23,
				21
			]
		],
		[
			[
				988,
				2349
			],
			[
				43,
				-26
			]
		],
		[
			[
				1031,
				2323
			],
			[
				43,
				-101
			]
		],
		[
			[
				1074,
				2222
			],
			[
				29,
				-21
			],
			[
				-12,
				-14
			],
			[
				3,
				-28
			],
			[
				-24,
				-24
			]
		],
		[
			[
				1070,
				2135
			],
			[
				-16,
				20
			],
			[
				-19,
				-8
			],
			[
				-5,
				25
			],
			[
				-14,
				13
			]
		],
		[
			[
				1016,
				2185
			],
			[
				-62,
				-28
			]
		],
		[
			[
				954,
				2157
			],
			[
				-75,
				-3
			]
		],
		[
			[
				879,
				2154
			],
			[
				-30,
				-38
			]
		],
		[
			[
				849,
				2116
			],
			[
				-1,
				42
			],
			[
				-26,
				49
			]
		],
		[
			[
				822,
				2207
			],
			[
				-45,
				66
			]
		],
		[
			[
				777,
				2273
			],
			[
				69,
				74
			]
		],
		[
			[
				846,
				2347
			],
			[
				81,
				78
			]
		],
		[
			[
				3415,
				2986
			],
			[
				56,
				1
			],
			[
				15,
				-105
			]
		],
		[
			[
				3486,
				2882
			],
			[
				6,
				-26
			]
		],
		[
			[
				3492,
				2856
			],
			[
				-51,
				-83
			]
		],
		[
			[
				3441,
				2773
			],
			[
				-32,
				23
			]
		],
		[
			[
				3409,
				2796
			],
			[
				-17,
				-67
			]
		],
		[
			[
				3392,
				2729
			],
			[
				-22,
				-10
			]
		],
		[
			[
				3370,
				2719
			],
			[
				15,
				-37
			],
			[
				-69,
				-70
			],
			[
				-15,
				20
			],
			[
				-33,
				1
			]
		],
		[
			[
				3186,
				2740
			],
			[
				-30,
				50
			],
			[
				21,
				141
			]
		],
		[
			[
				3177,
				2931
			],
			[
				40,
				25
			]
		],
		[
			[
				3217,
				2956
			],
			[
				42,
				-1
			],
			[
				53,
				17
			],
			[
				68,
				45
			],
			[
				-7,
				-24
			],
			[
				42,
				-7
			]
		],
		[
			[
				3921,
				3563
			],
			[
				97,
				36
			]
		],
		[
			[
				4018,
				3599
			],
			[
				34,
				-126
			]
		],
		[
			[
				4052,
				3473
			],
			[
				31,
				3
			]
		],
		[
			[
				4083,
				3476
			],
			[
				26,
				-33
			]
		],
		[
			[
				4109,
				3443
			],
			[
				-56,
				-58
			]
		],
		[
			[
				4036,
				3390
			],
			[
				-28,
				-51
			]
		],
		[
			[
				3984,
				3290
			],
			[
				-5,
				-59
			]
		],
		[
			[
				3945,
				3235
			],
			[
				-50,
				-65
			]
		],
		[
			[
				3895,
				3170
			],
			[
				-26,
				64
			]
		],
		[
			[
				3869,
				3234
			],
			[
				-16,
				9
			]
		],
		[
			[
				3853,
				3243
			],
			[
				-90,
				93
			],
			[
				-12,
				60
			]
		],
		[
			[
				3751,
				3396
			],
			[
				-31,
				31
			]
		],
		[
			[
				3720,
				3427
			],
			[
				24,
				65
			]
		],
		[
			[
				3744,
				3492
			],
			[
				37,
				93
			]
		],
		[
			[
				3781,
				3585
			],
			[
				83,
				20
			]
		],
		[
			[
				3864,
				3605
			],
			[
				35,
				28
			]
		],
		[
			[
				3899,
				3633
			],
			[
				22,
				-70
			]
		],
		[
			[
				4680,
				3694
			],
			[
				111,
				-29
			],
			[
				131,
				9
			]
		],
		[
			[
				4922,
				3674
			],
			[
				33,
				-18
			]
		],
		[
			[
				4955,
				3656
			],
			[
				5,
				-48
			],
			[
				26,
				0
			]
		],
		[
			[
				4986,
				3608
			],
			[
				-41,
				-96
			],
			[
				30,
				-78
			],
			[
				-85,
				-66
			]
		],
		[
			[
				4890,
				3368
			],
			[
				-49,
				-44
			]
		],
		[
			[
				4841,
				3324
			],
			[
				-47,
				31
			]
		],
		[
			[
				4794,
				3355
			],
			[
				-112,
				-63
			]
		],
		[
			[
				4682,
				3292
			],
			[
				-27,
				-11
			]
		],
		[
			[
				4655,
				3281
			],
			[
				13,
				152
			],
			[
				-99,
				122
			]
		],
		[
			[
				4569,
				3555
			],
			[
				1,
				34
			],
			[
				-16,
				21
			]
		],
		[
			[
				4554,
				3610
			],
			[
				71,
				62
			]
		],
		[
			[
				4625,
				3672
			],
			[
				55,
				22
			]
		],
		[
			[
				6484,
				8682
			],
			[
				-10,
				-116
			],
			[
				-104,
				-127
			],
			[
				86,
				-139
			]
		],
		[
			[
				6456,
				8300
			],
			[
				-11,
				-44
			]
		],
		[
			[
				6445,
				8256
			],
			[
				-79,
				-99
			]
		],
		[
			[
				6366,
				8157
			],
			[
				14,
				-26
			]
		],
		[
			[
				6380,
				8131
			],
			[
				-52,
				-3
			]
		],
		[
			[
				6328,
				8128
			],
			[
				-31,
				19
			]
		],
		[
			[
				6297,
				8147
			],
			[
				-89,
				30
			]
		],
		[
			[
				6208,
				8177
			],
			[
				-12,
				-24
			]
		],
		[
			[
				6196,
				8153
			],
			[
				-321,
				181
			],
			[
				21,
				82
			],
			[
				-60,
				122
			],
			[
				150,
				-50
			],
			[
				170,
				14
			],
			[
				59,
				54
			],
			[
				11,
				124
			],
			[
				120,
				92
			],
			[
				138,
				-90
			]
		],
		[
			[
				1677,
				3280
			],
			[
				31,
				-3
			]
		],
		[
			[
				1708,
				3277
			],
			[
				-14,
				-87
			]
		],
		[
			[
				1694,
				3190
			],
			[
				-54,
				-97
			]
		],
		[
			[
				1640,
				3093
			],
			[
				-93,
				-81
			]
		],
		[
			[
				1547,
				3012
			],
			[
				38,
				-40
			]
		],
		[
			[
				1585,
				2972
			],
			[
				-39,
				-70
			]
		],
		[
			[
				1546,
				2902
			],
			[
				-66,
				-45
			]
		],
		[
			[
				1480,
				2857
			],
			[
				-27,
				-53
			]
		],
		[
			[
				1453,
				2804
			],
			[
				-51,
				36
			],
			[
				43,
				53
			]
		],
		[
			[
				1445,
				2893
			],
			[
				-42,
				21
			]
		],
		[
			[
				1403,
				2914
			],
			[
				-17,
				-7
			]
		],
		[
			[
				1386,
				2907
			],
			[
				-5,
				123
			]
		],
		[
			[
				1381,
				3030
			],
			[
				-12,
				88
			]
		],
		[
			[
				1429,
				3117
			],
			[
				-9,
				75
			]
		],
		[
			[
				1433,
				3206
			],
			[
				50,
				66
			]
		],
		[
			[
				1565,
				3252
			],
			[
				39,
				-20
			]
		],
		[
			[
				1604,
				3232
			],
			[
				73,
				48
			]
		],
		[
			[
				1810,
				3284
			],
			[
				94,
				-88
			],
			[
				102,
				5
			]
		],
		[
			[
				2006,
				3201
			],
			[
				13,
				-57
			]
		],
		[
			[
				2019,
				3144
			],
			[
				-25,
				-24
			],
			[
				-10,
				9
			]
		],
		[
			[
				1984,
				3129
			],
			[
				-42,
				-14
			]
		],
		[
			[
				1942,
				3115
			],
			[
				-43,
				-46
			]
		],
		[
			[
				1899,
				3069
			],
			[
				-16,
				-92
			],
			[
				-77,
				-123
			],
			[
				26,
				-80
			]
		],
		[
			[
				1832,
				2774
			],
			[
				-141,
				-35
			]
		],
		[
			[
				1691,
				2739
			],
			[
				-107,
				166
			]
		],
		[
			[
				1584,
				2905
			],
			[
				1,
				67
			]
		],
		[
			[
				1547,
				3012
			],
			[
				93,
				81
			]
		],
		[
			[
				1640,
				3093
			],
			[
				54,
				97
			]
		],
		[
			[
				1708,
				3277
			],
			[
				18,
				-1
			]
		],
		[
			[
				1726,
				3276
			],
			[
				39,
				-9
			]
		],
		[
			[
				1765,
				3267
			],
			[
				45,
				17
			]
		],
		[
			[
				794,
				1865
			],
			[
				127,
				-89
			],
			[
				84,
				16
			]
		],
		[
			[
				1005,
				1792
			],
			[
				47,
				-45
			]
		],
		[
			[
				1052,
				1747
			],
			[
				100,
				-39
			]
		],
		[
			[
				1152,
				1708
			],
			[
				24,
				-14
			]
		],
		[
			[
				1176,
				1694
			],
			[
				-92,
				-86
			],
			[
				-35,
				-189
			]
		],
		[
			[
				1049,
				1419
			],
			[
				-103,
				-23
			]
		],
		[
			[
				946,
				1396
			],
			[
				-76,
				83
			]
		],
		[
			[
				870,
				1479
			],
			[
				-53,
				-28
			]
		],
		[
			[
				817,
				1451
			],
			[
				-63,
				157
			],
			[
				33,
				90
			],
			[
				-59,
				80
			],
			[
				26,
				67
			]
		],
		[
			[
				754,
				1845
			],
			[
				-1,
				31
			]
		],
		[
			[
				753,
				1876
			],
			[
				41,
				-11
			]
		],
		[
			[
				2446,
				4163
			],
			[
				78,
				-58
			]
		],
		[
			[
				2524,
				4105
			],
			[
				7,
				-38
			]
		],
		[
			[
				2531,
				4067
			],
			[
				-22,
				-24
			]
		],
		[
			[
				2509,
				4043
			],
			[
				80,
				-186
			]
		],
		[
			[
				2589,
				3857
			],
			[
				2,
				10
			],
			[
				63,
				16
			],
			[
				9,
				-7
			]
		],
		[
			[
				2663,
				3876
			],
			[
				-3,
				-21
			]
		],
		[
			[
				2660,
				3855
			],
			[
				-97,
				-46
			]
		],
		[
			[
				2563,
				3809
			],
			[
				-56,
				-43
			]
		],
		[
			[
				2507,
				3766
			],
			[
				-110,
				-5
			]
		],
		[
			[
				2397,
				3761
			],
			[
				-49,
				18
			]
		],
		[
			[
				2348,
				3779
			],
			[
				-124,
				12
			],
			[
				13,
				282
			]
		],
		[
			[
				2237,
				4073
			],
			[
				31,
				16
			]
		],
		[
			[
				2268,
				4089
			],
			[
				31,
				-7
			]
		],
		[
			[
				2299,
				4082
			],
			[
				46,
				37
			]
		],
		[
			[
				2345,
				4119
			],
			[
				101,
				44
			]
		],
		[
			[
				3380,
				6300
			],
			[
				60,
				5
			],
			[
				132,
				-78
			],
			[
				161,
				-25
			]
		],
		[
			[
				3733,
				6202
			],
			[
				5,
				-45
			]
		],
		[
			[
				3738,
				6157
			],
			[
				14,
				-138
			]
		],
		[
			[
				3752,
				6019
			],
			[
				-32,
				-64
			]
		],
		[
			[
				3720,
				5955
			],
			[
				-192,
				-97
			],
			[
				-141,
				-25
			]
		],
		[
			[
				3387,
				5833
			],
			[
				-48,
				-10
			]
		],
		[
			[
				3164,
				5980
			],
			[
				-156,
				39
			]
		],
		[
			[
				3008,
				6019
			],
			[
				-60,
				58
			]
		],
		[
			[
				2948,
				6077
			],
			[
				35,
				36
			],
			[
				201,
				43
			],
			[
				113,
				111
			],
			[
				-13,
				75
			],
			[
				54,
				59
			]
		],
		[
			[
				3338,
				6401
			],
			[
				28,
				-68
			]
		],
		[
			[
				3366,
				6333
			],
			[
				14,
				-33
			]
		],
		[
			[
				2729,
				4095
			],
			[
				2,
				-87
			]
		],
		[
			[
				2731,
				4008
			],
			[
				-40,
				-36
			]
		],
		[
			[
				2691,
				3972
			],
			[
				-26,
				-55
			]
		],
		[
			[
				2665,
				3917
			],
			[
				-2,
				-41
			]
		],
		[
			[
				2663,
				3876
			],
			[
				-21,
				8
			],
			[
				-2,
				-12
			],
			[
				-17,
				4
			],
			[
				-34,
				-19
			]
		],
		[
			[
				2509,
				4043
			],
			[
				75,
				38
			]
		],
		[
			[
				2584,
				4081
			],
			[
				93,
				31
			]
		],
		[
			[
				2677,
				4112
			],
			[
				52,
				-17
			]
		],
		[
			[
				8213,
				6121
			],
			[
				50,
				-28
			]
		],
		[
			[
				8263,
				6093
			],
			[
				-33,
				-168
			],
			[
				-67,
				-89
			]
		],
		[
			[
				8163,
				5836
			],
			[
				-4,
				-15
			]
		],
		[
			[
				8159,
				5821
			],
			[
				-66,
				-8
			],
			[
				-37,
				55
			],
			[
				-122,
				-47
			]
		],
		[
			[
				7934,
				5821
			],
			[
				-24,
				106
			],
			[
				12,
				38
			]
		],
		[
			[
				7922,
				5965
			],
			[
				18,
				2
			]
		],
		[
			[
				7940,
				5967
			],
			[
				45,
				46
			]
		],
		[
			[
				7985,
				6013
			],
			[
				-12,
				27
			]
		],
		[
			[
				7973,
				6040
			],
			[
				48,
				82
			]
		],
		[
			[
				8021,
				6122
			],
			[
				39,
				24
			]
		],
		[
			[
				8060,
				6146
			],
			[
				131,
				7
			]
		],
		[
			[
				4727,
				4595
			],
			[
				22,
				-21
			],
			[
				8,
				-37
			]
		],
		[
			[
				4757,
				4537
			],
			[
				76,
				-113
			]
		],
		[
			[
				4833,
				4424
			],
			[
				39,
				-166
			]
		],
		[
			[
				4872,
				4258
			],
			[
				-49,
				-14
			]
		],
		[
			[
				4823,
				4244
			],
			[
				-14,
				23
			]
		],
		[
			[
				4809,
				4267
			],
			[
				-81,
				-2
			]
		],
		[
			[
				4728,
				4265
			],
			[
				-107,
				54
			]
		],
		[
			[
				4621,
				4319
			],
			[
				-33,
				17
			]
		],
		[
			[
				4588,
				4336
			],
			[
				-60,
				13
			]
		],
		[
			[
				4528,
				4349
			],
			[
				-44,
				-23
			]
		],
		[
			[
				4484,
				4326
			],
			[
				-28,
				113
			],
			[
				-62,
				94
			]
		],
		[
			[
				4394,
				4533
			],
			[
				70,
				35
			]
		],
		[
			[
				4464,
				4568
			],
			[
				143,
				-2
			]
		],
		[
			[
				4607,
				4566
			],
			[
				45,
				12
			]
		],
		[
			[
				4652,
				4578
			],
			[
				33,
				-8
			]
		],
		[
			[
				4685,
				4570
			],
			[
				42,
				25
			]
		],
		[
			[
				2930,
				3554
			],
			[
				43,
				-123
			]
		],
		[
			[
				3000,
				3379
			],
			[
				34,
				-82
			]
		],
		[
			[
				3034,
				3297
			],
			[
				-3,
				-28
			]
		],
		[
			[
				3031,
				3269
			],
			[
				59,
				24
			]
		],
		[
			[
				3090,
				3293
			],
			[
				3,
				-41
			]
		],
		[
			[
				3093,
				3252
			],
			[
				33,
				-72
			]
		],
		[
			[
				3126,
				3180
			],
			[
				-72,
				-34
			]
		],
		[
			[
				3054,
				3146
			],
			[
				-62,
				53
			]
		],
		[
			[
				2992,
				3199
			],
			[
				-86,
				24
			],
			[
				-190,
				-61
			]
		],
		[
			[
				2716,
				3162
			],
			[
				-19,
				86
			]
		],
		[
			[
				2664,
				3250
			],
			[
				-46,
				-4
			]
		],
		[
			[
				2588,
				3259
			],
			[
				36,
				79
			]
		],
		[
			[
				2624,
				3338
			],
			[
				40,
				-5
			]
		],
		[
			[
				2664,
				3333
			],
			[
				113,
				93
			]
		],
		[
			[
				2777,
				3426
			],
			[
				43,
				77
			]
		],
		[
			[
				1497,
				4563
			],
			[
				7,
				-45
			]
		],
		[
			[
				1504,
				4518
			],
			[
				48,
				-76
			]
		],
		[
			[
				1552,
				4442
			],
			[
				-30,
				-85
			]
		],
		[
			[
				1522,
				4357
			],
			[
				-65,
				1
			]
		],
		[
			[
				1457,
				4358
			],
			[
				-26,
				34
			]
		],
		[
			[
				1431,
				4392
			],
			[
				-63,
				75
			]
		],
		[
			[
				1368,
				4467
			],
			[
				-52,
				88
			]
		],
		[
			[
				1316,
				4555
			],
			[
				49,
				30
			]
		],
		[
			[
				1365,
				4585
			],
			[
				75,
				26
			]
		],
		[
			[
				1440,
				4611
			],
			[
				57,
				-48
			]
		],
		[
			[
				3070,
				7367
			],
			[
				-37,
				-45
			]
		],
		[
			[
				3033,
				7322
			],
			[
				34,
				-67
			],
			[
				63,
				-39
			]
		],
		[
			[
				3130,
				7216
			],
			[
				-105,
				-108
			],
			[
				-60,
				-3
			]
		],
		[
			[
				2965,
				7105
			],
			[
				0,
				-45
			]
		],
		[
			[
				2965,
				7060
			],
			[
				-43,
				2
			]
		],
		[
			[
				2922,
				7062
			],
			[
				-54,
				-42
			]
		],
		[
			[
				2868,
				7020
			],
			[
				-85,
				50
			],
			[
				-37,
				107
			]
		],
		[
			[
				2746,
				7177
			],
			[
				41,
				55
			]
		],
		[
			[
				2787,
				7232
			],
			[
				-15,
				13
			]
		],
		[
			[
				2939,
				7429
			],
			[
				131,
				-62
			]
		],
		[
			[
				3636,
				7762
			],
			[
				39,
				8
			],
			[
				51,
				-252
			],
			[
				45,
				-40
			]
		],
		[
			[
				3771,
				7478
			],
			[
				-4,
				-44
			]
		],
		[
			[
				3767,
				7434
			],
			[
				-17,
				-13
			]
		],
		[
			[
				3750,
				7421
			],
			[
				-45,
				60
			]
		],
		[
			[
				3705,
				7481
			],
			[
				-108,
				3
			]
		],
		[
			[
				3597,
				7484
			],
			[
				-106,
				163
			],
			[
				18,
				93
			]
		],
		[
			[
				3509,
				7740
			],
			[
				-8,
				92
			],
			[
				87,
				49
			]
		],
		[
			[
				3588,
				7881
			],
			[
				48,
				-119
			]
		],
		[
			[
				6832,
				6438
			],
			[
				120,
				-57
			]
		],
		[
			[
				6952,
				6381
			],
			[
				70,
				5
			]
		],
		[
			[
				7022,
				6386
			],
			[
				71,
				-63
			],
			[
				-3,
				-72
			]
		],
		[
			[
				7090,
				6251
			],
			[
				13,
				-39
			]
		],
		[
			[
				7103,
				6212
			],
			[
				-71,
				7
			],
			[
				-113,
				-57
			],
			[
				11,
				-16
			],
			[
				-10,
				-12
			]
		],
		[
			[
				6920,
				6134
			],
			[
				-66,
				127
			]
		],
		[
			[
				6854,
				6261
			],
			[
				-86,
				97
			]
		],
		[
			[
				6768,
				6358
			],
			[
				45,
				24
			],
			[
				-24,
				23
			],
			[
				43,
				33
			]
		],
		[
			[
				2530,
				3644
			],
			[
				39,
				-50
			]
		],
		[
			[
				2569,
				3594
			],
			[
				78,
				-28
			]
		],
		[
			[
				2647,
				3566
			],
			[
				12,
				-13
			]
		],
		[
			[
				2659,
				3553
			],
			[
				6,
				-23
			]
		],
		[
			[
				2665,
				3530
			],
			[
				13,
				-43
			]
		],
		[
			[
				2678,
				3487
			],
			[
				-108,
				-29
			]
		],
		[
			[
				2570,
				3458
			],
			[
				-25,
				-9
			]
		],
		[
			[
				2545,
				3449
			],
			[
				-62,
				7
			]
		],
		[
			[
				2483,
				3456
			],
			[
				8,
				61
			]
		],
		[
			[
				2491,
				3517
			],
			[
				-92,
				34
			],
			[
				-2,
				91
			],
			[
				133,
				2
			]
		],
		[
			[
				4841,
				3324
			],
			[
				65,
				12
			]
		],
		[
			[
				4906,
				3336
			],
			[
				80,
				-116
			],
			[
				109,
				77
			]
		],
		[
			[
				5095,
				3297
			],
			[
				32,
				-45
			]
		],
		[
			[
				5053,
				3028
			],
			[
				-34,
				-12
			]
		],
		[
			[
				5019,
				3016
			],
			[
				-85,
				-1
			]
		],
		[
			[
				4934,
				3015
			],
			[
				-53,
				-46
			],
			[
				-95,
				18
			]
		],
		[
			[
				4786,
				2987
			],
			[
				-90,
				-27
			]
		],
		[
			[
				4696,
				2960
			],
			[
				-15,
				8
			]
		],
		[
			[
				4681,
				2968
			],
			[
				14,
				27
			]
		],
		[
			[
				4695,
				2995
			],
			[
				5,
				169
			],
			[
				-33,
				85
			]
		],
		[
			[
				4667,
				3249
			],
			[
				15,
				43
			]
		],
		[
			[
				4794,
				3355
			],
			[
				47,
				-31
			]
		],
		[
			[
				925,
				3138
			],
			[
				27,
				-20
			]
		],
		[
			[
				952,
				3118
			],
			[
				158,
				-39
			]
		],
		[
			[
				1110,
				3079
			],
			[
				54,
				-27
			]
		],
		[
			[
				1307,
				3014
			],
			[
				74,
				16
			]
		],
		[
			[
				1381,
				3030
			],
			[
				5,
				-123
			]
		],
		[
			[
				1403,
				2914
			],
			[
				42,
				-21
			]
		],
		[
			[
				1445,
				2893
			],
			[
				-55,
				-39
			]
		],
		[
			[
				1390,
				2854
			],
			[
				-57,
				-49
			],
			[
				-141,
				-1
			],
			[
				-25,
				-71
			]
		],
		[
			[
				1167,
				2733
			],
			[
				-95,
				-15
			]
		],
		[
			[
				1072,
				2718
			],
			[
				-54,
				13
			]
		],
		[
			[
				1018,
				2731
			],
			[
				-14,
				46
			]
		],
		[
			[
				1004,
				2777
			],
			[
				16,
				3
			]
		],
		[
			[
				1020,
				2780
			],
			[
				-12,
				43
			]
		],
		[
			[
				1008,
				2823
			],
			[
				3,
				40
			]
		],
		[
			[
				1011,
				2863
			],
			[
				-49,
				-5
			],
			[
				-100,
				170
			],
			[
				-58,
				-14
			]
		],
		[
			[
				804,
				3014
			],
			[
				-24,
				56
			]
		],
		[
			[
				780,
				3070
			],
			[
				11,
				8
			]
		],
		[
			[
				791,
				3078
			],
			[
				-14,
				18
			]
		],
		[
			[
				777,
				3096
			],
			[
				29,
				16
			]
		],
		[
			[
				806,
				3112
			],
			[
				94,
				19
			]
		],
		[
			[
				900,
				3131
			],
			[
				25,
				7
			]
		],
		[
			[
				551,
				2462
			],
			[
				37,
				-11
			]
		],
		[
			[
				588,
				2451
			],
			[
				81,
				-65
			]
		],
		[
			[
				669,
				2386
			],
			[
				-12,
				-47
			]
		],
		[
			[
				657,
				2339
			],
			[
				8,
				-20
			]
		],
		[
			[
				665,
				2319
			],
			[
				-102,
				-35
			]
		],
		[
			[
				563,
				2284
			],
			[
				-54,
				55
			],
			[
				-171,
				63
			],
			[
				-7,
				54
			]
		],
		[
			[
				331,
				2456
			],
			[
				109,
				-66
			],
			[
				111,
				72
			]
		],
		[
			[
				3189,
				5495
			],
			[
				-23,
				-35
			]
		],
		[
			[
				3166,
				5460
			],
			[
				17,
				-171
			]
		],
		[
			[
				3183,
				5289
			],
			[
				-19,
				3
			]
		],
		[
			[
				3164,
				5292
			],
			[
				-39,
				-3
			]
		],
		[
			[
				3125,
				5289
			],
			[
				-66,
				-46
			]
		],
		[
			[
				3059,
				5243
			],
			[
				-62,
				-54
			]
		],
		[
			[
				2997,
				5189
			],
			[
				-128,
				-43
			]
		],
		[
			[
				2869,
				5146
			],
			[
				-84,
				63
			]
		],
		[
			[
				2785,
				5209
			],
			[
				10,
				1
			]
		],
		[
			[
				2795,
				5210
			],
			[
				-1,
				47
			]
		],
		[
			[
				2794,
				5257
			],
			[
				-35,
				109
			],
			[
				84,
				78
			]
		],
		[
			[
				2843,
				5444
			],
			[
				84,
				70
			]
		],
		[
			[
				3036,
				5549
			],
			[
				54,
				5
			]
		],
		[
			[
				4258,
				4763
			],
			[
				50,
				-115
			]
		],
		[
			[
				4308,
				4648
			],
			[
				11,
				5
			]
		],
		[
			[
				4319,
				4653
			],
			[
				3,
				-9
			],
			[
				-27,
				-27
			],
			[
				34,
				-67
			]
		],
		[
			[
				4329,
				4550
			],
			[
				-46,
				-26
			]
		],
		[
			[
				4283,
				4524
			],
			[
				-34,
				-3
			]
		],
		[
			[
				4249,
				4521
			],
			[
				-6,
				-25
			],
			[
				-16,
				-10
			]
		],
		[
			[
				4227,
				4486
			],
			[
				9,
				50
			]
		],
		[
			[
				4236,
				4536
			],
			[
				-71,
				50
			]
		],
		[
			[
				4165,
				4586
			],
			[
				9,
				12
			]
		],
		[
			[
				4146,
				4719
			],
			[
				112,
				44
			]
		],
		[
			[
				1154,
				5499
			],
			[
				-4,
				-23
			]
		],
		[
			[
				1150,
				5476
			],
			[
				-117,
				-4
			]
		],
		[
			[
				1033,
				5472
			],
			[
				-76,
				73
			],
			[
				-54,
				6
			]
		],
		[
			[
				903,
				5551
			],
			[
				37,
				32
			]
		],
		[
			[
				940,
				5583
			],
			[
				-13,
				205
			]
		],
		[
			[
				927,
				5788
			],
			[
				-64,
				130
			]
		],
		[
			[
				863,
				5918
			],
			[
				7,
				85
			]
		],
		[
			[
				870,
				6003
			],
			[
				53,
				-16
			],
			[
				109,
				-81
			],
			[
				36,
				-58
			],
			[
				31,
				-105
			],
			[
				32,
				-27
			],
			[
				38,
				-11
			],
			[
				96,
				-12
			]
		],
		[
			[
				2394,
				6415
			],
			[
				14,
				10
			]
		],
		[
			[
				2408,
				6425
			],
			[
				36,
				-57
			]
		],
		[
			[
				2444,
				6368
			],
			[
				44,
				-38
			]
		],
		[
			[
				2488,
				6330
			],
			[
				-18,
				-123
			]
		],
		[
			[
				2470,
				6207
			],
			[
				-13,
				-50
			]
		],
		[
			[
				2457,
				6157
			],
			[
				10,
				-27
			],
			[
				-8,
				-4
			],
			[
				38,
				-29
			]
		],
		[
			[
				2497,
				6097
			],
			[
				-56,
				-55
			],
			[
				74,
				-129
			],
			[
				4,
				-76
			]
		],
		[
			[
				2519,
				5837
			],
			[
				-113,
				-51
			]
		],
		[
			[
				2406,
				5786
			],
			[
				-90,
				103
			]
		],
		[
			[
				2316,
				5889
			],
			[
				-94,
				14
			]
		],
		[
			[
				2222,
				5903
			],
			[
				-66,
				-28
			]
		],
		[
			[
				2156,
				5875
			],
			[
				-32,
				-16
			]
		],
		[
			[
				2124,
				5859
			],
			[
				-57,
				197
			],
			[
				74,
				130
			],
			[
				-54,
				130
			]
		],
		[
			[
				2087,
				6316
			],
			[
				26,
				28
			]
		],
		[
			[
				2113,
				6344
			],
			[
				54,
				-19
			]
		],
		[
			[
				2167,
				6325
			],
			[
				154,
				54
			]
		],
		[
			[
				2321,
				6379
			],
			[
				73,
				36
			]
		],
		[
			[
				5426,
				2174
			],
			[
				100,
				-89
			]
		],
		[
			[
				5526,
				2085
			],
			[
				79,
				-41
			]
		],
		[
			[
				5605,
				2044
			],
			[
				-8,
				-47
			]
		],
		[
			[
				5597,
				1997
			],
			[
				-78,
				-123
			],
			[
				-108,
				-54
			]
		],
		[
			[
				5400,
				1836
			],
			[
				-70,
				10
			]
		],
		[
			[
				5308,
				1849
			],
			[
				-53,
				2
			]
		],
		[
			[
				5255,
				1851
			],
			[
				-30,
				37
			]
		],
		[
			[
				5225,
				1888
			],
			[
				18,
				39
			]
		],
		[
			[
				5243,
				1927
			],
			[
				-15,
				128
			],
			[
				90,
				56
			]
		],
		[
			[
				5318,
				2111
			],
			[
				22,
				15
			]
		],
		[
			[
				5340,
				2126
			],
			[
				32,
				18
			]
		],
		[
			[
				5372,
				2144
			],
			[
				54,
				30
			]
		],
		[
			[
				5658,
				3041
			],
			[
				-6,
				-10
			]
		],
		[
			[
				5652,
				3031
			],
			[
				60,
				-97
			]
		],
		[
			[
				5712,
				2934
			],
			[
				-12,
				-59
			]
		],
		[
			[
				5700,
				2875
			],
			[
				-46,
				-94
			]
		],
		[
			[
				5637,
				2755
			],
			[
				-51,
				1
			],
			[
				-45,
				-13
			],
			[
				-44,
				-22
			]
		],
		[
			[
				5497,
				2721
			],
			[
				-110,
				23
			]
		],
		[
			[
				5387,
				2744
			],
			[
				-73,
				16
			]
		],
		[
			[
				5314,
				2760
			],
			[
				-96,
				-73
			]
		],
		[
			[
				5218,
				2687
			],
			[
				-13,
				46
			]
		],
		[
			[
				5205,
				2733
			],
			[
				-32,
				105
			]
		],
		[
			[
				5173,
				2838
			],
			[
				-81,
				-49
			]
		],
		[
			[
				5092,
				2789
			],
			[
				-46,
				-6
			]
		],
		[
			[
				5046,
				2783
			],
			[
				-44,
				-4
			]
		],
		[
			[
				5002,
				2779
			],
			[
				-33,
				62
			],
			[
				61,
				71
			]
		],
		[
			[
				5030,
				2912
			],
			[
				13,
				-14
			],
			[
				49,
				1
			]
		],
		[
			[
				5591,
				3128
			],
			[
				44,
				-97
			]
		],
		[
			[
				2992,
				3199
			],
			[
				62,
				-53
			]
		],
		[
			[
				3054,
				3146
			],
			[
				29,
				11
			]
		],
		[
			[
				3083,
				3157
			],
			[
				7,
				-12
			]
		],
		[
			[
				2886,
				3057
			],
			[
				-84,
				-2
			],
			[
				-66,
				-58
			],
			[
				-52,
				39
			]
		],
		[
			[
				2684,
				3036
			],
			[
				1,
				61
			],
			[
				31,
				65
			]
		],
		[
			[
				3534,
				4615
			],
			[
				-2,
				-111
			]
		],
		[
			[
				3532,
				4504
			],
			[
				-133,
				-6
			]
		],
		[
			[
				3399,
				4498
			],
			[
				-16,
				-56
			]
		],
		[
			[
				3383,
				4442
			],
			[
				-67,
				-109
			]
		],
		[
			[
				3316,
				4333
			],
			[
				-173,
				26
			]
		],
		[
			[
				3143,
				4359
			],
			[
				-63,
				-23
			]
		],
		[
			[
				3080,
				4336
			],
			[
				-77,
				82
			]
		],
		[
			[
				3003,
				4418
			],
			[
				-4,
				83
			]
		],
		[
			[
				2999,
				4501
			],
			[
				-18,
				67
			]
		],
		[
			[
				2981,
				4568
			],
			[
				-23,
				39
			]
		],
		[
			[
				2958,
				4607
			],
			[
				80,
				37
			]
		],
		[
			[
				3038,
				4644
			],
			[
				35,
				51
			]
		],
		[
			[
				3073,
				4695
			],
			[
				42,
				4
			]
		],
		[
			[
				3115,
				4699
			],
			[
				56,
				21
			]
		],
		[
			[
				3171,
				4720
			],
			[
				36,
				50
			]
		],
		[
			[
				3207,
				4770
			],
			[
				49,
				-18
			]
		],
		[
			[
				3256,
				4752
			],
			[
				57,
				23
			]
		],
		[
			[
				3313,
				4775
			],
			[
				13,
				19
			]
		],
		[
			[
				3326,
				4794
			],
			[
				139,
				-22
			]
		],
		[
			[
				4218,
				2349
			],
			[
				20,
				-33
			]
		],
		[
			[
				4238,
				2316
			],
			[
				51,
				-38
			]
		],
		[
			[
				4289,
				2278
			],
			[
				24,
				12
			]
		],
		[
			[
				4313,
				2290
			],
			[
				30,
				-34
			]
		],
		[
			[
				4343,
				2256
			],
			[
				-75,
				-223
			]
		],
		[
			[
				4268,
				2033
			],
			[
				-19,
				-36
			]
		],
		[
			[
				4111,
				1997
			],
			[
				-49,
				29
			]
		],
		[
			[
				3982,
				1987
			],
			[
				1,
				43
			]
		],
		[
			[
				3983,
				2030
			],
			[
				-40,
				48
			]
		],
		[
			[
				3943,
				2078
			],
			[
				103,
				20
			]
		],
		[
			[
				4046,
				2098
			],
			[
				80,
				133
			],
			[
				64,
				33
			],
			[
				-11,
				92
			]
		],
		[
			[
				4179,
				2356
			],
			[
				46,
				8
			]
		],
		[
			[
				4225,
				2364
			],
			[
				-7,
				-15
			]
		],
		[
			[
				4488,
				2628
			],
			[
				25,
				-51
			]
		],
		[
			[
				4513,
				2577
			],
			[
				76,
				9
			]
		],
		[
			[
				4589,
				2586
			],
			[
				9,
				-75
			],
			[
				19,
				-41
			],
			[
				-15,
				-46
			]
		],
		[
			[
				4602,
				2424
			],
			[
				-121,
				-97
			]
		],
		[
			[
				4481,
				2327
			],
			[
				-66,
				-31
			]
		],
		[
			[
				4415,
				2296
			],
			[
				-68,
				7
			]
		],
		[
			[
				4347,
				2303
			],
			[
				-34,
				-13
			]
		],
		[
			[
				4289,
				2278
			],
			[
				-51,
				38
			]
		],
		[
			[
				4238,
				2316
			],
			[
				-20,
				33
			]
		],
		[
			[
				4225,
				2364
			],
			[
				-31,
				58
			]
		],
		[
			[
				4194,
				2422
			],
			[
				-66,
				166
			],
			[
				26,
				32
			]
		],
		[
			[
				4154,
				2620
			],
			[
				-16,
				32
			]
		],
		[
			[
				4138,
				2652
			],
			[
				46,
				14
			]
		],
		[
			[
				4184,
				2666
			],
			[
				22,
				-1
			],
			[
				30,
				16
			],
			[
				20,
				-2
			]
		],
		[
			[
				4256,
				2679
			],
			[
				2,
				-12
			]
		],
		[
			[
				4258,
				2667
			],
			[
				107,
				33
			]
		],
		[
			[
				4365,
				2700
			],
			[
				57,
				-7
			]
		],
		[
			[
				4422,
				2693
			],
			[
				66,
				-65
			]
		],
		[
			[
				4111,
				3096
			],
			[
				11,
				-14
			],
			[
				37,
				-11
			]
		],
		[
			[
				4159,
				3071
			],
			[
				11,
				-17
			]
		],
		[
			[
				4170,
				3054
			],
			[
				9,
				-65
			]
		],
		[
			[
				4179,
				2989
			],
			[
				-6,
				-11
			]
		],
		[
			[
				4173,
				2978
			],
			[
				-56,
				-106
			],
			[
				-57,
				19
			],
			[
				-152,
				-35
			],
			[
				-75,
				19
			]
		],
		[
			[
				3833,
				2875
			],
			[
				-22,
				16
			]
		],
		[
			[
				3811,
				2891
			],
			[
				-8,
				60
			]
		],
		[
			[
				3803,
				2951
			],
			[
				56,
				72
			]
		],
		[
			[
				3859,
				3023
			],
			[
				16,
				49
			]
		],
		[
			[
				3875,
				3072
			],
			[
				12,
				-3
			]
		],
		[
			[
				3887,
				3069
			],
			[
				66,
				3
			]
		],
		[
			[
				1998,
				2001
			],
			[
				15,
				-191
			],
			[
				-82,
				-54
			]
		],
		[
			[
				1931,
				1756
			],
			[
				5,
				-16
			]
		],
		[
			[
				1936,
				1740
			],
			[
				-64,
				40
			],
			[
				-176,
				22
			]
		],
		[
			[
				1696,
				1802
			],
			[
				-37,
				-21
			]
		],
		[
			[
				1659,
				1781
			],
			[
				16,
				-22
			]
		],
		[
			[
				1675,
				1759
			],
			[
				-80,
				-38
			]
		],
		[
			[
				1595,
				1721
			],
			[
				-2,
				56
			]
		],
		[
			[
				1593,
				1777
			],
			[
				-43,
				32
			]
		],
		[
			[
				1568,
				1877
			],
			[
				37,
				10
			]
		],
		[
			[
				1776,
				1959
			],
			[
				20,
				17
			]
		],
		[
			[
				1796,
				1976
			],
			[
				131,
				10
			]
		],
		[
			[
				1927,
				1986
			],
			[
				71,
				15
			]
		],
		[
			[
				2549,
				1903
			],
			[
				-2,
				-22
			]
		],
		[
			[
				2547,
				1881
			],
			[
				-121,
				-37
			]
		],
		[
			[
				2426,
				1844
			],
			[
				-47,
				-44
			]
		],
		[
			[
				2379,
				1800
			],
			[
				-11,
				15
			]
		],
		[
			[
				2368,
				1815
			],
			[
				-18,
				-2
			]
		],
		[
			[
				2350,
				1813
			],
			[
				-46,
				167
			]
		],
		[
			[
				2304,
				1980
			],
			[
				41,
				55
			]
		],
		[
			[
				2345,
				2035
			],
			[
				102,
				28
			]
		],
		[
			[
				2447,
				2063
			],
			[
				65,
				15
			]
		],
		[
			[
				2512,
				2078
			],
			[
				49,
				-170
			]
		],
		[
			[
				3422,
				1951
			],
			[
				20,
				4
			]
		],
		[
			[
				3442,
				1955
			],
			[
				-61,
				-88
			]
		],
		[
			[
				3381,
				1867
			],
			[
				-115,
				-40
			]
		],
		[
			[
				3266,
				1827
			],
			[
				-102,
				-2
			]
		],
		[
			[
				3164,
				1825
			],
			[
				-35,
				37
			]
		],
		[
			[
				3129,
				1862
			],
			[
				18,
				42
			]
		],
		[
			[
				3147,
				1904
			],
			[
				29,
				51
			]
		],
		[
			[
				3176,
				1955
			],
			[
				64,
				-41
			]
		],
		[
			[
				3240,
				1914
			],
			[
				68,
				-1
			],
			[
				81,
				60
			]
		],
		[
			[
				3389,
				1973
			],
			[
				33,
				-22
			]
		],
		[
			[
				4797,
				6711
			],
			[
				72,
				-36
			]
		],
		[
			[
				4869,
				6675
			],
			[
				-74,
				-69
			]
		],
		[
			[
				4795,
				6606
			],
			[
				22,
				-55
			]
		],
		[
			[
				4817,
				6551
			],
			[
				-45,
				-12
			]
		],
		[
			[
				4772,
				6539
			],
			[
				-80,
				-42
			]
		],
		[
			[
				4692,
				6497
			],
			[
				-60,
				-13
			]
		],
		[
			[
				4632,
				6484
			],
			[
				-71,
				-67
			]
		],
		[
			[
				4561,
				6417
			],
			[
				-7,
				23
			]
		],
		[
			[
				4445,
				6827
			],
			[
				-40,
				9
			]
		],
		[
			[
				4405,
				6836
			],
			[
				48,
				114
			]
		],
		[
			[
				4453,
				6950
			],
			[
				72,
				2
			]
		],
		[
			[
				3774,
				6018
			],
			[
				107,
				-33
			]
		],
		[
			[
				3881,
				5985
			],
			[
				9,
				4
			]
		],
		[
			[
				3890,
				5989
			],
			[
				91,
				-69
			],
			[
				16,
				-110
			]
		],
		[
			[
				3997,
				5810
			],
			[
				-12,
				-58
			]
		],
		[
			[
				3985,
				5752
			],
			[
				-107,
				-166
			]
		],
		[
			[
				3878,
				5586
			],
			[
				-6,
				20
			]
		],
		[
			[
				3847,
				5630
			],
			[
				-58,
				-41
			]
		],
		[
			[
				3789,
				5589
			],
			[
				-36,
				-14
			]
		],
		[
			[
				3753,
				5575
			],
			[
				-157,
				86
			]
		],
		[
			[
				3596,
				5661
			],
			[
				-43,
				-38
			]
		],
		[
			[
				3553,
				5623
			],
			[
				-49,
				28
			]
		],
		[
			[
				3504,
				5651
			],
			[
				-22,
				-15
			]
		],
		[
			[
				3331,
				5784
			],
			[
				56,
				49
			]
		],
		[
			[
				3720,
				5955
			],
			[
				54,
				63
			]
		],
		[
			[
				3266,
				1827
			],
			[
				25,
				-5
			]
		],
		[
			[
				3260,
				1672
			],
			[
				24,
				-35
			]
		],
		[
			[
				3284,
				1637
			],
			[
				-45,
				-1
			],
			[
				-33,
				-20
			]
		],
		[
			[
				3206,
				1616
			],
			[
				-21,
				33
			]
		],
		[
			[
				3185,
				1649
			],
			[
				-101,
				25
			]
		],
		[
			[
				3084,
				1674
			],
			[
				-75,
				83
			]
		],
		[
			[
				3009,
				1757
			],
			[
				45,
				52
			]
		],
		[
			[
				3054,
				1809
			],
			[
				75,
				53
			]
		],
		[
			[
				3129,
				1862
			],
			[
				35,
				-37
			]
		],
		[
			[
				2906,
				6114
			],
			[
				102,
				-95
			]
		],
		[
			[
				3008,
				6019
			],
			[
				115,
				-41
			],
			[
				-94,
				-71
			]
		],
		[
			[
				2891,
				5811
			],
			[
				-3,
				-11
			]
		],
		[
			[
				2888,
				5800
			],
			[
				-101,
				19
			],
			[
				-32,
				72
			]
		],
		[
			[
				2755,
				5891
			],
			[
				-79,
				11
			]
		],
		[
			[
				2676,
				5902
			],
			[
				-5,
				14
			]
		],
		[
			[
				2671,
				5916
			],
			[
				57,
				208
			]
		],
		[
			[
				2728,
				6124
			],
			[
				39,
				26
			]
		],
		[
			[
				2767,
				6150
			],
			[
				-8,
				11
			]
		],
		[
			[
				2759,
				6161
			],
			[
				62,
				81
			]
		],
		[
			[
				2821,
				6242
			],
			[
				20,
				6
			]
		],
		[
			[
				2841,
				6248
			],
			[
				65,
				-134
			]
		],
		[
			[
				3838,
				2222
			],
			[
				4,
				141
			]
		],
		[
			[
				3842,
				2363
			],
			[
				-23,
				27
			]
		],
		[
			[
				3819,
				2390
			],
			[
				14,
				4
			],
			[
				12,
				24
			],
			[
				43,
				11
			],
			[
				54,
				-42
			],
			[
				151,
				40
			],
			[
				62,
				-38
			]
		],
		[
			[
				4155,
				2389
			],
			[
				24,
				-33
			]
		],
		[
			[
				4046,
				2098
			],
			[
				-118,
				3
			]
		],
		[
			[
				3928,
				2101
			],
			[
				-37,
				58
			],
			[
				-69,
				19
			]
		],
		[
			[
				3822,
				2178
			],
			[
				16,
				44
			]
		],
		[
			[
				5019,
				3016
			],
			[
				14,
				-54
			]
		],
		[
			[
				5049,
				2897
			],
			[
				-19,
				15
			]
		],
		[
			[
				5002,
				2779
			],
			[
				-43,
				-136
			]
		],
		[
			[
				4959,
				2643
			],
			[
				-52,
				29
			]
		],
		[
			[
				4907,
				2672
			],
			[
				-87,
				-13
			]
		],
		[
			[
				4820,
				2659
			],
			[
				-156,
				-45
			]
		],
		[
			[
				4664,
				2614
			],
			[
				-19,
				10
			]
		],
		[
			[
				4645,
				2624
			],
			[
				52,
				59
			],
			[
				-27,
				122
			],
			[
				41,
				122
			]
		],
		[
			[
				4711,
				2927
			],
			[
				75,
				60
			]
		],
		[
			[
				4934,
				3015
			],
			[
				85,
				1
			]
		],
		[
			[
				4820,
				2659
			],
			[
				87,
				13
			]
		],
		[
			[
				4959,
				2643
			],
			[
				-2,
				-13
			]
		],
		[
			[
				4926,
				2418
			],
			[
				-21,
				-55
			]
		],
		[
			[
				4760,
				2367
			],
			[
				-158,
				57
			]
		],
		[
			[
				4589,
				2586
			],
			[
				10,
				-4
			]
		],
		[
			[
				4599,
				2582
			],
			[
				65,
				32
			]
		],
		[
			[
				4434,
				2960
			],
			[
				-27,
				-15
			]
		],
		[
			[
				4407,
				2945
			],
			[
				-7,
				-26
			]
		],
		[
			[
				4400,
				2919
			],
			[
				-84,
				-12
			],
			[
				-103,
				-151
			],
			[
				34,
				-53
			]
		],
		[
			[
				4247,
				2703
			],
			[
				9,
				-24
			]
		],
		[
			[
				4256,
				2679
			],
			[
				-72,
				-13
			]
		],
		[
			[
				4138,
				2652
			],
			[
				-26,
				-10
			]
		],
		[
			[
				4112,
				2642
			],
			[
				-76,
				-38
			]
		],
		[
			[
				4036,
				2604
			],
			[
				-76,
				-40
			]
		],
		[
			[
				3960,
				2564
			],
			[
				-49,
				82
			]
		],
		[
			[
				3911,
				2646
			],
			[
				2,
				95
			],
			[
				-135,
				1
			]
		],
		[
			[
				3778,
				2742
			],
			[
				14,
				71
			]
		],
		[
			[
				3792,
				2813
			],
			[
				14,
				25
			]
		],
		[
			[
				3806,
				2838
			],
			[
				27,
				37
			]
		],
		[
			[
				4173,
				2978
			],
			[
				44,
				-35
			]
		],
		[
			[
				4217,
				2943
			],
			[
				129,
				48
			]
		],
		[
			[
				4346,
				2991
			],
			[
				29,
				24
			]
		],
		[
			[
				4375,
				3015
			],
			[
				59,
				-55
			]
		],
		[
			[
				5972,
				4269
			],
			[
				28,
				-3
			]
		],
		[
			[
				6000,
				4266
			],
			[
				19,
				-96
			],
			[
				-57,
				-76
			],
			[
				46,
				-211
			]
		],
		[
			[
				6008,
				3883
			],
			[
				12,
				-55
			]
		],
		[
			[
				6020,
				3828
			],
			[
				-51,
				-150
			],
			[
				-129,
				105
			]
		],
		[
			[
				5840,
				3783
			],
			[
				-48,
				6
			]
		],
		[
			[
				5792,
				3789
			],
			[
				-43,
				50
			]
		],
		[
			[
				5749,
				3839
			],
			[
				-8,
				-27
			]
		],
		[
			[
				5741,
				3812
			],
			[
				-107,
				88
			],
			[
				-159,
				-21
			],
			[
				-22,
				-105
			]
		],
		[
			[
				5453,
				3774
			],
			[
				-51,
				-13
			]
		],
		[
			[
				5402,
				3761
			],
			[
				-17,
				-22
			]
		],
		[
			[
				5385,
				3739
			],
			[
				-28,
				5
			]
		],
		[
			[
				5357,
				3744
			],
			[
				-6,
				118
			],
			[
				76,
				82
			],
			[
				-61,
				44
			]
		],
		[
			[
				5366,
				3988
			],
			[
				71,
				56
			]
		],
		[
			[
				5437,
				4044
			],
			[
				-18,
				102
			]
		],
		[
			[
				5419,
				4146
			],
			[
				65,
				100
			],
			[
				57,
				7
			]
		],
		[
			[
				5541,
				4253
			],
			[
				12,
				35
			]
		],
		[
			[
				5553,
				4288
			],
			[
				69,
				34
			]
		],
		[
			[
				5622,
				4322
			],
			[
				51,
				-17
			]
		],
		[
			[
				4481,
				2327
			],
			[
				60,
				-62
			],
			[
				-4,
				-83
			],
			[
				-142,
				-219
			],
			[
				-94,
				-21
			],
			[
				-38,
				47
			]
		],
		[
			[
				4263,
				1989
			],
			[
				5,
				44
			]
		],
		[
			[
				4343,
				2256
			],
			[
				4,
				47
			]
		],
		[
			[
				4347,
				2303
			],
			[
				68,
				-7
			]
		],
		[
			[
				4420,
				3553
			],
			[
				12,
				32
			]
		],
		[
			[
				4432,
				3585
			],
			[
				65,
				-21
			],
			[
				59,
				15
			],
			[
				8,
				15
			]
		],
		[
			[
				4564,
				3594
			],
			[
				5,
				-39
			]
		],
		[
			[
				4655,
				3281
			],
			[
				-37,
				-33
			]
		],
		[
			[
				4618,
				3248
			],
			[
				-186,
				-18
			]
		],
		[
			[
				4432,
				3230
			],
			[
				-58,
				67
			]
		],
		[
			[
				4374,
				3297
			],
			[
				57,
				177
			],
			[
				-11,
				79
			]
		],
		[
			[
				4400,
				2919
			],
			[
				77,
				-118
			]
		],
		[
			[
				4477,
				2801
			],
			[
				4,
				-39
			]
		],
		[
			[
				4481,
				2762
			],
			[
				-59,
				-69
			]
		],
		[
			[
				4422,
				2693
			],
			[
				-57,
				7
			]
		],
		[
			[
				4258,
				2667
			],
			[
				-11,
				36
			]
		],
		[
			[
				4662,
				2955
			],
			[
				19,
				13
			]
		],
		[
			[
				4696,
				2960
			],
			[
				15,
				-33
			]
		],
		[
			[
				4645,
				2624
			],
			[
				-46,
				-42
			]
		],
		[
			[
				4599,
				2582
			],
			[
				-42,
				6
			],
			[
				-44,
				-11
			]
		],
		[
			[
				4488,
				2628
			],
			[
				-7,
				134
			]
		],
		[
			[
				4477,
				2801
			],
			[
				-77,
				118
			]
		],
		[
			[
				4407,
				2945
			],
			[
				113,
				10
			]
		],
		[
			[
				4520,
				2955
			],
			[
				87,
				32
			]
		],
		[
			[
				4607,
				2987
			],
			[
				55,
				-32
			]
		],
		[
			[
				5497,
				2721
			],
			[
				76,
				27
			]
		],
		[
			[
				5590,
				2701
			],
			[
				50,
				-71
			]
		],
		[
			[
				5635,
				2558
			],
			[
				-6,
				-110
			]
		],
		[
			[
				5629,
				2448
			],
			[
				-89,
				29
			]
		],
		[
			[
				5540,
				2477
			],
			[
				-2,
				30
			]
		],
		[
			[
				5538,
				2507
			],
			[
				-76,
				26
			]
		],
		[
			[
				5462,
				2533
			],
			[
				29,
				-15
			]
		],
		[
			[
				5491,
				2518
			],
			[
				-72,
				-66
			]
		],
		[
			[
				5419,
				2452
			],
			[
				-68,
				102
			]
		],
		[
			[
				5351,
				2554
			],
			[
				-30,
				-1
			]
		],
		[
			[
				5321,
				2553
			],
			[
				-76,
				11
			]
		],
		[
			[
				5204,
				2714
			],
			[
				14,
				-27
			]
		],
		[
			[
				5218,
				2687
			],
			[
				96,
				73
			]
		],
		[
			[
				5314,
				2760
			],
			[
				73,
				-16
			]
		],
		[
			[
				3778,
				2455
			],
			[
				41,
				-48
			]
		],
		[
			[
				3819,
				2407
			],
			[
				2,
				-24
			],
			[
				21,
				-20
			]
		],
		[
			[
				3838,
				2222
			],
			[
				-19,
				-34
			],
			[
				-1,
				-28
			]
		],
		[
			[
				3818,
				2160
			],
			[
				-19,
				-2
			]
		],
		[
			[
				3799,
				2158
			],
			[
				-34,
				-27
			]
		],
		[
			[
				3765,
				2131
			],
			[
				-21,
				-64
			]
		],
		[
			[
				3744,
				2067
			],
			[
				-45,
				-21
			]
		],
		[
			[
				3699,
				2046
			],
			[
				-21,
				34
			]
		],
		[
			[
				3678,
				2080
			],
			[
				-86,
				42
			]
		],
		[
			[
				3592,
				2122
			],
			[
				0,
				36
			]
		],
		[
			[
				3592,
				2158
			],
			[
				-33,
				4
			]
		],
		[
			[
				3559,
				2162
			],
			[
				-23,
				86
			],
			[
				-98,
				45
			]
		],
		[
			[
				3438,
				2293
			],
			[
				50,
				39
			]
		],
		[
			[
				3488,
				2332
			],
			[
				149,
				70
			]
		],
		[
			[
				3637,
				2402
			],
			[
				19,
				58
			]
		],
		[
			[
				3656,
				2460
			],
			[
				31,
				-5
			],
			[
				91,
				0
			]
		],
		[
			[
				3685,
				2980
			],
			[
				3,
				-22
			]
		],
		[
			[
				3688,
				2958
			],
			[
				115,
				-7
			]
		],
		[
			[
				3811,
				2891
			],
			[
				-5,
				-53
			]
		],
		[
			[
				3792,
				2813
			],
			[
				-50,
				-100
			]
		],
		[
			[
				3742,
				2713
			],
			[
				-132,
				-66
			]
		],
		[
			[
				3610,
				2647
			],
			[
				-68,
				-26
			]
		],
		[
			[
				3542,
				2621
			],
			[
				-79,
				-60
			]
		],
		[
			[
				3463,
				2561
			],
			[
				-71,
				-11
			]
		],
		[
			[
				3392,
				2550
			],
			[
				-74,
				58
			],
			[
				68,
				77
			],
			[
				-16,
				34
			]
		],
		[
			[
				3392,
				2729
			],
			[
				17,
				67
			]
		],
		[
			[
				3441,
				2773
			],
			[
				51,
				83
			]
		],
		[
			[
				3492,
				2856
			],
			[
				82,
				27
			]
		],
		[
			[
				3574,
				2883
			],
			[
				45,
				64
			]
		],
		[
			[
				3619,
				2947
			],
			[
				66,
				33
			]
		],
		[
			[
				3559,
				2162
			],
			[
				33,
				-4
			]
		],
		[
			[
				3592,
				2158
			],
			[
				0,
				-36
			]
		],
		[
			[
				3678,
				2080
			],
			[
				-64,
				-37
			]
		],
		[
			[
				3614,
				2043
			],
			[
				-93,
				-149
			]
		],
		[
			[
				3521,
				1894
			],
			[
				-79,
				61
			]
		],
		[
			[
				3422,
				1951
			],
			[
				-33,
				22
			]
		],
		[
			[
				3389,
				1973
			],
			[
				53,
				208
			]
		],
		[
			[
				3442,
				2181
			],
			[
				-4,
				112
			]
		],
		[
			[
				1936,
				1740
			],
			[
				47,
				-83
			]
		],
		[
			[
				1722,
				1455
			],
			[
				1,
				-11
			]
		],
		[
			[
				1723,
				1444
			],
			[
				-78,
				-6
			]
		],
		[
			[
				1645,
				1438
			],
			[
				-53,
				22
			]
		],
		[
			[
				1592,
				1460
			],
			[
				-18,
				113
			]
		],
		[
			[
				1574,
				1573
			],
			[
				8,
				70
			]
		],
		[
			[
				1582,
				1643
			],
			[
				21,
				67
			]
		],
		[
			[
				1603,
				1710
			],
			[
				72,
				49
			]
		],
		[
			[
				1659,
				1781
			],
			[
				37,
				21
			]
		],
		[
			[
				911,
				5300
			],
			[
				-37,
				-56
			]
		],
		[
			[
				874,
				5244
			],
			[
				27,
				-71
			]
		],
		[
			[
				901,
				5173
			],
			[
				9,
				-12
			]
		],
		[
			[
				910,
				5161
			],
			[
				-18,
				-32
			]
		],
		[
			[
				892,
				5129
			],
			[
				-11,
				-36
			]
		],
		[
			[
				881,
				5093
			],
			[
				-46,
				-4
			],
			[
				-70,
				-51
			],
			[
				-18,
				-63
			],
			[
				5,
				-12
			]
		],
		[
			[
				752,
				4963
			],
			[
				-45,
				-36
			]
		],
		[
			[
				707,
				4927
			],
			[
				-193,
				182
			],
			[
				8,
				41
			]
		],
		[
			[
				522,
				5150
			],
			[
				39,
				-10
			],
			[
				101,
				166
			],
			[
				87,
				91
			]
		],
		[
			[
				749,
				5397
			],
			[
				49,
				-1
			],
			[
				106,
				-80
			],
			[
				7,
				-16
			]
		],
		[
			[
				2102,
				2053
			],
			[
				60,
				-47
			],
			[
				69,
				58
			]
		],
		[
			[
				2231,
				2064
			],
			[
				3,
				18
			]
		],
		[
			[
				2234,
				2082
			],
			[
				19,
				17
			],
			[
				42,
				-70
			],
			[
				31,
				-20
			]
		],
		[
			[
				2326,
				2009
			],
			[
				-22,
				-29
			]
		],
		[
			[
				2350,
				1813
			],
			[
				-17,
				-72
			]
		],
		[
			[
				2258,
				1715
			],
			[
				-37,
				-60
			]
		],
		[
			[
				2232,
				1647
			],
			[
				-65,
				-115
			]
		],
		[
			[
				1968,
				1674
			],
			[
				-37,
				82
			]
		],
		[
			[
				1998,
				2001
			],
			[
				-48,
				4
			]
		],
		[
			[
				1950,
				2005
			],
			[
				99,
				104
			]
		],
		[
			[
				2049,
				2109
			],
			[
				53,
				-56
			]
		],
		[
			[
				3310,
				2618
			],
			[
				82,
				-68
			]
		],
		[
			[
				3463,
				2561
			],
			[
				55,
				-11
			]
		],
		[
			[
				3518,
				2550
			],
			[
				45,
				-81
			],
			[
				78,
				32
			]
		],
		[
			[
				3641,
				2501
			],
			[
				15,
				-41
			]
		],
		[
			[
				3656,
				2460
			],
			[
				-19,
				-58
			]
		],
		[
			[
				3488,
				2332
			],
			[
				-54,
				-41
			]
		],
		[
			[
				3434,
				2291
			],
			[
				-81,
				47
			]
		],
		[
			[
				3353,
				2338
			],
			[
				-21,
				3
			],
			[
				-3,
				15
			],
			[
				-50,
				37
			],
			[
				-41,
				-14
			]
		],
		[
			[
				3238,
				2379
			],
			[
				-56,
				15
			]
		],
		[
			[
				3182,
				2394
			],
			[
				11,
				25
			]
		],
		[
			[
				3193,
				2419
			],
			[
				-19,
				19
			]
		],
		[
			[
				3174,
				2438
			],
			[
				7,
				23
			]
		],
		[
			[
				3699,
				3386
			],
			[
				52,
				10
			]
		],
		[
			[
				3853,
				3243
			],
			[
				16,
				-9
			]
		],
		[
			[
				3895,
				3170
			],
			[
				23,
				22
			]
		],
		[
			[
				3903,
				3094
			],
			[
				-16,
				-25
			]
		],
		[
			[
				3875,
				3072
			],
			[
				-16,
				-49
			]
		],
		[
			[
				3803,
				2951
			],
			[
				-115,
				7
			]
		],
		[
			[
				3685,
				2980
			],
			[
				-66,
				-33
			]
		],
		[
			[
				3574,
				2883
			],
			[
				-88,
				-1
			]
		],
		[
			[
				3415,
				2986
			],
			[
				-3,
				68
			]
		],
		[
			[
				3412,
				3054
			],
			[
				59,
				33
			]
		],
		[
			[
				3471,
				3087
			],
			[
				48,
				102
			],
			[
				76,
				15
			],
			[
				44,
				90
			]
		],
		[
			[
				3639,
				3294
			],
			[
				-13,
				58
			]
		],
		[
			[
				3626,
				3352
			],
			[
				73,
				67
			]
		],
		[
			[
				3699,
				3419
			],
			[
				0,
				-33
			]
		],
		[
			[
				2636,
				3456
			],
			[
				26,
				-96
			]
		],
		[
			[
				2662,
				3360
			],
			[
				2,
				-27
			]
		],
		[
			[
				2624,
				3338
			],
			[
				-36,
				-79
			]
		],
		[
			[
				2588,
				3259
			],
			[
				-79,
				-25
			]
		],
		[
			[
				2509,
				3234
			],
			[
				-63,
				71
			],
			[
				72,
				123
			]
		],
		[
			[
				2518,
				3428
			],
			[
				27,
				21
			]
		],
		[
			[
				2570,
				3458
			],
			[
				66,
				-2
			]
		],
		[
			[
				1505,
				4943
			],
			[
				46,
				-40
			]
		],
		[
			[
				1551,
				4903
			],
			[
				62,
				-1
			]
		],
		[
			[
				1613,
				4902
			],
			[
				4,
				-106
			],
			[
				79,
				31
			]
		],
		[
			[
				1696,
				4827
			],
			[
				6,
				-109
			]
		],
		[
			[
				1702,
				4718
			],
			[
				7,
				-19
			]
		],
		[
			[
				1709,
				4699
			],
			[
				-37,
				-99
			]
		],
		[
			[
				1672,
				4600
			],
			[
				-17,
				-25
			]
		],
		[
			[
				1655,
				4575
			],
			[
				-67,
				25
			]
		],
		[
			[
				1588,
				4600
			],
			[
				-93,
				-16
			]
		],
		[
			[
				1495,
				4584
			],
			[
				-58,
				79
			]
		],
		[
			[
				1437,
				4663
			],
			[
				-10,
				102
			]
		],
		[
			[
				1427,
				4765
			],
			[
				26,
				4
			]
		],
		[
			[
				1453,
				4769
			],
			[
				-39,
				119
			],
			[
				83,
				64
			]
		],
		[
			[
				1497,
				4952
			],
			[
				8,
				-9
			]
		],
		[
			[
				1965,
				3573
			],
			[
				76,
				4
			],
			[
				14,
				-143
			]
		],
		[
			[
				2055,
				3434
			],
			[
				163,
				-65
			]
		],
		[
			[
				2218,
				3369
			],
			[
				-10,
				-91
			]
		],
		[
			[
				2208,
				3278
			],
			[
				11,
				-26
			]
		],
		[
			[
				2219,
				3252
			],
			[
				-70,
				1
			],
			[
				-21,
				-82
			],
			[
				-109,
				-34
			]
		],
		[
			[
				2019,
				3137
			],
			[
				-13,
				64
			]
		],
		[
			[
				1810,
				3284
			],
			[
				-32,
				26
			]
		],
		[
			[
				1778,
				3310
			],
			[
				15,
				84
			]
		],
		[
			[
				1793,
				3394
			],
			[
				43,
				19
			]
		],
		[
			[
				1836,
				3413
			],
			[
				6,
				180
			]
		],
		[
			[
				1842,
				3593
			],
			[
				123,
				-20
			]
		],
		[
			[
				1691,
				2739
			],
			[
				141,
				35
			]
		],
		[
			[
				1832,
				2774
			],
			[
				55,
				-113
			]
		],
		[
			[
				1887,
				2661
			],
			[
				-105,
				-30
			]
		],
		[
			[
				1782,
				2631
			],
			[
				-72,
				-41
			]
		],
		[
			[
				1710,
				2590
			],
			[
				-32,
				-40
			],
			[
				-30,
				-8
			]
		],
		[
			[
				1648,
				2542
			],
			[
				-5,
				14
			]
		],
		[
			[
				1643,
				2556
			],
			[
				-31,
				15
			]
		],
		[
			[
				1612,
				2571
			],
			[
				-111,
				-12
			]
		],
		[
			[
				1501,
				2559
			],
			[
				-19,
				45
			]
		],
		[
			[
				1482,
				2604
			],
			[
				-81,
				78
			],
			[
				27,
				94
			]
		],
		[
			[
				1428,
				2776
			],
			[
				24,
				22
			],
			[
				28,
				59
			]
		],
		[
			[
				1546,
				2902
			],
			[
				38,
				3
			]
		],
		[
			[
				426,
				2887
			],
			[
				-32,
				-90
			]
		],
		[
			[
				394,
				2797
			],
			[
				-43,
				27
			]
		],
		[
			[
				351,
				2824
			],
			[
				-97,
				8
			]
		],
		[
			[
				254,
				2832
			],
			[
				-35,
				28
			]
		],
		[
			[
				219,
				2860
			],
			[
				2,
				51
			],
			[
				97,
				122
			],
			[
				124,
				30
			]
		],
		[
			[
				1260,
				2541
			],
			[
				43,
				-3
			]
		],
		[
			[
				1303,
				2538
			],
			[
				62,
				-36
			]
		],
		[
			[
				1365,
				2502
			],
			[
				9,
				2
			]
		],
		[
			[
				1374,
				2504
			],
			[
				14,
				-126
			]
		],
		[
			[
				1388,
				2378
			],
			[
				-42,
				-3
			]
		],
		[
			[
				1346,
				2375
			],
			[
				0,
				-79
			]
		],
		[
			[
				1346,
				2296
			],
			[
				-19,
				-87
			]
		],
		[
			[
				1327,
				2209
			],
			[
				-97,
				-9
			]
		],
		[
			[
				1230,
				2200
			],
			[
				-50,
				40
			]
		],
		[
			[
				1180,
				2240
			],
			[
				-106,
				-18
			]
		],
		[
			[
				1031,
				2323
			],
			[
				-43,
				26
			]
		],
		[
			[
				965,
				2328
			],
			[
				-10,
				27
			]
		],
		[
			[
				933,
				2364
			],
			[
				7,
				48
			]
		],
		[
			[
				940,
				2412
			],
			[
				36,
				45
			]
		],
		[
			[
				976,
				2457
			],
			[
				69,
				39
			]
		],
		[
			[
				1045,
				2496
			],
			[
				100,
				8
			]
		],
		[
			[
				1145,
				2504
			],
			[
				53,
				84
			]
		],
		[
			[
				1198,
				2588
			],
			[
				16,
				-34
			]
		],
		[
			[
				1214,
				2554
			],
			[
				46,
				-13
			]
		],
		[
			[
				738,
				2226
			],
			[
				48,
				14
			]
		],
		[
			[
				786,
				2240
			],
			[
				36,
				-33
			]
		],
		[
			[
				849,
				2116
			],
			[
				-53,
				-60
			]
		],
		[
			[
				796,
				2056
			],
			[
				-21,
				-16
			]
		],
		[
			[
				775,
				2040
			],
			[
				-122,
				-8
			],
			[
				-54,
				47
			]
		],
		[
			[
				599,
				2079
			],
			[
				4,
				12
			]
		],
		[
			[
				620,
				2172
			],
			[
				-14,
				47
			]
		],
		[
			[
				606,
				2219
			],
			[
				53,
				15
			]
		],
		[
			[
				659,
				2234
			],
			[
				79,
				-8
			]
		],
		[
			[
				1487,
				2464
			],
			[
				58,
				-127
			],
			[
				2,
				-91
			]
		],
		[
			[
				1547,
				2246
			],
			[
				40,
				-13
			]
		],
		[
			[
				1552,
				2165
			],
			[
				-15,
				-79
			]
		],
		[
			[
				1537,
				2086
			],
			[
				-75,
				-40
			]
		],
		[
			[
				1462,
				2046
			],
			[
				-19,
				16
			]
		],
		[
			[
				1352,
				2047
			],
			[
				-21,
				99
			]
		],
		[
			[
				1331,
				2146
			],
			[
				-40,
				39
			]
		],
		[
			[
				1291,
				2185
			],
			[
				36,
				24
			]
		],
		[
			[
				1346,
				2296
			],
			[
				0,
				79
			]
		],
		[
			[
				1388,
				2378
			],
			[
				24,
				40
			]
		],
		[
			[
				1412,
				2418
			],
			[
				48,
				45
			]
		],
		[
			[
				1460,
				2463
			],
			[
				27,
				1
			]
		],
		[
			[
				3928,
				2101
			],
			[
				15,
				-23
			]
		],
		[
			[
				3943,
				2078
			],
			[
				40,
				-48
			]
		],
		[
			[
				3983,
				2030
			],
			[
				-1,
				-35
			]
		],
		[
			[
				3849,
				1931
			],
			[
				-25,
				2
			]
		],
		[
			[
				3653,
				1829
			],
			[
				-56,
				-51
			]
		],
		[
			[
				3529,
				1843
			],
			[
				-8,
				51
			]
		],
		[
			[
				3614,
				2043
			],
			[
				85,
				3
			]
		],
		[
			[
				3744,
				2067
			],
			[
				21,
				64
			]
		],
		[
			[
				3765,
				2131
			],
			[
				34,
				27
			]
		],
		[
			[
				3818,
				2160
			],
			[
				4,
				18
			]
		],
		[
			[
				6045,
				6565
			],
			[
				104,
				-89
			],
			[
				144,
				-2
			],
			[
				46,
				-119
			]
		],
		[
			[
				6339,
				6355
			],
			[
				-9,
				-18
			]
		],
		[
			[
				6330,
				6337
			],
			[
				-110,
				-66
			]
		],
		[
			[
				6220,
				6271
			],
			[
				-1,
				-44
			]
		],
		[
			[
				6219,
				6227
			],
			[
				-95,
				-86
			]
		],
		[
			[
				6124,
				6141
			],
			[
				-128,
				8
			]
		],
		[
			[
				5996,
				6149
			],
			[
				-104,
				93
			]
		],
		[
			[
				5892,
				6242
			],
			[
				23,
				32
			]
		],
		[
			[
				5915,
				6274
			],
			[
				-42,
				19
			]
		],
		[
			[
				5873,
				6293
			],
			[
				-1,
				28
			]
		],
		[
			[
				5872,
				6321
			],
			[
				-64,
				66
			]
		],
		[
			[
				5808,
				6387
			],
			[
				25,
				24
			]
		],
		[
			[
				5833,
				6411
			],
			[
				16,
				22
			]
		],
		[
			[
				5849,
				6433
			],
			[
				38,
				-30
			]
		],
		[
			[
				5887,
				6403
			],
			[
				23,
				95
			]
		],
		[
			[
				5910,
				6498
			],
			[
				-27,
				55
			]
		],
		[
			[
				5883,
				6553
			],
			[
				22,
				9
			]
		],
		[
			[
				5905,
				6562
			],
			[
				99,
				44
			]
		],
		[
			[
				6004,
				6606
			],
			[
				41,
				-41
			]
		],
		[
			[
				7544,
				5867
			],
			[
				101,
				-35
			]
		],
		[
			[
				7645,
				5832
			],
			[
				22,
				33
			]
		],
		[
			[
				7667,
				5865
			],
			[
				33,
				16
			]
		],
		[
			[
				7700,
				5881
			],
			[
				35,
				-31
			]
		],
		[
			[
				7735,
				5850
			],
			[
				12,
				-126
			]
		],
		[
			[
				7747,
				5724
			],
			[
				13,
				-7
			]
		],
		[
			[
				7760,
				5717
			],
			[
				-18,
				-37
			]
		],
		[
			[
				7742,
				5680
			],
			[
				67,
				5
			]
		],
		[
			[
				7809,
				5685
			],
			[
				-34,
				-45
			],
			[
				26,
				-115
			],
			[
				-101,
				-73
			],
			[
				71,
				-84
			],
			[
				-11,
				-80
			]
		],
		[
			[
				7760,
				5288
			],
			[
				-28,
				-26
			]
		],
		[
			[
				7732,
				5262
			],
			[
				-84,
				60
			]
		],
		[
			[
				7648,
				5322
			],
			[
				-42,
				9
			]
		],
		[
			[
				7606,
				5331
			],
			[
				-104,
				-52
			]
		],
		[
			[
				7502,
				5279
			],
			[
				-37,
				115
			]
		],
		[
			[
				7465,
				5394
			],
			[
				31,
				105
			],
			[
				-4,
				136
			],
			[
				29,
				59
			]
		],
		[
			[
				7521,
				5694
			],
			[
				-27,
				45
			]
		],
		[
			[
				7494,
				5739
			],
			[
				-35,
				39
			]
		],
		[
			[
				7459,
				5778
			],
			[
				-14,
				67
			]
		],
		[
			[
				7445,
				5845
			],
			[
				47,
				31
			]
		],
		[
			[
				7492,
				5876
			],
			[
				52,
				-9
			]
		],
		[
			[
				5221,
				2464
			],
			[
				12,
				-37
			]
		],
		[
			[
				5233,
				2427
			],
			[
				-5,
				-89
			]
		],
		[
			[
				5228,
				2338
			],
			[
				-32,
				-1
			]
		],
		[
			[
				5196,
				2337
			],
			[
				60,
				-82
			]
		],
		[
			[
				5256,
				2255
			],
			[
				121,
				-1
			]
		],
		[
			[
				5377,
				2254
			],
			[
				-5,
				-110
			]
		],
		[
			[
				5340,
				2126
			],
			[
				-22,
				-15
			]
		],
		[
			[
				5243,
				1927
			],
			[
				-79,
				13
			]
		],
		[
			[
				5164,
				1940
			],
			[
				-77,
				-34
			],
			[
				-36,
				13
			],
			[
				15,
				75
			],
			[
				-43,
				59
			],
			[
				-83,
				-12
			]
		],
		[
			[
				4940,
				2041
			],
			[
				14,
				84
			]
		],
		[
			[
				4999,
				2356
			],
			[
				-29,
				31
			]
		],
		[
			[
				4970,
				2387
			],
			[
				-9,
				21
			]
		],
		[
			[
				4996,
				2433
			],
			[
				44,
				12
			]
		],
		[
			[
				5175,
				2412
			],
			[
				46,
				52
			]
		],
		[
			[
				2207,
				2422
			],
			[
				71,
				-47
			]
		],
		[
			[
				2278,
				2375
			],
			[
				38,
				-42
			]
		],
		[
			[
				2316,
				2333
			],
			[
				-36,
				-108
			]
		],
		[
			[
				2280,
				2225
			],
			[
				-74,
				-26
			]
		],
		[
			[
				2206,
				2199
			],
			[
				-35,
				-32
			]
		],
		[
			[
				2171,
				2167
			],
			[
				-110,
				112
			],
			[
				48,
				73
			]
		],
		[
			[
				2109,
				2352
			],
			[
				-79,
				27
			]
		],
		[
			[
				2030,
				2379
			],
			[
				48,
				72
			]
		],
		[
			[
				7956,
				6871
			],
			[
				50,
				-186
			],
			[
				-123,
				-115
			]
		],
		[
			[
				7883,
				6570
			],
			[
				-228,
				33
			]
		],
		[
			[
				7655,
				6603
			],
			[
				-29,
				63
			]
		],
		[
			[
				7626,
				6666
			],
			[
				6,
				42
			]
		],
		[
			[
				7632,
				6708
			],
			[
				72,
				-19
			]
		],
		[
			[
				7704,
				6689
			],
			[
				54,
				34
			]
		],
		[
			[
				7758,
				6723
			],
			[
				-6,
				98
			]
		],
		[
			[
				7752,
				6821
			],
			[
				-10,
				31
			]
		],
		[
			[
				7742,
				6852
			],
			[
				35,
				13
			]
		],
		[
			[
				7777,
				6865
			],
			[
				12,
				36
			]
		],
		[
			[
				7789,
				6901
			],
			[
				167,
				-30
			]
		],
		[
			[
				6783,
				6122
			],
			[
				68,
				-10
			],
			[
				73,
				16
			]
		],
		[
			[
				6924,
				6128
			],
			[
				30,
				-37
			],
			[
				11,
				-66
			]
		],
		[
			[
				6965,
				6025
			],
			[
				-23,
				-28
			],
			[
				-77,
				-22
			],
			[
				52,
				-78
			]
		],
		[
			[
				6917,
				5897
			],
			[
				-101,
				-14
			]
		],
		[
			[
				6755,
				5861
			],
			[
				-31,
				27
			]
		],
		[
			[
				6724,
				5888
			],
			[
				-94,
				83
			],
			[
				-135,
				-9
			]
		],
		[
			[
				6495,
				5962
			],
			[
				2,
				104
			]
		],
		[
			[
				6497,
				6066
			],
			[
				136,
				77
			]
		],
		[
			[
				6633,
				6143
			],
			[
				61,
				15
			]
		],
		[
			[
				6694,
				6158
			],
			[
				89,
				-36
			]
		],
		[
			[
				3668,
				4003
			],
			[
				61,
				-47
			]
		],
		[
			[
				3729,
				3956
			],
			[
				-12,
				-36
			]
		],
		[
			[
				3717,
				3920
			],
			[
				-11,
				-69
			],
			[
				44,
				-16
			]
		],
		[
			[
				3750,
				3835
			],
			[
				-19,
				-26
			]
		],
		[
			[
				3731,
				3809
			],
			[
				-26,
				-23
			]
		],
		[
			[
				3705,
				3786
			],
			[
				-27,
				-35
			]
		],
		[
			[
				3678,
				3751
			],
			[
				35,
				-50
			]
		],
		[
			[
				3713,
				3701
			],
			[
				-109,
				-14
			]
		],
		[
			[
				3604,
				3687
			],
			[
				-46,
				-58
			]
		],
		[
			[
				3558,
				3629
			],
			[
				-13,
				9
			]
		],
		[
			[
				3545,
				3638
			],
			[
				-36,
				37
			]
		],
		[
			[
				3509,
				3675
			],
			[
				-63,
				-46
			]
		],
		[
			[
				3446,
				3629
			],
			[
				-23,
				31
			]
		],
		[
			[
				3423,
				3660
			],
			[
				16,
				74
			]
		],
		[
			[
				3439,
				3734
			],
			[
				37,
				31
			]
		],
		[
			[
				3476,
				3765
			],
			[
				-22,
				104
			]
		],
		[
			[
				3454,
				3869
			],
			[
				-7,
				9
			]
		],
		[
			[
				3447,
				3878
			],
			[
				42,
				40
			]
		],
		[
			[
				3489,
				3918
			],
			[
				167,
				51
			]
		],
		[
			[
				3656,
				3969
			],
			[
				12,
				34
			]
		],
		[
			[
				1127,
				4633
			],
			[
				74,
				-13
			]
		],
		[
			[
				1201,
				4620
			],
			[
				58,
				-9
			]
		],
		[
			[
				1259,
				4611
			],
			[
				49,
				-66
			]
		],
		[
			[
				1308,
				4545
			],
			[
				60,
				-78
			]
		],
		[
			[
				1431,
				4392
			],
			[
				-23,
				-89
			]
		],
		[
			[
				1408,
				4303
			],
			[
				-72,
				6
			],
			[
				-74,
				25
			],
			[
				-11,
				-13
			]
		],
		[
			[
				1251,
				4321
			],
			[
				-154,
				144
			]
		],
		[
			[
				1097,
				4465
			],
			[
				-22,
				62
			]
		],
		[
			[
				1075,
				4527
			],
			[
				-21,
				101
			]
		],
		[
			[
				1054,
				4628
			],
			[
				73,
				5
			]
		],
		[
			[
				2034,
				6280
			],
			[
				-129,
				-91
			],
			[
				3,
				-97
			],
			[
				-61,
				-156
			],
			[
				12,
				-70
			]
		],
		[
			[
				1859,
				5866
			],
			[
				-40,
				23
			]
		],
		[
			[
				1819,
				5889
			],
			[
				-95,
				12
			]
		],
		[
			[
				1724,
				5901
			],
			[
				-53,
				-30
			]
		],
		[
			[
				1671,
				5871
			],
			[
				-5,
				-21
			]
		],
		[
			[
				1666,
				5850
			],
			[
				-88,
				118
			]
		],
		[
			[
				1578,
				5968
			],
			[
				-42,
				116
			],
			[
				-50,
				-6
			]
		],
		[
			[
				1486,
				6078
			],
			[
				13,
				62
			],
			[
				109,
				93
			],
			[
				216,
				66
			],
			[
				97,
				60
			],
			[
				113,
				-79
			]
		],
		[
			[
				4014,
				5271
			],
			[
				39,
				-60
			]
		],
		[
			[
				4053,
				5211
			],
			[
				22,
				-49
			]
		],
		[
			[
				4075,
				5162
			],
			[
				31,
				-66
			]
		],
		[
			[
				4106,
				5096
			],
			[
				30,
				-32
			]
		],
		[
			[
				4136,
				5064
			],
			[
				-5,
				-47
			]
		],
		[
			[
				3721,
				5031
			],
			[
				12,
				32
			]
		],
		[
			[
				3715,
				5083
			],
			[
				44,
				32
			]
		],
		[
			[
				3812,
				5183
			],
			[
				10,
				58
			]
		],
		[
			[
				3822,
				5241
			],
			[
				33,
				37
			]
		],
		[
			[
				3856,
				5293
			],
			[
				51,
				-26
			]
		],
		[
			[
				791,
				3034
			],
			[
				13,
				-20
			]
		],
		[
			[
				1011,
				2863
			],
			[
				-3,
				-40
			]
		],
		[
			[
				1008,
				2823
			],
			[
				12,
				-43
			]
		],
		[
			[
				1004,
				2777
			],
			[
				-21,
				-17
			]
		],
		[
			[
				983,
				2760
			],
			[
				-68,
				-102
			]
		],
		[
			[
				915,
				2658
			],
			[
				-77,
				-22
			]
		],
		[
			[
				838,
				2636
			],
			[
				-25,
				72
			]
		],
		[
			[
				813,
				2708
			],
			[
				-2,
				46
			]
		],
		[
			[
				700,
				2890
			],
			[
				-38,
				57
			],
			[
				4,
				26
			]
		],
		[
			[
				666,
				2973
			],
			[
				96,
				49
			],
			[
				29,
				12
			]
		],
		[
			[
				2453,
				7148
			],
			[
				-46,
				-107
			],
			[
				85,
				-163
			]
		],
		[
			[
				2492,
				6878
			],
			[
				-73,
				-55
			]
		],
		[
			[
				2419,
				6823
			],
			[
				-85,
				-141
			]
		],
		[
			[
				2334,
				6682
			],
			[
				-46,
				-10
			]
		],
		[
			[
				2288,
				6672
			],
			[
				-270,
				186
			],
			[
				-65,
				0
			],
			[
				17,
				121
			],
			[
				136,
				63
			],
			[
				23,
				134
			],
			[
				203,
				2
			],
			[
				54,
				35
			]
		],
		[
			[
				2386,
				7213
			],
			[
				67,
				-65
			]
		],
		[
			[
				7104,
				6798
			],
			[
				93,
				-123
			]
		],
		[
			[
				7197,
				6675
			],
			[
				3,
				-14
			]
		],
		[
			[
				7200,
				6661
			],
			[
				-34,
				-61
			],
			[
				-153,
				-76
			],
			[
				-53,
				-105
			]
		],
		[
			[
				6960,
				6419
			],
			[
				-8,
				-38
			]
		],
		[
			[
				6832,
				6438
			],
			[
				4,
				80
			]
		],
		[
			[
				6836,
				6518
			],
			[
				17,
				-7
			]
		],
		[
			[
				6853,
				6511
			],
			[
				8,
				90
			]
		],
		[
			[
				6861,
				6601
			],
			[
				17,
				30
			]
		],
		[
			[
				6878,
				6631
			],
			[
				-3,
				42
			]
		],
		[
			[
				6875,
				6673
			],
			[
				-19,
				57
			]
		],
		[
			[
				6856,
				6730
			],
			[
				7,
				74
			]
		],
		[
			[
				6863,
				6804
			],
			[
				50,
				-21
			]
		],
		[
			[
				6913,
				6783
			],
			[
				58,
				26
			]
		],
		[
			[
				6971,
				6809
			],
			[
				76,
				-10
			]
		],
		[
			[
				7047,
				6799
			],
			[
				18,
				26
			]
		],
		[
			[
				7065,
				6825
			],
			[
				39,
				-27
			]
		],
		[
			[
				3164,
				5292
			],
			[
				50,
				-12
			]
		],
		[
			[
				3214,
				5280
			],
			[
				86,
				-69
			]
		],
		[
			[
				3300,
				5211
			],
			[
				63,
				-28
			]
		],
		[
			[
				3363,
				5183
			],
			[
				45,
				-15
			]
		],
		[
			[
				3408,
				5168
			],
			[
				0,
				-75
			]
		],
		[
			[
				3408,
				5093
			],
			[
				-19,
				-61
			]
		],
		[
			[
				3389,
				5032
			],
			[
				-76,
				-41
			]
		],
		[
			[
				3313,
				4991
			],
			[
				-39,
				-22
			],
			[
				-22,
				-27
			]
		],
		[
			[
				3252,
				4942
			],
			[
				-112,
				-47
			]
		],
		[
			[
				3140,
				4895
			],
			[
				-55,
				294
			]
		],
		[
			[
				3085,
				5189
			],
			[
				-54,
				31
			]
		],
		[
			[
				3031,
				5220
			],
			[
				28,
				23
			]
		],
		[
			[
				3125,
				5289
			],
			[
				39,
				3
			]
		],
		[
			[
				5731,
				5784
			],
			[
				62,
				-15
			],
			[
				53,
				-114
			]
		],
		[
			[
				5846,
				5655
			],
			[
				24,
				-88
			]
		],
		[
			[
				5870,
				5567
			],
			[
				-38,
				-99
			]
		],
		[
			[
				5832,
				5468
			],
			[
				-2,
				-74
			],
			[
				-66,
				-52
			]
		],
		[
			[
				5764,
				5342
			],
			[
				-40,
				-15
			]
		],
		[
			[
				5724,
				5327
			],
			[
				-76,
				-7
			]
		],
		[
			[
				5648,
				5320
			],
			[
				-60,
				13
			]
		],
		[
			[
				5588,
				5333
			],
			[
				12,
				88
			],
			[
				-59,
				68
			]
		],
		[
			[
				5541,
				5489
			],
			[
				-119,
				53
			]
		],
		[
			[
				5422,
				5542
			],
			[
				-23,
				40
			]
		],
		[
			[
				5399,
				5582
			],
			[
				37,
				49
			],
			[
				-11,
				104
			]
		],
		[
			[
				5425,
				5735
			],
			[
				58,
				9
			]
		],
		[
			[
				5483,
				5744
			],
			[
				108,
				-10
			]
		],
		[
			[
				5591,
				5734
			],
			[
				55,
				68
			],
			[
				29,
				2
			],
			[
				59,
				-7
			],
			[
				-3,
				-13
			]
		],
		[
			[
				4227,
				4486
			],
			[
				-25,
				-2
			]
		],
		[
			[
				4202,
				4484
			],
			[
				-6,
				-131
			]
		],
		[
			[
				4196,
				4353
			],
			[
				-11,
				-131
			]
		],
		[
			[
				4185,
				4222
			],
			[
				-61,
				18
			]
		],
		[
			[
				4124,
				4240
			],
			[
				-203,
				97
			]
		],
		[
			[
				3921,
				4337
			],
			[
				15,
				28
			],
			[
				-9,
				22
			]
		],
		[
			[
				3941,
				4409
			],
			[
				65,
				76
			]
		],
		[
			[
				4014,
				4526
			],
			[
				72,
				55
			]
		],
		[
			[
				4118,
				4542
			],
			[
				47,
				44
			]
		],
		[
			[
				4165,
				4586
			],
			[
				71,
				-50
			]
		],
		[
			[
				2779,
				1863
			],
			[
				14,
				-61
			]
		],
		[
			[
				2793,
				1802
			],
			[
				72,
				-56
			]
		],
		[
			[
				2865,
				1746
			],
			[
				-22,
				-30
			]
		],
		[
			[
				2843,
				1716
			],
			[
				-64,
				-31
			]
		],
		[
			[
				2779,
				1685
			],
			[
				-124,
				-112
			]
		],
		[
			[
				2655,
				1573
			],
			[
				-34,
				-15
			]
		],
		[
			[
				2621,
				1558
			],
			[
				-66,
				9
			]
		],
		[
			[
				2559,
				1587
			],
			[
				-85,
				45
			]
		],
		[
			[
				2454,
				1644
			],
			[
				-68,
				61
			]
		],
		[
			[
				2368,
				1717
			],
			[
				26,
				65
			]
		],
		[
			[
				2394,
				1782
			],
			[
				-15,
				18
			]
		],
		[
			[
				2379,
				1800
			],
			[
				15,
				23
			],
			[
				32,
				21
			]
		],
		[
			[
				2547,
				1881
			],
			[
				59,
				-5
			]
		],
		[
			[
				2779,
				1685
			],
			[
				25,
				-13
			]
		],
		[
			[
				2804,
				1672
			],
			[
				-41,
				-196
			],
			[
				50,
				-123
			],
			[
				-15,
				-50
			]
		],
		[
			[
				2798,
				1303
			],
			[
				-46,
				19
			]
		],
		[
			[
				2752,
				1322
			],
			[
				-53,
				28
			]
		],
		[
			[
				2699,
				1350
			],
			[
				-46,
				97
			]
		],
		[
			[
				2606,
				1515
			],
			[
				15,
				43
			]
		],
		[
			[
				2655,
				1573
			],
			[
				124,
				112
			]
		],
		[
			[
				1438,
				5200
			],
			[
				19,
				-61
			]
		],
		[
			[
				1457,
				5139
			],
			[
				29,
				7
			]
		],
		[
			[
				1478,
				5165
			],
			[
				51,
				31
			]
		],
		[
			[
				1529,
				5196
			],
			[
				50,
				17
			]
		],
		[
			[
				1579,
				5213
			],
			[
				41,
				-177
			]
		],
		[
			[
				1620,
				5036
			],
			[
				33,
				-46
			]
		],
		[
			[
				1653,
				4990
			],
			[
				-102,
				-87
			]
		],
		[
			[
				1505,
				4943
			],
			[
				-15,
				14
			],
			[
				-57,
				-3
			]
		],
		[
			[
				1433,
				4954
			],
			[
				-100,
				20
			]
		],
		[
			[
				1333,
				4974
			],
			[
				-37,
				69
			],
			[
				14,
				134
			]
		],
		[
			[
				1310,
				5177
			],
			[
				70,
				31
			]
		],
		[
			[
				1380,
				5208
			],
			[
				58,
				-8
			]
		],
		[
			[
				4601,
				4774
			],
			[
				30,
				-42
			]
		],
		[
			[
				4631,
				4732
			],
			[
				87,
				18
			]
		],
		[
			[
				4718,
				4750
			],
			[
				37,
				-146
			]
		],
		[
			[
				4755,
				4604
			],
			[
				-70,
				-34
			]
		],
		[
			[
				4652,
				4578
			],
			[
				-45,
				-12
			]
		],
		[
			[
				4464,
				4568
			],
			[
				-135,
				-18
			]
		],
		[
			[
				4319,
				4653
			],
			[
				25,
				-1
			]
		],
		[
			[
				4344,
				4652
			],
			[
				188,
				104
			]
		],
		[
			[
				4532,
				4756
			],
			[
				69,
				18
			]
		],
		[
			[
				3453,
				5534
			],
			[
				122,
				-125
			],
			[
				44,
				-6
			]
		],
		[
			[
				3619,
				5403
			],
			[
				32,
				-38
			],
			[
				63,
				-29
			]
		],
		[
			[
				3564,
				5181
			],
			[
				-66,
				-5
			]
		],
		[
			[
				3488,
				5165
			],
			[
				-33,
				-25
			]
		],
		[
			[
				3455,
				5140
			],
			[
				-7,
				38
			]
		],
		[
			[
				3448,
				5178
			],
			[
				-26,
				16
			]
		],
		[
			[
				3422,
				5194
			],
			[
				-54,
				4
			]
		],
		[
			[
				3368,
				5198
			],
			[
				56,
				84
			],
			[
				-140,
				166
			]
		],
		[
			[
				3284,
				5448
			],
			[
				25,
				67
			]
		],
		[
			[
				3393,
				5571
			],
			[
				60,
				-37
			]
		],
		[
			[
				2406,
				5786
			],
			[
				100,
				15
			]
		],
		[
			[
				2506,
				5801
			],
			[
				-15,
				-127
			]
		],
		[
			[
				2491,
				5674
			],
			[
				-127,
				-69
			]
		],
		[
			[
				2364,
				5605
			],
			[
				-41,
				30
			]
		],
		[
			[
				2323,
				5635
			],
			[
				-103,
				25
			]
		],
		[
			[
				2220,
				5660
			],
			[
				-61,
				14
			]
		],
		[
			[
				2159,
				5674
			],
			[
				-9,
				81
			]
		],
		[
			[
				2150,
				5755
			],
			[
				-33,
				39
			]
		],
		[
			[
				2117,
				5794
			],
			[
				39,
				81
			]
		],
		[
			[
				2222,
				5903
			],
			[
				94,
				-14
			]
		],
		[
			[
				7598,
				7002
			],
			[
				36,
				-8
			]
		],
		[
			[
				7634,
				6994
			],
			[
				33,
				-117
			],
			[
				45,
				-23
			]
		],
		[
			[
				7712,
				6854
			],
			[
				30,
				-2
			]
		],
		[
			[
				7752,
				6821
			],
			[
				6,
				-98
			]
		],
		[
			[
				7704,
				6689
			],
			[
				-72,
				19
			]
		],
		[
			[
				7632,
				6708
			],
			[
				-58,
				1
			]
		],
		[
			[
				7574,
				6709
			],
			[
				-48,
				12
			]
		],
		[
			[
				7526,
				6721
			],
			[
				-16,
				67
			]
		],
		[
			[
				7510,
				6788
			],
			[
				-31,
				21
			]
		],
		[
			[
				7479,
				6809
			],
			[
				-32,
				54
			]
		],
		[
			[
				7447,
				6863
			],
			[
				17,
				35
			]
		],
		[
			[
				7464,
				6898
			],
			[
				14,
				67
			]
		],
		[
			[
				7478,
				6965
			],
			[
				120,
				37
			]
		],
		[
			[
				1433,
				4954
			],
			[
				64,
				-2
			]
		],
		[
			[
				1453,
				4769
			],
			[
				-26,
				-4
			]
		],
		[
			[
				1437,
				4663
			],
			[
				3,
				-52
			]
		],
		[
			[
				1440,
				4611
			],
			[
				-75,
				-26
			]
		],
		[
			[
				1316,
				4555
			],
			[
				-8,
				-10
			]
		],
		[
			[
				1308,
				4545
			],
			[
				-70,
				94
			]
		],
		[
			[
				1238,
				4639
			],
			[
				-9,
				196
			],
			[
				65,
				109
			]
		],
		[
			[
				1294,
				4944
			],
			[
				18,
				39
			]
		],
		[
			[
				1312,
				4983
			],
			[
				21,
				-9
			]
		],
		[
			[
				7307,
				7466
			],
			[
				38,
				-12
			]
		],
		[
			[
				7355,
				7441
			],
			[
				-54,
				-72
			]
		],
		[
			[
				7301,
				7369
			],
			[
				-9,
				-156
			]
		],
		[
			[
				7292,
				7213
			],
			[
				-23,
				-64
			]
		],
		[
			[
				7269,
				7149
			],
			[
				-121,
				-35
			],
			[
				-75,
				57
			]
		],
		[
			[
				7073,
				7171
			],
			[
				-109,
				-12
			]
		],
		[
			[
				6964,
				7159
			],
			[
				-86,
				-8
			]
		],
		[
			[
				6878,
				7151
			],
			[
				61,
				132
			]
		],
		[
			[
				6939,
				7283
			],
			[
				8,
				48
			]
		],
		[
			[
				6947,
				7331
			],
			[
				58,
				22
			]
		],
		[
			[
				7005,
				7353
			],
			[
				140,
				47
			],
			[
				49,
				49
			]
		],
		[
			[
				7194,
				7449
			],
			[
				7,
				29
			]
		],
		[
			[
				7227,
				7489
			],
			[
				51,
				-12
			]
		],
		[
			[
				4276,
				3726
			],
			[
				6,
				-83
			],
			[
				104,
				11
			]
		],
		[
			[
				4386,
				3654
			],
			[
				44,
				-1
			]
		],
		[
			[
				4430,
				3653
			],
			[
				21,
				-34
			]
		],
		[
			[
				4451,
				3619
			],
			[
				-24,
				-24
			],
			[
				-7,
				-42
			]
		],
		[
			[
				4374,
				3297
			],
			[
				-35,
				9
			]
		],
		[
			[
				4339,
				3306
			],
			[
				-16,
				-11
			]
		],
		[
			[
				4152,
				3384
			],
			[
				-19,
				31
			]
		],
		[
			[
				4133,
				3415
			],
			[
				-24,
				28
			]
		],
		[
			[
				4109,
				3443
			],
			[
				-26,
				33
			]
		],
		[
			[
				4052,
				3473
			],
			[
				2,
				97
			]
		],
		[
			[
				4054,
				3570
			],
			[
				65,
				106
			],
			[
				77,
				54
			]
		],
		[
			[
				4196,
				3730
			],
			[
				44,
				30
			]
		],
		[
			[
				4240,
				3760
			],
			[
				36,
				-34
			]
		],
		[
			[
				5099,
				4941
			],
			[
				-15,
				-65
			]
		],
		[
			[
				5084,
				4876
			],
			[
				-52,
				-59
			]
		],
		[
			[
				5032,
				4817
			],
			[
				-87,
				-47
			]
		],
		[
			[
				4945,
				4770
			],
			[
				-47,
				-9
			]
		],
		[
			[
				4898,
				4761
			],
			[
				-34,
				-8
			]
		],
		[
			[
				4864,
				4753
			],
			[
				-20,
				-33
			]
		],
		[
			[
				4844,
				4720
			],
			[
				-74,
				69
			]
		],
		[
			[
				4770,
				4789
			],
			[
				-22,
				23
			]
		],
		[
			[
				4748,
				4812
			],
			[
				-33,
				7
			]
		],
		[
			[
				4715,
				4819
			],
			[
				25,
				70
			]
		],
		[
			[
				4740,
				4889
			],
			[
				-38,
				110
			]
		],
		[
			[
				4702,
				4999
			],
			[
				107,
				62
			]
		],
		[
			[
				4809,
				5061
			],
			[
				114,
				-50
			]
		],
		[
			[
				8159,
				5821
			],
			[
				-23,
				-30
			]
		],
		[
			[
				8136,
				5791
			],
			[
				4,
				-28
			]
		],
		[
			[
				8140,
				5763
			],
			[
				66,
				-106
			]
		],
		[
			[
				8206,
				5657
			],
			[
				-3,
				-28
			]
		],
		[
			[
				8203,
				5629
			],
			[
				-70,
				-216
			]
		],
		[
			[
				8133,
				5413
			],
			[
				-45,
				-77
			]
		],
		[
			[
				8088,
				5336
			],
			[
				-20,
				-81
			]
		],
		[
			[
				8068,
				5255
			],
			[
				-33,
				-32
			]
		],
		[
			[
				8035,
				5223
			],
			[
				-39,
				-15
			]
		],
		[
			[
				7996,
				5208
			],
			[
				-75,
				55
			],
			[
				-66,
				-42
			],
			[
				-111,
				9
			]
		],
		[
			[
				7744,
				5230
			],
			[
				16,
				58
			]
		],
		[
			[
				7809,
				5685
			],
			[
				-67,
				-5
			]
		],
		[
			[
				7742,
				5680
			],
			[
				18,
				37
			]
		],
		[
			[
				7760,
				5717
			],
			[
				16,
				-9
			]
		],
		[
			[
				7776,
				5708
			],
			[
				124,
				54
			]
		],
		[
			[
				7900,
				5762
			],
			[
				34,
				59
			]
		],
		[
			[
				7958,
				6131
			],
			[
				15,
				-91
			]
		],
		[
			[
				7985,
				6013
			],
			[
				-45,
				-46
			]
		],
		[
			[
				7922,
				5965
			],
			[
				-14,
				-58
			],
			[
				26,
				-58
			],
			[
				-2,
				-36
			],
			[
				-32,
				-51
			]
		],
		[
			[
				7776,
				5708
			],
			[
				-29,
				16
			]
		],
		[
			[
				7735,
				5850
			],
			[
				-35,
				31
			]
		],
		[
			[
				7667,
				5865
			],
			[
				-22,
				-33
			]
		],
		[
			[
				7544,
				5867
			],
			[
				-5,
				39
			]
		],
		[
			[
				7539,
				5906
			],
			[
				5,
				54
			],
			[
				318,
				93
			],
			[
				96,
				78
			]
		],
		[
			[
				5276,
				5926
			],
			[
				86,
				-20
			]
		],
		[
			[
				5362,
				5906
			],
			[
				17,
				-64
			]
		],
		[
			[
				5379,
				5842
			],
			[
				71,
				-102
			]
		],
		[
			[
				5450,
				5740
			],
			[
				-25,
				-5
			]
		],
		[
			[
				5399,
				5582
			],
			[
				-10,
				-25
			]
		],
		[
			[
				5389,
				5557
			],
			[
				-120,
				-23
			]
		],
		[
			[
				5269,
				5534
			],
			[
				-81,
				23
			]
		],
		[
			[
				5188,
				5557
			],
			[
				-127,
				13
			]
		],
		[
			[
				5061,
				5570
			],
			[
				8,
				37
			]
		],
		[
			[
				5069,
				5607
			],
			[
				-61,
				26
			]
		],
		[
			[
				5008,
				5633
			],
			[
				11,
				81
			]
		],
		[
			[
				5019,
				5714
			],
			[
				79,
				167
			]
		],
		[
			[
				5098,
				5881
			],
			[
				-2,
				47
			]
		],
		[
			[
				5096,
				5928
			],
			[
				124,
				25
			],
			[
				56,
				-27
			]
		],
		[
			[
				2660,
				3855
			],
			[
				61,
				-26
			],
			[
				88,
				-135
			]
		],
		[
			[
				2809,
				3694
			],
			[
				-26,
				-29
			]
		],
		[
			[
				2783,
				3665
			],
			[
				-40,
				-12
			]
		],
		[
			[
				2743,
				3653
			],
			[
				13,
				-17
			]
		],
		[
			[
				2756,
				3636
			],
			[
				-77,
				-74
			]
		],
		[
			[
				2679,
				3562
			],
			[
				-20,
				-9
			]
		],
		[
			[
				2659,
				3553
			],
			[
				-12,
				13
			]
		],
		[
			[
				2569,
				3594
			],
			[
				-22,
				74
			]
		],
		[
			[
				2547,
				3668
			],
			[
				15,
				98
			]
		],
		[
			[
				2562,
				3766
			],
			[
				1,
				43
			]
		],
		[
			[
				6337,
				3204
			],
			[
				4,
				-29
			]
		],
		[
			[
				6341,
				3175
			],
			[
				102,
				-98
			]
		],
		[
			[
				6443,
				3077
			],
			[
				-114,
				-96
			],
			[
				45,
				-113
			],
			[
				25,
				-146
			],
			[
				-175,
				-174
			]
		],
		[
			[
				6224,
				2548
			],
			[
				-132,
				33
			],
			[
				-42,
				-56
			],
			[
				-121,
				37
			]
		],
		[
			[
				5929,
				2562
			],
			[
				-16,
				10
			]
		],
		[
			[
				5942,
				2649
			],
			[
				-58,
				42
			]
		],
		[
			[
				5700,
				2875
			],
			[
				12,
				59
			]
		],
		[
			[
				5652,
				3031
			],
			[
				43,
				56
			]
		],
		[
			[
				5695,
				3087
			],
			[
				95,
				-5
			]
		],
		[
			[
				5790,
				3082
			],
			[
				150,
				-43
			],
			[
				68,
				47
			]
		],
		[
			[
				6008,
				3086
			],
			[
				141,
				150
			]
		],
		[
			[
				6149,
				3236
			],
			[
				61,
				-28
			]
		],
		[
			[
				6210,
				3208
			],
			[
				81,
				61
			]
		],
		[
			[
				6291,
				3269
			],
			[
				46,
				-65
			]
		],
		[
			[
				7574,
				6709
			],
			[
				52,
				-43
			]
		],
		[
			[
				7626,
				6666
			],
			[
				29,
				-63
			]
		],
		[
			[
				7883,
				6570
			],
			[
				69,
				60
			],
			[
				50,
				-80
			],
			[
				-22,
				-37
			],
			[
				4,
				-11
			]
		],
		[
			[
				7984,
				6502
			],
			[
				-25,
				-10
			]
		],
		[
			[
				7959,
				6492
			],
			[
				-7,
				19
			]
		],
		[
			[
				7952,
				6511
			],
			[
				-131,
				-59
			],
			[
				-2,
				-80
			]
		],
		[
			[
				7819,
				6372
			],
			[
				-159,
				-48
			]
		],
		[
			[
				7660,
				6324
			],
			[
				-71,
				-13
			],
			[
				-37,
				73
			]
		],
		[
			[
				7552,
				6384
			],
			[
				-17,
				21
			]
		],
		[
			[
				7535,
				6405
			],
			[
				-40,
				-6
			]
		],
		[
			[
				7495,
				6399
			],
			[
				-3,
				15
			]
		],
		[
			[
				7492,
				6414
			],
			[
				-62,
				190
			]
		],
		[
			[
				7430,
				6604
			],
			[
				29,
				61
			]
		],
		[
			[
				7459,
				6665
			],
			[
				22,
				58
			]
		],
		[
			[
				7481,
				6723
			],
			[
				45,
				-2
			]
		],
		[
			[
				4437,
				3830
			],
			[
				51,
				-25
			]
		],
		[
			[
				4488,
				3805
			],
			[
				-15,
				-14
			]
		],
		[
			[
				4473,
				3791
			],
			[
				18,
				-45
			]
		],
		[
			[
				4491,
				3746
			],
			[
				104,
				-8
			]
		],
		[
			[
				4595,
				3738
			],
			[
				33,
				14
			]
		],
		[
			[
				4628,
				3752
			],
			[
				40,
				-20
			]
		],
		[
			[
				4668,
				3732
			],
			[
				-43,
				-60
			]
		],
		[
			[
				4554,
				3610
			],
			[
				10,
				-16
			]
		],
		[
			[
				4432,
				3585
			],
			[
				19,
				34
			]
		],
		[
			[
				4451,
				3619
			],
			[
				-21,
				34
			]
		],
		[
			[
				4386,
				3654
			],
			[
				20,
				79
			]
		],
		[
			[
				4406,
				3733
			],
			[
				31,
				97
			]
		],
		[
			[
				3829,
				4344
			],
			[
				-26,
				-29
			]
		],
		[
			[
				3803,
				4315
			],
			[
				-47,
				-75
			]
		],
		[
			[
				3756,
				4240
			],
			[
				-87,
				16
			]
		],
		[
			[
				3669,
				4256
			],
			[
				0,
				31
			]
		],
		[
			[
				3669,
				4287
			],
			[
				-35,
				-51
			]
		],
		[
			[
				3634,
				4236
			],
			[
				-60,
				34
			]
		],
		[
			[
				3574,
				4270
			],
			[
				-15,
				45
			],
			[
				9,
				-11
			],
			[
				74,
				63
			]
		],
		[
			[
				3642,
				4367
			],
			[
				64,
				22
			],
			[
				42,
				32
			],
			[
				76,
				2
			],
			[
				13,
				-14
			]
		],
		[
			[
				4538,
				5183
			],
			[
				15,
				-18
			]
		],
		[
			[
				4553,
				5165
			],
			[
				53,
				-13
			]
		],
		[
			[
				4606,
				5152
			],
			[
				57,
				18
			],
			[
				32,
				-173
			]
		],
		[
			[
				4695,
				4997
			],
			[
				-21,
				-10
			]
		],
		[
			[
				4674,
				4987
			],
			[
				-13,
				-6
			]
		],
		[
			[
				4661,
				4981
			],
			[
				-41,
				-52
			]
		],
		[
			[
				4620,
				4929
			],
			[
				-28,
				14
			]
		],
		[
			[
				4592,
				4943
			],
			[
				-84,
				21
			]
		],
		[
			[
				4508,
				4964
			],
			[
				-31,
				62
			]
		],
		[
			[
				4477,
				5026
			],
			[
				-45,
				18
			]
		],
		[
			[
				4432,
				5044
			],
			[
				10,
				12
			]
		],
		[
			[
				4442,
				5056
			],
			[
				-19,
				25
			]
		],
		[
			[
				4423,
				5081
			],
			[
				41,
				112
			]
		],
		[
			[
				4464,
				5193
			],
			[
				74,
				-10
			]
		],
		[
			[
				5639,
				7031
			],
			[
				68,
				-55
			]
		],
		[
			[
				5707,
				6976
			],
			[
				42,
				-86
			],
			[
				-24,
				-86
			]
		],
		[
			[
				5725,
				6804
			],
			[
				-20,
				-37
			]
		],
		[
			[
				5705,
				6767
			],
			[
				-101,
				-50
			]
		],
		[
			[
				5604,
				6717
			],
			[
				-118,
				21
			]
		],
		[
			[
				5486,
				6738
			],
			[
				-11,
				18
			]
		],
		[
			[
				5475,
				6756
			],
			[
				-59,
				-40
			]
		],
		[
			[
				5416,
				6716
			],
			[
				-77,
				-30
			]
		],
		[
			[
				5339,
				6686
			],
			[
				-38,
				55
			]
		],
		[
			[
				5301,
				6741
			],
			[
				50,
				187
			],
			[
				79,
				47
			],
			[
				6,
				13
			],
			[
				48,
				17
			],
			[
				99,
				-15
			],
			[
				22,
				63
			]
		],
		[
			[
				5605,
				7053
			],
			[
				34,
				-22
			]
		],
		[
			[
				3372,
				4159
			],
			[
				53,
				26
			]
		],
		[
			[
				3425,
				4185
			],
			[
				33,
				-66
			]
		],
		[
			[
				3458,
				4119
			],
			[
				-24,
				-183
			]
		],
		[
			[
				3434,
				3936
			],
			[
				-18,
				9
			]
		],
		[
			[
				3416,
				3945
			],
			[
				-77,
				-52
			]
		],
		[
			[
				3339,
				3893
			],
			[
				-8,
				35
			]
		],
		[
			[
				3331,
				3928
			],
			[
				-83,
				-16
			]
		],
		[
			[
				3248,
				3912
			],
			[
				-105,
				-38
			]
		],
		[
			[
				3116,
				3868
			],
			[
				14,
				47
			]
		],
		[
			[
				3130,
				3915
			],
			[
				125,
				123
			]
		],
		[
			[
				3255,
				4038
			],
			[
				-20,
				120
			]
		],
		[
			[
				3235,
				4158
			],
			[
				59,
				24
			]
		],
		[
			[
				3294,
				4182
			],
			[
				45,
				36
			]
		],
		[
			[
				3339,
				4218
			],
			[
				33,
				-59
			]
		],
		[
			[
				3911,
				2646
			],
			[
				-34,
				-42
			]
		],
		[
			[
				3877,
				2604
			],
			[
				-67,
				-109
			],
			[
				-74,
				-21
			]
		],
		[
			[
				3736,
				2474
			],
			[
				3,
				-20
			]
		],
		[
			[
				3739,
				2454
			],
			[
				-40,
				-2
			],
			[
				-28,
				8
			],
			[
				-30,
				41
			]
		],
		[
			[
				3518,
				2550
			],
			[
				24,
				71
			]
		],
		[
			[
				3542,
				2621
			],
			[
				68,
				26
			]
		],
		[
			[
				3742,
				2713
			],
			[
				36,
				29
			]
		],
		[
			[
				3886,
				3929
			],
			[
				-24,
				-109
			],
			[
				92,
				-86
			]
		],
		[
			[
				3954,
				3734
			],
			[
				-16,
				-29
			]
		],
		[
			[
				3938,
				3705
			],
			[
				-42,
				-30
			]
		],
		[
			[
				3896,
				3675
			],
			[
				-32,
				-70
			]
		],
		[
			[
				3781,
				3585
			],
			[
				-38,
				-48
			]
		],
		[
			[
				3743,
				3537
			],
			[
				-38,
				49
			]
		],
		[
			[
				3705,
				3586
			],
			[
				0,
				-29
			]
		],
		[
			[
				3705,
				3557
			],
			[
				-25,
				2
			]
		],
		[
			[
				3680,
				3559
			],
			[
				-1,
				69
			]
		],
		[
			[
				3679,
				3628
			],
			[
				-32,
				32
			]
		],
		[
			[
				3647,
				3660
			],
			[
				-26,
				-19
			]
		],
		[
			[
				3621,
				3641
			],
			[
				-36,
				15
			]
		],
		[
			[
				3585,
				3656
			],
			[
				19,
				31
			]
		],
		[
			[
				3713,
				3701
			],
			[
				-35,
				50
			]
		],
		[
			[
				3678,
				3751
			],
			[
				27,
				35
			]
		],
		[
			[
				3731,
				3809
			],
			[
				29,
				29
			],
			[
				-9,
				17
			]
		],
		[
			[
				3751,
				3855
			],
			[
				-13,
				20
			]
		],
		[
			[
				3738,
				3875
			],
			[
				84,
				76
			]
		],
		[
			[
				3822,
				3951
			],
			[
				64,
				-22
			]
		],
		[
			[
				3300,
				5500
			],
			[
				-16,
				-52
			]
		],
		[
			[
				3368,
				5198
			],
			[
				-5,
				-15
			]
		],
		[
			[
				3363,
				5183
			],
			[
				-63,
				28
			]
		],
		[
			[
				3214,
				5280
			],
			[
				-31,
				9
			]
		],
		[
			[
				3166,
				5460
			],
			[
				22,
				21
			]
		],
		[
			[
				3259,
				5500
			],
			[
				41,
				0
			]
		],
		[
			[
				5996,
				6149
			],
			[
				80,
				-28
			]
		],
		[
			[
				6076,
				6121
			],
			[
				12,
				-64
			],
			[
				-133,
				-104
			]
		],
		[
			[
				5955,
				5953
			],
			[
				-31,
				-42
			]
		],
		[
			[
				5924,
				5911
			],
			[
				-74,
				-53
			]
		],
		[
			[
				5850,
				5858
			],
			[
				-110,
				45
			]
		],
		[
			[
				5740,
				5903
			],
			[
				-59,
				80
			]
		],
		[
			[
				5681,
				5983
			],
			[
				-67,
				51
			]
		],
		[
			[
				5614,
				6034
			],
			[
				33,
				4
			]
		],
		[
			[
				5647,
				6038
			],
			[
				41,
				26
			]
		],
		[
			[
				5688,
				6064
			],
			[
				15,
				58
			],
			[
				123,
				109
			]
		],
		[
			[
				5826,
				6231
			],
			[
				89,
				43
			]
		],
		[
			[
				5915,
				6274
			],
			[
				-23,
				-32
			]
		],
		[
			[
				7254,
				6687
			],
			[
				151,
				-63
			]
		],
		[
			[
				7405,
				6624
			],
			[
				25,
				-20
			]
		],
		[
			[
				7492,
				6414
			],
			[
				-44,
				-59
			]
		],
		[
			[
				7448,
				6355
			],
			[
				-23,
				-31
			]
		],
		[
			[
				7425,
				6324
			],
			[
				-37,
				-41
			]
		],
		[
			[
				7388,
				6283
			],
			[
				-36,
				25
			],
			[
				-91,
				-138
			]
		],
		[
			[
				7261,
				6170
			],
			[
				-47,
				-41
			]
		],
		[
			[
				7214,
				6129
			],
			[
				-53,
				20
			]
		],
		[
			[
				7161,
				6149
			],
			[
				-71,
				102
			]
		],
		[
			[
				7022,
				6386
			],
			[
				-62,
				33
			]
		],
		[
			[
				7200,
				6661
			],
			[
				3,
				-10
			]
		],
		[
			[
				7203,
				6651
			],
			[
				21,
				6
			]
		],
		[
			[
				7224,
				6657
			],
			[
				30,
				30
			]
		],
		[
			[
				394,
				2797
			],
			[
				39,
				-31
			]
		],
		[
			[
				490,
				2656
			],
			[
				-53,
				-45
			]
		],
		[
			[
				437,
				2611
			],
			[
				-106,
				-155
			]
		],
		[
			[
				331,
				2456
			],
			[
				27,
				143
			],
			[
				-167,
				7
			]
		],
		[
			[
				229,
				2812
			],
			[
				25,
				20
			]
		],
		[
			[
				254,
				2832
			],
			[
				97,
				-8
			]
		],
		[
			[
				4588,
				4336
			],
			[
				33,
				-17
			]
		],
		[
			[
				4728,
				4265
			],
			[
				39,
				-67
			]
		],
		[
			[
				4767,
				4198
			],
			[
				-65,
				-112
			]
		],
		[
			[
				4702,
				4086
			],
			[
				-74,
				-82
			]
		],
		[
			[
				4628,
				4004
			],
			[
				-71,
				-72
			]
		],
		[
			[
				4557,
				3932
			],
			[
				-30,
				14
			]
		],
		[
			[
				4527,
				3946
			],
			[
				-82,
				-1
			]
		],
		[
			[
				4445,
				3945
			],
			[
				11,
				352
			],
			[
				28,
				29
			]
		],
		[
			[
				4528,
				4349
			],
			[
				60,
				-13
			]
		],
		[
			[
				3626,
				3427
			],
			[
				-6,
				-64
			],
			[
				19,
				-69
			]
		],
		[
			[
				3471,
				3087
			],
			[
				-89,
				20
			]
		],
		[
			[
				3382,
				3107
			],
			[
				-16,
				22
			]
		],
		[
			[
				3366,
				3129
			],
			[
				-13,
				125
			],
			[
				62,
				4
			]
		],
		[
			[
				3415,
				3258
			],
			[
				11,
				83
			]
		],
		[
			[
				3426,
				3341
			],
			[
				17,
				49
			]
		],
		[
			[
				3443,
				3390
			],
			[
				99,
				13
			],
			[
				54,
				57
			]
		],
		[
			[
				3596,
				3460
			],
			[
				30,
				-33
			]
		],
		[
			[
				6841,
				7691
			],
			[
				21,
				1
			]
		],
		[
			[
				6862,
				7692
			],
			[
				-5,
				-18
			]
		],
		[
			[
				6857,
				7674
			],
			[
				45,
				-7
			]
		],
		[
			[
				6902,
				7667
			],
			[
				44,
				-103
			],
			[
				60,
				-30
			]
		],
		[
			[
				7006,
				7534
			],
			[
				-5,
				-101
			]
		],
		[
			[
				7001,
				7433
			],
			[
				-54,
				-102
			]
		],
		[
			[
				6947,
				7331
			],
			[
				-38,
				-27
			]
		],
		[
			[
				6909,
				7304
			],
			[
				-89,
				58
			]
		],
		[
			[
				6820,
				7362
			],
			[
				-99,
				44
			],
			[
				30,
				88
			]
		],
		[
			[
				6726,
				7493
			],
			[
				-7,
				48
			]
		],
		[
			[
				6764,
				7615
			],
			[
				36,
				62
			]
		],
		[
			[
				6800,
				7677
			],
			[
				2,
				23
			]
		],
		[
			[
				6802,
				7700
			],
			[
				39,
				-9
			]
		],
		[
			[
				6009,
				7160
			],
			[
				-6,
				-56
			]
		],
		[
			[
				6003,
				7104
			],
			[
				-45,
				-27
			]
		],
		[
			[
				5958,
				7077
			],
			[
				-9,
				-34
			]
		],
		[
			[
				5949,
				7043
			],
			[
				-6,
				-14
			]
		],
		[
			[
				5943,
				7029
			],
			[
				-97,
				-94
			],
			[
				-100,
				-56
			]
		],
		[
			[
				5746,
				6879
			],
			[
				-39,
				97
			]
		],
		[
			[
				5639,
				7031
			],
			[
				-34,
				22
			]
		],
		[
			[
				5605,
				7053
			],
			[
				157,
				178
			],
			[
				107,
				-56
			],
			[
				140,
				-15
			]
		],
		[
			[
				2427,
				3178
			],
			[
				36,
				-10
			]
		],
		[
			[
				2463,
				3168
			],
			[
				26,
				-22
			]
		],
		[
			[
				2516,
				3092
			],
			[
				17,
				-88
			],
			[
				-72,
				-76
			]
		],
		[
			[
				2461,
				2928
			],
			[
				-86,
				33
			],
			[
				-20,
				22
			],
			[
				3,
				35
			],
			[
				56,
				42
			],
			[
				12,
				30
			],
			[
				-15,
				39
			]
		],
		[
			[
				2411,
				3129
			],
			[
				-52,
				46
			]
		],
		[
			[
				2359,
				3175
			],
			[
				9,
				8
			],
			[
				-6,
				13
			]
		],
		[
			[
				2362,
				3196
			],
			[
				65,
				-18
			]
		],
		[
			[
				1230,
				2200
			],
			[
				61,
				-15
			]
		],
		[
			[
				1331,
				2146
			],
			[
				9,
				-54
			]
		],
		[
			[
				1340,
				2092
			],
			[
				-43,
				-25
			]
		],
		[
			[
				1242,
				2020
			],
			[
				-9,
				-12
			]
		],
		[
			[
				1233,
				2008
			],
			[
				-136,
				-6
			]
		],
		[
			[
				1097,
				2002
			],
			[
				-42,
				119
			]
		],
		[
			[
				1055,
				2121
			],
			[
				44,
				49
			],
			[
				70,
				40
			],
			[
				11,
				30
			]
		],
		[
			[
				3422,
				7452
			],
			[
				-44,
				-29
			],
			[
				-42,
				-62
			]
		],
		[
			[
				3336,
				7361
			],
			[
				-71,
				66
			]
		],
		[
			[
				3265,
				7427
			],
			[
				-49,
				-19
			]
		],
		[
			[
				3216,
				7408
			],
			[
				-50,
				-51
			]
		],
		[
			[
				3166,
				7357
			],
			[
				-71,
				16
			],
			[
				-25,
				-6
			]
		],
		[
			[
				3070,
				7367
			],
			[
				-108,
				100
			],
			[
				-22,
				34
			],
			[
				6,
				176
			],
			[
				53,
				74
			],
			[
				234,
				12
			]
		],
		[
			[
				3233,
				7763
			],
			[
				67,
				-194
			],
			[
				91,
				-24
			],
			[
				28,
				-67
			],
			[
				3,
				-26
			]
		],
		[
			[
				5966,
				7067
			],
			[
				84,
				-53
			]
		],
		[
			[
				6050,
				7014
			],
			[
				19,
				-54
			]
		],
		[
			[
				6069,
				6960
			],
			[
				60,
				-81
			]
		],
		[
			[
				6129,
				6879
			],
			[
				-90,
				-101
			],
			[
				-140,
				-27
			]
		],
		[
			[
				5899,
				6751
			],
			[
				-55,
				-40
			]
		],
		[
			[
				5844,
				6711
			],
			[
				-1,
				-18
			]
		],
		[
			[
				5843,
				6693
			],
			[
				-82,
				7
			]
		],
		[
			[
				5761,
				6700
			],
			[
				-22,
				32
			]
		],
		[
			[
				5739,
				6732
			],
			[
				-34,
				35
			]
		],
		[
			[
				5725,
				6804
			],
			[
				21,
				75
			]
		],
		[
			[
				5943,
				7029
			],
			[
				6,
				14
			]
		],
		[
			[
				5958,
				7077
			],
			[
				8,
				-10
			]
		],
		[
			[
				7189,
				4864
			],
			[
				79,
				-49
			]
		],
		[
			[
				7268,
				4815
			],
			[
				103,
				-68
			]
		],
		[
			[
				7371,
				4747
			],
			[
				89,
				-38
			]
		],
		[
			[
				7460,
				4709
			],
			[
				-193,
				-100
			],
			[
				139,
				-216
			],
			[
				-21,
				-156
			],
			[
				-120,
				13
			],
			[
				-86,
				-63
			],
			[
				-121,
				55
			],
			[
				-171,
				-74
			],
			[
				-76,
				79
			]
		],
		[
			[
				6946,
				4494
			],
			[
				75,
				13
			]
		],
		[
			[
				7021,
				4507
			],
			[
				46,
				91
			]
		],
		[
			[
				7067,
				4598
			],
			[
				63,
				106
			]
		],
		[
			[
				7130,
				4704
			],
			[
				-30,
				49
			]
		],
		[
			[
				7100,
				4753
			],
			[
				-30,
				54
			]
		],
		[
			[
				7070,
				4807
			],
			[
				88,
				24
			]
		],
		[
			[
				7158,
				4831
			],
			[
				31,
				33
			]
		],
		[
			[
				1238,
				4639
			],
			[
				21,
				-28
			]
		],
		[
			[
				1201,
				4620
			],
			[
				-74,
				13
			]
		],
		[
			[
				1054,
				4628
			],
			[
				3,
				-20
			]
		],
		[
			[
				864,
				4615
			],
			[
				-56,
				31
			],
			[
				-30,
				143
			]
		],
		[
			[
				778,
				4789
			],
			[
				103,
				84
			],
			[
				38,
				-40
			],
			[
				139,
				26
			],
			[
				82,
				112
			]
		],
		[
			[
				1140,
				4971
			],
			[
				122,
				-45
			],
			[
				32,
				18
			]
		],
		[
			[
				4855,
				4240
			],
			[
				52,
				-146
			]
		],
		[
			[
				4907,
				4094
			],
			[
				12,
				-36
			]
		],
		[
			[
				4919,
				4058
			],
			[
				27,
				-81
			]
		],
		[
			[
				4946,
				3977
			],
			[
				-29,
				-89
			]
		],
		[
			[
				4917,
				3888
			],
			[
				-73,
				-52
			]
		],
		[
			[
				4844,
				3836
			],
			[
				-49,
				44
			],
			[
				-112,
				-24
			],
			[
				-112,
				64
			]
		],
		[
			[
				4571,
				3920
			],
			[
				57,
				84
			]
		],
		[
			[
				4702,
				4086
			],
			[
				65,
				112
			]
		],
		[
			[
				4767,
				4198
			],
			[
				42,
				69
			]
		],
		[
			[
				4823,
				4244
			],
			[
				32,
				-4
			]
		],
		[
			[
				3753,
				5575
			],
			[
				-23,
				-22
			]
		],
		[
			[
				3722,
				5527
			],
			[
				64,
				-96
			]
		],
		[
			[
				3786,
				5431
			],
			[
				-19,
				-44
			]
		],
		[
			[
				3694,
				5345
			],
			[
				-75,
				58
			]
		],
		[
			[
				3453,
				5534
			],
			[
				29,
				102
			]
		],
		[
			[
				3504,
				5651
			],
			[
				49,
				-28
			]
		],
		[
			[
				3553,
				5623
			],
			[
				43,
				38
			]
		],
		[
			[
				2832,
				3603
			],
			[
				-12,
				-100
			]
		],
		[
			[
				2777,
				3426
			],
			[
				-115,
				-66
			]
		],
		[
			[
				2636,
				3456
			],
			[
				42,
				31
			]
		],
		[
			[
				2665,
				3530
			],
			[
				14,
				32
			]
		],
		[
			[
				2756,
				3636
			],
			[
				6,
				17
			]
		],
		[
			[
				5394,
				5196
			],
			[
				46,
				-37
			]
		],
		[
			[
				5440,
				5159
			],
			[
				2,
				-15
			],
			[
				33,
				-14
			]
		],
		[
			[
				5475,
				5130
			],
			[
				-19,
				-125
			],
			[
				16,
				-123
			]
		],
		[
			[
				5472,
				4882
			],
			[
				32,
				-50
			]
		],
		[
			[
				5504,
				4832
			],
			[
				40,
				-26
			]
		],
		[
			[
				5544,
				4806
			],
			[
				-129,
				-10
			]
		],
		[
			[
				5415,
				4796
			],
			[
				-66,
				-14
			]
		],
		[
			[
				5349,
				4782
			],
			[
				-28,
				27
			]
		],
		[
			[
				5321,
				4809
			],
			[
				-135,
				-20
			]
		],
		[
			[
				5186,
				4789
			],
			[
				-24,
				46
			]
		],
		[
			[
				5162,
				4835
			],
			[
				-76,
				-27
			]
		],
		[
			[
				5086,
				4808
			],
			[
				-2,
				68
			]
		],
		[
			[
				5084,
				4876
			],
			[
				101,
				85
			]
		],
		[
			[
				5314,
				5181
			],
			[
				80,
				15
			]
		],
		[
			[
				2190,
				4057
			],
			[
				21,
				21
			]
		],
		[
			[
				2211,
				4078
			],
			[
				26,
				-5
			]
		],
		[
			[
				2348,
				3779
			],
			[
				49,
				-18
			]
		],
		[
			[
				2507,
				3766
			],
			[
				55,
				0
			]
		],
		[
			[
				2547,
				3668
			],
			[
				-17,
				-24
			]
		],
		[
			[
				2491,
				3517
			],
			[
				-8,
				-61
			]
		],
		[
			[
				2483,
				3456
			],
			[
				35,
				-28
			]
		],
		[
			[
				2509,
				3234
			],
			[
				18,
				-17
			]
		],
		[
			[
				2527,
				3217
			],
			[
				-64,
				-49
			]
		],
		[
			[
				2427,
				3178
			],
			[
				-65,
				18
			]
		],
		[
			[
				2359,
				3175
			],
			[
				-18,
				53
			],
			[
				22,
				69
			],
			[
				-24,
				26
			],
			[
				-32,
				-12
			],
			[
				-46,
				-63
			],
			[
				-40,
				1
			],
			[
				-13,
				29
			]
		],
		[
			[
				2218,
				3369
			],
			[
				-43,
				45
			],
			[
				-120,
				20
			]
		],
		[
			[
				1965,
				3573
			],
			[
				84,
				129
			]
		],
		[
			[
				2049,
				3702
			],
			[
				-44,
				28
			],
			[
				-17,
				33
			],
			[
				77,
				153
			],
			[
				-5,
				48
			],
			[
				-41,
				46
			]
		],
		[
			[
				2019,
				4010
			],
			[
				64,
				67
			]
		],
		[
			[
				2083,
				4077
			],
			[
				107,
				-20
			]
		],
		[
			[
				6417,
				6385
			],
			[
				15,
				-25
			]
		],
		[
			[
				6432,
				6360
			],
			[
				31,
				11
			]
		],
		[
			[
				6463,
				6371
			],
			[
				51,
				-62
			],
			[
				-4,
				-83
			],
			[
				59,
				-117
			]
		],
		[
			[
				6569,
				6109
			],
			[
				-204,
				-93
			]
		],
		[
			[
				6365,
				6016
			],
			[
				-59,
				12
			],
			[
				-65,
				134
			]
		],
		[
			[
				6241,
				6162
			],
			[
				-42,
				34
			]
		],
		[
			[
				6199,
				6196
			],
			[
				20,
				31
			]
		],
		[
			[
				6219,
				6227
			],
			[
				1,
				44
			]
		],
		[
			[
				6330,
				6337
			],
			[
				24,
				37
			]
		],
		[
			[
				6354,
				6374
			],
			[
				49,
				25
			]
		],
		[
			[
				6403,
				6399
			],
			[
				14,
				-14
			]
		],
		[
			[
				6443,
				5367
			],
			[
				58,
				-38
			]
		],
		[
			[
				6501,
				5329
			],
			[
				31,
				-182
			]
		],
		[
			[
				6303,
				5012
			],
			[
				-60,
				-38
			]
		],
		[
			[
				6243,
				4974
			],
			[
				-32,
				26
			]
		],
		[
			[
				6211,
				5000
			],
			[
				11,
				44
			]
		],
		[
			[
				6222,
				5044
			],
			[
				-63,
				37
			]
		],
		[
			[
				6159,
				5081
			],
			[
				-36,
				134
			],
			[
				-16,
				18
			]
		],
		[
			[
				6107,
				5233
			],
			[
				23,
				91
			]
		],
		[
			[
				6130,
				5324
			],
			[
				3,
				34
			]
		],
		[
			[
				6133,
				5358
			],
			[
				94,
				84
			]
		],
		[
			[
				6227,
				5442
			],
			[
				119,
				-33
			]
		],
		[
			[
				6346,
				5409
			],
			[
				97,
				-42
			]
		],
		[
			[
				783,
				2440
			],
			[
				49,
				-8
			]
		],
		[
			[
				832,
				2432
			],
			[
				14,
				-85
			]
		],
		[
			[
				777,
				2273
			],
			[
				9,
				-33
			]
		],
		[
			[
				738,
				2226
			],
			[
				-79,
				8
			]
		],
		[
			[
				659,
				2234
			],
			[
				-14,
				-4
			]
		],
		[
			[
				645,
				2230
			],
			[
				20,
				89
			]
		],
		[
			[
				657,
				2339
			],
			[
				63,
				112
			]
		],
		[
			[
				720,
				2451
			],
			[
				25,
				-10
			]
		],
		[
			[
				745,
				2441
			],
			[
				18,
				24
			]
		],
		[
			[
				763,
				2465
			],
			[
				10,
				-8
			],
			[
				10,
				-17
			]
		],
		[
			[
				1390,
				2854
			],
			[
				63,
				-50
			]
		],
		[
			[
				1453,
				2804
			],
			[
				-25,
				-28
			]
		],
		[
			[
				1482,
				2604
			],
			[
				20,
				-53
			]
		],
		[
			[
				1502,
				2551
			],
			[
				-42,
				-18
			]
		],
		[
			[
				1460,
				2533
			],
			[
				-9,
				-32
			]
		],
		[
			[
				1451,
				2501
			],
			[
				22,
				-5
			]
		],
		[
			[
				1473,
				2496
			],
			[
				-13,
				-33
			]
		],
		[
			[
				1412,
				2418
			],
			[
				-38,
				86
			]
		],
		[
			[
				1365,
				2502
			],
			[
				-62,
				36
			]
		],
		[
			[
				1260,
				2541
			],
			[
				-46,
				13
			]
		],
		[
			[
				1198,
				2588
			],
			[
				-92,
				23
			]
		],
		[
			[
				1106,
				2611
			],
			[
				59,
				26
			],
			[
				-11,
				96
			]
		],
		[
			[
				1154,
				2733
			],
			[
				13,
				0
			]
		],
		[
			[
				1028,
				4116
			],
			[
				14,
				-110
			]
		],
		[
			[
				1042,
				4006
			],
			[
				23,
				-1
			]
		],
		[
			[
				1065,
				4005
			],
			[
				-13,
				-177
			]
		],
		[
			[
				941,
				3795
			],
			[
				-34,
				-84
			]
		],
		[
			[
				907,
				3711
			],
			[
				-30,
				-25
			]
		],
		[
			[
				877,
				3686
			],
			[
				-18,
				106
			]
		],
		[
			[
				859,
				3792
			],
			[
				-86,
				93
			]
		],
		[
			[
				773,
				3885
			],
			[
				-107,
				20
			]
		],
		[
			[
				666,
				3905
			],
			[
				35,
				104
			],
			[
				135,
				129
			]
		],
		[
			[
				913,
				4127
			],
			[
				21,
				-29
			],
			[
				94,
				18
			]
		],
		[
			[
				6818,
				6605
			],
			[
				43,
				-4
			]
		],
		[
			[
				6853,
				6511
			],
			[
				-17,
				7
			]
		],
		[
			[
				6768,
				6358
			],
			[
				-112,
				22
			]
		],
		[
			[
				6656,
				6380
			],
			[
				-28,
				65
			]
		],
		[
			[
				6628,
				6445
			],
			[
				41,
				134
			]
		],
		[
			[
				6669,
				6579
			],
			[
				37,
				8
			]
		],
		[
			[
				6706,
				6587
			],
			[
				62,
				-12
			]
		],
		[
			[
				6768,
				6575
			],
			[
				13,
				48
			]
		],
		[
			[
				6781,
				6623
			],
			[
				37,
				-18
			]
		],
		[
			[
				5339,
				6686
			],
			[
				47,
				16
			]
		],
		[
			[
				5386,
				6702
			],
			[
				5,
				-182
			]
		],
		[
			[
				5391,
				6520
			],
			[
				-51,
				27
			]
		],
		[
			[
				5340,
				6547
			],
			[
				-205,
				37
			],
			[
				-57,
				79
			],
			[
				51,
				93
			],
			[
				-56,
				85
			]
		],
		[
			[
				5073,
				6841
			],
			[
				120,
				130
			],
			[
				160,
				-41
			],
			[
				-52,
				-189
			]
		],
		[
			[
				3597,
				7484
			],
			[
				-159,
				-8
			]
		],
		[
			[
				3438,
				7476
			],
			[
				-16,
				-24
			]
		],
		[
			[
				3233,
				7763
			],
			[
				192,
				-1
			],
			[
				84,
				-22
			]
		],
		[
			[
				832,
				3519
			],
			[
				67,
				-87
			]
		],
		[
			[
				899,
				3432
			],
			[
				-23,
				-9
			]
		],
		[
			[
				876,
				3423
			],
			[
				-40,
				-60
			],
			[
				-41,
				-23
			],
			[
				-79,
				70
			]
		],
		[
			[
				716,
				3410
			],
			[
				-24,
				40
			],
			[
				-156,
				-98
			],
			[
				-65,
				52
			],
			[
				-7,
				157
			],
			[
				30,
				24
			]
		],
		[
			[
				494,
				3585
			],
			[
				265,
				43
			]
		],
		[
			[
				759,
				3628
			],
			[
				67,
				-25
			]
		],
		[
			[
				2323,
				6626
			],
			[
				163,
				-81
			]
		],
		[
			[
				2486,
				6545
			],
			[
				54,
				13
			]
		],
		[
			[
				2540,
				6558
			],
			[
				-1,
				-71
			],
			[
				-6,
				-35
			]
		],
		[
			[
				2533,
				6452
			],
			[
				-32,
				12
			]
		],
		[
			[
				2501,
				6464
			],
			[
				-85,
				-48
			]
		],
		[
			[
				2416,
				6416
			],
			[
				-8,
				9
			]
		],
		[
			[
				2394,
				6415
			],
			[
				-73,
				-36
			]
		],
		[
			[
				2321,
				6379
			],
			[
				-154,
				-54
			]
		],
		[
			[
				2113,
				6344
			],
			[
				84,
				70
			],
			[
				24,
				118
			],
			[
				72,
				21
			],
			[
				-5,
				119
			]
		],
		[
			[
				2288,
				6672
			],
			[
				35,
				-46
			]
		],
		[
			[
				7103,
				6212
			],
			[
				58,
				-63
			]
		],
		[
			[
				7214,
				6129
			],
			[
				20,
				14
			]
		],
		[
			[
				7234,
				6143
			],
			[
				61,
				-37
			]
		],
		[
			[
				7295,
				6106
			],
			[
				14,
				-139
			]
		],
		[
			[
				7309,
				5967
			],
			[
				-40,
				-61
			]
		],
		[
			[
				7269,
				5906
			],
			[
				-244,
				-23
			]
		],
		[
			[
				7025,
				5883
			],
			[
				-53,
				75
			]
		],
		[
			[
				6972,
				5958
			],
			[
				-14,
				120
			],
			[
				-38,
				56
			]
		],
		[
			[
				5255,
				1851
			],
			[
				46,
				-78
			]
		],
		[
			[
				5144,
				1640
			],
			[
				-112,
				155
			],
			[
				22,
				123
			],
			[
				47,
				-10
			],
			[
				63,
				32
			]
		],
		[
			[
				5164,
				1940
			],
			[
				61,
				-52
			]
		],
		[
			[
				5311,
				3635
			],
			[
				37,
				3
			]
		],
		[
			[
				5348,
				3638
			],
			[
				59,
				-4
			]
		],
		[
			[
				5407,
				3634
			],
			[
				-48,
				-106
			],
			[
				29,
				-48
			]
		],
		[
			[
				5388,
				3480
			],
			[
				-68,
				-89
			]
		],
		[
			[
				5104,
				3282
			],
			[
				-9,
				15
			]
		],
		[
			[
				4906,
				3336
			],
			[
				-16,
				32
			]
		],
		[
			[
				4986,
				3608
			],
			[
				-12,
				2
			]
		],
		[
			[
				4974,
				3610
			],
			[
				1,
				23
			],
			[
				70,
				6
			],
			[
				63,
				-26
			],
			[
				137,
				51
			]
		],
		[
			[
				5245,
				3664
			],
			[
				66,
				-29
			]
		],
		[
			[
				7513,
				8009
			],
			[
				-11,
				-152
			],
			[
				-37,
				-89
			]
		],
		[
			[
				7443,
				7750
			],
			[
				-58,
				10
			]
		],
		[
			[
				7385,
				7760
			],
			[
				-31,
				22
			]
		],
		[
			[
				7257,
				7692
			],
			[
				-228,
				66
			]
		],
		[
			[
				7029,
				7758
			],
			[
				33,
				64
			],
			[
				24,
				2
			],
			[
				13,
				85
			],
			[
				107,
				150
			]
		],
		[
			[
				7206,
				8059
			],
			[
				10,
				37
			]
		],
		[
			[
				7216,
				8096
			],
			[
				1,
				5
			]
		],
		[
			[
				7217,
				8101
			],
			[
				109,
				56
			],
			[
				81,
				-69
			],
			[
				-18,
				-75
			],
			[
				124,
				-4
			]
		],
		[
			[
				6665,
				8364
			],
			[
				16,
				-45
			]
		],
		[
			[
				6681,
				8319
			],
			[
				170,
				-47
			]
		],
		[
			[
				6851,
				8272
			],
			[
				12,
				-81
			],
			[
				-70,
				-49
			]
		],
		[
			[
				6793,
				8142
			],
			[
				-40,
				-91
			]
		],
		[
			[
				6753,
				8051
			],
			[
				-132,
				-6
			]
		],
		[
			[
				6621,
				8045
			],
			[
				-153,
				37
			]
		],
		[
			[
				6468,
				8082
			],
			[
				-2,
				37
			]
		],
		[
			[
				6466,
				8119
			],
			[
				-86,
				12
			]
		],
		[
			[
				6366,
				8157
			],
			[
				79,
				99
			]
		],
		[
			[
				6445,
				8256
			],
			[
				3,
				25
			]
		],
		[
			[
				6448,
				8281
			],
			[
				91,
				9
			],
			[
				45,
				61
			]
		],
		[
			[
				6584,
				8351
			],
			[
				81,
				13
			]
		],
		[
			[
				1522,
				4038
			],
			[
				7,
				-121
			],
			[
				-56,
				-28
			]
		],
		[
			[
				1473,
				3889
			],
			[
				8,
				-11
			]
		],
		[
			[
				1481,
				3878
			],
			[
				-160,
				-90
			]
		],
		[
			[
				1321,
				3788
			],
			[
				-50,
				77
			],
			[
				-42,
				33
			]
		],
		[
			[
				1229,
				3898
			],
			[
				45,
				11
			]
		],
		[
			[
				1274,
				3909
			],
			[
				-48,
				93
			]
		],
		[
			[
				1226,
				4002
			],
			[
				56,
				41
			]
		],
		[
			[
				1282,
				4043
			],
			[
				152,
				6
			]
		],
		[
			[
				1434,
				4049
			],
			[
				16,
				27
			]
		],
		[
			[
				1450,
				4076
			],
			[
				72,
				-38
			]
		],
		[
			[
				946,
				1396
			],
			[
				-61,
				-70
			]
		],
		[
			[
				885,
				1326
			],
			[
				4,
				-29
			]
		],
		[
			[
				889,
				1297
			],
			[
				37,
				-66
			],
			[
				-37,
				-10
			],
			[
				-142,
				-1
			],
			[
				13,
				164
			]
		],
		[
			[
				760,
				1384
			],
			[
				9,
				-4
			]
		],
		[
			[
				769,
				1380
			],
			[
				101,
				99
			]
		],
		[
			[
				908,
				1217
			],
			[
				-6,
				-54
			]
		],
		[
			[
				902,
				1163
			],
			[
				6,
				54
			]
		],
		[
			[
				2246,
				1080
			],
			[
				7,
				-126
			],
			[
				103,
				-47
			],
			[
				151,
				-2
			]
		],
		[
			[
				2507,
				905
			],
			[
				26,
				-18
			]
		],
		[
			[
				2533,
				887
			],
			[
				3,
				-103
			],
			[
				-49,
				-30
			],
			[
				-18,
				-228
			],
			[
				-104,
				-64
			],
			[
				-258,
				149
			]
		],
		[
			[
				1961,
				809
			],
			[
				99,
				155
			]
		],
		[
			[
				2060,
				964
			],
			[
				74,
				64
			]
		],
		[
			[
				2134,
				1028
			],
			[
				18,
				37
			]
		],
		[
			[
				2152,
				1065
			],
			[
				51,
				13
			]
		],
		[
			[
				2203,
				1078
			],
			[
				43,
				2
			]
		],
		[
			[
				2888,
				5800
			],
			[
				22,
				-24
			]
		],
		[
			[
				2921,
				5617
			],
			[
				-23,
				-29
			]
		],
		[
			[
				2898,
				5588
			],
			[
				-3,
				-45
			]
		],
		[
			[
				2821,
				5488
			],
			[
				22,
				-44
			]
		],
		[
			[
				2794,
				5257
			],
			[
				1,
				-47
			]
		],
		[
			[
				2795,
				5210
			],
			[
				-36,
				2
			]
		],
		[
			[
				2759,
				5212
			],
			[
				-7,
				-23
			]
		],
		[
			[
				2752,
				5189
			],
			[
				-87,
				-10
			]
		],
		[
			[
				2665,
				5179
			],
			[
				-37,
				18
			]
		],
		[
			[
				2628,
				5197
			],
			[
				-47,
				28
			]
		],
		[
			[
				2581,
				5225
			],
			[
				-41,
				40
			]
		],
		[
			[
				2540,
				5265
			],
			[
				-69,
				-36
			]
		],
		[
			[
				2471,
				5229
			],
			[
				-20,
				81
			],
			[
				51,
				172
			],
			[
				53,
				23
			],
			[
				-28,
				113
			]
		],
		[
			[
				2527,
				5618
			],
			[
				-41,
				66
			],
			[
				20,
				117
			]
		],
		[
			[
				2506,
				5801
			],
			[
				94,
				-23
			]
		],
		[
			[
				2600,
				5778
			],
			[
				40,
				99
			]
		],
		[
			[
				2640,
				5877
			],
			[
				115,
				14
			]
		],
		[
			[
				1756,
				4775
			],
			[
				48,
				-75
			],
			[
				38,
				-30
			]
		],
		[
			[
				1842,
				4670
			],
			[
				70,
				-151
			]
		],
		[
			[
				1912,
				4519
			],
			[
				5,
				-69
			]
		],
		[
			[
				1917,
				4450
			],
			[
				-23,
				-130
			],
			[
				-55,
				-47
			]
		],
		[
			[
				1839,
				4273
			],
			[
				-11,
				-22
			]
		],
		[
			[
				1828,
				4251
			],
			[
				-128,
				-3
			],
			[
				-21,
				79
			]
		],
		[
			[
				1679,
				4327
			],
			[
				60,
				219
			],
			[
				-36,
				30
			]
		],
		[
			[
				1703,
				4576
			],
			[
				6,
				123
			]
		],
		[
			[
				1702,
				4718
			],
			[
				14,
				54
			]
		],
		[
			[
				1716,
				4772
			],
			[
				40,
				3
			]
		],
		[
			[
				670,
				3237
			],
			[
				53,
				-59
			]
		],
		[
			[
				723,
				3178
			],
			[
				40,
				-47
			]
		],
		[
			[
				763,
				3131
			],
			[
				-15,
				-13
			]
		],
		[
			[
				748,
				3118
			],
			[
				43,
				-40
			]
		],
		[
			[
				780,
				3070
			],
			[
				11,
				-36
			]
		],
		[
			[
				666,
				2973
			],
			[
				-89,
				84
			]
		],
		[
			[
				577,
				3057
			],
			[
				-90,
				112
			],
			[
				111,
				82
			],
			[
				72,
				-14
			]
		],
		[
			[
				5391,
				6520
			],
			[
				39,
				-17
			]
		],
		[
			[
				5430,
				6503
			],
			[
				80,
				-76
			],
			[
				18,
				-27
			]
		],
		[
			[
				5528,
				6400
			],
			[
				-9,
				-11
			]
		],
		[
			[
				5519,
				6389
			],
			[
				-4,
				-62
			]
		],
		[
			[
				5515,
				6327
			],
			[
				-67,
				-59
			]
		],
		[
			[
				5448,
				6268
			],
			[
				-22,
				9
			]
		],
		[
			[
				5426,
				6277
			],
			[
				-36,
				46
			]
		],
		[
			[
				5390,
				6323
			],
			[
				-100,
				-3
			]
		],
		[
			[
				5290,
				6320
			],
			[
				35,
				139
			]
		],
		[
			[
				5325,
				6459
			],
			[
				1,
				26
			]
		],
		[
			[
				5326,
				6485
			],
			[
				65,
				35
			]
		],
		[
			[
				2765,
				1304
			],
			[
				77,
				-122
			]
		],
		[
			[
				2842,
				1182
			],
			[
				19,
				2
			]
		],
		[
			[
				2861,
				1184
			],
			[
				-50,
				-120
			]
		],
		[
			[
				2811,
				1064
			],
			[
				-109,
				-151
			],
			[
				-35,
				24
			]
		],
		[
			[
				2667,
				937
			],
			[
				33,
				104
			]
		],
		[
			[
				2700,
				1041
			],
			[
				7,
				96
			]
		],
		[
			[
				2707,
				1137
			],
			[
				-18,
				116
			],
			[
				63,
				69
			]
		],
		[
			[
				2752,
				1322
			],
			[
				13,
				-18
			]
		],
		[
			[
				6020,
				3828
			],
			[
				6,
				-19
			]
		],
		[
			[
				6026,
				3809
			],
			[
				68,
				-84
			]
		],
		[
			[
				6094,
				3725
			],
			[
				62,
				15
			]
		],
		[
			[
				6156,
				3740
			],
			[
				9,
				-37
			]
		],
		[
			[
				6165,
				3703
			],
			[
				20,
				-87
			]
		],
		[
			[
				6185,
				3616
			],
			[
				-47,
				-42
			]
		],
		[
			[
				6138,
				3574
			],
			[
				-8,
				-22
			]
		],
		[
			[
				6130,
				3552
			],
			[
				32,
				-33
			]
		],
		[
			[
				6162,
				3519
			],
			[
				50,
				-116
			],
			[
				47,
				15
			]
		],
		[
			[
				6259,
				3418
			],
			[
				38,
				-47
			]
		],
		[
			[
				6297,
				3371
			],
			[
				-123,
				-133
			]
		],
		[
			[
				6174,
				3238
			],
			[
				-25,
				-2
			]
		],
		[
			[
				6149,
				3236
			],
			[
				-141,
				-150
			]
		],
		[
			[
				5790,
				3082
			],
			[
				-95,
				5
			]
		],
		[
			[
				5583,
				3222
			],
			[
				-41,
				29
			]
		],
		[
			[
				5467,
				3225
			],
			[
				-20,
				60
			]
		],
		[
			[
				5475,
				3307
			],
			[
				42,
				75
			]
		],
		[
			[
				5517,
				3382
			],
			[
				87,
				106
			],
			[
				-11,
				75
			],
			[
				171,
				82
			],
			[
				24,
				108
			]
		],
		[
			[
				5788,
				3753
			],
			[
				52,
				30
			]
		],
		[
			[
				5898,
				2584
			],
			[
				31,
				-22
			]
		],
		[
			[
				6224,
				2548
			],
			[
				-60,
				-211
			],
			[
				-107,
				-106
			],
			[
				-48,
				-110
			],
			[
				-153,
				-14
			],
			[
				-78,
				128
			]
		],
		[
			[
				5778,
				2235
			],
			[
				6,
				22
			]
		],
		[
			[
				5784,
				2257
			],
			[
				-85,
				99
			]
		],
		[
			[
				5699,
				2356
			],
			[
				-2,
				27
			]
		],
		[
			[
				5697,
				2383
			],
			[
				22,
				49
			]
		],
		[
			[
				5779,
				2545
			],
			[
				113,
				64
			]
		],
		[
			[
				5924,
				5911
			],
			[
				14,
				-44
			]
		],
		[
			[
				5938,
				5867
			],
			[
				51,
				-51
			]
		],
		[
			[
				5989,
				5816
			],
			[
				18,
				-103
			]
		],
		[
			[
				6007,
				5713
			],
			[
				-59,
				-101
			]
		],
		[
			[
				5948,
				5612
			],
			[
				-19,
				-8
			]
		],
		[
			[
				5929,
				5604
			],
			[
				-16,
				-21
			]
		],
		[
			[
				5913,
				5583
			],
			[
				-67,
				72
			]
		],
		[
			[
				5731,
				5784
			],
			[
				3,
				35
			],
			[
				-8,
				2
			],
			[
				12,
				32
			],
			[
				112,
				5
			]
		],
		[
			[
				5604,
				6717
			],
			[
				135,
				15
			]
		],
		[
			[
				5761,
				6700
			],
			[
				50,
				-18
			],
			[
				72,
				-129
			]
		],
		[
			[
				5910,
				6498
			],
			[
				-23,
				-95
			]
		],
		[
			[
				5849,
				6433
			],
			[
				-88,
				15
			]
		],
		[
			[
				5761,
				6448
			],
			[
				-139,
				45
			]
		],
		[
			[
				5622,
				6493
			],
			[
				-33,
				1
			]
		],
		[
			[
				5589,
				6494
			],
			[
				-61,
				-94
			]
		],
		[
			[
				5528,
				6400
			],
			[
				-98,
				103
			]
		],
		[
			[
				5386,
				6702
			],
			[
				30,
				14
			]
		],
		[
			[
				5475,
				6756
			],
			[
				11,
				-18
			]
		],
		[
			[
				4347,
				3896
			],
			[
				98,
				49
			]
		],
		[
			[
				4527,
				3946
			],
			[
				12,
				-3
			]
		],
		[
			[
				4539,
				3943
			],
			[
				18,
				-63
			],
			[
				1,
				-22
			],
			[
				-19,
				-24
			],
			[
				-24,
				-10
			]
		],
		[
			[
				4515,
				3824
			],
			[
				-20,
				19
			]
		],
		[
			[
				4495,
				3843
			],
			[
				-58,
				-13
			]
		],
		[
			[
				4437,
				3830
			],
			[
				-31,
				-97
			]
		],
		[
			[
				4276,
				3726
			],
			[
				-36,
				34
			]
		],
		[
			[
				4240,
				3760
			],
			[
				-11,
				-3
			]
		],
		[
			[
				4229,
				3757
			],
			[
				32,
				36
			]
		],
		[
			[
				4261,
				3793
			],
			[
				-3,
				118
			]
		],
		[
			[
				4258,
				3911
			],
			[
				32,
				33
			]
		],
		[
			[
				4290,
				3944
			],
			[
				57,
				-48
			]
		],
		[
			[
				6490,
				7359
			],
			[
				41,
				26
			]
		],
		[
			[
				6531,
				7385
			],
			[
				14,
				2
			]
		],
		[
			[
				6545,
				7387
			],
			[
				7,
				-25
			],
			[
				15,
				-3
			],
			[
				12,
				-51
			]
		],
		[
			[
				6579,
				7308
			],
			[
				8,
				-57
			]
		],
		[
			[
				6587,
				7251
			],
			[
				10,
				-4
			]
		],
		[
			[
				6597,
				7247
			],
			[
				-14,
				-60
			]
		],
		[
			[
				6583,
				7187
			],
			[
				-122,
				-41
			]
		],
		[
			[
				6461,
				7146
			],
			[
				-4,
				-39
			]
		],
		[
			[
				6457,
				7107
			],
			[
				-27,
				22
			]
		],
		[
			[
				6430,
				7129
			],
			[
				-84,
				63
			]
		],
		[
			[
				6346,
				7192
			],
			[
				-15,
				46
			]
		],
		[
			[
				6331,
				7238
			],
			[
				-9,
				99
			]
		],
		[
			[
				6322,
				7337
			],
			[
				81,
				17
			],
			[
				14,
				20
			],
			[
				33,
				15
			],
			[
				40,
				-30
			]
		],
		[
			[
				6491,
				7734
			],
			[
				6,
				-15
			]
		],
		[
			[
				6497,
				7719
			],
			[
				97,
				-69
			]
		],
		[
			[
				6605,
				7426
			],
			[
				-25,
				-6
			]
		],
		[
			[
				6580,
				7420
			],
			[
				-7,
				-32
			]
		],
		[
			[
				6573,
				7388
			],
			[
				-42,
				-3
			]
		],
		[
			[
				6490,
				7359
			],
			[
				-79,
				74
			]
		],
		[
			[
				6411,
				7433
			],
			[
				-22,
				24
			]
		],
		[
			[
				6389,
				7457
			],
			[
				-131,
				20
			]
		],
		[
			[
				6258,
				7477
			],
			[
				149,
				163
			],
			[
				70,
				35
			]
		],
		[
			[
				6477,
				7675
			],
			[
				14,
				59
			]
		],
		[
			[
				4596,
				8228
			],
			[
				-76,
				-159
			],
			[
				-53,
				-17
			]
		],
		[
			[
				4467,
				8052
			],
			[
				-109,
				-52
			],
			[
				-139,
				86
			]
		],
		[
			[
				4219,
				8086
			],
			[
				97,
				99
			]
		],
		[
			[
				4316,
				8185
			],
			[
				11,
				108
			],
			[
				101,
				21
			]
		],
		[
			[
				4428,
				8314
			],
			[
				168,
				-86
			]
		],
		[
			[
				6987,
				8292
			],
			[
				117,
				-188
			],
			[
				84,
				-19
			]
		],
		[
			[
				7188,
				8085
			],
			[
				18,
				-26
			]
		],
		[
			[
				7029,
				7758
			],
			[
				-37,
				34
			]
		],
		[
			[
				6992,
				7792
			],
			[
				-17,
				-8
			],
			[
				-140,
				78
			]
		],
		[
			[
				6835,
				7862
			],
			[
				37,
				60
			],
			[
				4,
				42
			],
			[
				-52,
				6
			]
		],
		[
			[
				6824,
				7970
			],
			[
				-31,
				172
			]
		],
		[
			[
				6851,
				8272
			],
			[
				136,
				20
			]
		],
		[
			[
				3015,
				1244
			],
			[
				69,
				30
			]
		],
		[
			[
				3084,
				1274
			],
			[
				93,
				-48
			],
			[
				-13,
				-76
			],
			[
				-180,
				-49
			],
			[
				-52,
				-103
			],
			[
				-121,
				66
			]
		],
		[
			[
				2861,
				1184
			],
			[
				100,
				111
			]
		],
		[
			[
				2961,
				1295
			],
			[
				54,
				-51
			]
		],
		[
			[
				4854,
				6540
			],
			[
				39,
				-85
			]
		],
		[
			[
				4893,
				6455
			],
			[
				15,
				-107
			],
			[
				-82,
				-63
			]
		],
		[
			[
				4826,
				6285
			],
			[
				-91,
				-75
			]
		],
		[
			[
				4735,
				6210
			],
			[
				-101,
				12
			],
			[
				-79,
				66
			]
		],
		[
			[
				4555,
				6288
			],
			[
				-19,
				-2
			]
		],
		[
			[
				4559,
				6375
			],
			[
				2,
				42
			]
		],
		[
			[
				4632,
				6484
			],
			[
				60,
				13
			]
		],
		[
			[
				4772,
				6539
			],
			[
				45,
				12
			]
		],
		[
			[
				4817,
				6551
			],
			[
				37,
				-11
			]
		],
		[
			[
				3140,
				4895
			],
			[
				-84,
				-2
			]
		],
		[
			[
				3056,
				4893
			],
			[
				-14,
				82
			],
			[
				-80,
				86
			]
		],
		[
			[
				2962,
				5061
			],
			[
				-69,
				45
			]
		],
		[
			[
				2893,
				5106
			],
			[
				-24,
				40
			]
		],
		[
			[
				2997,
				5189
			],
			[
				34,
				31
			]
		],
		[
			[
				3031,
				5220
			],
			[
				16,
				-4
			],
			[
				38,
				-27
			]
		],
		[
			[
				1578,
				5968
			],
			[
				-37,
				-9
			]
		],
		[
			[
				1541,
				5959
			],
			[
				-14,
				-13
			]
		],
		[
			[
				1527,
				5946
			],
			[
				-58,
				-5
			],
			[
				-65,
				-33
			],
			[
				-65,
				-5
			]
		],
		[
			[
				1315,
				5914
			],
			[
				-4,
				42
			]
		],
		[
			[
				1324,
				5968
			],
			[
				-58,
				71
			],
			[
				71,
				92
			],
			[
				149,
				-53
			]
		],
		[
			[
				6365,
				6016
			],
			[
				32,
				-52
			]
		],
		[
			[
				6397,
				5964
			],
			[
				-21,
				-34
			]
		],
		[
			[
				6376,
				5930
			],
			[
				-128,
				-72
			]
		],
		[
			[
				6248,
				5858
			],
			[
				-142,
				-173
			]
		],
		[
			[
				6106,
				5685
			],
			[
				-57,
				-126
			]
		],
		[
			[
				6049,
				5559
			],
			[
				-101,
				53
			]
		],
		[
			[
				5948,
				5612
			],
			[
				59,
				101
			]
		],
		[
			[
				5989,
				5816
			],
			[
				-51,
				51
			]
		],
		[
			[
				5938,
				5867
			],
			[
				17,
				86
			]
		],
		[
			[
				6076,
				6121
			],
			[
				48,
				20
			]
		],
		[
			[
				6124,
				6141
			],
			[
				75,
				55
			]
		],
		[
			[
				6199,
				6196
			],
			[
				42,
				-34
			]
		],
		[
			[
				1150,
				5476
			],
			[
				61,
				-59
			]
		],
		[
			[
				1211,
				5417
			],
			[
				-44,
				-80
			]
		],
		[
			[
				1167,
				5337
			],
			[
				-90,
				-106
			]
		],
		[
			[
				1077,
				5231
			],
			[
				-57,
				38
			]
		],
		[
			[
				1020,
				5269
			],
			[
				-51,
				-23
			]
		],
		[
			[
				969,
				5246
			],
			[
				-69,
				75
			],
			[
				-50,
				34
			],
			[
				7,
				4
			],
			[
				-51,
				30
			]
		],
		[
			[
				806,
				5389
			],
			[
				42,
				75
			]
		],
		[
			[
				848,
				5464
			],
			[
				-6,
				31
			],
			[
				-28,
				45
			]
		],
		[
			[
				814,
				5540
			],
			[
				24,
				7
			],
			[
				116,
				0
			],
			[
				18,
				-32
			],
			[
				61,
				-43
			]
		],
		[
			[
				4316,
				8185
			],
			[
				-107,
				-100
			],
			[
				-127,
				-18
			]
		],
		[
			[
				4082,
				8067
			],
			[
				-54,
				92
			]
		],
		[
			[
				4028,
				8159
			],
			[
				-16,
				14
			]
		],
		[
			[
				4012,
				8173
			],
			[
				71,
				51
			],
			[
				77,
				171
			],
			[
				-76,
				45
			],
			[
				78,
				172
			],
			[
				205,
				-86
			],
			[
				61,
				-212
			]
		],
		[
			[
				3343,
				4958
			],
			[
				72,
				-146
			]
		],
		[
			[
				3415,
				4812
			],
			[
				-89,
				-18
			]
		],
		[
			[
				3313,
				4775
			],
			[
				-57,
				-23
			]
		],
		[
			[
				3207,
				4770
			],
			[
				-36,
				-50
			]
		],
		[
			[
				3171,
				4720
			],
			[
				-56,
				-21
			]
		],
		[
			[
				3073,
				4695
			],
			[
				-34,
				22
			]
		],
		[
			[
				3039,
				4717
			],
			[
				-35,
				154
			]
		],
		[
			[
				3004,
				4871
			],
			[
				136,
				24
			]
		],
		[
			[
				3252,
				4942
			],
			[
				37,
				36
			]
		],
		[
			[
				3289,
				4978
			],
			[
				20,
				-30
			],
			[
				34,
				10
			]
		],
		[
			[
				4113,
				3859
			],
			[
				20,
				-45
			],
			[
				67,
				1
			]
		],
		[
			[
				4200,
				3815
			],
			[
				34,
				-38
			]
		],
		[
			[
				4234,
				3777
			],
			[
				-5,
				-20
			]
		],
		[
			[
				4229,
				3757
			],
			[
				-33,
				-27
			]
		],
		[
			[
				4054,
				3570
			],
			[
				-36,
				29
			]
		],
		[
			[
				3921,
				3563
			],
			[
				-22,
				70
			]
		],
		[
			[
				3899,
				3633
			],
			[
				-3,
				42
			]
		],
		[
			[
				3938,
				3705
			],
			[
				58,
				52
			]
		],
		[
			[
				3996,
				3757
			],
			[
				117,
				102
			]
		],
		[
			[
				7956,
				6871
			],
			[
				-167,
				30
			]
		],
		[
			[
				7777,
				6865
			],
			[
				-65,
				-11
			]
		],
		[
			[
				7634,
				6994
			],
			[
				-34,
				38
			]
		],
		[
			[
				7600,
				7032
			],
			[
				-6,
				194
			]
		],
		[
			[
				7594,
				7226
			],
			[
				66,
				69
			],
			[
				90,
				-50
			],
			[
				127,
				-3
			],
			[
				-18,
				-118
			],
			[
				138,
				-143
			],
			[
				-41,
				-110
			]
		],
		[
			[
				6455,
				7747
			],
			[
				22,
				-72
			]
		],
		[
			[
				6258,
				7477
			],
			[
				-73,
				85
			],
			[
				47,
				62
			],
			[
				-7,
				114
			],
			[
				32,
				15
			],
			[
				72,
				13
			],
			[
				126,
				-19
			]
		],
		[
			[
				2846,
				2058
			],
			[
				79,
				-64
			]
		],
		[
			[
				2925,
				1994
			],
			[
				24,
				-53
			],
			[
				-42,
				-171
			]
		],
		[
			[
				2907,
				1770
			],
			[
				-114,
				32
			]
		],
		[
			[
				2793,
				1802
			],
			[
				-15,
				99
			],
			[
				-11,
				33
			],
			[
				-30,
				21
			],
			[
				-79,
				42
			]
		],
		[
			[
				2658,
				1997
			],
			[
				10,
				41
			]
		],
		[
			[
				2668,
				2038
			],
			[
				117,
				19
			]
		],
		[
			[
				2785,
				2057
			],
			[
				61,
				1
			]
		],
		[
			[
				7247,
				7056
			],
			[
				64,
				-81
			],
			[
				123,
				-23
			]
		],
		[
			[
				7434,
				6952
			],
			[
				30,
				-54
			]
		],
		[
			[
				7447,
				6863
			],
			[
				32,
				-54
			]
		],
		[
			[
				7510,
				6788
			],
			[
				-29,
				-65
			]
		],
		[
			[
				7459,
				6665
			],
			[
				-54,
				-41
			]
		],
		[
			[
				7254,
				6687
			],
			[
				-30,
				-30
			]
		],
		[
			[
				7203,
				6651
			],
			[
				-6,
				24
			]
		],
		[
			[
				7104,
				6798
			],
			[
				-24,
				58
			]
		],
		[
			[
				7080,
				6856
			],
			[
				28,
				28
			]
		],
		[
			[
				7108,
				6884
			],
			[
				54,
				8
			]
		],
		[
			[
				7162,
				6892
			],
			[
				1,
				138
			]
		],
		[
			[
				7163,
				7030
			],
			[
				4,
				39
			]
		],
		[
			[
				7167,
				7069
			],
			[
				80,
				-13
			]
		],
		[
			[
				4740,
				4889
			],
			[
				-25,
				-70
			]
		],
		[
			[
				4715,
				4819
			],
			[
				19,
				-21
			]
		],
		[
			[
				4734,
				4798
			],
			[
				-103,
				-66
			]
		],
		[
			[
				4601,
				4774
			],
			[
				-69,
				-18
			]
		],
		[
			[
				4344,
				4652
			],
			[
				-36,
				-4
			]
		],
		[
			[
				4258,
				4763
			],
			[
				-15,
				12
			]
		],
		[
			[
				4243,
				4775
			],
			[
				-12,
				76
			]
		],
		[
			[
				4235,
				4866
			],
			[
				5,
				72
			]
		],
		[
			[
				4240,
				4938
			],
			[
				184,
				30
			],
			[
				53,
				-27
			]
		],
		[
			[
				4477,
				4941
			],
			[
				115,
				2
			]
		],
		[
			[
				4620,
				4929
			],
			[
				41,
				52
			]
		],
		[
			[
				4674,
				4987
			],
			[
				28,
				12
			]
		],
		[
			[
				4433,
				5138
			],
			[
				-10,
				-57
			]
		],
		[
			[
				4423,
				5081
			],
			[
				19,
				-25
			]
		],
		[
			[
				4432,
				5044
			],
			[
				45,
				-18
			]
		],
		[
			[
				4508,
				4964
			],
			[
				-31,
				-23
			]
		],
		[
			[
				4240,
				4938
			],
			[
				-26,
				-47
			]
		],
		[
			[
				4147,
				4990
			],
			[
				-11,
				74
			]
		],
		[
			[
				4136,
				5064
			],
			[
				84,
				-29
			]
		],
		[
			[
				4220,
				5035
			],
			[
				45,
				61
			]
		],
		[
			[
				4265,
				5096
			],
			[
				98,
				22
			]
		],
		[
			[
				4363,
				5118
			],
			[
				3,
				23
			]
		],
		[
			[
				4366,
				5141
			],
			[
				67,
				-3
			]
		],
		[
			[
				940,
				5583
			],
			[
				-37,
				-32
			]
		],
		[
			[
				903,
				5551
			],
			[
				-94,
				-15
			],
			[
				-45,
				112
			]
		],
		[
			[
				764,
				5648
			],
			[
				-41,
				32
			]
		],
		[
			[
				723,
				5680
			],
			[
				-4,
				-16
			]
		],
		[
			[
				719,
				5664
			],
			[
				-47,
				23
			]
		],
		[
			[
				672,
				5687
			],
			[
				-2,
				-72
			]
		],
		[
			[
				670,
				5615
			],
			[
				-97,
				42
			]
		],
		[
			[
				884,
				5875
			],
			[
				43,
				-87
			]
		],
		[
			[
				5622,
				6493
			],
			[
				139,
				-45
			]
		],
		[
			[
				5761,
				6448
			],
			[
				72,
				-37
			]
		],
		[
			[
				5808,
				6387
			],
			[
				64,
				-66
			]
		],
		[
			[
				5872,
				6321
			],
			[
				1,
				-28
			]
		],
		[
			[
				5873,
				6293
			],
			[
				-47,
				-62
			]
		],
		[
			[
				5688,
				6064
			],
			[
				-73,
				66
			]
		],
		[
			[
				5615,
				6130
			],
			[
				-50,
				13
			],
			[
				-66,
				139
			]
		],
		[
			[
				5499,
				6282
			],
			[
				16,
				45
			]
		],
		[
			[
				5519,
				6389
			],
			[
				12,
				32
			],
			[
				58,
				73
			]
		],
		[
			[
				3625,
				7042
			],
			[
				89,
				-15
			]
		],
		[
			[
				3714,
				7027
			],
			[
				-31,
				-111
			]
		],
		[
			[
				3683,
				6916
			],
			[
				12,
				-62
			]
		],
		[
			[
				3695,
				6854
			],
			[
				-87,
				-49
			],
			[
				-53,
				37
			]
		],
		[
			[
				3555,
				6842
			],
			[
				-147,
				59
			]
		],
		[
			[
				3408,
				6901
			],
			[
				10,
				21
			]
		],
		[
			[
				3418,
				6922
			],
			[
				-7,
				9
			]
		],
		[
			[
				3411,
				6931
			],
			[
				48,
				-3
			],
			[
				97,
				87
			]
		],
		[
			[
				3556,
				7015
			],
			[
				69,
				27
			]
		],
		[
			[
				5419,
				2452
			],
			[
				72,
				66
			]
		],
		[
			[
				5462,
				2533
			],
			[
				76,
				-26
			]
		],
		[
			[
				5540,
				2477
			],
			[
				99,
				-53
			]
		],
		[
			[
				5668,
				2374
			],
			[
				29,
				9
			]
		],
		[
			[
				5699,
				2356
			],
			[
				85,
				-99
			]
		],
		[
			[
				5778,
				2235
			],
			[
				-101,
				-171
			],
			[
				-80,
				-67
			]
		],
		[
			[
				5605,
				2044
			],
			[
				-79,
				41
			]
		],
		[
			[
				5426,
				2174
			],
			[
				-49,
				80
			]
		],
		[
			[
				5256,
				2255
			],
			[
				-60,
				82
			]
		],
		[
			[
				5228,
				2338
			],
			[
				5,
				89
			]
		],
		[
			[
				5233,
				2427
			],
			[
				-12,
				56
			]
		],
		[
			[
				5290,
				2520
			],
			[
				31,
				33
			]
		],
		[
			[
				5321,
				2553
			],
			[
				30,
				1
			]
		],
		[
			[
				3143,
				4359
			],
			[
				173,
				-26
			]
		],
		[
			[
				3316,
				4333
			],
			[
				7,
				-122
			]
		],
		[
			[
				3323,
				4211
			],
			[
				-29,
				-29
			]
		],
		[
			[
				3235,
				4158
			],
			[
				20,
				-120
			]
		],
		[
			[
				3130,
				3915
			],
			[
				-23,
				64
			]
		],
		[
			[
				3107,
				3979
			],
			[
				-42,
				35
			],
			[
				26,
				124
			]
		],
		[
			[
				3091,
				4138
			],
			[
				-26,
				51
			]
		],
		[
			[
				3065,
				4189
			],
			[
				-45,
				15
			]
		],
		[
			[
				3020,
				4204
			],
			[
				-18,
				-13
			]
		],
		[
			[
				3002,
				4191
			],
			[
				-10,
				64
			]
		],
		[
			[
				2992,
				4255
			],
			[
				28,
				77
			]
		],
		[
			[
				3020,
				4332
			],
			[
				60,
				4
			]
		],
		[
			[
				2000,
				4887
			],
			[
				95,
				-57
			],
			[
				36,
				-15
			],
			[
				27,
				9
			],
			[
				27,
				-8
			]
		],
		[
			[
				2185,
				4816
			],
			[
				-16,
				-42
			]
		],
		[
			[
				2169,
				4774
			],
			[
				89,
				-64
			],
			[
				18,
				-85
			],
			[
				-30,
				-120
			]
		],
		[
			[
				2246,
				4505
			],
			[
				-10,
				-35
			]
		],
		[
			[
				2236,
				4470
			],
			[
				34,
				-33
			],
			[
				-11,
				-255
			],
			[
				20,
				-31
			]
		],
		[
			[
				2279,
				4151
			],
			[
				-11,
				-62
			]
		],
		[
			[
				2268,
				4089
			],
			[
				-57,
				-11
			]
		],
		[
			[
				2190,
				4057
			],
			[
				-107,
				20
			]
		],
		[
			[
				2019,
				4010
			],
			[
				-135,
				65
			],
			[
				-9,
				44
			],
			[
				47,
				38
			]
		],
		[
			[
				1922,
				4157
			],
			[
				-44,
				47
			]
		],
		[
			[
				1878,
				4204
			],
			[
				-30,
				23
			]
		],
		[
			[
				1848,
				4227
			],
			[
				-17,
				-5
			]
		],
		[
			[
				1831,
				4222
			],
			[
				8,
				51
			]
		],
		[
			[
				1917,
				4450
			],
			[
				-5,
				69
			]
		],
		[
			[
				1842,
				4670
			],
			[
				-30,
				27
			]
		],
		[
			[
				1812,
				4697
			],
			[
				91,
				28
			],
			[
				79,
				56
			]
		],
		[
			[
				1982,
				4781
			],
			[
				-47,
				36
			],
			[
				-9,
				37
			],
			[
				24,
				71
			]
		],
		[
			[
				1950,
				4925
			],
			[
				50,
				-38
			]
		],
		[
			[
				4251,
				4043
			],
			[
				49,
				-80
			]
		],
		[
			[
				4300,
				3963
			],
			[
				-42,
				-52
			]
		],
		[
			[
				4261,
				3793
			],
			[
				-27,
				-16
			]
		],
		[
			[
				4200,
				3815
			],
			[
				-71,
				5
			],
			[
				-17,
				43
			],
			[
				-10,
				79
			]
		],
		[
			[
				4102,
				3942
			],
			[
				-3,
				57
			]
		],
		[
			[
				4099,
				3999
			],
			[
				93,
				10
			]
		],
		[
			[
				4192,
				4009
			],
			[
				34,
				13
			]
		],
		[
			[
				4226,
				4022
			],
			[
				25,
				21
			]
		],
		[
			[
				2124,
				5859
			],
			[
				-7,
				-65
			]
		],
		[
			[
				2117,
				5794
			],
			[
				-22,
				-23
			]
		],
		[
			[
				2095,
				5771
			],
			[
				-92,
				7
			]
		],
		[
			[
				2003,
				5778
			],
			[
				-96,
				21
			]
		],
		[
			[
				1907,
				5799
			],
			[
				-48,
				67
			]
		],
		[
			[
				2034,
				6280
			],
			[
				53,
				36
			]
		],
		[
			[
				7217,
				8101
			],
			[
				-1,
				-5
			]
		],
		[
			[
				7216,
				8096
			],
			[
				-28,
				-11
			]
		],
		[
			[
				6987,
				8292
			],
			[
				194,
				-25
			],
			[
				116,
				62
			],
			[
				83,
				-10
			],
			[
				210,
				309
			],
			[
				96,
				72
			],
			[
				85,
				3
			],
			[
				90,
				-88
			],
			[
				-82,
				-75
			],
			[
				54,
				-178
			],
			[
				-72,
				-106
			],
			[
				-28,
				-128
			],
			[
				-136,
				-37
			],
			[
				-84,
				-82
			]
		],
		[
			[
				6671,
				7398
			],
			[
				81,
				-100
			]
		],
		[
			[
				6752,
				7298
			],
			[
				-12,
				-54
			],
			[
				-113,
				-22
			]
		],
		[
			[
				6627,
				7222
			],
			[
				-30,
				25
			]
		],
		[
			[
				6587,
				7251
			],
			[
				-8,
				57
			]
		],
		[
			[
				6545,
				7387
			],
			[
				28,
				1
			]
		],
		[
			[
				6580,
				7420
			],
			[
				75,
				6
			]
		],
		[
			[
				4082,
				8067
			],
			[
				79,
				13
			],
			[
				62,
				-173
			],
			[
				28,
				-47
			]
		],
		[
			[
				4251,
				7860
			],
			[
				98,
				-137
			]
		],
		[
			[
				4349,
				7723
			],
			[
				-6,
				-41
			],
			[
				-60,
				-152
			]
		],
		[
			[
				4283,
				7530
			],
			[
				-121,
				50
			]
		],
		[
			[
				4162,
				7580
			],
			[
				-41,
				43
			]
		],
		[
			[
				4121,
				7623
			],
			[
				-58,
				185
			]
		],
		[
			[
				4063,
				7808
			],
			[
				-113,
				172
			]
		],
		[
			[
				3950,
				7980
			],
			[
				-138,
				67
			]
		],
		[
			[
				3812,
				8047
			],
			[
				14,
				31
			]
		],
		[
			[
				3826,
				8078
			],
			[
				159,
				111
			],
			[
				27,
				-16
			]
		],
		[
			[
				4012,
				8173
			],
			[
				16,
				-14
			]
		],
		[
			[
				5615,
				6130
			],
			[
				32,
				-92
			]
		],
		[
			[
				5614,
				6034
			],
			[
				67,
				-51
			]
		],
		[
			[
				5740,
				5903
			],
			[
				6,
				-31
			],
			[
				-20,
				-42
			],
			[
				3,
				-35
			],
			[
				-82,
				8
			],
			[
				-56,
				-69
			]
		],
		[
			[
				5483,
				5744
			],
			[
				-33,
				-4
			]
		],
		[
			[
				5379,
				5842
			],
			[
				-17,
				64
			]
		],
		[
			[
				5362,
				5906
			],
			[
				-42,
				144
			]
		],
		[
			[
				5320,
				6050
			],
			[
				23,
				-2
			],
			[
				111,
				53
			],
			[
				-19,
				121
			]
		],
		[
			[
				5435,
				6222
			],
			[
				-18,
				27
			]
		],
		[
			[
				5417,
				6249
			],
			[
				9,
				28
			]
		],
		[
			[
				5448,
				6268
			],
			[
				51,
				14
			]
		],
		[
			[
				3705,
				7481
			],
			[
				72,
				-84
			]
		],
		[
			[
				3777,
				7397
			],
			[
				23,
				-174
			]
		],
		[
			[
				3800,
				7223
			],
			[
				-26,
				-86
			]
		],
		[
			[
				3774,
				7137
			],
			[
				-60,
				-110
			]
		],
		[
			[
				3625,
				7042
			],
			[
				-59,
				29
			]
		],
		[
			[
				3566,
				7071
			],
			[
				-45,
				95
			],
			[
				-63,
				36
			]
		],
		[
			[
				3458,
				7202
			],
			[
				-42,
				65
			]
		],
		[
			[
				3416,
				7267
			],
			[
				-54,
				9
			]
		],
		[
			[
				3362,
				7276
			],
			[
				-10,
				15
			],
			[
				-16,
				78
			],
			[
				59,
				72
			],
			[
				34,
				14
			],
			[
				9,
				21
			]
		],
		[
			[
				3438,
				7476
			],
			[
				122,
				-18
			],
			[
				145,
				23
			]
		],
		[
			[
				6475,
				3951
			],
			[
				27,
				-107
			],
			[
				-75,
				-61
			]
		],
		[
			[
				6427,
				3783
			],
			[
				-161,
				-44
			]
		],
		[
			[
				6266,
				3739
			],
			[
				-59,
				-6
			]
		],
		[
			[
				6207,
				3733
			],
			[
				-13,
				-21
			]
		],
		[
			[
				6194,
				3712
			],
			[
				-47,
				40
			]
		],
		[
			[
				6147,
				3752
			],
			[
				39,
				121
			],
			[
				-59,
				224
			],
			[
				68,
				85
			],
			[
				-67,
				121
			]
		],
		[
			[
				6128,
				4303
			],
			[
				6,
				17
			]
		],
		[
			[
				6134,
				4320
			],
			[
				79,
				49
			],
			[
				38,
				48
			]
		],
		[
			[
				6251,
				4417
			],
			[
				-2,
				-54
			]
		],
		[
			[
				6266,
				4312
			],
			[
				6,
				-25
			]
		],
		[
			[
				7465,
				5394
			],
			[
				37,
				-115
			]
		],
		[
			[
				7502,
				5279
			],
			[
				-24,
				-112
			]
		],
		[
			[
				7478,
				5167
			],
			[
				48,
				-95
			]
		],
		[
			[
				7526,
				5072
			],
			[
				37,
				-1
			]
		],
		[
			[
				7563,
				5071
			],
			[
				-30,
				-73
			]
		],
		[
			[
				7533,
				4998
			],
			[
				2,
				-32
			]
		],
		[
			[
				7535,
				4966
			],
			[
				-105,
				-39
			]
		],
		[
			[
				7430,
				4927
			],
			[
				-24,
				-37
			]
		],
		[
			[
				7406,
				4890
			],
			[
				-99,
				-70
			]
		],
		[
			[
				7307,
				4820
			],
			[
				-39,
				-5
			]
		],
		[
			[
				7189,
				4864
			],
			[
				-50,
				9
			]
		],
		[
			[
				7139,
				4873
			],
			[
				-173,
				131
			]
		],
		[
			[
				6966,
				5004
			],
			[
				-27,
				136
			]
		],
		[
			[
				7088,
				5200
			],
			[
				69,
				20
			]
		],
		[
			[
				7185,
				5383
			],
			[
				27,
				20
			]
		],
		[
			[
				7238,
				5419
			],
			[
				27,
				25
			],
			[
				-1,
				19
			]
		],
		[
			[
				7264,
				5463
			],
			[
				152,
				-18
			],
			[
				49,
				-51
			]
		],
		[
			[
				6210,
				6711
			],
			[
				-4,
				-58
			],
			[
				-127,
				-78
			]
		],
		[
			[
				6079,
				6575
			],
			[
				-75,
				31
			]
		],
		[
			[
				5905,
				6562
			],
			[
				-62,
				131
			]
		],
		[
			[
				5844,
				6711
			],
			[
				55,
				40
			]
		],
		[
			[
				6129,
				6879
			],
			[
				37,
				-66
			],
			[
				50,
				-28
			],
			[
				15,
				-24
			],
			[
				-9,
				-4
			],
			[
				-12,
				-46
			]
		],
		[
			[
				1569,
				5583
			],
			[
				141,
				-113
			],
			[
				130,
				15
			]
		],
		[
			[
				1840,
				5485
			],
			[
				52,
				12
			],
			[
				37,
				-42
			]
		],
		[
			[
				1929,
				5455
			],
			[
				-21,
				-29
			]
		],
		[
			[
				1908,
				5426
			],
			[
				94,
				-33
			]
		],
		[
			[
				2002,
				5393
			],
			[
				13,
				-83
			],
			[
				-12,
				-31
			],
			[
				-14,
				-19
			],
			[
				-31,
				0
			]
		],
		[
			[
				1958,
				5260
			],
			[
				-13,
				5
			]
		],
		[
			[
				1945,
				5265
			],
			[
				1,
				-30
			]
		],
		[
			[
				1946,
				5235
			],
			[
				-67,
				-9
			]
		],
		[
			[
				1879,
				5226
			],
			[
				-73,
				-29
			]
		],
		[
			[
				1806,
				5197
			],
			[
				-46,
				35
			]
		],
		[
			[
				1760,
				5232
			],
			[
				-18,
				-6
			]
		],
		[
			[
				1742,
				5226
			],
			[
				-23,
				-28
			],
			[
				-10,
				-32
			]
		],
		[
			[
				1709,
				5166
			],
			[
				-18,
				-10
			]
		],
		[
			[
				1691,
				5156
			],
			[
				-6,
				25
			]
		],
		[
			[
				1685,
				5181
			],
			[
				-52,
				-17
			]
		],
		[
			[
				1633,
				5164
			],
			[
				-54,
				49
			]
		],
		[
			[
				1529,
				5196
			],
			[
				15,
				19
			]
		],
		[
			[
				1544,
				5215
			],
			[
				-44,
				20
			]
		],
		[
			[
				1451,
				5360
			],
			[
				-46,
				136
			]
		],
		[
			[
				1405,
				5496
			],
			[
				40,
				65
			],
			[
				61,
				20
			],
			[
				21,
				-10
			],
			[
				42,
				12
			]
		],
		[
			[
				2511,
				2231
			],
			[
				-14,
				-37
			]
		],
		[
			[
				2497,
				2194
			],
			[
				15,
				-116
			]
		],
		[
			[
				2512,
				2078
			],
			[
				-65,
				-15
			]
		],
		[
			[
				2345,
				2035
			],
			[
				-19,
				-26
			]
		],
		[
			[
				2234,
				2082
			],
			[
				-5,
				42
			]
		],
		[
			[
				2229,
				2124
			],
			[
				-54,
				1
			],
			[
				9,
				40
			],
			[
				-9,
				9
			]
		],
		[
			[
				2175,
				2174
			],
			[
				31,
				25
			]
		],
		[
			[
				2280,
				2225
			],
			[
				104,
				65
			]
		],
		[
			[
				2384,
				2290
			],
			[
				3,
				-9
			]
		],
		[
			[
				2387,
				2281
			],
			[
				124,
				-50
			]
		],
		[
			[
				1274,
				3909
			],
			[
				-69,
				-15
			]
		],
		[
			[
				1205,
				3894
			],
			[
				-14,
				74
			]
		],
		[
			[
				1191,
				3968
			],
			[
				-127,
				-45
			]
		],
		[
			[
				1064,
				3923
			],
			[
				1,
				82
			]
		],
		[
			[
				1042,
				4006
			],
			[
				-14,
				110
			]
		],
		[
			[
				1028,
				4116
			],
			[
				39,
				18
			]
		],
		[
			[
				1067,
				4134
			],
			[
				31,
				54
			]
		],
		[
			[
				1098,
				4188
			],
			[
				59,
				-2
			]
		],
		[
			[
				1157,
				4186
			],
			[
				3,
				11
			]
		],
		[
			[
				1160,
				4197
			],
			[
				0,
				-10
			],
			[
				8,
				0
			],
			[
				16,
				-47
			],
			[
				35,
				-132
			],
			[
				55,
				-99
			]
		],
		[
			[
				2592,
				6801
			],
			[
				209,
				-18
			]
		],
		[
			[
				2801,
				6783
			],
			[
				17,
				-94
			]
		],
		[
			[
				2818,
				6689
			],
			[
				-221,
				-105
			],
			[
				-37,
				10
			]
		],
		[
			[
				2560,
				6594
			],
			[
				-20,
				-36
			]
		],
		[
			[
				2540,
				6558
			],
			[
				-54,
				-13
			]
		],
		[
			[
				2323,
				6626
			],
			[
				11,
				56
			]
		],
		[
			[
				2419,
				6823
			],
			[
				110,
				62
			]
		],
		[
			[
				2529,
				6885
			],
			[
				17,
				-11
			]
		],
		[
			[
				2546,
				6874
			],
			[
				46,
				-73
			]
		],
		[
			[
				3557,
				4068
			],
			[
				38,
				-5
			]
		],
		[
			[
				3595,
				4063
			],
			[
				19,
				1
			]
		],
		[
			[
				3614,
				4064
			],
			[
				18,
				-36
			]
		],
		[
			[
				3632,
				4028
			],
			[
				30,
				-19
			]
		],
		[
			[
				3662,
				4009
			],
			[
				-6,
				-40
			]
		],
		[
			[
				3489,
				3918
			],
			[
				-55,
				18
			]
		],
		[
			[
				3458,
				4119
			],
			[
				77,
				-21
			]
		],
		[
			[
				3535,
				4098
			],
			[
				22,
				-30
			]
		],
		[
			[
				4347,
				3896
			],
			[
				-57,
				48
			]
		],
		[
			[
				4290,
				3944
			],
			[
				10,
				19
			]
		],
		[
			[
				4251,
				4043
			],
			[
				-25,
				-21
			]
		],
		[
			[
				4192,
				4009
			],
			[
				-41,
				57
			]
		],
		[
			[
				4151,
				4066
			],
			[
				-34,
				123
			]
		],
		[
			[
				4117,
				4189
			],
			[
				7,
				51
			]
		],
		[
			[
				4185,
				4222
			],
			[
				46,
				84
			],
			[
				-35,
				47
			]
		],
		[
			[
				4202,
				4484
			],
			[
				38,
				9
			],
			[
				9,
				28
			]
		],
		[
			[
				4283,
				4524
			],
			[
				111,
				9
			]
		],
		[
			[
				1075,
				1279
			],
			[
				27,
				-20
			],
			[
				56,
				44
			],
			[
				6,
				-10
			],
			[
				37,
				39
			]
		],
		[
			[
				1201,
				1332
			],
			[
				5,
				-62
			]
		],
		[
			[
				1206,
				1270
			],
			[
				77,
				-37
			]
		],
		[
			[
				1283,
				1233
			],
			[
				-5,
				-63
			]
		],
		[
			[
				1251,
				1157
			],
			[
				-3,
				-32
			]
		],
		[
			[
				1274,
				1077
			],
			[
				32,
				-13
			]
		],
		[
			[
				1306,
				1064
			],
			[
				-131,
				-164
			],
			[
				-17,
				-129
			]
		],
		[
			[
				1158,
				771
			],
			[
				-55,
				95
			],
			[
				-89,
				41
			]
		],
		[
			[
				1014,
				907
			],
			[
				-34,
				29
			]
		],
		[
			[
				980,
				936
			],
			[
				-23,
				66
			]
		],
		[
			[
				957,
				1002
			],
			[
				-31,
				99
			]
		],
		[
			[
				926,
				1101
			],
			[
				29,
				76
			],
			[
				-66,
				120
			]
		],
		[
			[
				885,
				1326
			],
			[
				100,
				76
			]
		],
		[
			[
				985,
				1402
			],
			[
				-5,
				-35
			]
		],
		[
			[
				980,
				1367
			],
			[
				95,
				-88
			]
		],
		[
			[
				908,
				1217
			],
			[
				-6,
				-54
			]
		],
		[
			[
				3566,
				7071
			],
			[
				-10,
				-56
			]
		],
		[
			[
				3411,
				6931
			],
			[
				-47,
				-4
			]
		],
		[
			[
				3364,
				6927
			],
			[
				-12,
				6
			]
		],
		[
			[
				3352,
				6933
			],
			[
				5,
				132
			],
			[
				-40,
				69
			]
		],
		[
			[
				3317,
				7134
			],
			[
				3,
				27
			],
			[
				-30,
				92
			]
		],
		[
			[
				3290,
				7253
			],
			[
				72,
				23
			]
		],
		[
			[
				3416,
				7267
			],
			[
				42,
				-65
			]
		],
		[
			[
				3695,
				6854
			],
			[
				30,
				-15
			]
		],
		[
			[
				3725,
				6839
			],
			[
				27,
				-84
			]
		],
		[
			[
				3752,
				6755
			],
			[
				-145,
				-82
			]
		],
		[
			[
				3607,
				6673
			],
			[
				13,
				-45
			]
		],
		[
			[
				3620,
				6628
			],
			[
				-95,
				-72
			]
		],
		[
			[
				3525,
				6556
			],
			[
				-68,
				-45
			]
		],
		[
			[
				3457,
				6511
			],
			[
				-134,
				-66
			],
			[
				-51,
				13
			]
		],
		[
			[
				3272,
				6458
			],
			[
				-55,
				78
			],
			[
				42,
				53
			],
			[
				-37,
				60
			]
		],
		[
			[
				3222,
				6649
			],
			[
				36,
				23
			]
		],
		[
			[
				3258,
				6672
			],
			[
				7,
				62
			],
			[
				44,
				9
			],
			[
				77,
				-14
			]
		],
		[
			[
				3386,
				6729
			],
			[
				85,
				73
			]
		],
		[
			[
				3471,
				6802
			],
			[
				84,
				40
			]
		],
		[
			[
				2829,
				4727
			],
			[
				49,
				-106
			]
		],
		[
			[
				2878,
				4621
			],
			[
				80,
				-14
			]
		],
		[
			[
				2981,
				4568
			],
			[
				18,
				-67
			]
		],
		[
			[
				3003,
				4418
			],
			[
				17,
				-86
			]
		],
		[
			[
				2992,
				4255
			],
			[
				-5,
				-74
			]
		],
		[
			[
				2987,
				4181
			],
			[
				-148,
				-50
			]
		],
		[
			[
				2839,
				4131
			],
			[
				-46,
				-6
			]
		],
		[
			[
				2793,
				4125
			],
			[
				-36,
				15
			]
		],
		[
			[
				2757,
				4140
			],
			[
				-80,
				-28
			]
		],
		[
			[
				2584,
				4081
			],
			[
				-53,
				-14
			]
		],
		[
			[
				2524,
				4105
			],
			[
				-19,
				72
			]
		],
		[
			[
				2505,
				4177
			],
			[
				59,
				55
			],
			[
				43,
				209
			],
			[
				-99,
				90
			]
		],
		[
			[
				2508,
				4531
			],
			[
				-56,
				59
			]
		],
		[
			[
				2452,
				4590
			],
			[
				62,
				78
			]
		],
		[
			[
				2514,
				4668
			],
			[
				164,
				49
			]
		],
		[
			[
				2678,
				4717
			],
			[
				15,
				88
			]
		],
		[
			[
				2693,
				4805
			],
			[
				10,
				13
			]
		],
		[
			[
				2703,
				4818
			],
			[
				126,
				-91
			]
		],
		[
			[
				1646,
				3589
			],
			[
				29,
				-115
			],
			[
				69,
				-88
			]
		],
		[
			[
				1744,
				3386
			],
			[
				49,
				8
			]
		],
		[
			[
				1778,
				3310
			],
			[
				-13,
				-43
			]
		],
		[
			[
				1726,
				3276
			],
			[
				-49,
				4
			]
		],
		[
			[
				1604,
				3232
			],
			[
				-50,
				96
			]
		],
		[
			[
				1554,
				3576
			],
			[
				20,
				-13
			]
		],
		[
			[
				1574,
				3563
			],
			[
				19,
				41
			]
		],
		[
			[
				1593,
				3604
			],
			[
				53,
				-15
			]
		],
		[
			[
				4229,
				6023
			],
			[
				135,
				-115
			],
			[
				61,
				-218
			]
		],
		[
			[
				4425,
				5690
			],
			[
				38,
				4
			]
		],
		[
			[
				4463,
				5694
			],
			[
				18,
				-83
			]
		],
		[
			[
				4481,
				5611
			],
			[
				-49,
				-52
			]
		],
		[
			[
				4432,
				5559
			],
			[
				-55,
				-1
			]
		],
		[
			[
				4377,
				5558
			],
			[
				-85,
				-39
			]
		],
		[
			[
				4292,
				5519
			],
			[
				-36,
				23
			]
		],
		[
			[
				4256,
				5542
			],
			[
				-35,
				-16
			]
		],
		[
			[
				4221,
				5526
			],
			[
				-3,
				28
			],
			[
				-14,
				12
			]
		],
		[
			[
				4204,
				5566
			],
			[
				-116,
				154
			]
		],
		[
			[
				4088,
				5720
			],
			[
				-55,
				84
			],
			[
				50,
				73
			]
		],
		[
			[
				4083,
				5877
			],
			[
				-7,
				135
			],
			[
				66,
				55
			]
		],
		[
			[
				4142,
				6067
			],
			[
				87,
				-44
			]
		],
		[
			[
				4329,
				5331
			],
			[
				34,
				-213
			]
		],
		[
			[
				4363,
				5118
			],
			[
				-98,
				-22
			]
		],
		[
			[
				4220,
				5035
			],
			[
				-114,
				61
			]
		],
		[
			[
				4106,
				5096
			],
			[
				-31,
				66
			]
		],
		[
			[
				4075,
				5162
			],
			[
				38,
				83
			]
		],
		[
			[
				4113,
				5245
			],
			[
				20,
				9
			]
		],
		[
			[
				4133,
				5254
			],
			[
				51,
				27
			]
		],
		[
			[
				4184,
				5281
			],
			[
				34,
				-12
			]
		],
		[
			[
				4218,
				5269
			],
			[
				59,
				52
			]
		],
		[
			[
				4277,
				5321
			],
			[
				52,
				10
			]
		],
		[
			[
				6791,
				6859
			],
			[
				92,
				-7
			]
		],
		[
			[
				6883,
				6852
			],
			[
				-20,
				-48
			]
		],
		[
			[
				6856,
				6730
			],
			[
				19,
				-57
			]
		],
		[
			[
				6878,
				6631
			],
			[
				-60,
				-26
			]
		],
		[
			[
				6818,
				6605
			],
			[
				-37,
				18
			]
		],
		[
			[
				6781,
				6623
			],
			[
				-13,
				-48
			]
		],
		[
			[
				6706,
				6587
			],
			[
				-23,
				77
			],
			[
				33,
				88
			]
		],
		[
			[
				6716,
				6752
			],
			[
				-34,
				83
			]
		],
		[
			[
				6682,
				6835
			],
			[
				17,
				2
			]
		],
		[
			[
				6699,
				6837
			],
			[
				14,
				38
			]
		],
		[
			[
				6713,
				6875
			],
			[
				49,
				3
			],
			[
				29,
				-19
			]
		],
		[
			[
				7600,
				7032
			],
			[
				-2,
				-30
			]
		],
		[
			[
				7478,
				6965
			],
			[
				-44,
				-13
			]
		],
		[
			[
				7247,
				7056
			],
			[
				22,
				93
			]
		],
		[
			[
				7269,
				7149
			],
			[
				23,
				64
			]
		],
		[
			[
				7301,
				7369
			],
			[
				58,
				74
			],
			[
				74,
				-14
			]
		],
		[
			[
				7464,
				7444
			],
			[
				45,
				-1
			]
		],
		[
			[
				7497,
				7482
			],
			[
				86,
				-92
			],
			[
				11,
				-164
			]
		],
		[
			[
				4140,
				7603
			],
			[
				-92,
				-114
			],
			[
				50,
				-107
			],
			[
				104,
				-56
			]
		],
		[
			[
				4202,
				7326
			],
			[
				-43,
				-35
			]
		],
		[
			[
				4159,
				7291
			],
			[
				-11,
				12
			]
		],
		[
			[
				4148,
				7303
			],
			[
				-78,
				-21
			]
		],
		[
			[
				4070,
				7282
			],
			[
				-14,
				27
			]
		],
		[
			[
				4056,
				7309
			],
			[
				-45,
				-53
			],
			[
				-56,
				-38
			],
			[
				-21,
				2
			],
			[
				-68,
				43
			]
		],
		[
			[
				3866,
				7263
			],
			[
				-29,
				9
			]
		],
		[
			[
				3837,
				7272
			],
			[
				-60,
				125
			]
		],
		[
			[
				3777,
				7397
			],
			[
				-27,
				24
			]
		],
		[
			[
				3767,
				7434
			],
			[
				71,
				36
			]
		],
		[
			[
				3838,
				7470
			],
			[
				93,
				49
			]
		],
		[
			[
				3931,
				7519
			],
			[
				13,
				22
			]
		],
		[
			[
				3944,
				7541
			],
			[
				177,
				82
			]
		],
		[
			[
				4121,
				7623
			],
			[
				19,
				-20
			]
		],
		[
			[
				1748,
				250
			],
			[
				-50,
				-93
			],
			[
				-180,
				-71
			],
			[
				-54,
				-86
			],
			[
				-63,
				95
			],
			[
				-106,
				50
			],
			[
				-4,
				60
			],
			[
				35,
				27
			],
			[
				-29,
				32
			],
			[
				10,
				18
			],
			[
				39,
				29
			]
		],
		[
			[
				1632,
				409
			],
			[
				79,
				15
			]
		],
		[
			[
				3800,
				6724
			],
			[
				52,
				-47
			]
		],
		[
			[
				3852,
				6677
			],
			[
				90,
				19
			]
		],
		[
			[
				3942,
				6696
			],
			[
				21,
				-81
			],
			[
				-28,
				-38
			]
		],
		[
			[
				3865,
				6503
			],
			[
				-36,
				-67
			]
		],
		[
			[
				3829,
				6436
			],
			[
				-47,
				3
			]
		],
		[
			[
				3782,
				6439
			],
			[
				-14,
				-16
			]
		],
		[
			[
				3768,
				6423
			],
			[
				-74,
				92
			]
		],
		[
			[
				3694,
				6515
			],
			[
				-82,
				41
			]
		],
		[
			[
				3612,
				6556
			],
			[
				-19,
				-2
			]
		],
		[
			[
				3593,
				6554
			],
			[
				27,
				74
			]
		],
		[
			[
				3607,
				6673
			],
			[
				131,
				62
			]
		],
		[
			[
				3738,
				6735
			],
			[
				62,
				-11
			]
		],
		[
			[
				5333,
				4099
			],
			[
				104,
				-55
			]
		],
		[
			[
				5437,
				4044
			],
			[
				-71,
				-56
			]
		],
		[
			[
				5357,
				3744
			],
			[
				-32,
				-23
			]
		],
		[
			[
				5325,
				3721
			],
			[
				-29,
				13
			]
		],
		[
			[
				5296,
				3734
			],
			[
				-51,
				-70
			]
		],
		[
			[
				4974,
				3610
			],
			[
				-19,
				46
			]
		],
		[
			[
				4955,
				3656
			],
			[
				-24,
				58
			]
		],
		[
			[
				4931,
				3714
			],
			[
				-30,
				96
			]
		],
		[
			[
				4901,
				3810
			],
			[
				16,
				78
			]
		],
		[
			[
				4946,
				3977
			],
			[
				-27,
				81
			]
		],
		[
			[
				4907,
				4094
			],
			[
				67,
				120
			]
		],
		[
			[
				4974,
				4214
			],
			[
				126,
				41
			],
			[
				133,
				-159
			],
			[
				100,
				3
			]
		],
		[
			[
				5741,
				3812
			],
			[
				8,
				27
			]
		],
		[
			[
				5792,
				3789
			],
			[
				-4,
				-36
			]
		],
		[
			[
				5517,
				3382
			],
			[
				-33,
				-17
			]
		],
		[
			[
				5431,
				3450
			],
			[
				-43,
				30
			]
		],
		[
			[
				5407,
				3634
			],
			[
				-59,
				4
			]
		],
		[
			[
				5311,
				3635
			],
			[
				-15,
				99
			]
		],
		[
			[
				5325,
				3721
			],
			[
				60,
				18
			]
		],
		[
			[
				5402,
				3761
			],
			[
				51,
				13
			]
		],
		[
			[
				1946,
				1240
			],
			[
				77,
				-75
			]
		],
		[
			[
				2023,
				1165
			],
			[
				44,
				-53
			],
			[
				83,
				5
			]
		],
		[
			[
				2150,
				1117
			],
			[
				2,
				-52
			]
		],
		[
			[
				2134,
				1028
			],
			[
				-74,
				-64
			]
		],
		[
			[
				1904,
				767
			],
			[
				-32,
				-13
			]
		],
		[
			[
				1782,
				755
			],
			[
				-22,
				14
			]
		],
		[
			[
				1760,
				769
			],
			[
				-2,
				130
			],
			[
				-91,
				-8
			]
		],
		[
			[
				1667,
				891
			],
			[
				-46,
				-22
			]
		],
		[
			[
				1621,
				869
			],
			[
				-13,
				57
			]
		],
		[
			[
				1608,
				926
			],
			[
				18,
				61
			]
		],
		[
			[
				1626,
				987
			],
			[
				-18,
				78
			]
		],
		[
			[
				1608,
				1065
			],
			[
				12,
				-16
			]
		],
		[
			[
				1644,
				1160
			],
			[
				61,
				68
			]
		],
		[
			[
				1588,
				4600
			],
			[
				67,
				-25
			]
		],
		[
			[
				1672,
				4600
			],
			[
				31,
				-24
			]
		],
		[
			[
				1679,
				4327
			],
			[
				-36,
				-89
			]
		],
		[
			[
				1643,
				4238
			],
			[
				-54,
				52
			]
		],
		[
			[
				1589,
				4290
			],
			[
				-21,
				42
			]
		],
		[
			[
				1568,
				4332
			],
			[
				-5,
				43
			]
		],
		[
			[
				1563,
				4375
			],
			[
				-11,
				67
			]
		],
		[
			[
				1552,
				4442
			],
			[
				-48,
				76
			]
		],
		[
			[
				1504,
				4518
			],
			[
				-7,
				45
			]
		],
		[
			[
				1497,
				4563
			],
			[
				-2,
				21
			]
		],
		[
			[
				1495,
				4584
			],
			[
				93,
				16
			]
		],
		[
			[
				2728,
				6124
			],
			[
				-57,
				-208
			]
		],
		[
			[
				2676,
				5902
			],
			[
				-36,
				-25
			]
		],
		[
			[
				2600,
				5778
			],
			[
				-81,
				59
			]
		],
		[
			[
				2497,
				6097
			],
			[
				96,
				24
			]
		],
		[
			[
				2593,
				6121
			],
			[
				34,
				-2
			]
		],
		[
			[
				2627,
				6119
			],
			[
				45,
				62
			]
		],
		[
			[
				2672,
				6181
			],
			[
				95,
				-31
			]
		],
		[
			[
				5186,
				4789
			],
			[
				16,
				-87
			],
			[
				-48,
				-46
			],
			[
				-9,
				-104
			]
		],
		[
			[
				5145,
				4552
			],
			[
				-18,
				29
			]
		],
		[
			[
				5127,
				4581
			],
			[
				-123,
				-36
			]
		],
		[
			[
				5004,
				4545
			],
			[
				-71,
				83
			]
		],
		[
			[
				4933,
				4628
			],
			[
				-3,
				16
			]
		],
		[
			[
				4930,
				4644
			],
			[
				-66,
				109
			]
		],
		[
			[
				4898,
				4761
			],
			[
				47,
				9
			]
		],
		[
			[
				5032,
				4817
			],
			[
				54,
				-9
			]
		],
		[
			[
				5162,
				4835
			],
			[
				24,
				-46
			]
		],
		[
			[
				1896,
				3625
			],
			[
				30,
				-22
			]
		],
		[
			[
				1926,
				3603
			],
			[
				-84,
				-10
			]
		],
		[
			[
				1836,
				3413
			],
			[
				-92,
				-27
			]
		],
		[
			[
				1646,
				3589
			],
			[
				27,
				31
			]
		],
		[
			[
				1673,
				3620
			],
			[
				82,
				45
			]
		],
		[
			[
				1755,
				3665
			],
			[
				30,
				-1
			],
			[
				68,
				54
			]
		],
		[
			[
				1853,
				3718
			],
			[
				16,
				-2
			]
		],
		[
			[
				1869,
				3716
			],
			[
				27,
				-91
			]
		],
		[
			[
				1568,
				4332
			],
			[
				-14,
				-61
			]
		],
		[
			[
				1554,
				4271
			],
			[
				-98,
				-1
			],
			[
				13,
				-203
			]
		],
		[
			[
				1469,
				4067
			],
			[
				-19,
				9
			]
		],
		[
			[
				1434,
				4049
			],
			[
				-152,
				-6
			]
		],
		[
			[
				1226,
				4002
			],
			[
				-5,
				5
			],
			[
				-61,
				190
			]
		],
		[
			[
				1160,
				4197
			],
			[
				10,
				29
			],
			[
				59,
				30
			]
		],
		[
			[
				1229,
				4256
			],
			[
				13,
				32
			]
		],
		[
			[
				1242,
				4288
			],
			[
				13,
				44
			],
			[
				153,
				-29
			]
		],
		[
			[
				1408,
				4303
			],
			[
				49,
				55
			]
		],
		[
			[
				1522,
				4357
			],
			[
				41,
				18
			]
		],
		[
			[
				4204,
				5566
			],
			[
				14,
				-22
			]
		],
		[
			[
				4218,
				5544
			],
			[
				-31,
				-9
			],
			[
				-62,
				-45
			],
			[
				-49,
				-9
			]
		],
		[
			[
				4076,
				5481
			],
			[
				-58,
				-30
			]
		],
		[
			[
				3993,
				5459
			],
			[
				-4,
				47
			]
		],
		[
			[
				3858,
				5581
			],
			[
				20,
				5
			]
		],
		[
			[
				3985,
				5752
			],
			[
				103,
				-32
			]
		],
		[
			[
				8433,
				5612
			],
			[
				-59,
				-40
			]
		],
		[
			[
				8374,
				5572
			],
			[
				-74,
				59
			]
		],
		[
			[
				8300,
				5631
			],
			[
				19,
				-108
			]
		],
		[
			[
				8319,
				5523
			],
			[
				-21,
				-33
			]
		],
		[
			[
				8298,
				5490
			],
			[
				-83,
				-78
			]
		],
		[
			[
				8215,
				5412
			],
			[
				-49,
				-37
			]
		],
		[
			[
				8166,
				5375
			],
			[
				-33,
				38
			]
		],
		[
			[
				8203,
				5629
			],
			[
				3,
				28
			]
		],
		[
			[
				8206,
				5657
			],
			[
				-66,
				106
			]
		],
		[
			[
				8136,
				5791
			],
			[
				24,
				23
			],
			[
				3,
				22
			]
		],
		[
			[
				8263,
				6093
			],
			[
				48,
				20
			],
			[
				27,
				-5
			],
			[
				68,
				45
			],
			[
				102,
				-38
			],
			[
				90,
				-106
			],
			[
				-36,
				-75
			],
			[
				50,
				-64
			],
			[
				-154,
				-149
			],
			[
				-25,
				-109
			]
		],
		[
			[
				8106,
				5340
			],
			[
				166,
				-186
			]
		],
		[
			[
				8272,
				5154
			],
			[
				32,
				-23
			]
		],
		[
			[
				8304,
				5131
			],
			[
				40,
				2
			]
		],
		[
			[
				8344,
				5133
			],
			[
				88,
				-84
			],
			[
				-129,
				-178
			],
			[
				-28,
				-138
			],
			[
				-90,
				-4
			]
		],
		[
			[
				8185,
				4729
			],
			[
				-340,
				142
			]
		],
		[
			[
				7845,
				4871
			],
			[
				5,
				54
			]
		],
		[
			[
				7850,
				4925
			],
			[
				36,
				8
			]
		],
		[
			[
				7886,
				4933
			],
			[
				25,
				5
			]
		],
		[
			[
				7911,
				4938
			],
			[
				21,
				11
			]
		],
		[
			[
				7932,
				4949
			],
			[
				43,
				-12
			]
		],
		[
			[
				7975,
				4937
			],
			[
				24,
				207
			]
		],
		[
			[
				7999,
				5144
			],
			[
				-7,
				46
			]
		],
		[
			[
				7992,
				5190
			],
			[
				4,
				18
			]
		],
		[
			[
				8035,
				5223
			],
			[
				33,
				32
			]
		],
		[
			[
				8088,
				5336
			],
			[
				18,
				4
			]
		],
		[
			[
				6535,
				3546
			],
			[
				12,
				-99
			]
		],
		[
			[
				6580,
				3396
			],
			[
				-90,
				-46
			]
		],
		[
			[
				6490,
				3350
			],
			[
				58,
				-84
			]
		],
		[
			[
				6548,
				3266
			],
			[
				-70,
				-21
			]
		],
		[
			[
				6478,
				3245
			],
			[
				-85,
				-78
			],
			[
				-51,
				38
			]
		],
		[
			[
				6342,
				3205
			],
			[
				-51,
				64
			]
		],
		[
			[
				6210,
				3208
			],
			[
				-36,
				30
			]
		],
		[
			[
				6297,
				3371
			],
			[
				-38,
				47
			]
		],
		[
			[
				6162,
				3519
			],
			[
				-32,
				33
			]
		],
		[
			[
				6138,
				3574
			],
			[
				47,
				42
			]
		],
		[
			[
				6165,
				3703
			],
			[
				-9,
				37
			]
		],
		[
			[
				6156,
				3740
			],
			[
				38,
				-28
			]
		],
		[
			[
				6207,
				3733
			],
			[
				59,
				6
			]
		],
		[
			[
				6427,
				3783
			],
			[
				87,
				-38
			],
			[
				46,
				-82
			]
		],
		[
			[
				1158,
				771
			],
			[
				49,
				24
			]
		],
		[
			[
				1207,
				795
			],
			[
				-21,
				-70
			]
		],
		[
			[
				1186,
				725
			],
			[
				-97,
				-53
			]
		],
		[
			[
				1055,
				639
			],
			[
				-110,
				30
			],
			[
				-109,
				-39
			],
			[
				-66,
				154
			],
			[
				95,
				134
			],
			[
				27,
				151
			],
			[
				34,
				32
			]
		],
		[
			[
				957,
				1002
			],
			[
				23,
				-66
			]
		],
		[
			[
				980,
				936
			],
			[
				34,
				-29
			]
		],
		[
			[
				868,
				965
			],
			[
				-99,
				-168
			],
			[
				-54,
				86
			],
			[
				153,
				82
			]
		],
		[
			[
				4844,
				4720
			],
			[
				86,
				-76
			]
		],
		[
			[
				4933,
				4628
			],
			[
				-43,
				19
			]
		],
		[
			[
				4890,
				4647
			],
			[
				2,
				-11
			]
		],
		[
			[
				4892,
				4636
			],
			[
				-43,
				-21
			]
		],
		[
			[
				4849,
				4615
			],
			[
				-16,
				-20
			]
		],
		[
			[
				4833,
				4595
			],
			[
				-19,
				-67
			]
		],
		[
			[
				4814,
				4528
			],
			[
				-57,
				9
			]
		],
		[
			[
				4757,
				4537
			],
			[
				-19,
				54
			],
			[
				-8,
				-4
			],
			[
				-3,
				8
			]
		],
		[
			[
				4727,
				4595
			],
			[
				28,
				9
			]
		],
		[
			[
				4718,
				4750
			],
			[
				16,
				48
			]
		],
		[
			[
				4734,
				4798
			],
			[
				14,
				14
			]
		],
		[
			[
				4748,
				4812
			],
			[
				22,
				-23
			]
		],
		[
			[
				3933,
				4351
			],
			[
				-12,
				-14
			]
		],
		[
			[
				4124,
				4240
			],
			[
				-7,
				-51
			]
		],
		[
			[
				4117,
				4189
			],
			[
				34,
				-123
			]
		],
		[
			[
				4151,
				4066
			],
			[
				-52,
				-67
			]
		],
		[
			[
				4102,
				3942
			],
			[
				16,
				-40
			],
			[
				-5,
				-43
			]
		],
		[
			[
				3996,
				3757
			],
			[
				-42,
				-23
			]
		],
		[
			[
				3886,
				3929
			],
			[
				-64,
				22
			]
		],
		[
			[
				3738,
				3875
			],
			[
				13,
				-20
			]
		],
		[
			[
				3751,
				3855
			],
			[
				-1,
				-20
			]
		],
		[
			[
				3717,
				3920
			],
			[
				12,
				36
			]
		],
		[
			[
				3668,
				4003
			],
			[
				-6,
				6
			]
		],
		[
			[
				3632,
				4028
			],
			[
				25,
				67
			]
		],
		[
			[
				3657,
				4095
			],
			[
				21,
				157
			]
		],
		[
			[
				3678,
				4252
			],
			[
				78,
				-12
			]
		],
		[
			[
				3803,
				4315
			],
			[
				20,
				24
			],
			[
				59,
				11
			],
			[
				18,
				-8
			],
			[
				33,
				9
			]
		],
		[
			[
				1671,
				5871
			],
			[
				53,
				30
			]
		],
		[
			[
				1819,
				5889
			],
			[
				88,
				-90
			]
		],
		[
			[
				1907,
				5799
			],
			[
				96,
				-21
			]
		],
		[
			[
				2095,
				5771
			],
			[
				55,
				-16
			]
		],
		[
			[
				2150,
				5755
			],
			[
				8,
				-97
			]
		],
		[
			[
				2158,
				5658
			],
			[
				-166,
				-100
			],
			[
				-50,
				-68
			]
		],
		[
			[
				1942,
				5490
			],
			[
				-13,
				-35
			]
		],
		[
			[
				1929,
				5455
			],
			[
				-40,
				42
			],
			[
				-49,
				-12
			]
		],
		[
			[
				1569,
				5583
			],
			[
				-41,
				-13
			],
			[
				-20,
				11
			],
			[
				-34,
				-10
			]
		],
		[
			[
				1477,
				5937
			],
			[
				50,
				9
			]
		],
		[
			[
				1541,
				5959
			],
			[
				125,
				-109
			]
		],
		[
			[
				6147,
				3752
			],
			[
				9,
				-12
			]
		],
		[
			[
				6156,
				3740
			],
			[
				-62,
				-15
			]
		],
		[
			[
				6026,
				3809
			],
			[
				-18,
				74
			]
		],
		[
			[
				6000,
				4266
			],
			[
				62,
				44
			]
		],
		[
			[
				6062,
				4310
			],
			[
				66,
				-7
			]
		],
		[
			[
				6468,
				8082
			],
			[
				153,
				-37
			]
		],
		[
			[
				6753,
				8051
			],
			[
				71,
				-81
			]
		],
		[
			[
				6835,
				7862
			],
			[
				-95,
				36
			],
			[
				-39,
				-2
			],
			[
				-49,
				-25
			]
		],
		[
			[
				6652,
				7871
			],
			[
				-23,
				-35
			]
		],
		[
			[
				6629,
				7836
			],
			[
				-39,
				-24
			],
			[
				-98,
				-41
			]
		],
		[
			[
				6492,
				7771
			],
			[
				-24,
				61
			],
			[
				8,
				40
			],
			[
				-21,
				10
			],
			[
				-51,
				111
			],
			[
				64,
				89
			]
		],
		[
			[
				4934,
				7635
			],
			[
				-96,
				86
			]
		],
		[
			[
				4838,
				7721
			],
			[
				29,
				92
			]
		],
		[
			[
				4930,
				8172
			],
			[
				50,
				-26
			],
			[
				18,
				-103
			],
			[
				90,
				-122
			],
			[
				-138,
				-5
			],
			[
				-16,
				-281
			]
		],
		[
			[
				1595,
				1721
			],
			[
				8,
				-11
			]
		],
		[
			[
				1582,
				1643
			],
			[
				-8,
				-70
			]
		],
		[
			[
				1592,
				1460
			],
			[
				18,
				-4
			]
		],
		[
			[
				1610,
				1456
			],
			[
				-2,
				-11
			],
			[
				-32,
				7
			],
			[
				-50,
				-20
			],
			[
				-78,
				79
			],
			[
				-51,
				-20
			]
		],
		[
			[
				1397,
				1491
			],
			[
				-55,
				10
			]
		],
		[
			[
				1342,
				1501
			],
			[
				11,
				111
			]
		],
		[
			[
				1353,
				1612
			],
			[
				49,
				13
			]
		],
		[
			[
				1542,
				1765
			],
			[
				51,
				12
			]
		],
		[
			[
				3950,
				7980
			],
			[
				113,
				-172
			]
		],
		[
			[
				3944,
				7541
			],
			[
				-13,
				-22
			]
		],
		[
			[
				3838,
				7470
			],
			[
				-67,
				8
			]
		],
		[
			[
				3636,
				7762
			],
			[
				-48,
				119
			]
		],
		[
			[
				3588,
				7881
			],
			[
				51,
				64
			],
			[
				98,
				18
			],
			[
				89,
				115
			]
		],
		[
			[
				3826,
				8078
			],
			[
				-14,
				-31
			]
		],
		[
			[
				1879,
				5226
			],
			[
				67,
				9
			]
		],
		[
			[
				1946,
				5235
			],
			[
				10,
				-66
			]
		],
		[
			[
				1956,
				5169
			],
			[
				22,
				-1
			]
		],
		[
			[
				1978,
				5168
			],
			[
				57,
				-129
			]
		],
		[
			[
				2035,
				5039
			],
			[
				-7,
				-14
			]
		],
		[
			[
				2028,
				5025
			],
			[
				-75,
				-85
			]
		],
		[
			[
				1953,
				4940
			],
			[
				-20,
				44
			],
			[
				-34,
				12
			],
			[
				-44,
				-7
			],
			[
				-65,
				-35
			],
			[
				-40,
				9
			],
			[
				-14,
				29
			],
			[
				-1,
				75
			]
		],
		[
			[
				1735,
				5067
			],
			[
				-26,
				106
			],
			[
				33,
				53
			]
		],
		[
			[
				1760,
				5232
			],
			[
				46,
				-35
			]
		],
		[
			[
				4844,
				3836
			],
			[
				57,
				-26
			]
		],
		[
			[
				4931,
				3714
			],
			[
				-9,
				-40
			]
		],
		[
			[
				4680,
				3694
			],
			[
				-12,
				38
			]
		],
		[
			[
				4628,
				3752
			],
			[
				-33,
				-14
			]
		],
		[
			[
				4491,
				3746
			],
			[
				-18,
				45
			]
		],
		[
			[
				4488,
				3805
			],
			[
				7,
				38
			]
		],
		[
			[
				4515,
				3824
			],
			[
				34,
				18
			],
			[
				10,
				20
			],
			[
				-20,
				81
			]
		],
		[
			[
				4539,
				3943
			],
			[
				18,
				-11
			]
		],
		[
			[
				4557,
				3932
			],
			[
				14,
				-12
			]
		],
		[
			[
				3336,
				7361
			],
			[
				26,
				-85
			]
		],
		[
			[
				3290,
				7253
			],
			[
				22,
				-73
			]
		],
		[
			[
				3312,
				7180
			],
			[
				-84,
				-15
			]
		],
		[
			[
				3228,
				7165
			],
			[
				-156,
				83
			],
			[
				-39,
				74
			]
		],
		[
			[
				3033,
				7322
			],
			[
				45,
				50
			],
			[
				88,
				-15
			]
		],
		[
			[
				3216,
				7408
			],
			[
				49,
				19
			]
		],
		[
			[
				4961,
				5978
			],
			[
				37,
				4
			]
		],
		[
			[
				4998,
				5982
			],
			[
				20,
				-20
			]
		],
		[
			[
				5018,
				5962
			],
			[
				80,
				-81
			]
		],
		[
			[
				5019,
				5714
			],
			[
				-11,
				-81
			]
		],
		[
			[
				5069,
				5607
			],
			[
				-7,
				-29
			]
		],
		[
			[
				5062,
				5578
			],
			[
				-37,
				-56
			]
		],
		[
			[
				5025,
				5522
			],
			[
				-53,
				-19
			]
		],
		[
			[
				4972,
				5503
			],
			[
				-119,
				-4
			]
		],
		[
			[
				4853,
				5499
			],
			[
				-24,
				74
			]
		],
		[
			[
				4829,
				5573
			],
			[
				-48,
				8
			]
		],
		[
			[
				4781,
				5581
			],
			[
				-57,
				28
			]
		],
		[
			[
				4724,
				5609
			],
			[
				-38,
				38
			]
		],
		[
			[
				4686,
				5647
			],
			[
				-18,
				2
			]
		],
		[
			[
				4668,
				5649
			],
			[
				8,
				70
			]
		],
		[
			[
				4676,
				5719
			],
			[
				-57,
				146
			]
		],
		[
			[
				4619,
				5865
			],
			[
				-11,
				55
			]
		],
		[
			[
				4608,
				5920
			],
			[
				27,
				11
			]
		],
		[
			[
				4635,
				5931
			],
			[
				88,
				-24
			],
			[
				111,
				-9
			],
			[
				12,
				18
			],
			[
				-14,
				40
			]
		],
		[
			[
				4832,
				5956
			],
			[
				20,
				51
			]
		],
		[
			[
				4852,
				6007
			],
			[
				22,
				-2
			]
		],
		[
			[
				4874,
				6005
			],
			[
				87,
				-27
			]
		],
		[
			[
				2705,
				3948
			],
			[
				123,
				28
			]
		],
		[
			[
				2828,
				3976
			],
			[
				8,
				-23
			]
		],
		[
			[
				2836,
				3953
			],
			[
				-22,
				-58
			],
			[
				126,
				-43
			]
		],
		[
			[
				2905,
				3795
			],
			[
				-59,
				-97
			]
		],
		[
			[
				2846,
				3698
			],
			[
				-37,
				-4
			]
		],
		[
			[
				2660,
				3855
			],
			[
				5,
				62
			]
		],
		[
			[
				2691,
				3972
			],
			[
				14,
				-24
			]
		],
		[
			[
				6149,
				7119
			],
			[
				107,
				-15
			]
		],
		[
			[
				6256,
				7104
			],
			[
				2,
				-41
			]
		],
		[
			[
				6258,
				7063
			],
			[
				-53,
				-118
			]
		],
		[
			[
				6205,
				6945
			],
			[
				-27,
				-57
			]
		],
		[
			[
				6178,
				6888
			],
			[
				-11,
				8
			]
		],
		[
			[
				6167,
				6896
			],
			[
				-98,
				64
			]
		],
		[
			[
				6050,
				7014
			],
			[
				-84,
				53
			]
		],
		[
			[
				5966,
				7067
			],
			[
				37,
				37
			]
		],
		[
			[
				6009,
				7160
			],
			[
				140,
				-41
			]
		],
		[
			[
				8433,
				5612
			],
			[
				67,
				-120
			],
			[
				-54,
				-141
			],
			[
				17,
				-80
			],
			[
				116,
				20
			],
			[
				-19,
				-82
			],
			[
				-119,
				-17
			],
			[
				-97,
				-59
			]
		],
		[
			[
				8304,
				5131
			],
			[
				-32,
				23
			]
		],
		[
			[
				8106,
				5340
			],
			[
				60,
				35
			]
		],
		[
			[
				8166,
				5375
			],
			[
				49,
				37
			]
		],
		[
			[
				8298,
				5490
			],
			[
				21,
				33
			]
		],
		[
			[
				8300,
				5631
			],
			[
				74,
				-59
			]
		],
		[
			[
				4472,
				6289
			],
			[
				83,
				-1
			]
		],
		[
			[
				4735,
				6210
			],
			[
				23,
				-1
			],
			[
				27,
				-22
			],
			[
				43,
				-66
			],
			[
				-3,
				-61
			]
		],
		[
			[
				4825,
				6060
			],
			[
				7,
				-104
			]
		],
		[
			[
				4832,
				5956
			],
			[
				11,
				-55
			],
			[
				-92,
				0
			],
			[
				-116,
				30
			]
		],
		[
			[
				4635,
				5931
			],
			[
				-78,
				103
			]
		],
		[
			[
				4557,
				6034
			],
			[
				-108,
				-22
			],
			[
				-72,
				99
			]
		],
		[
			[
				4377,
				6111
			],
			[
				13,
				42
			],
			[
				-16,
				16
			],
			[
				10,
				12
			]
		],
		[
			[
				4384,
				6181
			],
			[
				11,
				-9
			]
		],
		[
			[
				4365,
				6304
			],
			[
				75,
				11
			]
		],
		[
			[
				6665,
				8364
			],
			[
				-81,
				-13
			]
		],
		[
			[
				6448,
				8281
			],
			[
				8,
				19
			]
		],
		[
			[
				6484,
				8682
			],
			[
				-21,
				34
			],
			[
				230,
				124
			],
			[
				111,
				-91
			],
			[
				29,
				-182
			],
			[
				-18,
				-83
			],
			[
				10,
				-193
			],
			[
				-144,
				28
			]
		],
		[
			[
				2059,
				2369
			],
			[
				50,
				-17
			]
		],
		[
			[
				2171,
				2167
			],
			[
				4,
				7
			]
		],
		[
			[
				2229,
				2124
			],
			[
				2,
				-60
			]
		],
		[
			[
				2102,
				2053
			],
			[
				-53,
				56
			]
		],
		[
			[
				1950,
				2005
			],
			[
				-23,
				-19
			]
		],
		[
			[
				1796,
				1976
			],
			[
				-26,
				39
			]
		],
		[
			[
				1650,
				2175
			],
			[
				-22,
				64
			]
		],
		[
			[
				1628,
				2239
			],
			[
				101,
				47
			],
			[
				123,
				-3
			]
		],
		[
			[
				1852,
				2283
			],
			[
				77,
				78
			]
		],
		[
			[
				1929,
				2361
			],
			[
				130,
				8
			]
		],
		[
			[
				1643,
				2556
			],
			[
				32,
				-56
			],
			[
				80,
				-48
			]
		],
		[
			[
				1755,
				2452
			],
			[
				119,
				-124
			]
		],
		[
			[
				1874,
				2328
			],
			[
				-22,
				-45
			]
		],
		[
			[
				1628,
				2239
			],
			[
				-81,
				7
			]
		],
		[
			[
				1487,
				2464
			],
			[
				-14,
				32
			]
		],
		[
			[
				1451,
				2501
			],
			[
				9,
				32
			]
		],
		[
			[
				1460,
				2533
			],
			[
				42,
				18
			]
		],
		[
			[
				1502,
				2551
			],
			[
				-1,
				8
			]
		],
		[
			[
				1501,
				2559
			],
			[
				111,
				12
			]
		],
		[
			[
				1233,
				2008
			],
			[
				-7,
				-32
			]
		],
		[
			[
				1261,
				1794
			],
			[
				-65,
				-83
			]
		],
		[
			[
				1196,
				1711
			],
			[
				-3,
				-23
			]
		],
		[
			[
				1193,
				1688
			],
			[
				-41,
				20
			]
		],
		[
			[
				1052,
				1747
			],
			[
				-38,
				81
			]
		],
		[
			[
				1014,
				1828
			],
			[
				102,
				101
			],
			[
				-2,
				71
			]
		],
		[
			[
				1114,
				2000
			],
			[
				119,
				8
			]
		],
		[
			[
				3272,
				6458
			],
			[
				67,
				-19
			]
		],
		[
			[
				3339,
				6439
			],
			[
				-1,
				-38
			]
		],
		[
			[
				2948,
				6077
			],
			[
				-42,
				37
			]
		],
		[
			[
				2906,
				6114
			],
			[
				-65,
				134
			]
		],
		[
			[
				2841,
				6248
			],
			[
				9,
				51
			]
		],
		[
			[
				2850,
				6299
			],
			[
				68,
				198
			]
		],
		[
			[
				2918,
				6497
			],
			[
				6,
				96
			]
		],
		[
			[
				2924,
				6593
			],
			[
				279,
				34
			]
		],
		[
			[
				3203,
				6627
			],
			[
				19,
				22
			]
		],
		[
			[
				1709,
				5166
			],
			[
				26,
				-99
			]
		],
		[
			[
				1735,
				5067
			],
			[
				3,
				-83
			],
			[
				18,
				-26
			],
			[
				39,
				-3
			],
			[
				85,
				41
			],
			[
				60,
				-20
			],
			[
				13,
				-36
			]
		],
		[
			[
				1953,
				4940
			],
			[
				-27,
				-104
			],
			[
				16,
				-28
			],
			[
				40,
				-27
			]
		],
		[
			[
				1812,
				4697
			],
			[
				-56,
				78
			]
		],
		[
			[
				1756,
				4775
			],
			[
				-40,
				-3
			]
		],
		[
			[
				1716,
				4772
			],
			[
				-20,
				55
			]
		],
		[
			[
				1613,
				4902
			],
			[
				40,
				88
			]
		],
		[
			[
				1620,
				5036
			],
			[
				13,
				128
			]
		],
		[
			[
				1685,
				5181
			],
			[
				6,
				-25
			]
		],
		[
			[
				2384,
				5072
			],
			[
				-125,
				-91
			]
		],
		[
			[
				2259,
				4981
			],
			[
				18,
				-35
			]
		],
		[
			[
				2277,
				4946
			],
			[
				-84,
				-60
			]
		],
		[
			[
				2193,
				4886
			],
			[
				-13,
				-25
			]
		],
		[
			[
				2180,
				4861
			],
			[
				5,
				-45
			]
		],
		[
			[
				2000,
				4887
			],
			[
				-50,
				38
			]
		],
		[
			[
				1950,
				4925
			],
			[
				3,
				15
			]
		],
		[
			[
				2028,
				5025
			],
			[
				62,
				0
			],
			[
				48,
				12
			],
			[
				70,
				45
			]
		],
		[
			[
				2208,
				5082
			],
			[
				140,
				32
			]
		],
		[
			[
				2348,
				5114
			],
			[
				36,
				-42
			]
		],
		[
			[
				4793,
				7048
			],
			[
				-39,
				56
			]
		],
		[
			[
				4947,
				7427
			],
			[
				177,
				-85
			],
			[
				14,
				-179
			],
			[
				-345,
				-115
			]
		],
		[
			[
				2869,
				5146
			],
			[
				24,
				-40
			]
		],
		[
			[
				2893,
				5106
			],
			[
				69,
				-45
			]
		],
		[
			[
				3056,
				4893
			],
			[
				-52,
				-22
			]
		],
		[
			[
				3039,
				4717
			],
			[
				-1,
				-73
			]
		],
		[
			[
				2958,
				4607
			],
			[
				-80,
				14
			]
		],
		[
			[
				2829,
				4727
			],
			[
				-98,
				87
			]
		],
		[
			[
				2693,
				5064
			],
			[
				7,
				101
			]
		],
		[
			[
				2700,
				5165
			],
			[
				52,
				24
			]
		],
		[
			[
				2759,
				5212
			],
			[
				26,
				-3
			]
		],
		[
			[
				6029,
				5010
			],
			[
				15,
				-2
			]
		],
		[
			[
				6044,
				5008
			],
			[
				4,
				-30
			]
		],
		[
			[
				6048,
				4978
			],
			[
				-64,
				-99
			],
			[
				61,
				-136
			],
			[
				-81,
				-16
			]
		],
		[
			[
				5964,
				4727
			],
			[
				-34,
				11
			]
		],
		[
			[
				5780,
				4748
			],
			[
				-89,
				27
			]
		],
		[
			[
				5691,
				4775
			],
			[
				20,
				30
			]
		],
		[
			[
				5711,
				4805
			],
			[
				-50,
				88
			],
			[
				24,
				77
			]
		],
		[
			[
				5685,
				4970
			],
			[
				31,
				40
			]
		],
		[
			[
				5716,
				5010
			],
			[
				126,
				-13
			],
			[
				50,
				30
			]
		],
		[
			[
				5892,
				5027
			],
			[
				27,
				16
			]
		],
		[
			[
				5919,
				5043
			],
			[
				80,
				14
			]
		],
		[
			[
				5999,
				5057
			],
			[
				30,
				-47
			]
		],
		[
			[
				3408,
				6901
			],
			[
				63,
				-99
			]
		],
		[
			[
				3386,
				6729
			],
			[
				-111,
				14
			],
			[
				-19,
				-40
			],
			[
				2,
				-31
			]
		],
		[
			[
				3258,
				6672
			],
			[
				-23,
				-23
			],
			[
				-18,
				0
			],
			[
				-14,
				-22
			]
		],
		[
			[
				2924,
				6593
			],
			[
				-8,
				22
			],
			[
				-9,
				-6
			],
			[
				-14,
				20
			],
			[
				-52,
				27
			],
			[
				4,
				89
			]
		],
		[
			[
				2845,
				6745
			],
			[
				75,
				-24
			],
			[
				84,
				30
			],
			[
				110,
				134
			]
		],
		[
			[
				3114,
				6885
			],
			[
				184,
				-13
			]
		],
		[
			[
				3298,
				6872
			],
			[
				11,
				32
			]
		],
		[
			[
				3309,
				6904
			],
			[
				43,
				29
			]
		],
		[
			[
				3364,
				6927
			],
			[
				54,
				-5
			]
		],
		[
			[
				2006,
				5538
			],
			[
				22,
				-50
			],
			[
				108,
				-50
			]
		],
		[
			[
				2136,
				5438
			],
			[
				56,
				-112
			]
		],
		[
			[
				2192,
				5326
			],
			[
				136,
				-4
			]
		],
		[
			[
				2328,
				5322
			],
			[
				9,
				-59
			]
		],
		[
			[
				2337,
				5263
			],
			[
				59,
				-88
			]
		],
		[
			[
				2396,
				5175
			],
			[
				-48,
				-61
			]
		],
		[
			[
				2348,
				5114
			],
			[
				-140,
				-32
			]
		],
		[
			[
				2208,
				5082
			],
			[
				-69,
				-44
			],
			[
				-47,
				-12
			],
			[
				-57,
				13
			]
		],
		[
			[
				2035,
				5039
			],
			[
				-57,
				129
			]
		],
		[
			[
				1956,
				5169
			],
			[
				-11,
				96
			]
		],
		[
			[
				1958,
				5260
			],
			[
				12,
				14
			],
			[
				20,
				-13
			],
			[
				25,
				41
			],
			[
				-13,
				91
			]
		],
		[
			[
				1908,
				5426
			],
			[
				34,
				64
			]
		],
		[
			[
				1942,
				5490
			],
			[
				64,
				48
			]
		],
		[
			[
				2647,
				2710
			],
			[
				93,
				49
			],
			[
				130,
				-17
			]
		],
		[
			[
				2870,
				2742
			],
			[
				-14,
				-21
			]
		],
		[
			[
				2915,
				2497
			],
			[
				71,
				-67
			]
		],
		[
			[
				3036,
				2375
			],
			[
				4,
				-85
			]
		],
		[
			[
				3040,
				2290
			],
			[
				35,
				-129
			]
		],
		[
			[
				3075,
				2161
			],
			[
				-150,
				-167
			]
		],
		[
			[
				2846,
				2058
			],
			[
				-61,
				-1
			]
		],
		[
			[
				2668,
				2038
			],
			[
				-8,
				-13
			]
		],
		[
			[
				2600,
				2002
			],
			[
				-22,
				42
			]
		],
		[
			[
				2541,
				2011
			],
			[
				-44,
				183
			]
		],
		[
			[
				2511,
				2231
			],
			[
				-124,
				50
			]
		],
		[
			[
				2384,
				2290
			],
			[
				-68,
				43
			]
		],
		[
			[
				2278,
				2375
			],
			[
				-33,
				84
			]
		],
		[
			[
				2161,
				2900
			],
			[
				-1,
				26
			]
		],
		[
			[
				2160,
				2926
			],
			[
				34,
				18
			]
		],
		[
			[
				2194,
				2944
			],
			[
				32,
				-38
			]
		],
		[
			[
				2226,
				2906
			],
			[
				127,
				100
			]
		],
		[
			[
				2353,
				3006
			],
			[
				15,
				-41
			],
			[
				82,
				-30
			],
			[
				50,
				-41
			],
			[
				126,
				-104
			],
			[
				16,
				-28
			],
			[
				5,
				-52
			]
		],
		[
			[
				2505,
				4177
			],
			[
				-59,
				-14
			]
		],
		[
			[
				2345,
				4119
			],
			[
				-46,
				-37
			]
		],
		[
			[
				2299,
				4082
			],
			[
				-20,
				69
			]
		],
		[
			[
				2236,
				4470
			],
			[
				54,
				6
			]
		],
		[
			[
				2290,
				4476
			],
			[
				104,
				37
			]
		],
		[
			[
				2394,
				4513
			],
			[
				114,
				18
			]
		],
		[
			[
				4070,
				7282
			],
			[
				78,
				21
			]
		],
		[
			[
				4159,
				7291
			],
			[
				64,
				19
			]
		],
		[
			[
				4223,
				7310
			],
			[
				58,
				-38
			]
		],
		[
			[
				4281,
				7272
			],
			[
				17,
				2
			]
		],
		[
			[
				4298,
				7274
			],
			[
				58,
				-23
			]
		],
		[
			[
				4356,
				7251
			],
			[
				63,
				-2
			]
		],
		[
			[
				4419,
				7249
			],
			[
				0,
				-108
			]
		],
		[
			[
				4430,
				7155
			],
			[
				58,
				-52
			],
			[
				32,
				-14
			]
		],
		[
			[
				4405,
				6836
			],
			[
				-46,
				-4
			]
		],
		[
			[
				4231,
				6879
			],
			[
				-37,
				38
			]
		],
		[
			[
				4083,
				6896
			],
			[
				-70,
				46
			]
		],
		[
			[
				4013,
				6942
			],
			[
				-21,
				67
			]
		],
		[
			[
				3992,
				7009
			],
			[
				3,
				12
			]
		],
		[
			[
				3995,
				7021
			],
			[
				28,
				59
			]
		],
		[
			[
				4023,
				7080
			],
			[
				-53,
				147
			]
		],
		[
			[
				3970,
				7227
			],
			[
				86,
				82
			]
		],
		[
			[
				4781,
				5581
			],
			[
				48,
				-8
			]
		],
		[
			[
				4853,
				5499
			],
			[
				119,
				4
			]
		],
		[
			[
				4972,
				5503
			],
			[
				82,
				-49
			]
		],
		[
			[
				5054,
				5454
			],
			[
				59,
				-70
			]
		],
		[
			[
				4905,
				5140
			],
			[
				7,
				-72
			]
		],
		[
			[
				4912,
				5068
			],
			[
				-103,
				-7
			]
		],
		[
			[
				4809,
				5061
			],
			[
				-114,
				-64
			]
		],
		[
			[
				4606,
				5152
			],
			[
				-53,
				13
			]
		],
		[
			[
				4538,
				5183
			],
			[
				-74,
				10
			]
		],
		[
			[
				4464,
				5193
			],
			[
				-31,
				-55
			]
		],
		[
			[
				4433,
				5138
			],
			[
				-67,
				3
			]
		],
		[
			[
				4366,
				5141
			],
			[
				-30,
				196
			]
		],
		[
			[
				4336,
				5337
			],
			[
				35,
				-2
			]
		],
		[
			[
				4371,
				5335
			],
			[
				59,
				35
			]
		],
		[
			[
				4430,
				5370
			],
			[
				31,
				28
			]
		],
		[
			[
				4461,
				5398
			],
			[
				-53,
				136
			]
		],
		[
			[
				4408,
				5534
			],
			[
				24,
				25
			]
		],
		[
			[
				4481,
				5611
			],
			[
				0,
				28
			]
		],
		[
			[
				4481,
				5639
			],
			[
				82,
				-55
			],
			[
				78,
				43
			]
		],
		[
			[
				4641,
				5627
			],
			[
				27,
				22
			]
		],
		[
			[
				4686,
				5647
			],
			[
				38,
				-38
			]
		],
		[
			[
				2745,
				7260
			],
			[
				42,
				-28
			]
		],
		[
			[
				2787,
				7232
			],
			[
				-41,
				-55
			]
		],
		[
			[
				2868,
				7020
			],
			[
				-61,
				-130
			],
			[
				-6,
				-107
			]
		],
		[
			[
				2592,
				6801
			],
			[
				-46,
				73
			]
		],
		[
			[
				2529,
				6885
			],
			[
				-37,
				-7
			]
		],
		[
			[
				2453,
				7148
			],
			[
				-67,
				65
			]
		],
		[
			[
				2386,
				7213
			],
			[
				32,
				113
			],
			[
				67,
				81
			],
			[
				109,
				16
			]
		],
		[
			[
				1975,
				3064
			],
			[
				28,
				-88
			],
			[
				108,
				-43
			]
		],
		[
			[
				2110,
				2910
			],
			[
				22,
				-72
			]
		],
		[
			[
				2051,
				2791
			],
			[
				-31,
				-64
			]
		],
		[
			[
				2020,
				2727
			],
			[
				-101,
				3
			]
		],
		[
			[
				1919,
				2730
			],
			[
				-87,
				44
			]
		],
		[
			[
				1899,
				3069
			],
			[
				43,
				46
			]
		],
		[
			[
				1942,
				3115
			],
			[
				33,
				-51
			]
		],
		[
			[
				1610,
				1456
			],
			[
				35,
				-18
			]
		],
		[
			[
				1723,
				1444
			],
			[
				10,
				-16
			]
		],
		[
			[
				1661,
				1281
			],
			[
				-10,
				12
			]
		],
		[
			[
				1541,
				1266
			],
			[
				-157,
				38
			]
		],
		[
			[
				1303,
				1250
			],
			[
				-20,
				-17
			]
		],
		[
			[
				1206,
				1270
			],
			[
				-9,
				82
			]
		],
		[
			[
				1197,
				1352
			],
			[
				33,
				27
			]
		],
		[
			[
				1230,
				1379
			],
			[
				140,
				26
			]
		],
		[
			[
				1370,
				1405
			],
			[
				-7,
				44
			]
		],
		[
			[
				1363,
				1449
			],
			[
				34,
				42
			]
		],
		[
			[
				3422,
				5194
			],
			[
				26,
				-16
			]
		],
		[
			[
				3455,
				5140
			],
			[
				25,
				11
			]
		],
		[
			[
				3536,
				5105
			],
			[
				-6,
				-21
			]
		],
		[
			[
				3585,
				4796
			],
			[
				-69,
				-30
			]
		],
		[
			[
				3516,
				4766
			],
			[
				-101,
				46
			]
		],
		[
			[
				3343,
				4958
			],
			[
				-34,
				-15
			],
			[
				-4,
				20
			],
			[
				-13,
				5
			],
			[
				-3,
				10
			]
		],
		[
			[
				3289,
				4978
			],
			[
				24,
				13
			]
		],
		[
			[
				3389,
				5032
			],
			[
				19,
				61
			]
		],
		[
			[
				3408,
				5168
			],
			[
				14,
				26
			]
		],
		[
			[
				1599,
				1080
			],
			[
				9,
				-15
			]
		],
		[
			[
				1608,
				1065
			],
			[
				18,
				-78
			]
		],
		[
			[
				1608,
				926
			],
			[
				6,
				-18
			]
		],
		[
			[
				1614,
				908
			],
			[
				-25,
				-17
			],
			[
				-16,
				9
			],
			[
				-26,
				-30
			],
			[
				6,
				-71
			],
			[
				-56,
				-93
			]
		],
		[
			[
				1497,
				706
			],
			[
				0,
				-28
			]
		],
		[
			[
				1415,
				663
			],
			[
				-74,
				16
			]
		],
		[
			[
				1323,
				663
			],
			[
				-37,
				6
			]
		],
		[
			[
				1262,
				702
			],
			[
				-32,
				6
			]
		],
		[
			[
				1134,
				681
			],
			[
				52,
				44
			]
		],
		[
			[
				1207,
				795
			],
			[
				-49,
				-24
			]
		],
		[
			[
				1306,
				1064
			],
			[
				6,
				69
			]
		],
		[
			[
				3558,
				3629
			],
			[
				27,
				27
			]
		],
		[
			[
				3621,
				3641
			],
			[
				26,
				19
			]
		],
		[
			[
				3647,
				3660
			],
			[
				32,
				-32
			]
		],
		[
			[
				3679,
				3628
			],
			[
				1,
				-69
			]
		],
		[
			[
				3680,
				3559
			],
			[
				25,
				-2
			]
		],
		[
			[
				3705,
				3586
			],
			[
				38,
				-49
			]
		],
		[
			[
				3743,
				3537
			],
			[
				1,
				-45
			]
		],
		[
			[
				3720,
				3427
			],
			[
				-21,
				-41
			]
		],
		[
			[
				3699,
				3386
			],
			[
				0,
				33
			]
		],
		[
			[
				3626,
				3352
			],
			[
				0,
				75
			]
		],
		[
			[
				3626,
				3427
			],
			[
				-30,
				33
			]
		],
		[
			[
				3443,
				3390
			],
			[
				-16,
				66
			]
		],
		[
			[
				3427,
				3456
			],
			[
				4,
				57
			]
		],
		[
			[
				3449,
				3614
			],
			[
				-3,
				15
			]
		],
		[
			[
				3509,
				3675
			],
			[
				36,
				-37
			]
		],
		[
			[
				4377,
				5558
			],
			[
				31,
				-24
			]
		],
		[
			[
				4461,
				5398
			],
			[
				-31,
				-28
			]
		],
		[
			[
				4371,
				5335
			],
			[
				-35,
				2
			]
		],
		[
			[
				4336,
				5337
			],
			[
				-7,
				-6
			]
		],
		[
			[
				4277,
				5321
			],
			[
				-59,
				-52
			]
		],
		[
			[
				4184,
				5281
			],
			[
				-51,
				-27
			]
		],
		[
			[
				4113,
				5245
			],
			[
				-60,
				-34
			]
		],
		[
			[
				4053,
				5211
			],
			[
				-43,
				131
			]
		],
		[
			[
				4010,
				5342
			],
			[
				12,
				89
			]
		],
		[
			[
				4022,
				5431
			],
			[
				54,
				50
			]
		],
		[
			[
				4218,
				5544
			],
			[
				3,
				-18
			]
		],
		[
			[
				4256,
				5542
			],
			[
				36,
				-23
			]
		],
		[
			[
				5415,
				4796
			],
			[
				59,
				-14
			],
			[
				118,
				34
			]
		],
		[
			[
				5592,
				4816
			],
			[
				60,
				-51
			]
		],
		[
			[
				5652,
				4765
			],
			[
				22,
				-26
			]
		],
		[
			[
				5605,
				4366
			],
			[
				-59,
				24
			]
		],
		[
			[
				5546,
				4390
			],
			[
				-165,
				91
			]
		],
		[
			[
				5381,
				4481
			],
			[
				-73,
				-14
			],
			[
				-26,
				7
			],
			[
				-17,
				-10
			],
			[
				-24,
				7
			],
			[
				-45,
				41
			]
		],
		[
			[
				5196,
				4512
			],
			[
				-34,
				11
			]
		],
		[
			[
				5162,
				4523
			],
			[
				-17,
				29
			]
		],
		[
			[
				5321,
				4809
			],
			[
				28,
				-27
			]
		],
		[
			[
				6457,
				7107
			],
			[
				30,
				-6
			]
		],
		[
			[
				6487,
				7101
			],
			[
				30,
				-99
			],
			[
				62,
				14
			],
			[
				62,
				-73
			]
		],
		[
			[
				6641,
				6943
			],
			[
				56,
				-3
			],
			[
				22,
				-26
			],
			[
				-8,
				-58
			],
			[
				-12,
				-19
			]
		],
		[
			[
				6682,
				6835
			],
			[
				34,
				-83
			]
		],
		[
			[
				6716,
				6752
			],
			[
				-33,
				-85
			],
			[
				-14,
				-88
			]
		],
		[
			[
				6628,
				6445
			],
			[
				-50,
				-44
			],
			[
				-46,
				-21
			],
			[
				-32,
				1
			],
			[
				-25,
				14
			],
			[
				-10,
				-22
			],
			[
				-33,
				-13
			]
		],
		[
			[
				6417,
				6385
			],
			[
				-14,
				14
			]
		],
		[
			[
				6354,
				6374
			],
			[
				-15,
				-19
			]
		],
		[
			[
				6045,
				6565
			],
			[
				34,
				10
			]
		],
		[
			[
				6210,
				6711
			],
			[
				21,
				62
			],
			[
				-57,
				32
			],
			[
				-41,
				69
			],
			[
				34,
				22
			]
		],
		[
			[
				6178,
				6888
			],
			[
				27,
				57
			]
		],
		[
			[
				6258,
				7063
			],
			[
				23,
				52
			]
		],
		[
			[
				6281,
				7115
			],
			[
				47,
				15
			]
		],
		[
			[
				6328,
				7130
			],
			[
				102,
				-1
			]
		],
		[
			[
				6888,
				5113
			],
			[
				78,
				-109
			]
		],
		[
			[
				7139,
				4873
			],
			[
				19,
				-42
			]
		],
		[
			[
				7070,
				4807
			],
			[
				30,
				-54
			]
		],
		[
			[
				7130,
				4704
			],
			[
				-63,
				-106
			]
		],
		[
			[
				7021,
				4507
			],
			[
				-88,
				37
			]
		],
		[
			[
				6702,
				4603
			],
			[
				-75,
				-7
			]
		],
		[
			[
				6814,
				5122
			],
			[
				62,
				4
			]
		],
		[
			[
				1760,
				769
			],
			[
				14,
				-61
			]
		],
		[
			[
				1618,
				489
			],
			[
				-21,
				-11
			]
		],
		[
			[
				1602,
				487
			],
			[
				-90,
				25
			]
		],
		[
			[
				1540,
				570
			],
			[
				-54,
				50
			]
		],
		[
			[
				1502,
				662
			],
			[
				-5,
				44
			]
		],
		[
			[
				1614,
				908
			],
			[
				7,
				-39
			]
		],
		[
			[
				1621,
				869
			],
			[
				46,
				22
			]
		],
		[
			[
				2953,
				7058
			],
			[
				37,
				-64
			],
			[
				95,
				-27
			]
		],
		[
			[
				3085,
				6967
			],
			[
				45,
				-34
			]
		],
		[
			[
				3130,
				6933
			],
			[
				1,
				-20
			]
		],
		[
			[
				3131,
				6913
			],
			[
				22,
				-19
			]
		],
		[
			[
				3153,
				6894
			],
			[
				-39,
				-9
			]
		],
		[
			[
				2845,
				6745
			],
			[
				-44,
				38
			]
		],
		[
			[
				2922,
				7062
			],
			[
				31,
				-4
			]
		],
		[
			[
				6921,
				7793
			],
			[
				-52,
				-72
			]
		],
		[
			[
				6869,
				7721
			],
			[
				-7,
				-29
			]
		],
		[
			[
				6841,
				7691
			],
			[
				-39,
				9
			]
		],
		[
			[
				6800,
				7677
			],
			[
				-31,
				-43
			]
		],
		[
			[
				6683,
				7708
			],
			[
				-72,
				25
			]
		],
		[
			[
				6611,
				7733
			],
			[
				-114,
				-14
			]
		],
		[
			[
				6491,
				7734
			],
			[
				-36,
				13
			]
		],
		[
			[
				6455,
				7747
			],
			[
				20,
				21
			]
		],
		[
			[
				6475,
				7768
			],
			[
				50,
				11
			],
			[
				40,
				29
			],
			[
				64,
				28
			]
		],
		[
			[
				6652,
				7871
			],
			[
				73,
				28
			],
			[
				90,
				-26
			],
			[
				83,
				-43
			],
			[
				23,
				-37
			]
		],
		[
			[
				5955,
				5252
			],
			[
				102,
				-23
			]
		],
		[
			[
				6057,
				5229
			],
			[
				10,
				-14
			]
		],
		[
			[
				6067,
				5215
			],
			[
				55,
				2
			],
			[
				37,
				-136
			]
		],
		[
			[
				6159,
				5081
			],
			[
				-86,
				-15
			]
		],
		[
			[
				6073,
				5066
			],
			[
				-29,
				-58
			]
		],
		[
			[
				6029,
				5010
			],
			[
				-30,
				47
			]
		],
		[
			[
				5919,
				5043
			],
			[
				-27,
				-16
			]
		],
		[
			[
				5716,
				5010
			],
			[
				-73,
				-26
			]
		],
		[
			[
				5643,
				4984
			],
			[
				-30,
				67
			]
		],
		[
			[
				5613,
				5051
			],
			[
				-3,
				75
			]
		],
		[
			[
				5610,
				5126
			],
			[
				16,
				50
			]
		],
		[
			[
				5626,
				5176
			],
			[
				37,
				9
			]
		],
		[
			[
				5663,
				5185
			],
			[
				90,
				64
			],
			[
				154,
				31
			]
		],
		[
			[
				5907,
				5280
			],
			[
				48,
				-28
			]
		],
		[
			[
				6656,
				6380
			],
			[
				109,
				-18
			],
			[
				89,
				-101
			]
		],
		[
			[
				6854,
				6261
			],
			[
				70,
				-133
			]
		],
		[
			[
				6783,
				6122
			],
			[
				-89,
				36
			]
		],
		[
			[
				6633,
				6143
			],
			[
				-64,
				-34
			]
		],
		[
			[
				6463,
				6371
			],
			[
				55,
				6
			],
			[
				84,
				39
			],
			[
				54,
				-36
			]
		],
		[
			[
				4194,
				2422
			],
			[
				-39,
				-33
			]
		],
		[
			[
				3819,
				2390
			],
			[
				0,
				17
			]
		],
		[
			[
				3778,
				2455
			],
			[
				-39,
				-1
			]
		],
		[
			[
				3739,
				2454
			],
			[
				-6,
				10
			],
			[
				3,
				10
			]
		],
		[
			[
				3877,
				2604
			],
			[
				83,
				-40
			]
		],
		[
			[
				4036,
				2604
			],
			[
				76,
				38
			]
		],
		[
			[
				4112,
				2642
			],
			[
				42,
				-22
			]
		],
		[
			[
				3185,
				1649
			],
			[
				26,
				-43
			]
		],
		[
			[
				3211,
				1606
			],
			[
				-79,
				-201
			]
		],
		[
			[
				3132,
				1405
			],
			[
				83,
				-151
			],
			[
				-30,
				-6
			],
			[
				-101,
				26
			]
		],
		[
			[
				3015,
				1244
			],
			[
				-54,
				51
			]
		],
		[
			[
				2961,
				1295
			],
			[
				-119,
				-113
			]
		],
		[
			[
				2765,
				1304
			],
			[
				33,
				-1
			]
		],
		[
			[
				2804,
				1672
			],
			[
				39,
				44
			]
		],
		[
			[
				2865,
				1746
			],
			[
				80,
				-41
			],
			[
				64,
				52
			]
		],
		[
			[
				3009,
				1757
			],
			[
				75,
				-83
			]
		],
		[
			[
				1020,
				5269
			],
			[
				-19,
				-31
			]
		],
		[
			[
				1001,
				5238
			],
			[
				17,
				-64
			],
			[
				179,
				-132
			],
			[
				-12,
				-65
			]
		],
		[
			[
				1185,
				4977
			],
			[
				-45,
				-6
			]
		],
		[
			[
				778,
				4789
			],
			[
				-57,
				49
			],
			[
				-14,
				89
			]
		],
		[
			[
				752,
				4963
			],
			[
				7,
				67
			],
			[
				19,
				21
			],
			[
				62,
				40
			],
			[
				41,
				2
			]
		],
		[
			[
				892,
				5129
			],
			[
				18,
				32
			]
		],
		[
			[
				901,
				5173
			],
			[
				-27,
				71
			]
		],
		[
			[
				911,
				5300
			],
			[
				58,
				-54
			]
		],
		[
			[
				939,
				3393
			],
			[
				65,
				-51
			]
		],
		[
			[
				1135,
				3149
			],
			[
				14,
				-41
			]
		],
		[
			[
				1149,
				3108
			],
			[
				-39,
				-29
			]
		],
		[
			[
				952,
				3118
			],
			[
				-27,
				20
			]
		],
		[
			[
				925,
				3138
			],
			[
				-25,
				-7
			]
		],
		[
			[
				806,
				3112
			],
			[
				-29,
				-16
			]
		],
		[
			[
				777,
				3096
			],
			[
				-29,
				22
			]
		],
		[
			[
				763,
				3131
			],
			[
				-40,
				47
			]
		],
		[
			[
				670,
				3237
			],
			[
				47,
				68
			],
			[
				-1,
				105
			]
		],
		[
			[
				716,
				3410
			],
			[
				84,
				-73
			],
			[
				49,
				38
			],
			[
				27,
				48
			]
		],
		[
			[
				899,
				3432
			],
			[
				40,
				-39
			]
		],
		[
			[
				1219,
				5304
			],
			[
				87,
				-73
			]
		],
		[
			[
				1366,
				5199
			],
			[
				-56,
				-22
			]
		],
		[
			[
				1312,
				4983
			],
			[
				-8,
				-30
			],
			[
				-40,
				-27
			],
			[
				-73,
				35
			],
			[
				-6,
				16
			]
		],
		[
			[
				1001,
				5238
			],
			[
				76,
				-7
			]
		],
		[
			[
				1167,
				5337
			],
			[
				26,
				44
			]
		],
		[
			[
				1193,
				5381
			],
			[
				26,
				-77
			]
		],
		[
			[
				2411,
				3129
			],
			[
				13,
				-48
			],
			[
				-71,
				-75
			]
		],
		[
			[
				2226,
				2906
			],
			[
				-32,
				38
			]
		],
		[
			[
				2160,
				2926
			],
			[
				-49,
				7
			]
		],
		[
			[
				1975,
				3064
			],
			[
				9,
				65
			]
		],
		[
			[
				2019,
				3144
			],
			[
				0,
				-7
			]
		],
		[
			[
				2219,
				3252
			],
			[
				37,
				-6
			],
			[
				65,
				74
			],
			[
				21,
				2
			],
			[
				19,
				-17
			],
			[
				-16,
				-53
			],
			[
				2,
				-56
			],
			[
				64,
				-67
			]
		],
		[
			[
				1497,
				3856
			],
			[
				87,
				-19
			]
		],
		[
			[
				1584,
				3837
			],
			[
				122,
				-11
			],
			[
				4,
				-45
			],
			[
				23,
				-59
			]
		],
		[
			[
				1733,
				3722
			],
			[
				33,
				5
			],
			[
				13,
				-40
			],
			[
				20,
				0
			],
			[
				5,
				-12
			]
		],
		[
			[
				1804,
				3675
			],
			[
				-49,
				-10
			]
		],
		[
			[
				1673,
				3620
			],
			[
				-80,
				-16
			]
		],
		[
			[
				1574,
				3563
			],
			[
				-32,
				22
			]
		],
		[
			[
				1505,
				3614
			],
			[
				-57,
				3
			],
			[
				-161,
				154
			]
		],
		[
			[
				1287,
				3771
			],
			[
				194,
				107
			]
		],
		[
			[
				1481,
				3878
			],
			[
				16,
				-22
			]
		],
		[
			[
				5627,
				5254
			],
			[
				-5,
				-23
			]
		],
		[
			[
				5622,
				5231
			],
			[
				4,
				-55
			]
		],
		[
			[
				5610,
				5126
			],
			[
				3,
				-75
			]
		],
		[
			[
				5643,
				4984
			],
			[
				42,
				-14
			]
		],
		[
			[
				5711,
				4805
			],
			[
				-59,
				-40
			]
		],
		[
			[
				5592,
				4816
			],
			[
				-48,
				-10
			]
		],
		[
			[
				5504,
				4832
			],
			[
				-32,
				50
			]
		],
		[
			[
				5475,
				5130
			],
			[
				-24,
				12
			]
		],
		[
			[
				5451,
				5142
			],
			[
				18,
				9
			],
			[
				-2,
				49
			],
			[
				20,
				40
			]
		],
		[
			[
				5487,
				5240
			],
			[
				78,
				4
			]
		],
		[
			[
				5565,
				5244
			],
			[
				62,
				10
			]
		],
		[
			[
				3020,
				4204
			],
			[
				45,
				-15
			]
		],
		[
			[
				3065,
				4189
			],
			[
				26,
				-51
			]
		],
		[
			[
				3107,
				3979
			],
			[
				3,
				-51
			]
		],
		[
			[
				2986,
				3895
			],
			[
				-46,
				-43
			]
		],
		[
			[
				2836,
				3953
			],
			[
				-8,
				23
			]
		],
		[
			[
				2705,
				3948
			],
			[
				26,
				60
			]
		],
		[
			[
				2729,
				4095
			],
			[
				28,
				45
			]
		],
		[
			[
				2793,
				4125
			],
			[
				46,
				6
			]
		],
		[
			[
				2987,
				4181
			],
			[
				15,
				10
			]
		],
		[
			[
				1643,
				4238
			],
			[
				185,
				13
			]
		],
		[
			[
				1828,
				4251
			],
			[
				3,
				-29
			]
		],
		[
			[
				1848,
				4227
			],
			[
				30,
				-23
			]
		],
		[
			[
				1922,
				4157
			],
			[
				-41,
				-26
			],
			[
				-8,
				-31
			],
			[
				16,
				-29
			],
			[
				109,
				-47
			]
		],
		[
			[
				1998,
				4024
			],
			[
				-17,
				-39
			],
			[
				-28,
				-22
			],
			[
				-28,
				-3
			]
		],
		[
			[
				1925,
				3960
			],
			[
				-129,
				-49
			]
		],
		[
			[
				1796,
				3911
			],
			[
				-2,
				-71
			]
		],
		[
			[
				1794,
				3840
			],
			[
				-210,
				-3
			]
		],
		[
			[
				1497,
				3856
			],
			[
				-24,
				33
			]
		],
		[
			[
				1522,
				4038
			],
			[
				-53,
				29
			]
		],
		[
			[
				1554,
				4271
			],
			[
				35,
				19
			]
		],
		[
			[
				2049,
				3702
			],
			[
				-123,
				-99
			]
		],
		[
			[
				1896,
				3625
			],
			[
				-27,
				91
			]
		],
		[
			[
				1853,
				3718
			],
			[
				-49,
				-43
			]
		],
		[
			[
				1733,
				3722
			],
			[
				-26,
				101
			],
			[
				87,
				17
			]
		],
		[
			[
				1796,
				3911
			],
			[
				129,
				49
			]
		],
		[
			[
				1925,
				3960
			],
			[
				43,
				11
			],
			[
				30,
				53
			]
		],
		[
			[
				1998,
				4024
			],
			[
				58,
				-54
			],
			[
				10,
				-31
			],
			[
				-8,
				-50
			],
			[
				-70,
				-121
			],
			[
				12,
				-33
			],
			[
				49,
				-33
			]
		],
		[
			[
				3193,
				2419
			],
			[
				-11,
				-25
			]
		],
		[
			[
				3238,
				2379
			],
			[
				36,
				16
			],
			[
				33,
				-18
			]
		],
		[
			[
				3307,
				2377
			],
			[
				-22,
				-24
			],
			[
				-9,
				-34
			]
		],
		[
			[
				3276,
				2319
			],
			[
				-91,
				-155
			]
		],
		[
			[
				3185,
				2164
			],
			[
				-31,
				-4
			]
		],
		[
			[
				3154,
				2160
			],
			[
				-79,
				1
			]
		],
		[
			[
				3040,
				2290
			],
			[
				3,
				53
			]
		],
		[
			[
				3142,
				2394
			],
			[
				32,
				44
			]
		],
		[
			[
				4155,
				6067
			],
			[
				-13,
				0
			]
		],
		[
			[
				4083,
				5877
			],
			[
				-86,
				-67
			]
		],
		[
			[
				3890,
				5989
			],
			[
				-9,
				-4
			]
		],
		[
			[
				3774,
				6018
			],
			[
				-22,
				1
			]
		],
		[
			[
				3752,
				6019
			],
			[
				-14,
				138
			]
		],
		[
			[
				3738,
				6157
			],
			[
				40,
				78
			]
		],
		[
			[
				3778,
				6235
			],
			[
				44,
				46
			],
			[
				-76,
				113
			]
		],
		[
			[
				3746,
				6394
			],
			[
				36,
				45
			]
		],
		[
			[
				3829,
				6436
			],
			[
				108,
				3
			]
		],
		[
			[
				548,
				1913
			],
			[
				-8,
				-29
			]
		],
		[
			[
				540,
				1884
			],
			[
				63,
				-7
			]
		],
		[
			[
				603,
				1877
			],
			[
				149,
				17
			]
		],
		[
			[
				752,
				1894
			],
			[
				2,
				-49
			]
		],
		[
			[
				817,
				1451
			],
			[
				-48,
				-71
			]
		],
		[
			[
				760,
				1384
			],
			[
				-74,
				-42
			],
			[
				-114,
				204
			],
			[
				-101,
				-4
			],
			[
				-97,
				40
			],
			[
				-13,
				172
			],
			[
				-58,
				111
			],
			[
				52,
				52
			],
			[
				-15,
				130
			],
			[
				95,
				-20
			]
		],
		[
			[
				7828,
				6291
			],
			[
				31,
				-125
			],
			[
				79,
				-14
			]
		],
		[
			[
				7938,
				6152
			],
			[
				20,
				-21
			]
		],
		[
			[
				7539,
				5906
			],
			[
				-47,
				-30
			]
		],
		[
			[
				7445,
				5845
			],
			[
				-28,
				194
			]
		],
		[
			[
				7417,
				6039
			],
			[
				64,
				3
			],
			[
				90,
				89
			],
			[
				19,
				84
			]
		],
		[
			[
				7590,
				6215
			],
			[
				42,
				-32
			],
			[
				33,
				3
			],
			[
				11,
				20
			],
			[
				100,
				61
			]
		],
		[
			[
				7776,
				6267
			],
			[
				57,
				72
			]
		],
		[
			[
				7833,
				6339
			],
			[
				-5,
				-48
			]
		],
		[
			[
				7660,
				6324
			],
			[
				83,
				13
			]
		],
		[
			[
				7743,
				6337
			],
			[
				-10,
				-42
			]
		],
		[
			[
				7733,
				6295
			],
			[
				20,
				-38
			],
			[
				-99,
				-74
			],
			[
				-55,
				16
			],
			[
				-9,
				16
			]
		],
		[
			[
				7417,
				6039
			],
			[
				16,
				-189
			]
		],
		[
			[
				7433,
				5850
			],
			[
				-17,
				30
			]
		],
		[
			[
				7416,
				5880
			],
			[
				-43,
				2
			]
		],
		[
			[
				7373,
				5882
			],
			[
				-9,
				-10
			]
		],
		[
			[
				7364,
				5872
			],
			[
				-8,
				51
			]
		],
		[
			[
				7356,
				5923
			],
			[
				-47,
				44
			]
		],
		[
			[
				7295,
				6106
			],
			[
				-61,
				37
			]
		],
		[
			[
				7234,
				6143
			],
			[
				27,
				27
			]
		],
		[
			[
				7388,
				6283
			],
			[
				37,
				41
			]
		],
		[
			[
				7448,
				6355
			],
			[
				47,
				44
			]
		],
		[
			[
				7535,
				6405
			],
			[
				17,
				-21
			]
		],
		[
			[
				1072,
				2718
			],
			[
				82,
				15
			]
		],
		[
			[
				1106,
				2611
			],
			[
				39,
				-107
			]
		],
		[
			[
				1045,
				2496
			],
			[
				-69,
				-39
			]
		],
		[
			[
				940,
				2412
			],
			[
				-13,
				13
			]
		],
		[
			[
				927,
				2425
			],
			[
				-95,
				7
			]
		],
		[
			[
				783,
				2440
			],
			[
				-20,
				25
			]
		],
		[
			[
				763,
				2465
			],
			[
				20,
				12
			]
		],
		[
			[
				783,
				2477
			],
			[
				-19,
				58
			],
			[
				85,
				79
			]
		],
		[
			[
				849,
				2614
			],
			[
				66,
				44
			]
		],
		[
			[
				983,
				2760
			],
			[
				35,
				-29
			]
		],
		[
			[
				3317,
				3303
			],
			[
				21,
				-45
			]
		],
		[
			[
				3338,
				3258
			],
			[
				28,
				-129
			]
		],
		[
			[
				3382,
				3107
			],
			[
				30,
				-53
			]
		],
		[
			[
				3412,
				3054
			],
			[
				-25,
				-36
			],
			[
				-93,
				-53
			],
			[
				-77,
				-9
			]
		],
		[
			[
				3217,
				2956
			],
			[
				-60,
				-14
			]
		],
		[
			[
				3157,
				2942
			],
			[
				-22,
				-6
			]
		],
		[
			[
				3135,
				2936
			],
			[
				-88,
				-11
			]
		],
		[
			[
				3047,
				2925
			],
			[
				43,
				159
			]
		],
		[
			[
				3090,
				3084
			],
			[
				25,
				29
			]
		],
		[
			[
				3115,
				3113
			],
			[
				-32,
				44
			]
		],
		[
			[
				3083,
				3157
			],
			[
				43,
				23
			]
		],
		[
			[
				3093,
				3252
			],
			[
				59,
				43
			]
		],
		[
			[
				3152,
				3295
			],
			[
				85,
				20
			]
		],
		[
			[
				3237,
				3315
			],
			[
				80,
				-12
			]
		],
		[
			[
				4618,
				3248
			],
			[
				49,
				1
			]
		],
		[
			[
				4695,
				2995
			],
			[
				-33,
				-40
			]
		],
		[
			[
				4662,
				2955
			],
			[
				-55,
				32
			]
		],
		[
			[
				4520,
				2955
			],
			[
				-86,
				5
			]
		],
		[
			[
				4434,
				2960
			],
			[
				-59,
				55
			]
		],
		[
			[
				4375,
				3015
			],
			[
				-29,
				-24
			]
		],
		[
			[
				4217,
				2943
			],
			[
				-38,
				46
			]
		],
		[
			[
				4170,
				3054
			],
			[
				-23,
				25
			]
		],
		[
			[
				4248,
				3228
			],
			[
				91,
				78
			]
		],
		[
			[
				4339,
				3306
			],
			[
				93,
				-76
			]
		],
		[
			[
				773,
				3885
			],
			[
				86,
				-93
			]
		],
		[
			[
				877,
				3686
			],
			[
				-9,
				-26
			]
		],
		[
			[
				801,
				3626
			],
			[
				-42,
				2
			]
		],
		[
			[
				759,
				3628
			],
			[
				-265,
				-43
			]
		],
		[
			[
				494,
				3585
			],
			[
				-25,
				59
			],
			[
				126,
				129
			],
			[
				71,
				132
			]
		],
		[
			[
				666,
				3905
			],
			[
				107,
				-20
			]
		],
		[
			[
				6909,
				7304
			],
			[
				30,
				-21
			]
		],
		[
			[
				6878,
				7151
			],
			[
				17,
				-7
			]
		],
		[
			[
				6895,
				7144
			],
			[
				-163,
				-121
			]
		],
		[
			[
				6732,
				7023
			],
			[
				-91,
				-80
			]
		],
		[
			[
				6487,
				7101
			],
			[
				-26,
				45
			]
		],
		[
			[
				6583,
				7187
			],
			[
				44,
				35
			]
		],
		[
			[
				6752,
				7298
			],
			[
				68,
				64
			]
		],
		[
			[
				1024,
				5913
			],
			[
				-123,
				84
			],
			[
				-205,
				59
			],
			[
				-99,
				232
			],
			[
				70,
				27
			],
			[
				88,
				-54
			],
			[
				42,
				-89
			],
			[
				218,
				-7
			],
			[
				19,
				-75
			],
			[
				97,
				6
			],
			[
				103,
				-70
			]
		],
		[
			[
				4666,
				8086
			],
			[
				12,
				-67
			]
		],
		[
			[
				4655,
				7817
			],
			[
				-68,
				34
			]
		],
		[
			[
				4587,
				7851
			],
			[
				-94,
				54
			],
			[
				-16,
				69
			]
		],
		[
			[
				4477,
				7974
			],
			[
				-12,
				56
			]
		],
		[
			[
				4465,
				8030
			],
			[
				2,
				22
			]
		],
		[
			[
				4596,
				8228
			],
			[
				73,
				-35
			]
		],
		[
			[
				4636,
				8166
			],
			[
				-13,
				-47
			]
		],
		[
			[
				5217,
				6370
			],
			[
				70,
				-33
			]
		],
		[
			[
				5287,
				6337
			],
			[
				3,
				-17
			]
		],
		[
			[
				5290,
				6320
			],
			[
				100,
				3
			]
		],
		[
			[
				5390,
				6323
			],
			[
				27,
				-74
			]
		],
		[
			[
				5435,
				6222
			],
			[
				22,
				-112
			],
			[
				-88,
				-42
			],
			[
				-49,
				-18
			]
		],
		[
			[
				5320,
				6050
			],
			[
				-44,
				-124
			]
		],
		[
			[
				5096,
				5928
			],
			[
				-78,
				34
			]
		],
		[
			[
				4998,
				5982
			],
			[
				-37,
				-4
			]
		],
		[
			[
				4961,
				5978
			],
			[
				-87,
				27
			]
		],
		[
			[
				4852,
				6007
			],
			[
				-27,
				53
			]
		],
		[
			[
				4825,
				6060
			],
			[
				8,
				33
			],
			[
				-6,
				30
			]
		],
		[
			[
				4827,
				6123
			],
			[
				119,
				-22
			],
			[
				106,
				64
			]
		],
		[
			[
				5052,
				6165
			],
			[
				1,
				63
			]
		],
		[
			[
				5053,
				6228
			],
			[
				102,
				101
			]
		],
		[
			[
				5155,
				6329
			],
			[
				27,
				58
			]
		],
		[
			[
				5182,
				6387
			],
			[
				35,
				-17
			]
		],
		[
			[
				1070,
				2135
			],
			[
				-15,
				-14
			]
		],
		[
			[
				1097,
				2002
			],
			[
				17,
				-2
			]
		],
		[
			[
				1014,
				1828
			],
			[
				-9,
				-36
			]
		],
		[
			[
				794,
				1865
			],
			[
				-41,
				11
			]
		],
		[
			[
				753,
				1876
			],
			[
				-1,
				18
			]
		],
		[
			[
				752,
				1894
			],
			[
				47,
				31
			]
		],
		[
			[
				799,
				1925
			],
			[
				-26,
				67
			]
		],
		[
			[
				773,
				1992
			],
			[
				23,
				64
			]
		],
		[
			[
				796,
				2056
			],
			[
				66,
				66
			],
			[
				17,
				32
			]
		],
		[
			[
				954,
				2157
			],
			[
				62,
				28
			]
		],
		[
			[
				2707,
				1137
			],
			[
				-7,
				-96
			]
		],
		[
			[
				2667,
				937
			],
			[
				-18,
				-53
			],
			[
				-116,
				3
			]
		],
		[
			[
				2533,
				887
			],
			[
				16,
				50
			]
		],
		[
			[
				2549,
				937
			],
			[
				-42,
				29
			]
		],
		[
			[
				2507,
				966
			],
			[
				-63,
				-12
			]
		],
		[
			[
				2444,
				954
			],
			[
				0,
				49
			]
		],
		[
			[
				2444,
				1003
			],
			[
				33,
				85
			]
		],
		[
			[
				2477,
				1088
			],
			[
				-15,
				110
			]
		],
		[
			[
				2665,
				1329
			],
			[
				34,
				21
			]
		],
		[
			[
				6724,
				5888
			],
			[
				38,
				-35
			]
		],
		[
			[
				6668,
				5597
			],
			[
				-34,
				2
			]
		],
		[
			[
				6634,
				5599
			],
			[
				-110,
				-8
			]
		],
		[
			[
				6524,
				5591
			],
			[
				-76,
				-59
			],
			[
				-120,
				-2
			],
			[
				-24,
				54
			]
		],
		[
			[
				6304,
				5584
			],
			[
				-69,
				-3
			]
		],
		[
			[
				6235,
				5581
			],
			[
				-83,
				-13
			]
		],
		[
			[
				6152,
				5568
			],
			[
				-46,
				117
			]
		],
		[
			[
				6106,
				5685
			],
			[
				142,
				173
			]
		],
		[
			[
				6248,
				5858
			],
			[
				128,
				72
			]
		],
		[
			[
				6397,
				5964
			],
			[
				100,
				102
			]
		],
		[
			[
				6497,
				6066
			],
			[
				-2,
				-104
			]
		],
		[
			[
				7269,
				5906
			],
			[
				87,
				17
			]
		],
		[
			[
				7356,
				5923
			],
			[
				-52,
				-43
			]
		],
		[
			[
				7304,
				5880
			],
			[
				9,
				-115
			]
		],
		[
			[
				7313,
				5765
			],
			[
				-86,
				-49
			]
		],
		[
			[
				6903,
				5895
			],
			[
				14,
				2
			]
		],
		[
			[
				6965,
				6025
			],
			[
				7,
				-67
			]
		],
		[
			[
				6972,
				5958
			],
			[
				53,
				-75
			]
		],
		[
			[
				2646,
				6458
			],
			[
				51,
				-21
			]
		],
		[
			[
				2697,
				6437
			],
			[
				14,
				-105
			]
		],
		[
			[
				2711,
				6332
			],
			[
				24,
				-98
			]
		],
		[
			[
				2735,
				6234
			],
			[
				59,
				14
			]
		],
		[
			[
				2794,
				6248
			],
			[
				27,
				-6
			]
		],
		[
			[
				2759,
				6161
			],
			[
				-87,
				20
			]
		],
		[
			[
				2672,
				6181
			],
			[
				-45,
				-62
			]
		],
		[
			[
				2593,
				6121
			],
			[
				-76,
				-26
			],
			[
				-32,
				8
			],
			[
				-5,
				15
			],
			[
				-15,
				-6
			],
			[
				-8,
				45
			]
		],
		[
			[
				2470,
				6207
			],
			[
				18,
				123
			]
		],
		[
			[
				2444,
				6368
			],
			[
				-28,
				48
			]
		],
		[
			[
				2501,
				6464
			],
			[
				19,
				-14
			],
			[
				126,
				8
			]
		],
		[
			[
				2020,
				2727
			],
			[
				-10,
				-33
			]
		],
		[
			[
				2030,
				2379
			],
			[
				29,
				-10
			]
		],
		[
			[
				1929,
				2361
			],
			[
				-55,
				-33
			]
		],
		[
			[
				1755,
				2452
			],
			[
				-57,
				27
			],
			[
				-46,
				52
			],
			[
				-4,
				11
			]
		],
		[
			[
				1710,
				2590
			],
			[
				72,
				41
			]
		],
		[
			[
				1887,
				2661
			],
			[
				32,
				69
			]
		],
		[
			[
				838,
				2636
			],
			[
				11,
				-22
			]
		],
		[
			[
				783,
				2477
			],
			[
				-38,
				-36
			]
		],
		[
			[
				720,
				2451
			],
			[
				-51,
				-65
			]
		],
		[
			[
				588,
				2451
			],
			[
				-37,
				11
			]
		],
		[
			[
				437,
				2611
			],
			[
				72,
				57
			]
		],
		[
			[
				546,
				2659
			],
			[
				61,
				52
			]
		],
		[
			[
				789,
				2718
			],
			[
				24,
				-10
			]
		],
		[
			[
				6211,
				5000
			],
			[
				32,
				-26
			]
		],
		[
			[
				6243,
				4974
			],
			[
				39,
				-25
			]
		],
		[
			[
				6440,
				4552
			],
			[
				-139,
				-93
			],
			[
				-52,
				-20
			],
			[
				2,
				-22
			]
		],
		[
			[
				6251,
				4417
			],
			[
				-117,
				-97
			]
		],
		[
			[
				6062,
				4310
			],
			[
				46,
				50
			]
		],
		[
			[
				5979,
				4642
			],
			[
				-15,
				85
			]
		],
		[
			[
				6048,
				4978
			],
			[
				25,
				88
			]
		],
		[
			[
				6159,
				5081
			],
			[
				63,
				-37
			]
		],
		[
			[
				5062,
				5578
			],
			[
				-1,
				-8
			]
		],
		[
			[
				5188,
				5557
			],
			[
				81,
				-23
			]
		],
		[
			[
				5389,
				5557
			],
			[
				33,
				-15
			]
		],
		[
			[
				5422,
				5542
			],
			[
				119,
				-53
			]
		],
		[
			[
				5588,
				5333
			],
			[
				-20,
				1
			]
		],
		[
			[
				5568,
				5334
			],
			[
				-8,
				-29
			]
		],
		[
			[
				5560,
				5305
			],
			[
				13,
				3
			]
		],
		[
			[
				5573,
				5308
			],
			[
				-8,
				-64
			]
		],
		[
			[
				5565,
				5244
			],
			[
				-78,
				-4
			]
		],
		[
			[
				5451,
				5142
			],
			[
				-11,
				17
			]
		],
		[
			[
				5394,
				5196
			],
			[
				-66,
				-14
			]
		],
		[
			[
				5307,
				5211
			],
			[
				-89,
				14
			]
		],
		[
			[
				5135,
				5367
			],
			[
				-81,
				87
			]
		],
		[
			[
				5054,
				5454
			],
			[
				-29,
				68
			]
		],
		[
			[
				5025,
				5522
			],
			[
				37,
				56
			]
		],
		[
			[
				3612,
				6556
			],
			[
				82,
				-41
			]
		],
		[
			[
				3768,
				6423
			],
			[
				-22,
				-29
			]
		],
		[
			[
				3778,
				6235
			],
			[
				-45,
				-33
			]
		],
		[
			[
				3380,
				6300
			],
			[
				-14,
				33
			]
		],
		[
			[
				3339,
				6439
			],
			[
				118,
				72
			]
		],
		[
			[
				3525,
				6556
			],
			[
				68,
				-2
			]
		],
		[
			[
				3328,
				3551
			],
			[
				19,
				-42
			]
		],
		[
			[
				3405,
				3513
			],
			[
				22,
				-57
			]
		],
		[
			[
				3427,
				3456
			],
			[
				-1,
				-115
			]
		],
		[
			[
				3415,
				3258
			],
			[
				-77,
				0
			]
		],
		[
			[
				3317,
				3303
			],
			[
				-80,
				12
			]
		],
		[
			[
				3152,
				3295
			],
			[
				-62,
				-2
			]
		],
		[
			[
				3090,
				3293
			],
			[
				-59,
				-24
			]
		],
		[
			[
				3034,
				3297
			],
			[
				42,
				73
			]
		],
		[
			[
				3106,
				3517
			],
			[
				69,
				21
			]
		],
		[
			[
				3198,
				3521
			],
			[
				72,
				54
			]
		],
		[
			[
				3270,
				3575
			],
			[
				28,
				-2
			]
		],
		[
			[
				3292,
				1624
			],
			[
				114,
				-31
			]
		],
		[
			[
				3530,
				1446
			],
			[
				3,
				-104
			]
		],
		[
			[
				3479,
				1373
			],
			[
				-76,
				-19
			]
		],
		[
			[
				3189,
				1304
			],
			[
				-57,
				101
			]
		],
		[
			[
				3211,
				1606
			],
			[
				-5,
				10
			]
		],
		[
			[
				3284,
				1637
			],
			[
				8,
				-13
			]
		],
		[
			[
				4283,
				7530
			],
			[
				-10,
				-13
			]
		],
		[
			[
				4273,
				7517
			],
			[
				51,
				4
			]
		],
		[
			[
				4324,
				7521
			],
			[
				47,
				-36
			],
			[
				55,
				-170
			],
			[
				-7,
				-66
			]
		],
		[
			[
				4356,
				7251
			],
			[
				-58,
				23
			]
		],
		[
			[
				4298,
				7274
			],
			[
				-17,
				-2
			]
		],
		[
			[
				4223,
				7310
			],
			[
				-21,
				16
			]
		],
		[
			[
				4140,
				7603
			],
			[
				22,
				-23
			]
		],
		[
			[
				4162,
				7580
			],
			[
				106,
				-44
			],
			[
				15,
				-6
			]
		],
		[
			[
				436,
				5746
			],
			[
				-64,
				-162
			]
		],
		[
			[
				372,
				5584
			],
			[
				-195,
				101
			],
			[
				94,
				70
			],
			[
				-29,
				125
			],
			[
				-80,
				107
			],
			[
				226,
				58
			]
		],
		[
			[
				6328,
				8128
			],
			[
				138,
				-9
			]
		],
		[
			[
				6492,
				7771
			],
			[
				-17,
				-3
			]
		],
		[
			[
				6455,
				7747
			],
			[
				-156,
				20
			],
			[
				-72,
				66
			],
			[
				3,
				150
			],
			[
				-34,
				170
			]
		],
		[
			[
				6208,
				8177
			],
			[
				89,
				-30
			]
		],
		[
			[
				2323,
				5635
			],
			[
				41,
				-30
			]
		],
		[
			[
				2491,
				5674
			],
			[
				36,
				-56
			]
		],
		[
			[
				2471,
				5229
			],
			[
				-84,
				-18
			]
		],
		[
			[
				2387,
				5211
			],
			[
				-50,
				52
			]
		],
		[
			[
				2337,
				5263
			],
			[
				-9,
				59
			]
		],
		[
			[
				2192,
				5326
			],
			[
				-56,
				112
			]
		],
		[
			[
				2006,
				5538
			],
			[
				152,
				120
			]
		],
		[
			[
				2158,
				5658
			],
			[
				1,
				16
			]
		],
		[
			[
				2159,
				5674
			],
			[
				61,
				-14
			]
		],
		[
			[
				1251,
				4321
			],
			[
				-9,
				-33
			]
		],
		[
			[
				1229,
				4256
			],
			[
				-63,
				-34
			],
			[
				-9,
				-36
			]
		],
		[
			[
				1157,
				4186
			],
			[
				-59,
				2
			]
		],
		[
			[
				1067,
				4134
			],
			[
				-109,
				-31
			],
			[
				-18,
				130
			]
		],
		[
			[
				1065,
				4441
			],
			[
				32,
				24
			]
		],
		[
			[
				3312,
				7180
			],
			[
				5,
				-46
			]
		],
		[
			[
				3352,
				6933
			],
			[
				-43,
				-29
			]
		],
		[
			[
				3298,
				6872
			],
			[
				-145,
				22
			]
		],
		[
			[
				3153,
				6894
			],
			[
				-22,
				19
			]
		],
		[
			[
				3130,
				6933
			],
			[
				-45,
				34
			]
		],
		[
			[
				2953,
				7058
			],
			[
				12,
				2
			]
		],
		[
			[
				2965,
				7060
			],
			[
				0,
				45
			]
		],
		[
			[
				3130,
				7216
			],
			[
				98,
				-51
			]
		],
		[
			[
				723,
				5680
			],
			[
				41,
				-32
			]
		],
		[
			[
				764,
				5648
			],
			[
				50,
				-108
			]
		],
		[
			[
				814,
				5540
			],
			[
				22,
				-34
			],
			[
				12,
				-42
			]
		],
		[
			[
				806,
				5389
			],
			[
				-57,
				8
			]
		],
		[
			[
				522,
				5150
			],
			[
				57,
				161
			],
			[
				-196,
				68
			],
			[
				-11,
				205
			]
		],
		[
			[
				372,
				5584
			],
			[
				34,
				85
			]
		],
		[
			[
				548,
				5668
			],
			[
				122,
				-53
			]
		],
		[
			[
				672,
				5687
			],
			[
				47,
				-23
			]
		],
		[
			[
				3434,
				2291
			],
			[
				8,
				-110
			]
		],
		[
			[
				3240,
				1914
			],
			[
				-46,
				22
			],
			[
				-27,
				34
			],
			[
				29,
				74
			]
		],
		[
			[
				3196,
				2044
			],
			[
				16,
				56
			]
		],
		[
			[
				3212,
				2100
			],
			[
				-27,
				64
			]
		],
		[
			[
				3276,
				2319
			],
			[
				15,
				42
			],
			[
				16,
				16
			]
		],
		[
			[
				3307,
				2377
			],
			[
				46,
				-39
			]
		],
		[
			[
				6760,
				3201
			],
			[
				24,
				-95
			],
			[
				-81,
				-57
			],
			[
				-260,
				28
			]
		],
		[
			[
				6341,
				3175
			],
			[
				-4,
				29
			]
		],
		[
			[
				6337,
				3204
			],
			[
				5,
				1
			]
		],
		[
			[
				6478,
				3245
			],
			[
				70,
				21
			]
		],
		[
			[
				6490,
				3350
			],
			[
				104,
				-15
			]
		],
		[
			[
				3154,
				2160
			],
			[
				58,
				-60
			]
		],
		[
			[
				3212,
				2100
			],
			[
				-16,
				-56
			]
		],
		[
			[
				3196,
				2044
			],
			[
				-28,
				-66
			],
			[
				8,
				-23
			]
		],
		[
			[
				3176,
				1955
			],
			[
				-29,
				-51
			]
		],
		[
			[
				3129,
				1862
			],
			[
				-75,
				-53
			]
		],
		[
			[
				3009,
				1757
			],
			[
				-102,
				13
			]
		],
		[
			[
				2925,
				1994
			],
			[
				113,
				100
			],
			[
				116,
				66
			]
		],
		[
			[
				6668,
				5597
			],
			[
				45,
				-70
			]
		],
		[
			[
				6700,
				5423
			],
			[
				6,
				-74
			]
		],
		[
			[
				6684,
				5339
			],
			[
				12,
				-32
			]
		],
		[
			[
				6696,
				5307
			],
			[
				69,
				-15
			]
		],
		[
			[
				6787,
				5272
			],
			[
				37,
				-68
			]
		],
		[
			[
				6840,
				5209
			],
			[
				25,
				-68
			],
			[
				-99,
				-32
			]
		],
		[
			[
				6618,
				5206
			],
			[
				-16,
				-40
			]
		],
		[
			[
				6526,
				5177
			],
			[
				-25,
				152
			]
		],
		[
			[
				6443,
				5367
			],
			[
				-97,
				42
			]
		],
		[
			[
				6346,
				5409
			],
			[
				-75,
				68
			]
		],
		[
			[
				6271,
				5477
			],
			[
				-14,
				2
			]
		],
		[
			[
				6257,
				5479
			],
			[
				18,
				41
			]
		],
		[
			[
				6275,
				5520
			],
			[
				-26,
				27
			]
		],
		[
			[
				6249,
				5547
			],
			[
				55,
				37
			]
		],
		[
			[
				6524,
				5591
			],
			[
				110,
				8
			]
		],
		[
			[
				7984,
				6502
			],
			[
				47,
				-70
			]
		],
		[
			[
				8031,
				6432
			],
			[
				-16,
				-73
			]
		],
		[
			[
				8034,
				6274
			],
			[
				76,
				-28
			]
		],
		[
			[
				8098,
				6157
			],
			[
				-38,
				-11
			]
		],
		[
			[
				8021,
				6122
			],
			[
				-83,
				30
			]
		],
		[
			[
				7828,
				6291
			],
			[
				5,
				48
			]
		],
		[
			[
				7776,
				6267
			],
			[
				-43,
				28
			]
		],
		[
			[
				7743,
				6337
			],
			[
				76,
				35
			]
		],
		[
			[
				7952,
				6511
			],
			[
				7,
				-19
			]
		],
		[
			[
				4465,
				8030
			],
			[
				12,
				-56
			]
		],
		[
			[
				4587,
				7851
			],
			[
				31,
				-21
			],
			[
				81,
				-26
			]
		],
		[
			[
				4740,
				7755
			],
			[
				-279,
				-101
			],
			[
				-102,
				-158
			]
		],
		[
			[
				4359,
				7496
			],
			[
				-35,
				25
			]
		],
		[
			[
				4273,
				7517
			],
			[
				26,
				45
			],
			[
				50,
				161
			]
		],
		[
			[
				4251,
				7860
			],
			[
				-63,
				134
			],
			[
				-26,
				80
			],
			[
				54,
				19
			],
			[
				3,
				-7
			]
		],
		[
			[
				7073,
				7171
			],
			[
				94,
				-102
			]
		],
		[
			[
				7167,
				7069
			],
			[
				-4,
				-39
			]
		],
		[
			[
				7162,
				6892
			],
			[
				-54,
				-8
			]
		],
		[
			[
				7080,
				6856
			],
			[
				-15,
				-31
			]
		],
		[
			[
				7047,
				6799
			],
			[
				-76,
				10
			]
		],
		[
			[
				6913,
				6783
			],
			[
				-30,
				69
			]
		],
		[
			[
				6791,
				6859
			],
			[
				-36,
				20
			],
			[
				-42,
				-4
			]
		],
		[
			[
				6713,
				6875
			],
			[
				4,
				51
			],
			[
				-23,
				26
			],
			[
				38,
				71
			]
		],
		[
			[
				6895,
				7144
			],
			[
				69,
				15
			]
		],
		[
			[
				4347,
				6202
			],
			[
				37,
				-21
			]
		],
		[
			[
				4384,
				6181
			],
			[
				-11,
				-18
			],
			[
				17,
				-17
			],
			[
				-13,
				-35
			]
		],
		[
			[
				4557,
				6034
			],
			[
				51,
				-114
			]
		],
		[
			[
				4608,
				5920
			],
			[
				11,
				-55
			]
		],
		[
			[
				4676,
				5719
			],
			[
				-35,
				-92
			]
		],
		[
			[
				4481,
				5639
			],
			[
				-18,
				55
			]
		],
		[
			[
				4463,
				5694
			],
			[
				-38,
				-4
			]
		],
		[
			[
				4229,
				6023
			],
			[
				-33,
				98
			]
		],
		[
			[
				4228,
				6109
			],
			[
				40,
				42
			]
		],
		[
			[
				4244,
				6164
			],
			[
				103,
				38
			]
		],
		[
			[
				4934,
				7635
			],
			[
				-91,
				-123
			]
		],
		[
			[
				4697,
				7537
			],
			[
				-107,
				37
			]
		],
		[
			[
				4450,
				7415
			],
			[
				-54,
				-7
			]
		],
		[
			[
				4396,
				7408
			],
			[
				-37,
				88
			]
		],
		[
			[
				7373,
				5882
			],
			[
				43,
				-2
			]
		],
		[
			[
				7433,
				5850
			],
			[
				26,
				-72
			]
		],
		[
			[
				7494,
				5739
			],
			[
				27,
				-45
			]
		],
		[
			[
				7264,
				5463
			],
			[
				2,
				-16
			]
		],
		[
			[
				7291,
				5626
			],
			[
				-18,
				113
			]
		],
		[
			[
				7273,
				5739
			],
			[
				40,
				26
			]
		],
		[
			[
				7304,
				5880
			],
			[
				60,
				-8
			]
		],
		[
			[
				5340,
				6547
			],
			[
				-14,
				-62
			]
		],
		[
			[
				5325,
				6459
			],
			[
				-38,
				-122
			]
		],
		[
			[
				5217,
				6370
			],
			[
				-35,
				17
			]
		],
		[
			[
				5182,
				6387
			],
			[
				-27,
				-58
			]
		],
		[
			[
				5053,
				6228
			],
			[
				-1,
				-63
			]
		],
		[
			[
				4827,
				6123
			],
			[
				-52,
				73
			],
			[
				51,
				89
			]
		],
		[
			[
				4893,
				6455
			],
			[
				-39,
				85
			]
		],
		[
			[
				4854,
				6540
			],
			[
				-59,
				66
			]
		],
		[
			[
				4869,
				6675
			],
			[
				-47,
				30
			]
		],
		[
			[
				4886,
				6828
			],
			[
				32,
				78
			],
			[
				155,
				-65
			]
		],
		[
			[
				3157,
				2942
			],
			[
				20,
				-11
			]
		],
		[
			[
				2996,
				2709
			],
			[
				-41,
				47
			]
		],
		[
			[
				2928,
				2772
			],
			[
				15,
				19
			]
		],
		[
			[
				2943,
				2791
			],
			[
				38,
				108
			]
		],
		[
			[
				2981,
				2899
			],
			[
				66,
				26
			]
		],
		[
			[
				3047,
				2925
			],
			[
				88,
				11
			]
		],
		[
			[
				2136,
				1433
			],
			[
				-9,
				-14
			]
		],
		[
			[
				2235,
				1424
			],
			[
				16,
				39
			]
		],
		[
			[
				2323,
				1469
			],
			[
				32,
				-45
			]
		],
		[
			[
				2398,
				1244
			],
			[
				64,
				-46
			]
		],
		[
			[
				2477,
				1088
			],
			[
				-33,
				-85
			]
		],
		[
			[
				2444,
				954
			],
			[
				63,
				12
			]
		],
		[
			[
				2549,
				937
			],
			[
				-42,
				-32
			]
		],
		[
			[
				2246,
				1080
			],
			[
				-43,
				-2
			]
		],
		[
			[
				2152,
				1065
			],
			[
				-2,
				52
			]
		],
		[
			[
				2023,
				1165
			],
			[
				-1,
				105
			]
		],
		[
			[
				2061,
				1460
			],
			[
				58,
				-14
			],
			[
				17,
				-13
			]
		],
		[
			[
				578,
				2040
			],
			[
				21,
				39
			]
		],
		[
			[
				775,
				2040
			],
			[
				-2,
				-48
			]
		],
		[
			[
				799,
				1925
			],
			[
				-196,
				-48
			]
		],
		[
			[
				540,
				1884
			],
			[
				17,
				49
			]
		],
		[
			[
				557,
				1933
			],
			[
				0,
				37
			]
		],
		[
			[
				535,
				2003
			],
			[
				-26,
				49
			]
		],
		[
			[
				509,
				2052
			],
			[
				37,
				6
			]
		],
		[
			[
				2539,
				4679
			],
			[
				-25,
				-11
			]
		],
		[
			[
				2452,
				4590
			],
			[
				-58,
				-77
			]
		],
		[
			[
				2290,
				4476
			],
			[
				-44,
				29
			]
		],
		[
			[
				2169,
				4774
			],
			[
				19,
				57
			],
			[
				-8,
				30
			]
		],
		[
			[
				2193,
				4886
			],
			[
				84,
				60
			]
		],
		[
			[
				2259,
				4981
			],
			[
				45,
				22
			]
		],
		[
			[
				2304,
				5003
			],
			[
				126,
				-175
			],
			[
				58,
				-133
			],
			[
				51,
				-16
			]
		],
		[
			[
				7732,
				5262
			],
			[
				12,
				-32
			]
		],
		[
			[
				7992,
				5190
			],
			[
				7,
				-46
			]
		],
		[
			[
				7975,
				4937
			],
			[
				-43,
				12
			]
		],
		[
			[
				7911,
				4938
			],
			[
				-25,
				-5
			]
		],
		[
			[
				7850,
				4925
			],
			[
				-15,
				-31
			]
		],
		[
			[
				7835,
				4894
			],
			[
				-29,
				-39
			],
			[
				-110,
				61
			],
			[
				4,
				84
			]
		],
		[
			[
				7700,
				5000
			],
			[
				-76,
				-38
			],
			[
				-52,
				23
			],
			[
				-9,
				86
			]
		],
		[
			[
				7526,
				5072
			],
			[
				-48,
				95
			]
		],
		[
			[
				7606,
				5331
			],
			[
				42,
				-9
			]
		],
		[
			[
				7835,
				4894
			],
			[
				10,
				-23
			]
		],
		[
			[
				8185,
				4729
			],
			[
				-208,
				-183
			],
			[
				-64,
				-93
			],
			[
				-135,
				0
			],
			[
				-61,
				87
			],
			[
				37,
				119
			],
			[
				-165,
				69
			],
			[
				-129,
				-19
			]
		],
		[
			[
				7371,
				4747
			],
			[
				-64,
				73
			]
		],
		[
			[
				7406,
				4890
			],
			[
				24,
				37
			]
		],
		[
			[
				7430,
				4927
			],
			[
				105,
				39
			]
		],
		[
			[
				7533,
				4998
			],
			[
				72,
				-27
			],
			[
				1,
				-8
			],
			[
				40,
				3
			],
			[
				54,
				34
			]
		],
		[
			[
				5127,
				4581
			],
			[
				35,
				-58
			]
		],
		[
			[
				5196,
				4512
			],
			[
				61,
				-46
			],
			[
				124,
				15
			]
		],
		[
			[
				5546,
				4390
			],
			[
				76,
				-68
			]
		],
		[
			[
				5553,
				4288
			],
			[
				-12,
				-35
			]
		],
		[
			[
				5419,
				4146
			],
			[
				-86,
				-47
			]
		],
		[
			[
				4974,
				4214
			],
			[
				-69,
				-49
			],
			[
				-50,
				75
			]
		],
		[
			[
				4855,
				4240
			],
			[
				17,
				18
			]
		],
		[
			[
				4833,
				4424
			],
			[
				-19,
				104
			]
		],
		[
			[
				4833,
				4595
			],
			[
				16,
				20
			]
		],
		[
			[
				4849,
				4615
			],
			[
				43,
				21
			]
		],
		[
			[
				4890,
				4647
			],
			[
				114,
				-102
			]
		],
		[
			[
				6411,
				7433
			],
			[
				1,
				-74
			],
			[
				-90,
				-22
			]
		],
		[
			[
				6331,
				7238
			],
			[
				15,
				-46
			]
		],
		[
			[
				6346,
				7192
			],
			[
				-18,
				-62
			]
		],
		[
			[
				6328,
				7130
			],
			[
				-47,
				-15
			]
		],
		[
			[
				6281,
				7115
			],
			[
				-25,
				-11
			]
		],
		[
			[
				6149,
				7119
			],
			[
				-37,
				131
			],
			[
				167,
				91
			],
			[
				110,
				116
			]
		],
		[
			[
				3416,
				3945
			],
			[
				31,
				-67
			]
		],
		[
			[
				3454,
				3869
			],
			[
				22,
				-104
			]
		],
		[
			[
				3439,
				3734
			],
			[
				-43,
				-61
			]
		],
		[
			[
				3376,
				3764
			],
			[
				-27,
				51
			]
		],
		[
			[
				3319,
				3828
			],
			[
				20,
				65
			]
		],
		[
			[
				3707,
				4482
			],
			[
				21,
				-79
			],
			[
				-86,
				-36
			]
		],
		[
			[
				3574,
				4270
			],
			[
				-27,
				21
			]
		],
		[
			[
				3547,
				4291
			],
			[
				-38,
				25
			]
		],
		[
			[
				3509,
				4316
			],
			[
				-84,
				-131
			]
		],
		[
			[
				3372,
				4159
			],
			[
				-33,
				59
			]
		],
		[
			[
				3339,
				4218
			],
			[
				-16,
				-7
			]
		],
		[
			[
				3383,
				4442
			],
			[
				16,
				56
			]
		],
		[
			[
				3532,
				4504
			],
			[
				29,
				113
			]
		],
		[
			[
				3547,
				4291
			],
			[
				87,
				-55
			]
		],
		[
			[
				3634,
				4236
			],
			[
				35,
				51
			]
		],
		[
			[
				3669,
				4256
			],
			[
				9,
				-4
			]
		],
		[
			[
				3657,
				4095
			],
			[
				-43,
				-31
			]
		],
		[
			[
				3595,
				4063
			],
			[
				-38,
				5
			]
		],
		[
			[
				3557,
				4068
			],
			[
				-22,
				30
			]
		],
		[
			[
				3509,
				4316
			],
			[
				38,
				-25
			]
		],
		[
			[
				2872,
				2940
			],
			[
				79,
				-9
			]
		],
		[
			[
				2987,
				2920
			],
			[
				-6,
				-21
			]
		],
		[
			[
				2943,
				2791
			],
			[
				-73,
				-49
			]
		],
		[
			[
				2647,
				2710
			],
			[
				-7,
				58
			],
			[
				-20,
				29
			],
			[
				-159,
				131
			]
		],
		[
			[
				2461,
				2928
			],
			[
				99,
				30
			]
		],
		[
			[
				2611,
				2958
			],
			[
				70,
				11
			]
		],
		[
			[
				2681,
				2969
			],
			[
				3,
				67
			]
		],
		[
			[
				2684,
				3036
			],
			[
				50,
				-40
			],
			[
				66,
				58
			],
			[
				20,
				-1
			],
			[
				66,
				4
			]
		],
		[
			[
				2850,
				6299
			],
			[
				-56,
				-51
			]
		],
		[
			[
				2794,
				6248
			],
			[
				-59,
				-14
			]
		],
		[
			[
				2711,
				6332
			],
			[
				-14,
				105
			]
		],
		[
			[
				2646,
				6458
			],
			[
				-113,
				-6
			]
		],
		[
			[
				2533,
				6452
			],
			[
				2,
				89
			],
			[
				25,
				53
			]
		],
		[
			[
				2818,
				6689
			],
			[
				24,
				-36
			],
			[
				80,
				-51
			],
			[
				-4,
				-105
			]
		],
		[
			[
				3866,
				7263
			],
			[
				75,
				-46
			],
			[
				29,
				10
			]
		],
		[
			[
				4023,
				7080
			],
			[
				-28,
				-59
			]
		],
		[
			[
				3995,
				7021
			],
			[
				-68,
				-59
			]
		],
		[
			[
				3927,
				6962
			],
			[
				-90,
				19
			]
		],
		[
			[
				3837,
				6981
			],
			[
				-32,
				-19
			]
		],
		[
			[
				3805,
				6962
			],
			[
				-63,
				26
			]
		],
		[
			[
				3742,
				6988
			],
			[
				-5,
				70
			]
		],
		[
			[
				3737,
				7058
			],
			[
				37,
				79
			]
		],
		[
			[
				3774,
				7137
			],
			[
				26,
				86
			]
		],
		[
			[
				3800,
				7223
			],
			[
				37,
				49
			]
		],
		[
			[
				6049,
				5559
			],
			[
				103,
				9
			]
		],
		[
			[
				6235,
				5581
			],
			[
				14,
				-34
			]
		],
		[
			[
				6275,
				5520
			],
			[
				-18,
				-41
			]
		],
		[
			[
				6271,
				5477
			],
			[
				-44,
				-35
			]
		],
		[
			[
				6133,
				5358
			],
			[
				-3,
				-34
			]
		],
		[
			[
				6130,
				5324
			],
			[
				-23,
				-91
			]
		],
		[
			[
				6107,
				5233
			],
			[
				-40,
				-18
			]
		],
		[
			[
				6067,
				5215
			],
			[
				-10,
				14
			]
		],
		[
			[
				5955,
				5252
			],
			[
				-48,
				28
			]
		],
		[
			[
				5663,
				5185
			],
			[
				-41,
				46
			]
		],
		[
			[
				5627,
				5254
			],
			[
				-54,
				54
			]
		],
		[
			[
				5560,
				5305
			],
			[
				8,
				29
			]
		],
		[
			[
				5568,
				5334
			],
			[
				80,
				-14
			]
		],
		[
			[
				5648,
				5320
			],
			[
				76,
				7
			]
		],
		[
			[
				5764,
				5342
			],
			[
				67,
				53
			],
			[
				1,
				73
			]
		],
		[
			[
				5870,
				5567
			],
			[
				43,
				16
			]
		],
		[
			[
				5929,
				5604
			],
			[
				120,
				-45
			]
		],
		[
			[
				2628,
				5197
			],
			[
				30,
				-89
			]
		],
		[
			[
				2542,
				4934
			],
			[
				67,
				-58
			]
		],
		[
			[
				2659,
				4867
			],
			[
				34,
				-62
			]
		],
		[
			[
				2678,
				4717
			],
			[
				-139,
				-38
			]
		],
		[
			[
				2304,
				5003
			],
			[
				80,
				69
			]
		],
		[
			[
				2384,
				5072
			],
			[
				12,
				103
			]
		],
		[
			[
				2396,
				5175
			],
			[
				-9,
				36
			]
		],
		[
			[
				2387,
				5211
			],
			[
				78,
				15
			],
			[
				75,
				39
			]
		],
		[
			[
				2540,
				5265
			],
			[
				41,
				-40
			]
		],
		[
			[
				3742,
				6988
			],
			[
				63,
				-26
			]
		],
		[
			[
				3805,
				6962
			],
			[
				32,
				19
			]
		],
		[
			[
				3927,
				6962
			],
			[
				65,
				47
			]
		],
		[
			[
				4013,
				6942
			],
			[
				-23,
				-113
			]
		],
		[
			[
				3990,
				6829
			],
			[
				-44,
				-82
			]
		],
		[
			[
				3959,
				6699
			],
			[
				-107,
				-22
			]
		],
		[
			[
				3800,
				6724
			],
			[
				-62,
				11
			]
		],
		[
			[
				3738,
				6735
			],
			[
				14,
				20
			]
		],
		[
			[
				3725,
				6839
			],
			[
				-42,
				77
			]
		],
		[
			[
				3714,
				7027
			],
			[
				23,
				31
			]
		],
		[
			[
				1374,
				1663
			],
			[
				-21,
				-51
			]
		],
		[
			[
				1342,
				1501
			],
			[
				21,
				-52
			]
		],
		[
			[
				1370,
				1405
			],
			[
				-140,
				-26
			]
		],
		[
			[
				1230,
				1379
			],
			[
				-33,
				-27
			]
		],
		[
			[
				1197,
				1352
			],
			[
				4,
				-20
			]
		],
		[
			[
				1075,
				1279
			],
			[
				-95,
				88
			]
		],
		[
			[
				985,
				1402
			],
			[
				64,
				17
			]
		],
		[
			[
				1176,
				1694
			],
			[
				17,
				-6
			]
		],
		[
			[
				1196,
				1711
			],
			[
				85,
				44
			]
		],
		[
			[
				6992,
				7792
			],
			[
				14,
				-25
			],
			[
				63,
				-25
			],
			[
				152,
				-40
			]
		],
		[
			[
				7198,
				7695
			],
			[
				3,
				-26
			],
			[
				-12,
				-23
			],
			[
				-40,
				-7
			],
			[
				-32,
				-45
			],
			[
				20,
				-27
			],
			[
				36,
				-19
			],
			[
				28,
				-64
			],
			[
				-7,
				-35
			]
		],
		[
			[
				7005,
				7353
			],
			[
				-4,
				80
			]
		],
		[
			[
				7001,
				7433
			],
			[
				5,
				101
			]
		],
		[
			[
				6902,
				7667
			],
			[
				-45,
				7
			]
		],
		[
			[
				6857,
				7674
			],
			[
				12,
				47
			]
		],
		[
			[
				6921,
				7793
			],
			[
				60,
				-11
			],
			[
				11,
				10
			]
		]
	],
	"transform": {
		"scale": [
			0.0004145531070705779,
			0.0002480636152443112
		],
		"translate": [
			5.878025523533185,
			50.33856106917782
		]
	},
	"objects": {
		"nrw": {
			"type": "GeometryCollection",
			"geometries": [
				{
					"arcs": [
						[
							0,
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8,
							9
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382020",
						"GEN": "Hennef (Sieg)"
					}
				},
				{
					"arcs": [
						[
							10,
							11,
							12,
							13,
							14,
							15,
							16,
							17,
							18
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362036",
						"GEN": "Pulheim"
					}
				},
				{
					"arcs": [
						[
							19,
							20,
							21,
							22,
							23,
							24,
							25,
							26,
							27,
							28,
							29,
							30,
							31,
							32,
							33,
							34,
							35,
							36
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966020",
						"GEN": "Lennestadt"
					}
				},
				{
					"arcs": [
						[
							37,
							38,
							39,
							40,
							41,
							42,
							43,
							44,
							45,
							46,
							47,
							48,
							49,
							50,
							51,
							52
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962028",
						"GEN": "Kierspe"
					}
				},
				{
					"arcs": [
						[
							53,
							54,
							55,
							56,
							57,
							58,
							59,
							60,
							61,
							62,
							63
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774016",
						"GEN": "Büren"
					}
				},
				{
					"arcs": [
						[
							64,
							65,
							66,
							67,
							68,
							69,
							70,
							71,
							72
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566040",
						"GEN": "Lengerich"
					}
				},
				{
					"arcs": [
						[
							73,
							74,
							75,
							76,
							77,
							78,
							79,
							80,
							81,
							82,
							83,
							84,
							85,
							86,
							87,
							88,
							89,
							90,
							91,
							92,
							93,
							94,
							95,
							96,
							97,
							98,
							99,
							100,
							101
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05913000",
						"GEN": "Dortmund"
					}
				},
				{
					"arcs": [
						[
							102,
							103,
							104,
							105,
							106,
							107,
							108,
							109,
							110,
							111,
							112,
							113,
							114
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366032",
						"GEN": "Nettersheim"
					}
				},
				{
					"arcs": [
						[
							115,
							116,
							117,
							118,
							119,
							120,
							121,
							122,
							123,
							124,
							125,
							126,
							127,
							128,
							129,
							130,
							131,
							132,
							133,
							134,
							135
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774032",
						"GEN": "Paderborn"
					}
				},
				{
					"arcs": [
						[
							136,
							137,
							138,
							139,
							140,
							141,
							142,
							143,
							144,
							145,
							146,
							147,
							148
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358012",
						"GEN": "Heimbach"
					}
				},
				{
					"arcs": [
						[
							149,
							150,
							151,
							152,
							153,
							154,
							155,
							156,
							157
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562014",
						"GEN": "Gladbeck"
					}
				},
				{
					"arcs": [
						[
							158,
							159,
							160,
							161,
							162,
							163,
							164,
							165,
							166
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358040",
						"GEN": "Merzenich"
					}
				},
				{
					"arcs": [
						[
							167,
							168,
							169,
							170,
							171,
							172,
							173,
							174,
							175,
							176,
							177
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154044",
						"GEN": "Rees"
					}
				},
				{
					"arcs": [
						[
							178,
							179,
							180,
							181,
							182,
							-99,
							183,
							184,
							185,
							186,
							187,
							188,
							189,
							190,
							191
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562036",
						"GEN": "Waltrop"
					}
				},
				{
					"arcs": [
						[
							192,
							193,
							194,
							195,
							196,
							197,
							198,
							199,
							200,
							201,
							202,
							203,
							204,
							205,
							206,
							207
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366040",
						"GEN": "Weilerswist"
					}
				},
				{
					"arcs": [
						[
							208,
							209,
							210,
							211,
							212,
							213,
							214,
							215,
							216,
							-197,
							217
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382064",
						"GEN": "Swisttal"
					}
				},
				{
					"arcs": [
						[
							218,
							219,
							220,
							221,
							222,
							223,
							224,
							225,
							226,
							227,
							228
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758020",
						"GEN": "Kirchlengern"
					}
				},
				{
					"arcs": [
						[
							-70,
							229,
							-68,
							230,
							231,
							232,
							233,
							234,
							235,
							236
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566032",
						"GEN": "Ladbergen"
					}
				},
				{
					"arcs": [
						[
							237,
							238,
							239,
							240,
							241,
							242,
							243,
							244,
							245,
							246,
							247,
							248
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366044",
						"GEN": "Zülpich"
					}
				},
				{
					"arcs": [
						[
							-233,
							249,
							250,
							251,
							252,
							253,
							254,
							255,
							256
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570032",
						"GEN": "Ostbevern"
					}
				},
				{
					"arcs": [
						[
							257,
							258,
							259,
							260
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554020",
						"GEN": "Gronau (Westf.)"
					}
				},
				{
					"arcs": [
						[
							261,
							262,
							263,
							264,
							265,
							266,
							267,
							268,
							269,
							270,
							271,
							272,
							-179,
							273,
							274,
							275,
							276,
							277,
							278,
							279
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978032",
						"GEN": "Selm"
					}
				},
				{
					"arcs": [
						[
							280,
							281,
							282,
							283,
							284,
							285,
							286,
							287,
							288,
							289,
							290,
							291,
							292,
							293,
							294,
							295,
							296,
							297,
							298,
							299
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562016",
						"GEN": "Haltern am See"
					}
				},
				{
					"arcs": [
						[
							300,
							301,
							302,
							303,
							304,
							305,
							306,
							307,
							-59,
							308
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958012",
						"GEN": "Brilon"
					}
				},
				{
					"arcs": [
						[
							309,
							310,
							311,
							312,
							-163,
							313,
							314,
							315,
							316,
							317,
							318,
							319,
							320,
							321,
							322,
							323
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358008",
						"GEN": "Düren"
					}
				},
				{
					"arcs": [
						[
							324,
							325,
							326,
							327,
							328,
							329,
							330,
							331,
							332,
							333,
							334,
							335,
							336,
							337,
							338,
							339,
							340,
							341,
							342,
							343,
							344,
							345,
							346,
							347,
							348,
							349,
							350,
							351,
							352,
							353,
							354,
							355,
							356
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05124000",
						"GEN": "Wuppertal"
					}
				},
				{
					"arcs": [
						[
							357,
							358,
							359,
							360,
							361,
							362,
							363,
							364,
							365,
							366,
							367,
							368,
							369,
							370,
							371,
							372,
							373
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770032",
						"GEN": "Porta Westfalica"
					}
				},
				{
					"arcs": [
						[
							374,
							375,
							376,
							377,
							378,
							379,
							380
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154052",
						"GEN": "Straelen"
					}
				},
				{
					"arcs": [
						[
							381,
							382,
							383,
							384,
							385,
							386,
							387,
							388,
							389,
							390,
							391
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566092",
						"GEN": "Westerkappeln"
					}
				},
				{
					"arcs": [
						[
							-175,
							392,
							393,
							394,
							395,
							396,
							397,
							398,
							399,
							400,
							401,
							402,
							403,
							404,
							405,
							406,
							407
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170052",
						"GEN": "Xanten"
					}
				},
				{
					"arcs": [
						[
							-105,
							408,
							409,
							-107,
							410
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366008",
						"GEN": "Blankenheim"
					}
				},
				{
					"arcs": [
						[
							411,
							412,
							413,
							414,
							415,
							416,
							417,
							418,
							419,
							420
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158020",
						"GEN": "Langenfeld (Rhld.)"
					}
				},
				{
					"arcs": [
						[
							421,
							422,
							423,
							424
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382008",
						"GEN": "Bad Honnef"
					}
				},
				{
					"arcs": [
						[
							425,
							426,
							427,
							428,
							429,
							430,
							431,
							432,
							433,
							434,
							435,
							-127,
							436,
							-125,
							437
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774012",
						"GEN": "Borchen"
					}
				},
				{
					"arcs": [
						[
							438,
							439,
							440,
							441,
							442,
							443,
							444,
							445,
							446,
							447,
							448,
							449,
							-109,
							450,
							451,
							452,
							453,
							454,
							455,
							456
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366020",
						"GEN": "Hellenthal"
					}
				},
				{
					"arcs": [
						[
							457,
							458,
							459,
							460,
							461,
							462
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958028",
						"GEN": "Medebach"
					}
				},
				{
					"arcs": [
						[
							463,
							464,
							465,
							466,
							467,
							468,
							469,
							470,
							471,
							472,
							473
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974048",
						"GEN": "Welver"
					}
				},
				{
					"arcs": [
						[
							474,
							475,
							476,
							477,
							478,
							479,
							480,
							481,
							482,
							483,
							484,
							485,
							486,
							487,
							488,
							489,
							490
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970012",
						"GEN": "Erndtebrück"
					}
				},
				{
					"arcs": [
						[
							491,
							492,
							493,
							494,
							495,
							496,
							497,
							498,
							499
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362040",
						"GEN": "Wesseling"
					}
				},
				{
					"arcs": [
						[
							500,
							501,
							502,
							503,
							504,
							505,
							506,
							507,
							508,
							509,
							510,
							511,
							512,
							513,
							514,
							515,
							516,
							517,
							518,
							519,
							520,
							521,
							522,
							523,
							524
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05515000",
						"GEN": "Münster"
					}
				},
				{
					"arcs": [
						[
							525,
							526,
							527,
							528,
							529,
							530,
							531,
							532,
							533,
							534,
							535,
							536,
							537
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378004",
						"GEN": "Bergisch Gladbach"
					}
				},
				{
					"arcs": [
						[
							538,
							539,
							540,
							541,
							542,
							543,
							544
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378008",
						"GEN": "Burscheid"
					}
				},
				{
					"arcs": [
						[
							545,
							546,
							547,
							548,
							549,
							550,
							551,
							552,
							553
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974044",
						"GEN": "Warstein"
					}
				},
				{
					"arcs": [
						[
							554,
							555,
							556,
							557,
							-3,
							558,
							559,
							560
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382016",
						"GEN": "Eitorf"
					}
				},
				{
					"arcs": [
						[
							561,
							562,
							563,
							564,
							-556,
							565,
							566,
							567,
							568,
							569,
							570
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382076",
						"GEN": "Windeck"
					}
				},
				{
					"arcs": [
						[
							571,
							572,
							573,
							574,
							575,
							576,
							577,
							578,
							579,
							580,
							581,
							582,
							583,
							584,
							585,
							586,
							587,
							588,
							589
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05116000",
						"GEN": "Mönchengladbach"
					}
				},
				{
					"arcs": [
						[
							590,
							591,
							592,
							593,
							594,
							595
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970008",
						"GEN": "Burbach"
					}
				},
				{
					"arcs": [
						[
							596,
							597,
							598,
							599,
							600,
							601
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970016",
						"GEN": "Freudenberg"
					}
				},
				{
					"arcs": [
						[
							602,
							603,
							604,
							605,
							606,
							607,
							608
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766052",
						"GEN": "Lügde"
					}
				},
				{
					"arcs": [
						[
							609,
							610,
							611,
							612,
							-589,
							613,
							614,
							615,
							616,
							617,
							618,
							619,
							620
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166032",
						"GEN": "Viersen"
					}
				},
				{
					"arcs": [
						[
							621,
							622,
							623,
							624,
							625,
							626,
							627,
							628
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154036",
						"GEN": "Kleve"
					}
				},
				{
					"arcs": [
						[
							-615,
							629,
							-587,
							630,
							631,
							632,
							633,
							634,
							635,
							636,
							637
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166024",
						"GEN": "Schwalmtal"
					}
				},
				{
					"arcs": [
						[
							638,
							639,
							640,
							641,
							642,
							643,
							644,
							645,
							646,
							647,
							648,
							649,
							650,
							651,
							652
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970024",
						"GEN": "Kreuztal"
					}
				},
				{
					"arcs": [
						[
							653,
							654,
							655,
							656,
							657,
							658,
							659,
							660,
							661,
							662,
							663,
							664,
							665
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334016",
						"GEN": "Herzogenrath"
					}
				},
				{
					"arcs": [
						[
							666,
							667,
							668
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370024",
						"GEN": "Selfkant"
					}
				},
				{
					"arcs": [
						[
							669,
							670,
							671,
							672,
							673,
							674,
							675,
							676,
							677,
							678,
							679
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370016",
						"GEN": "Heinsberg"
					}
				},
				{
					"arcs": [
						[
							680,
							681,
							682,
							683,
							684,
							685,
							686,
							687,
							688,
							689,
							690,
							691,
							692,
							693,
							694
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358004",
						"GEN": "Aldenhoven"
					}
				},
				{
					"arcs": [
						[
							695,
							696,
							697,
							698,
							699,
							700,
							701,
							-529,
							702,
							703,
							704
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378012",
						"GEN": "Kürten"
					}
				},
				{
					"arcs": [
						[
							705,
							706,
							707,
							708,
							709,
							-51,
							710,
							-49,
							711,
							-47,
							712,
							713,
							714,
							715,
							716,
							717,
							718,
							719,
							720,
							721
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962012",
						"GEN": "Halver"
					}
				},
				{
					"arcs": [
						[
							722,
							723,
							724,
							725,
							726,
							727,
							728,
							729,
							730,
							731,
							732,
							733
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962052",
						"GEN": "Plettenberg"
					}
				},
				{
					"arcs": [
						[
							734,
							735,
							736,
							737,
							738,
							739,
							740,
							741,
							742
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770044",
						"GEN": "Stemwede"
					}
				},
				{
					"arcs": [
						[
							743,
							744,
							745,
							746,
							747,
							748,
							749,
							750,
							751,
							752,
							753,
							754,
							755,
							-580,
							756,
							-578,
							757,
							-576,
							758,
							759
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162012",
						"GEN": "Jüchen"
					}
				},
				{
					"arcs": [
						[
							760,
							761,
							762,
							763,
							764,
							765,
							766,
							767,
							768,
							-748,
							769,
							770,
							-745,
							771,
							772,
							773
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162008",
						"GEN": "Grevenbroich"
					}
				},
				{
					"arcs": [
						[
							774,
							775,
							776,
							777,
							778,
							779,
							780,
							781,
							782,
							783,
							784
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334032",
						"GEN": "Stolberg (Rhld.)"
					}
				},
				{
					"arcs": [
						[
							785,
							786,
							787,
							788,
							789,
							790,
							791,
							792,
							793,
							794,
							795,
							796,
							797,
							798,
							799
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158028",
						"GEN": "Ratingen"
					}
				},
				{
					"arcs": [
						[
							800,
							801,
							802,
							803,
							804,
							805,
							-281,
							806,
							807,
							808,
							809,
							810
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558016",
						"GEN": "Dülmen"
					}
				},
				{
					"arcs": [
						[
							811,
							812,
							813,
							814,
							815,
							-789,
							816,
							817,
							818
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158012",
						"GEN": "Heiligenhaus"
					}
				},
				{
					"arcs": [
						[
							-603,
							819,
							820,
							821,
							822,
							823,
							824,
							825,
							826,
							827,
							828,
							829
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762024",
						"GEN": "Marienmünster"
					}
				},
				{
					"arcs": [
						[
							830,
							831,
							832,
							833,
							834,
							835,
							836,
							837,
							838,
							839,
							840,
							841,
							842,
							843,
							844,
							845
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962040",
						"GEN": "Menden (Sauerland)"
					}
				},
				{
					"arcs": [
						[
							846,
							-342,
							847,
							848,
							849,
							850,
							851,
							852,
							853,
							854,
							855,
							-412,
							856,
							-420,
							857,
							858,
							859,
							860,
							-344
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05122000",
						"GEN": "Solingen"
					}
				},
				{
					"arcs": [
						[
							861,
							862,
							863,
							864,
							865,
							866,
							867,
							868,
							869,
							870
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154048",
						"GEN": "Rheurdt"
					}
				},
				{
					"arcs": [
						[
							871,
							872,
							873,
							874,
							875,
							876,
							877,
							878,
							879,
							-258,
							880
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554024",
						"GEN": "Heek"
					}
				},
				{
					"arcs": [
						[
							881,
							882,
							883,
							884,
							885,
							886,
							887,
							888
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566060",
						"GEN": "Neuenkirchen"
					}
				},
				{
					"arcs": [
						[
							889,
							890,
							891,
							892,
							893,
							894,
							895,
							896
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766004",
						"GEN": "Augustdorf"
					}
				},
				{
					"arcs": [
						[
							897,
							898,
							899,
							900,
							901,
							902,
							903,
							904,
							905,
							906
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158004",
						"GEN": "Erkrath"
					}
				},
				{
					"arcs": [
						[
							907,
							908,
							909,
							-34,
							910,
							911,
							912,
							913,
							914,
							915,
							916,
							917,
							-729,
							918
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966004",
						"GEN": "Attendorn"
					}
				},
				{
					"arcs": [
						[
							919,
							920,
							921,
							-582,
							922,
							923,
							-754,
							924,
							925,
							926,
							927,
							928,
							929,
							930,
							931,
							932,
							933,
							934,
							935,
							936,
							937,
							938,
							939
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370004",
						"GEN": "Erkelenz"
					}
				},
				{
					"arcs": [
						[
							940,
							941,
							942,
							943,
							944,
							945,
							946
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370028",
						"GEN": "Übach-Palenberg"
					}
				},
				{
					"arcs": [
						[
							-290,
							947,
							948,
							949,
							950,
							951,
							952,
							953,
							954,
							955,
							956,
							957,
							958,
							-292,
							959
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562024",
						"GEN": "Marl"
					}
				},
				{
					"arcs": [
						[
							960,
							961,
							962,
							963,
							964,
							965,
							966,
							967,
							968,
							-81,
							969
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978016",
						"GEN": "Holzwickede"
					}
				},
				{
					"arcs": [
						[
							-407,
							970,
							971,
							972,
							973,
							974,
							975,
							976,
							977
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154024",
						"GEN": "Kalkar"
					}
				},
				{
					"arcs": [
						[
							978,
							979,
							980,
							981,
							982,
							983,
							984,
							985,
							986,
							987,
							988,
							989,
							990,
							991,
							992,
							993,
							994
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554012",
						"GEN": "Borken"
					}
				},
				{
					"arcs": [
						[
							995,
							996,
							997,
							998,
							-591,
							999,
							-595,
							1000,
							1001,
							1002,
							1003,
							1004,
							1005,
							1006
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970044",
						"GEN": "Wilnsdorf"
					}
				},
				{
					"arcs": [
						[
							-28,
							1007,
							1008,
							1009,
							1010,
							-489,
							1011,
							1012,
							1013,
							1014,
							1015,
							1016,
							1017,
							1018,
							1019,
							1020,
							1021,
							-30,
							1022
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966016",
						"GEN": "Kirchhundem"
					}
				},
				{
					"arcs": [
						[
							1023,
							1024,
							1025,
							-544,
							1026,
							1027,
							-855
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378016",
						"GEN": "Leichlingen (Rhld.)"
					}
				},
				{
					"arcs": [
						[
							-94,
							1028,
							1029,
							1030,
							1031,
							1032,
							1033,
							1034,
							1035,
							1036,
							1037,
							1038,
							1039,
							1040,
							1041,
							1042,
							1043,
							1044,
							1045,
							1046
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05911000",
						"GEN": "Bochum"
					}
				},
				{
					"arcs": [
						[
							1047,
							1048,
							1049,
							1050,
							1051,
							1052,
							-562,
							1053,
							-570,
							1054,
							1055,
							1056,
							1057,
							1058,
							1059
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374044",
						"GEN": "Waldbröl"
					}
				},
				{
					"arcs": [
						[
							1060,
							1061,
							1062,
							1063,
							1064,
							1065,
							1066,
							-1050,
							1067,
							1068,
							-1060,
							1069,
							1070,
							1071,
							1072,
							1073,
							1074,
							1075,
							1076,
							1077
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374040",
						"GEN": "Reichshof"
					}
				},
				{
					"arcs": [
						[
							-43,
							1078,
							1079,
							1080,
							1081,
							1082,
							1083,
							1084,
							1085,
							1086,
							1087,
							1088
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374024",
						"GEN": "Marienheide"
					}
				},
				{
					"arcs": [
						[
							1089,
							1090,
							1091,
							1092,
							1093,
							1094,
							1095,
							1096,
							-315,
							1097,
							-161,
							1098,
							1099,
							1100
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358052",
						"GEN": "Nörvenich"
					}
				},
				{
					"arcs": [
						[
							-497,
							1101,
							1102,
							1103,
							1104,
							1105,
							1106,
							1107,
							1108,
							1109,
							1110
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362012",
						"GEN": "Brühl"
					}
				},
				{
					"arcs": [
						[
							1111,
							1112,
							1113,
							1114,
							1115,
							1116,
							1117,
							1118,
							1119,
							1120
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382060",
						"GEN": "Siegburg"
					}
				},
				{
					"arcs": [
						[
							-254,
							1121,
							1122,
							1123,
							1124,
							1125,
							1126,
							1127,
							1128,
							-503,
							1129,
							1130,
							1131
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570044",
						"GEN": "Telgte"
					}
				},
				{
					"arcs": [
						[
							1132,
							1133,
							1134,
							1135,
							1136,
							1137,
							-262,
							1138,
							1139,
							1140,
							1141,
							1142,
							1143,
							-283,
							1144,
							-805,
							1145
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558024",
						"GEN": "Lüdinghausen"
					}
				},
				{
					"arcs": [
						[
							-1115,
							1146,
							-8,
							1147,
							1148,
							1149,
							1150,
							1151,
							1152,
							1153,
							1154
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382056",
						"GEN": "Sankt Augustin"
					}
				},
				{
					"arcs": [
						[
							1155,
							1156,
							-299,
							1157,
							1158,
							1159,
							1160,
							1161,
							1162,
							1163,
							1164,
							1165,
							1166
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554044",
						"GEN": "Reken"
					}
				},
				{
					"arcs": [
						[
							1167,
							1168,
							1169,
							1170,
							-1058,
							1171,
							1172,
							1173
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374032",
						"GEN": "Nümbrecht"
					}
				},
				{
					"arcs": [
						[
							1174,
							-32,
							1175,
							-1021,
							1176,
							1177,
							1178,
							1179,
							1180,
							1181,
							1182,
							-913,
							1183
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966024",
						"GEN": "Olpe"
					}
				},
				{
					"arcs": [
						[
							1184,
							-1178,
							1185,
							-649,
							1186,
							-600,
							1187,
							-1063,
							1188,
							1189,
							-1180
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966028",
						"GEN": "Wenden"
					}
				},
				{
					"arcs": [
						[
							1190,
							1191,
							1192,
							1193,
							1194,
							-1073,
							1195,
							1196,
							1197,
							1198,
							1199,
							1200,
							1201,
							1202,
							-1083,
							1203,
							1204,
							1205,
							1206
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374012",
						"GEN": "Gummersbach"
					}
				},
				{
					"arcs": [
						[
							-550,
							1207,
							1208,
							1209,
							1210,
							1211,
							1212,
							1213,
							1214,
							1215,
							1216,
							1217,
							1218,
							1219,
							1220,
							1221,
							1222,
							1223,
							1224
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958032",
						"GEN": "Meschede"
					}
				},
				{
					"arcs": [
						[
							1225,
							1226,
							-1052,
							1227,
							1228,
							-1065
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374028",
						"GEN": "Morsbach"
					}
				},
				{
					"arcs": [
						[
							1229,
							1230,
							1231,
							-731,
							1232,
							1233,
							1234,
							1235
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962020",
						"GEN": "Herscheid"
					}
				},
				{
					"arcs": [
						[
							1236,
							1237,
							1238,
							1239,
							-1076,
							1240,
							-1193
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374004",
						"GEN": "Bergneustadt"
					}
				},
				{
					"arcs": [
						[
							1241,
							-915,
							1242,
							-1182,
							1243,
							1244,
							-1061,
							1245,
							-1238,
							1246,
							-1192,
							1247,
							1248,
							1249
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966008",
						"GEN": "Drolshagen"
					}
				},
				{
					"arcs": [
						[
							-1013,
							1250,
							-487,
							1251,
							-485,
							1252,
							1253,
							1254,
							1255,
							1256,
							1257,
							1258,
							1259,
							1260,
							-640,
							1261,
							1262,
							1263
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970020",
						"GEN": "Hilchenbach"
					}
				},
				{
					"arcs": [
						[
							1264,
							1265,
							-1168,
							1266,
							1267,
							1268,
							1269,
							1270,
							1271,
							1272,
							1273,
							1274,
							1275,
							1276,
							1277,
							1278,
							1279
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382036",
						"GEN": "Much"
					}
				},
				{
					"arcs": [
						[
							1280,
							1281,
							-1085,
							1282,
							-1202,
							1283,
							1284,
							1285,
							1286,
							1287,
							1288,
							-701,
							1289,
							-699,
							1290,
							1291,
							1292,
							1293
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374020",
						"GEN": "Lindlar"
					}
				},
				{
					"arcs": [
						[
							-1276,
							1294,
							1295,
							-1273,
							1296,
							1297,
							1298,
							-1112,
							1299,
							1300,
							1301
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382040",
						"GEN": "Neunkirchen-Seelscheid"
					}
				},
				{
					"arcs": [
						[
							1302,
							-247,
							1303,
							1304,
							1305,
							1306,
							1307,
							1308,
							1309,
							-1094,
							1310,
							-1092
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358060",
						"GEN": "Vettweiß"
					}
				},
				{
					"arcs": [
						[
							1311,
							1312,
							1313,
							1314,
							1315,
							1316,
							1317,
							1318,
							1319,
							1320
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154064",
						"GEN": "Weeze"
					}
				},
				{
					"arcs": [
						[
							1321,
							1322,
							1323,
							1324,
							-1107,
							1325,
							-205,
							1326,
							-203,
							1327,
							-249,
							1328,
							-1090,
							1329,
							1330,
							1331
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362020",
						"GEN": "Erftstadt"
					}
				},
				{
					"arcs": [
						[
							1332,
							-1288,
							1333,
							1334,
							1335,
							1336,
							-1278,
							1337,
							1338,
							1339,
							1340,
							1341,
							1342,
							1343,
							-531
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378024",
						"GEN": "Overath"
					}
				},
				{
					"arcs": [
						[
							1344,
							-716,
							1345,
							-714,
							1346,
							-45,
							1347,
							-1088,
							1348,
							-1086,
							1349,
							-1281,
							1350,
							-1293,
							1351,
							-696,
							1352,
							1353,
							1354,
							1355,
							1356,
							1357
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374052",
						"GEN": "Wipperfürth"
					}
				},
				{
					"arcs": [
						[
							1358,
							1359,
							-859,
							1360,
							1361,
							1362,
							1363,
							-904,
							1364
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158016",
						"GEN": "Hilden"
					}
				},
				{
					"arcs": [
						[
							1365,
							1366,
							1367,
							1368,
							1369,
							1370,
							1371,
							1372,
							1373,
							1374,
							1375,
							1376,
							1377,
							1378
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170020",
						"GEN": "Kamp-Lintfort"
					}
				},
				{
					"arcs": [
						[
							1379,
							1380,
							1381,
							1382,
							1383,
							1384,
							-761,
							1385,
							1386,
							1387,
							1388,
							1389
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162024",
						"GEN": "Neuss"
					}
				},
				{
					"arcs": [
						[
							-768,
							1390,
							1391,
							1392,
							1393,
							1394,
							1395,
							1396,
							1397,
							1398,
							1399,
							1400,
							-750,
							1401
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362004",
						"GEN": "Bedburg"
					}
				},
				{
					"arcs": [
						[
							-679,
							1402,
							1403,
							1404,
							1405,
							1406
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370032",
						"GEN": "Waldfeucht"
					}
				},
				{
					"arcs": [
						[
							1407,
							1408,
							1409,
							1410,
							1411,
							1412,
							1413,
							1414,
							1415,
							1416,
							-686,
							1417,
							-684,
							1418,
							-682,
							1419,
							1420,
							1421,
							1422,
							1423,
							1424,
							1425
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358024",
						"GEN": "Jülich"
					}
				},
				{
					"arcs": [
						[
							1426,
							1427,
							-692,
							1428,
							1429,
							1430,
							1431,
							-657,
							1432,
							1433,
							1434
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334004",
						"GEN": "Alsdorf"
					}
				},
				{
					"arcs": [
						[
							1435,
							1436,
							-166,
							1437,
							1438,
							1439,
							-311,
							1440,
							1441,
							1442,
							-1414,
							1443,
							-1412,
							1444,
							1445,
							1446
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358048",
						"GEN": "Niederzier"
					}
				},
				{
					"arcs": [
						[
							-1173,
							1447,
							1448,
							1449,
							-568,
							1450,
							-560,
							1451,
							-1,
							1452,
							-1298,
							1453,
							-1271,
							1454,
							1455,
							-1268,
							1456
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382052",
						"GEN": "Ruppichteroth"
					}
				},
				{
					"arcs": [
						[
							1457,
							1458,
							1459,
							1460,
							1461,
							1462,
							1463,
							1464,
							1465,
							1466,
							1467,
							1468,
							1469,
							1470,
							1471,
							1472,
							1473,
							1474,
							1475
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754008",
						"GEN": "Gütersloh"
					}
				},
				{
					"arcs": [
						[
							1476,
							1477,
							1478,
							1479,
							1480,
							1481,
							1482,
							1483,
							1484,
							1485,
							1486,
							1487,
							1488,
							1489,
							1490,
							1491,
							1492,
							1493,
							1494,
							1495
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762004",
						"GEN": "Bad Driburg"
					}
				},
				{
					"arcs": [
						[
							1496,
							1497,
							1498,
							1499,
							1500,
							1501,
							-1006,
							1502,
							-1004,
							1503,
							1504,
							1505,
							-597,
							1506,
							1507,
							-647,
							1508,
							-645,
							1509
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970040",
						"GEN": "Siegen"
					}
				},
				{
					"arcs": [
						[
							1510,
							1511,
							1512,
							1513,
							1514,
							1515,
							1516,
							1517,
							-13
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362024",
						"GEN": "Frechen"
					}
				},
				{
					"arcs": [
						[
							1518,
							1519,
							1520,
							1521,
							1522,
							1523,
							1524,
							1525,
							1526,
							1527,
							1528
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766012",
						"GEN": "Barntrup"
					}
				},
				{
					"arcs": [
						[
							1529,
							1530,
							1531,
							1532,
							-136,
							1533,
							1534,
							1535,
							1536,
							1537,
							1538
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774024",
						"GEN": "Hövelhof"
					}
				},
				{
					"arcs": [
						[
							1539,
							1540,
							1541,
							1542,
							1543,
							1544,
							1545,
							1546,
							1547,
							1548,
							1549,
							1550,
							1551,
							1552,
							1553,
							1554,
							1555,
							1556,
							1557,
							1558
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954008",
						"GEN": "Ennepetal"
					}
				},
				{
					"arcs": [
						[
							1559,
							1560,
							1561,
							1562,
							-867,
							1563,
							1564,
							1565,
							1566,
							1567,
							1568
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154028",
						"GEN": "Kerken"
					}
				},
				{
					"arcs": [
						[
							1569,
							1570,
							1571,
							1572,
							1573,
							1574,
							1575,
							1576
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554008",
						"GEN": "Bocholt"
					}
				},
				{
					"arcs": [
						[
							-270,
							1577,
							1578,
							1579,
							1580,
							1581,
							-74,
							1582,
							-101,
							1583,
							-182,
							1584,
							1585,
							-272,
							1586
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978024",
						"GEN": "Lünen"
					}
				},
				{
					"arcs": [
						[
							1587,
							-934,
							1588,
							1589,
							-931,
							1590,
							1591,
							1592,
							1593,
							1594,
							-671,
							1595,
							1596
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370020",
						"GEN": "Hückelhoven"
					}
				},
				{
					"arcs": [
						[
							1597,
							1598,
							1599,
							1600,
							1601,
							1602
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554068",
						"GEN": "Vreden"
					}
				},
				{
					"arcs": [
						[
							1603,
							1604,
							1605,
							1606,
							-890,
							1607,
							1608,
							1609,
							1610,
							1611,
							1612,
							1613,
							1614,
							1615,
							1616,
							1617,
							1618
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766040",
						"GEN": "Lage"
					}
				},
				{
					"arcs": [
						[
							1619,
							1620,
							1621,
							1622,
							1623,
							1624,
							1625,
							1626,
							1627,
							1628,
							1629,
							1630,
							-952,
							1631
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562032",
						"GEN": "Recklinghausen"
					}
				},
				{
					"arcs": [
						[
							1632,
							1633,
							1634,
							1635,
							1636,
							1637,
							1638,
							1639,
							1640,
							1641,
							1642,
							1643,
							1644,
							1645
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570048",
						"GEN": "Wadersloh"
					}
				},
				{
					"arcs": [
						[
							-967,
							1646,
							1647,
							1648,
							1649,
							1650,
							1651,
							-87,
							1652,
							-85,
							1653,
							-83,
							1654,
							1655
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978028",
						"GEN": "Schwerte"
					}
				},
				{
					"arcs": [
						[
							-495,
							1656,
							1657,
							1658,
							1659,
							1660,
							1661,
							1662,
							-209,
							1663,
							-195,
							1664,
							-193,
							1665,
							1666,
							1667,
							-1103,
							1668
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382012",
						"GEN": "Bornheim"
					}
				},
				{
					"arcs": [
						[
							1669,
							1670,
							1671,
							1672,
							1673,
							-211,
							1674,
							-1662,
							1675
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382004",
						"GEN": "Alfter"
					}
				},
				{
					"arcs": [
						[
							1676,
							1677,
							-397,
							1678,
							1679,
							1680,
							1681,
							1682,
							-1366,
							1683,
							1684,
							1685,
							1686,
							1687
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170004",
						"GEN": "Alpen"
					}
				},
				{
					"arcs": [
						[
							1688,
							1689,
							1690,
							1691,
							-845,
							1692,
							-843,
							1693,
							-963,
							1694,
							1695,
							1696
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978012",
						"GEN": "Fröndenberg/Ruhr"
					}
				},
				{
					"arcs": [
						[
							1697,
							1698,
							-191,
							1699,
							-189,
							1700,
							1701,
							1702,
							1703,
							1704,
							1705,
							-285,
							1706
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562008",
						"GEN": "Datteln"
					}
				},
				{
					"arcs": [
						[
							-987,
							1707,
							1708,
							1709,
							1710,
							1711,
							1712,
							1713,
							1714,
							1715,
							-989,
							1716
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554040",
						"GEN": "Raesfeld"
					}
				},
				{
					"arcs": [
						[
							1717,
							1718,
							1719,
							-1526,
							1720,
							-1524,
							1721,
							1722,
							1723,
							1724,
							1725,
							1726,
							1727,
							1728,
							1729
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766024",
						"GEN": "Dörentrup"
					}
				},
				{
					"arcs": [
						[
							-1685,
							1730,
							-1378,
							1731,
							-1376,
							1732,
							1733,
							-869,
							1734,
							1735,
							1736,
							1737,
							1738
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154020",
						"GEN": "Issum"
					}
				},
				{
					"arcs": [
						[
							-367,
							1739,
							-365,
							1740,
							1741,
							1742,
							1743,
							1744,
							1745,
							1746,
							1747,
							1748,
							1749,
							1750,
							-369,
							1751
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758036",
						"GEN": "Vlotho"
					}
				},
				{
					"arcs": [
						[
							1752,
							1753,
							1754,
							1755,
							-1236,
							1756,
							1757,
							-38,
							1758,
							1759,
							1760,
							-708,
							1761,
							1762,
							1763,
							1764
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962032",
						"GEN": "Lüdenscheid"
					}
				},
				{
					"arcs": [
						[
							-471,
							1765,
							1766,
							1767,
							1768,
							1769,
							1770,
							1771,
							1772,
							1773,
							1774,
							1775,
							1776,
							1777
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974052",
						"GEN": "Werl"
					}
				},
				{
					"arcs": [
						[
							1778,
							1779,
							1780,
							1781,
							1782,
							1783,
							1784,
							1785,
							1786,
							1787,
							1788,
							-1485,
							1789,
							1790,
							1791,
							1792,
							1793,
							-823
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762016",
						"GEN": "Brakel"
					}
				},
				{
					"arcs": [
						[
							1794,
							-827,
							1795,
							-825,
							1796,
							-1793,
							1797,
							-1481,
							1798,
							-1479,
							1799,
							-1477,
							1800,
							1801
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762028",
						"GEN": "Nieheim"
					}
				},
				{
					"arcs": [
						[
							1802,
							1803,
							1804,
							1805,
							-1643,
							1806,
							1807,
							1808,
							1809,
							1810,
							1811,
							1812,
							1813,
							1814,
							1815
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570008",
						"GEN": "Beckum"
					}
				},
				{
					"arcs": [
						[
							1816,
							1817,
							1818,
							1819,
							1820,
							1821,
							1822,
							-899,
							1823,
							1824,
							1825,
							-792
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158024",
						"GEN": "Mettmann"
					}
				},
				{
					"arcs": [
						[
							1826,
							1827,
							1828,
							1829,
							1830,
							-476,
							1831,
							-491,
							1832,
							-1009,
							1833,
							1834,
							1835,
							1836,
							1837,
							1838,
							1839
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970004",
						"GEN": "Bad Berleburg"
					}
				},
				{
					"arcs": [
						[
							-1724,
							1840,
							1841,
							-1520,
							1842,
							1843,
							1844,
							1845,
							1846,
							1847,
							1848,
							1849,
							1850,
							1851,
							1852,
							1853,
							1854
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766016",
						"GEN": "Blomberg"
					}
				},
				{
					"arcs": [
						[
							1855,
							1856,
							1857,
							1858,
							1859,
							1860,
							1861,
							-733,
							1862,
							-1231,
							1863,
							1864,
							-1754,
							1865,
							1866
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962060",
						"GEN": "Werdohl"
					}
				},
				{
					"arcs": [
						[
							-90,
							1867,
							1868,
							1869,
							1870,
							1871,
							1872,
							1873,
							1874
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954020",
						"GEN": "Herdecke"
					}
				},
				{
					"arcs": [
						[
							1875,
							1876,
							1877,
							1878,
							1879,
							1880,
							1881,
							1882,
							1883,
							1884,
							1885,
							1886,
							1887,
							1888
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978008",
						"GEN": "Bönen"
					}
				},
				{
					"arcs": [
						[
							1889,
							1890,
							1891,
							1892,
							1893,
							1894,
							1895,
							1896,
							1897,
							1898,
							1899
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754048",
						"GEN": "Versmold"
					}
				},
				{
					"arcs": [
						[
							1900,
							1901,
							1902,
							1903,
							1904,
							1905,
							1906,
							1907,
							-355,
							1908,
							1909,
							1910,
							1911,
							1912,
							1913
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954028",
						"GEN": "Sprockhövel"
					}
				},
				{
					"arcs": [
						[
							1914,
							1915,
							1916,
							1917,
							-1335,
							1918,
							1919,
							-1285,
							1920,
							-1200
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374008",
						"GEN": "Engelskirchen"
					}
				},
				{
					"arcs": [
						[
							1921,
							1922,
							1923,
							1924,
							-720,
							1925,
							1926,
							1927,
							1928,
							1929,
							1930,
							1931,
							1932,
							1933,
							-1547,
							1934,
							1935,
							-1544,
							1936,
							1937,
							1938,
							1939
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954004",
						"GEN": "Breckerfeld"
					}
				},
				{
					"arcs": [
						[
							1940,
							-1705,
							1941,
							1942,
							-1621,
							1943,
							-949,
							1944,
							-288,
							1945
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562028",
						"GEN": "Oer-Erkenschwick"
					}
				},
				{
					"arcs": [
						[
							-1464,
							1946,
							1947,
							1948,
							1949,
							1950,
							1951,
							1952,
							1953,
							1954,
							1955,
							1956,
							1957
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754028",
						"GEN": "Rheda-Wiedenbrück"
					}
				},
				{
					"arcs": [
						[
							1958,
							1959,
							-1852,
							1960,
							1961,
							1962,
							1963,
							1964,
							1965,
							1966,
							-892,
							1967,
							-1606,
							1968,
							1969,
							1970
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766020",
						"GEN": "Detmold"
					}
				},
				{
					"arcs": [
						[
							-1404,
							1971,
							-677,
							1972,
							1973,
							1974,
							-668,
							1975,
							1976
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370008",
						"GEN": "Gangelt"
					}
				},
				{
					"arcs": [
						[
							1977,
							-837,
							1978,
							1979,
							1980,
							1981,
							1982,
							1983,
							1984,
							-840,
							1985
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962016",
						"GEN": "Hemer"
					}
				},
				{
					"arcs": [
						[
							1986,
							-1355,
							1987,
							1988,
							1989,
							1990,
							1991,
							1992,
							1993
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374016",
						"GEN": "Hückeswagen"
					}
				},
				{
					"arcs": [
						[
							1994,
							1995,
							1996,
							1997,
							1998,
							1999,
							2000,
							2001,
							2002,
							-223,
							2003,
							-221,
							2004,
							2005,
							2006
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758024",
						"GEN": "Löhne"
					}
				},
				{
					"arcs": [
						[
							2007,
							2008,
							2009,
							2010,
							2011,
							2012,
							-1890,
							2013,
							2014
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754004",
						"GEN": "Borgholzhausen"
					}
				},
				{
					"arcs": [
						[
							2015,
							2016,
							-417,
							2017,
							2018,
							2019,
							2020,
							2021
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158026",
						"GEN": "Monheim am Rhein"
					}
				},
				{
					"arcs": [
						[
							2022,
							-1442,
							2023,
							2024,
							-323,
							2025,
							2026,
							2027,
							2028,
							-1416
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358020",
						"GEN": "Inden"
					}
				},
				{
					"arcs": [
						[
							2029,
							2030,
							2031,
							2032,
							2033,
							2034,
							2035
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566068",
						"GEN": "Ochtrup"
					}
				},
				{
					"arcs": [
						[
							2036,
							2037,
							2038,
							2039,
							2040,
							2041,
							2042,
							2043,
							2044,
							-1892,
							2045,
							-2012,
							2046,
							-2010,
							2047
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754012",
						"GEN": "Halle (Westf.)"
					}
				},
				{
					"arcs": [
						[
							2048,
							2049,
							2050,
							2051,
							-303,
							2052,
							2053,
							2054,
							2055,
							2056,
							2057,
							2058
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958024",
						"GEN": "Marsberg"
					}
				},
				{
					"arcs": [
						[
							-1737,
							2059,
							-1561,
							2060,
							-1569,
							2061,
							-381,
							2062,
							2063,
							2064
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154012",
						"GEN": "Geldern"
					}
				},
				{
					"arcs": [
						[
							2065,
							2066,
							2067,
							2068,
							2069,
							2070,
							2071,
							-1981,
							2072,
							2073,
							-835,
							2074
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962008",
						"GEN": "Balve"
					}
				},
				{
					"arcs": [
						[
							-1141,
							2075,
							-278,
							2076,
							2077,
							-275,
							2078,
							-1698,
							2079,
							-1144,
							2080,
							2081
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558036",
						"GEN": "Olfen"
					}
				},
				{
					"arcs": [
						[
							-346,
							2082,
							-861,
							2083,
							-1359,
							2084,
							-902,
							2085,
							-1821,
							2086
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158008",
						"GEN": "Haan"
					}
				},
				{
					"arcs": [
						[
							2087,
							2088,
							2089,
							2090,
							2091,
							2092,
							2093,
							2094,
							2095,
							2096,
							2097,
							2098,
							2099,
							-469,
							2100
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974040",
						"GEN": "Soest"
					}
				},
				{
					"arcs": [
						[
							2101,
							2102,
							-796,
							2103,
							-794,
							2104,
							-1825,
							2105,
							-907,
							2106,
							2107,
							-1363,
							2108,
							2109,
							-2016,
							2110,
							-2021,
							2111,
							-1382,
							2112,
							-1380,
							2113,
							2114,
							2115,
							2116
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05111000",
						"GEN": "Düsseldorf"
					}
				},
				{
					"arcs": [
						[
							2117,
							2118,
							2119,
							2120,
							2121,
							2122,
							2123,
							2124,
							-1460,
							2125,
							2126,
							2127
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754044",
						"GEN": "Verl"
					}
				},
				{
					"arcs": [
						[
							2128,
							2129,
							-62,
							2130,
							2131,
							2132,
							2133,
							2134,
							2135,
							2136,
							2137,
							2138,
							2139
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974020",
						"GEN": "Geseke"
					}
				},
				{
					"arcs": [
						[
							2140,
							2141,
							-694,
							2142,
							-1427,
							2143,
							2144,
							2145,
							-944,
							2146,
							2147,
							2148,
							2149
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334008",
						"GEN": "Baesweiler"
					}
				},
				{
					"arcs": [
						[
							2150,
							2151,
							-1400,
							2152,
							2153,
							2154,
							2155,
							2156,
							-1446,
							2157,
							-1410,
							2158,
							-1408,
							2159,
							-1425,
							2160,
							2161,
							2162,
							-927
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358056",
						"GEN": "Titz"
					}
				},
				{
					"arcs": [
						[
							2163,
							2164,
							2165,
							-618,
							2166,
							2167,
							2168,
							2169,
							2170,
							2171,
							-379,
							2172
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166016",
						"GEN": "Nettetal"
					}
				},
				{
					"arcs": [
						[
							2173,
							-1610,
							2174,
							-1608,
							-897,
							2175,
							2176,
							2177,
							2178,
							2179,
							2180,
							2181
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766056",
						"GEN": "Oerlinghausen"
					}
				},
				{
					"arcs": [
						[
							-1898,
							2182,
							2183,
							2184,
							2185,
							2186
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570036",
						"GEN": "Sassenberg"
					}
				},
				{
					"arcs": [
						[
							-887,
							2187,
							2188,
							-2036,
							2189
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566096",
						"GEN": "Wettringen"
					}
				},
				{
					"arcs": [
						[
							-633,
							2190,
							2191,
							2192,
							2193,
							2194,
							2195
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166020",
						"GEN": "Niederkrüchten"
					}
				},
				{
					"arcs": [
						[
							2196,
							2197,
							2198,
							2199,
							2200,
							2201,
							-979,
							2202,
							2203,
							-993,
							2204,
							2205
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554060",
						"GEN": "Südlohn"
					}
				},
				{
					"arcs": [
						[
							2206,
							-1966,
							2207,
							2208,
							2209,
							2210,
							2211,
							2212,
							2213,
							-894
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766064",
						"GEN": "Schlangen"
					}
				},
				{
					"arcs": [
						[
							-1002,
							2214,
							-593,
							2215,
							2216
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970036",
						"GEN": "Neunkirchen"
					}
				},
				{
					"arcs": [
						[
							2217,
							2218,
							2219,
							2220,
							-36,
							2221,
							-909,
							2222,
							-726,
							2223,
							2224,
							2225
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05966012",
						"GEN": "Finnentrop"
					}
				},
				{
					"arcs": [
						[
							2226,
							-359,
							2227,
							2228,
							-373,
							2229,
							2230,
							2231,
							2232,
							2233
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770024",
						"GEN": "Minden"
					}
				},
				{
					"arcs": [
						[
							2234,
							2235,
							2236,
							2237,
							2238,
							2239,
							2240,
							2241,
							-738,
							2242,
							2243,
							2244,
							2245
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770008",
						"GEN": "Espelkamp"
					}
				},
				{
					"arcs": [
						[
							2246,
							2247,
							2248,
							2249,
							2250,
							2251,
							2252,
							2253,
							2254,
							2255
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166028",
						"GEN": "Tönisvorst"
					}
				},
				{
					"arcs": [
						[
							2256,
							2257,
							2258,
							2259,
							2260,
							-781
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334024",
						"GEN": "Roetgen"
					}
				},
				{
					"arcs": [
						[
							2263,
							2264,
							2265,
							-103,
							2266,
							2267,
							2268,
							2269,
							2270
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366004",
						"GEN": "Bad Münstereifel"
					}
				},
				{
					"arcs": [
						[
							-1159,
							2271,
							-297,
							2272,
							2273,
							-294,
							2274,
							-958,
							2275,
							2276,
							2277,
							2278,
							2279,
							2280,
							2281,
							2282,
							2283,
							2284,
							2285,
							2286,
							2287
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562012",
						"GEN": "Dorsten"
					}
				},
				{
					"arcs": [
						[
							2288,
							2289,
							2290,
							2291,
							2292,
							2293,
							2294,
							2295,
							-1370,
							2296,
							2297
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170024",
						"GEN": "Moers"
					}
				},
				{
					"arcs": [
						[
							2298,
							2299,
							2300,
							2301,
							-936,
							2302,
							-1597,
							2303,
							2304
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370036",
						"GEN": "Wassenberg"
					}
				},
				{
					"arcs": [
						[
							2305,
							2306,
							2307,
							2308,
							2309,
							2310,
							2311,
							2312,
							2313,
							2314,
							2315
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570012",
						"GEN": "Beelen"
					}
				},
				{
					"arcs": [
						[
							2316,
							2317,
							2318,
							2319,
							2320,
							2321,
							2322,
							2323
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382032",
						"GEN": "Meckenheim"
					}
				},
				{
					"arcs": [
						[
							2324,
							2325,
							2326,
							2327,
							2328,
							2329,
							2330,
							2331,
							2332,
							2333,
							2334,
							2335,
							2336,
							-1836,
							2337,
							-26,
							2338,
							-24,
							2339,
							-22,
							2340,
							2341,
							2342,
							-1211
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958040",
						"GEN": "Schmallenberg"
					}
				},
				{
					"arcs": [
						[
							-478,
							2343,
							-1830,
							2344,
							2345,
							2346,
							2347,
							2348,
							-480,
							2349
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970028",
						"GEN": "Bad Laasphe"
					}
				},
				{
					"arcs": [
						[
							2350,
							2351,
							2352,
							2353,
							2354,
							2355,
							2356,
							-1633,
							2357,
							-1950
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754024",
						"GEN": "Langenberg"
					}
				},
				{
					"arcs": [
						[
							-1894,
							2358,
							-2044,
							2359,
							-1473,
							2360,
							-1471,
							2361,
							2362,
							2363,
							2364,
							2365,
							-2306,
							-2184,
							2366,
							-1896,
							2367
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754016",
						"GEN": "Harsewinkel"
					}
				},
				{
					"arcs": [
						[
							2368,
							-1984,
							2369,
							2370,
							2371,
							2372,
							2373,
							-1866,
							-1753,
							2374,
							2375,
							2376,
							2377,
							2378,
							2379
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962004",
						"GEN": "Altena"
					}
				},
				{
					"arcs": [
						[
							2380,
							2381,
							2382,
							2383,
							2384,
							2385,
							2386,
							2387,
							2388,
							2389,
							2390,
							2391,
							2392
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758008",
						"GEN": "Enger"
					}
				},
				{
					"arcs": [
						[
							2393,
							2394,
							-227,
							2395,
							2396,
							2397,
							-2381,
							2398,
							2399,
							2400,
							2401,
							2402
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758004",
						"GEN": "Bünde"
					}
				},
				{
					"arcs": [
						[
							2403,
							2404,
							2405,
							2406,
							2407
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566072",
						"GEN": "Recke"
					}
				},
				{
					"arcs": [
						[
							2408,
							2409,
							-2231,
							2410,
							2411,
							2412,
							2413,
							-2237,
							2414
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770012",
						"GEN": "Hille"
					}
				},
				{
					"arcs": [
						[
							2415,
							2416,
							-2319,
							2417,
							2418
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382072",
						"GEN": "Wachtberg"
					}
				},
				{
					"arcs": [
						[
							2419,
							2420,
							2421,
							2422,
							2423,
							-505,
							2424,
							-1128,
							2425,
							-1126,
							2426,
							2427
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570024",
						"GEN": "Everswinkel"
					}
				},
				{
					"arcs": [
						[
							-1629,
							2428,
							2429,
							2430,
							2431,
							-954,
							2432,
							2433
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562020",
						"GEN": "Herten"
					}
				},
				{
					"arcs": [
						[
							-1576,
							2434,
							2435,
							2436,
							-170,
							2437,
							-168,
							2438
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554032",
						"GEN": "Isselburg"
					}
				},
				{
					"arcs": [
						[
							-2122,
							2439,
							2440,
							2441,
							2442,
							2443,
							2444,
							2445,
							-2353,
							2446,
							2447,
							-1948,
							2448,
							2449,
							2450
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754032",
						"GEN": "Rietberg"
					}
				},
				{
					"arcs": [
						[
							-972,
							2451,
							2452,
							2453,
							2454,
							2455,
							2456,
							2457,
							2458,
							2459
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154056",
						"GEN": "Uedem"
					}
				},
				{
					"arcs": [
						[
							-2407,
							2460,
							2461,
							2462,
							2463
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566020",
						"GEN": "Hopsten"
					}
				},
				{
					"arcs": [
						[
							2464,
							2465,
							-1046,
							2466,
							-1044,
							2467,
							2468,
							-1041,
							2469,
							2470,
							2471,
							-1628,
							2472,
							2473
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05916000",
						"GEN": "Herne"
					}
				},
				{
					"arcs": [
						[
							2474,
							2475,
							2476,
							2477,
							-1763,
							2478,
							-706,
							2479,
							2480,
							-1924,
							2481,
							2482
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962056",
						"GEN": "Schalksmühle"
					}
				},
				{
					"arcs": [
						[
							2483,
							-1528,
							2484,
							-1719,
							2485,
							2486,
							2487
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766028",
						"GEN": "Extertal"
					}
				},
				{
					"arcs": [
						[
							2488,
							-2402,
							2489
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758028",
						"GEN": "Rödinghausen"
					}
				},
				{
					"arcs": [
						[
							2490,
							2491,
							2492,
							2493,
							2494,
							2495,
							2496
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382044",
						"GEN": "Niederkassel"
					}
				},
				{
					"arcs": [
						[
							2497,
							2498,
							-1728,
							2499,
							-1726,
							2500,
							-1854,
							2501,
							-1959,
							2502,
							-1970,
							2503,
							-1604,
							2504,
							2505,
							2506,
							2507,
							2508,
							2509
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766044",
						"GEN": "Lemgo"
					}
				},
				{
					"arcs": [
						[
							-1776,
							2510,
							2511,
							2512,
							-1689,
							2513,
							-1696,
							2514,
							-961,
							2515,
							2516,
							-78,
							2517,
							2518,
							2519,
							-1882,
							2520,
							-1880,
							2521
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978036",
						"GEN": "Unna"
					}
				},
				{
					"arcs": [
						[
							2522,
							2523,
							-1886,
							2524,
							-1884,
							2525,
							-2519,
							2526,
							-76,
							2527,
							2528,
							2529,
							2530,
							2531,
							2532
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978020",
						"GEN": "Kamen"
					}
				},
				{
					"arcs": [
						[
							-975,
							2533,
							2534,
							2535,
							2536,
							2537,
							2538,
							2539,
							-624,
							2540
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154004",
						"GEN": "Bedburg-Hau"
					}
				},
				{
					"arcs": [
						[
							-2364,
							2541,
							2542,
							-1469,
							2543,
							2544,
							2545,
							-1956,
							2546,
							2547,
							2548,
							-2309,
							2549
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754020",
						"GEN": "Herzebrock-Clarholz"
					}
				},
				{
					"arcs": [
						[
							2550,
							2551,
							2552,
							2553,
							2554,
							2555,
							2556,
							2557,
							2558
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566036",
						"GEN": "Laer"
					}
				},
				{
					"arcs": [
						[
							-1259,
							2559,
							-1257,
							2560,
							-1255,
							2561,
							-482,
							2562,
							-2348,
							2563,
							-2346,
							2564,
							-998,
							2565,
							-996,
							2566,
							-1501,
							2567,
							-1499,
							2568,
							2569,
							-642,
							2570,
							2571
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05970032",
						"GEN": "Netphen"
					}
				},
				{
					"arcs": [
						[
							-1034,
							2572,
							2573,
							2574,
							-1912,
							2575,
							-1910,
							2576,
							2577,
							2578,
							2579,
							2580,
							2581,
							2582,
							2583
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954016",
						"GEN": "Hattingen"
					}
				},
				{
					"arcs": [
						[
							2584,
							2585,
							2586,
							2587,
							2588,
							2589,
							2590,
							-2102,
							2591,
							-2116,
							2592,
							2593,
							2594,
							2595,
							2596,
							-2292,
							2597,
							-2290,
							2598,
							2599,
							2600,
							2601
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05112000",
						"GEN": "Duisburg"
					}
				},
				{
					"arcs": [
						[
							2602,
							2603,
							-2378,
							2604,
							-2476,
							2605,
							2606,
							2607,
							2608,
							2609
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962044",
						"GEN": "Nachrodt-Wiblingwerde"
					}
				},
				{
					"arcs": [
						[
							-991,
							2610,
							2611,
							2612,
							2613,
							2614,
							-1570,
							2615
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554048",
						"GEN": "Rhede"
					}
				},
				{
					"arcs": [
						[
							-2234,
							2616,
							2617,
							-2409,
							2618
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770028",
						"GEN": "Petershagen"
					}
				},
				{
					"arcs": [
						[
							-225,
							2619,
							2620,
							2621,
							-2385,
							2622,
							-2383,
							2623,
							-2397,
							2624
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758016",
						"GEN": "Hiddenhausen"
					}
				},
				{
					"arcs": [
						[
							-2462,
							2625,
							2626,
							2627,
							2628,
							2629,
							2630,
							2631,
							2632,
							2633,
							2634,
							2635
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566016",
						"GEN": "Hörstel"
					}
				},
				{
					"arcs": [
						[
							-2548,
							2636,
							-1954,
							2637,
							-1952,
							2638,
							-1645,
							2639,
							-1805,
							2640,
							2641,
							2642,
							2643,
							2644,
							-2311,
							2645
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570028",
						"GEN": "Oelde"
					}
				},
				{
					"arcs": [
						[
							2646,
							2647,
							2648,
							2649,
							-2551,
							2650,
							2651,
							2652,
							2653,
							2654,
							2655
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566084",
						"GEN": "Steinfurt"
					}
				},
				{
					"arcs": [
						[
							-305,
							2656,
							2657,
							2658,
							2659,
							2660,
							2661,
							2662,
							2663,
							2664,
							-307,
							2665
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958036",
						"GEN": "Olsberg"
					}
				},
				{
					"arcs": [
						[
							2666,
							2667,
							2668,
							2669,
							2670,
							2671,
							2672,
							2673,
							2674,
							2675,
							-2049,
							2676,
							2677,
							2678,
							-429,
							2679,
							-427,
							2680,
							-122,
							2681,
							2682
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774028",
						"GEN": "Lichtenau"
					}
				},
				{
					"arcs": [
						[
							2683,
							2684,
							-1475,
							2685,
							-2042,
							2686,
							-2040,
							2687
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754040",
						"GEN": "Steinhagen"
					}
				},
				{
					"arcs": [
						[
							2688,
							2689,
							2690,
							2691,
							2692,
							2693,
							2694,
							2695,
							2696,
							2697,
							2698,
							2699,
							2700,
							2701,
							2702,
							2703,
							-1680,
							2704,
							2705,
							-394,
							2706,
							2707
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170048",
						"GEN": "Wesel"
					}
				},
				{
					"arcs": [
						[
							2708,
							2709,
							2710,
							-1109,
							2711,
							-1324,
							2712,
							2713,
							2714,
							-1514,
							2715,
							2716,
							2717
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362028",
						"GEN": "Hürth"
					}
				},
				{
					"arcs": [
						[
							2718,
							2719,
							2720,
							2721,
							-2165,
							2722,
							2723,
							2724,
							2725,
							2726,
							2727
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166008",
						"GEN": "Grefrath"
					}
				},
				{
					"arcs": [
						[
							2728,
							2729,
							2730,
							2731,
							2732,
							-2197,
							2733,
							-1600,
							2734,
							2735,
							2736
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554056",
						"GEN": "Stadtlohn"
					}
				},
				{
					"arcs": [
						[
							2737,
							2738,
							2739,
							2740,
							2741,
							-1558,
							2742,
							-1903,
							2743,
							2744
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954012",
						"GEN": "Gevelsberg"
					}
				},
				{
					"arcs": [
						[
							-841,
							-1985,
							-2369,
							2745,
							2746,
							-2603,
							2747,
							-2609,
							2748,
							2749,
							2750,
							-1650,
							2751,
							-1648,
							2752,
							-965,
							2753
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962024",
						"GEN": "Iserlohn"
					}
				},
				{
					"arcs": [
						[
							2754,
							2755,
							2756,
							2757,
							-146,
							2758,
							-144,
							2759,
							2760,
							2761,
							2762,
							2763,
							2764,
							2765,
							-2258,
							2766,
							2767,
							2768
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334028",
						"GEN": "Simmerath"
					}
				},
				{
					"arcs": [
						[
							-2652,
							2770,
							-2558,
							2771,
							2772,
							2773,
							2774,
							2775,
							-2654,
							2776
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566024",
						"GEN": "Horstmar"
					}
				},
				{
					"arcs": [
						[
							-2554,
							2777,
							2778,
							2779,
							2780,
							2781,
							2782,
							2783,
							2784,
							2785,
							2786,
							2787,
							2788
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558008",
						"GEN": "Billerbeck"
					}
				},
				{
					"arcs": [
						[
							2789,
							2790,
							-1038,
							2791,
							-1036,
							2792,
							-2583,
							2793,
							2794,
							2795,
							2796,
							2797,
							-818,
							2798,
							-787,
							2799,
							2800,
							2801,
							2802,
							2803,
							2804,
							2805,
							2806
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05113000",
						"GEN": "Essen"
					}
				},
				{
					"arcs": [
						[
							2807,
							2808,
							-1387,
							2809,
							-773,
							2810,
							-760,
							2811,
							-574,
							2812,
							2813,
							2814
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162020",
						"GEN": "Korschenbroich"
					}
				},
				{
					"arcs": [
						[
							2815,
							2816,
							2817,
							2818,
							2819,
							2820,
							2821,
							2822,
							2823,
							2824,
							2825,
							2826,
							2827
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558004",
						"GEN": "Ascheberg"
					}
				},
				{
					"arcs": [
						[
							2828,
							2829,
							-2530,
							2830,
							2831,
							2832,
							2833,
							2834,
							2835,
							2836,
							2837
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978004",
						"GEN": "Bergkamen"
					}
				},
				{
					"arcs": [
						[
							2838,
							2839,
							-1614,
							2840,
							-1612,
							2841,
							2842,
							2843,
							-2180,
							2844,
							2845,
							2846,
							2847,
							2848
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766048",
						"GEN": "Leopoldshöhe"
					}
				},
				{
					"arcs": [
						[
							-2487,
							2849,
							-1730,
							2850,
							-2498,
							2851,
							2852,
							-1742,
							2853,
							-363,
							2854,
							-361,
							2855
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766036",
						"GEN": "Kalletal"
					}
				},
				{
					"arcs": [
						[
							2856,
							2857,
							2858,
							2859,
							2860,
							2861,
							2862,
							2863,
							2864,
							-884,
							2865,
							2866,
							2867,
							2868,
							2869
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566008",
						"GEN": "Emsdetten"
					}
				},
				{
					"arcs": [
						[
							-410,
							2870,
							-452,
							2871
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366012",
						"GEN": "Dahlem"
					}
				},
				{
					"arcs": [
						[
							2872,
							2873,
							2874,
							-518,
							2875,
							2876,
							2877,
							2878,
							2879,
							2880,
							2881,
							-2781,
							2882,
							2883
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558020",
						"GEN": "Havixbeck"
					}
				},
				{
					"arcs": [
						[
							2884,
							2885,
							-1219,
							2886,
							2887,
							2888,
							-2225,
							2889,
							2890,
							2891,
							2892,
							-2069,
							2893,
							-2067,
							2894,
							2895
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958044",
						"GEN": "Sundern (Sauerland)"
					}
				},
				{
					"arcs": [
						[
							2896,
							-1213,
							2897,
							-2342,
							2898,
							-20,
							2899,
							-2220,
							2900,
							-2218,
							2901,
							-2888,
							2902,
							-1217,
							2903,
							-1215
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958016",
						"GEN": "Eslohe (Sauerland)"
					}
				},
				{
					"arcs": [
						[
							2904,
							2905,
							2906,
							-2269,
							2907,
							-2267,
							-115,
							2908,
							-113,
							2909,
							2910,
							2911,
							2912,
							2913,
							2914,
							2915,
							-140,
							2916,
							-242
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366028",
						"GEN": "Mechernich"
					}
				},
				{
					"arcs": [
						[
							2917,
							-1372,
							2918,
							-2295,
							2919,
							2920,
							2921,
							2922,
							2923,
							2924,
							2925,
							2926,
							2927
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170028",
						"GEN": "Neukirchen-Vluyn"
					}
				},
				{
					"arcs": [
						[
							-1163,
							2928,
							-1161,
							2929,
							-2287,
							2930,
							-985,
							2931,
							2932,
							2933,
							2934
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554028",
						"GEN": "Heiden"
					}
				},
				{
					"arcs": [
						[
							2935,
							2936,
							2937,
							2938,
							2939,
							2940,
							-1770,
							2941,
							-1768,
							2942,
							-2098,
							2943
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974012",
						"GEN": "Ense"
					}
				},
				{
					"arcs": [
						[
							2944,
							2945,
							-1389,
							2946,
							-2808,
							2947,
							2948,
							2949,
							2950,
							2951
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162016",
						"GEN": "Kaarst"
					}
				},
				{
					"arcs": [
						[
							-2923,
							2952,
							2953,
							2954,
							-2255,
							2955,
							-2253,
							2956,
							2957,
							2958,
							2959,
							2960,
							-865,
							2961
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166012",
						"GEN": "Kempen"
					}
				},
				{
					"arcs": [
						[
							-2825,
							2962,
							2963,
							2964,
							-266,
							2965,
							-264,
							2966,
							-1137,
							2967
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558028",
						"GEN": "Nordkirchen"
					}
				},
				{
					"arcs": [
						[
							2968,
							2969,
							2970,
							2971,
							2972,
							2973,
							2974,
							-1783,
							2975,
							2976,
							-1780,
							2977,
							-821,
							2978
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762020",
						"GEN": "Höxter"
					}
				},
				{
					"arcs": [
						[
							2979,
							2980,
							2981,
							2982,
							2983,
							2984,
							2985,
							2986,
							2987,
							2988,
							2989,
							2990,
							2991,
							-1787,
							2992,
							-1785,
							2993
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762012",
						"GEN": "Borgentreich"
					}
				},
				{
					"arcs": [
						[
							-462,
							2994,
							-460,
							2995,
							2996,
							2997,
							2998,
							2999,
							-1839,
							3000,
							-2335,
							3001,
							-2333,
							3002,
							-2331,
							3003,
							-2329,
							3004,
							3005,
							-2660,
							3006,
							-2658,
							3007
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958048",
						"GEN": "Winterberg"
					}
				},
				{
					"arcs": [
						[
							[
								-2762,
								3008,
								3009,
								3010,
								-454,
								3011,
								-2765,
								3012,
								3013
							]
						],
						[
							[
								3014
							]
						]
					],
					"type": "MultiPolygon",
					"properties": {
						"AGS": "05334020",
						"GEN": "Monschau"
					}
				},
				{
					"arcs": [
						[
							-1772,
							3015,
							-2940,
							3016,
							3017,
							3018,
							3019,
							3020,
							3021,
							3022,
							3023,
							-1691,
							3024,
							3025,
							3026
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974056",
						"GEN": "Wickede (Ruhr)"
					}
				},
				{
					"arcs": [
						[
							3027,
							-1651,
							3028,
							3029,
							3030,
							-2607,
							3031,
							-2483,
							3032,
							-1922,
							3033,
							-1939,
							3034,
							3035,
							-1542,
							3036,
							-1540,
							3037,
							-2741,
							3038,
							3039,
							3040,
							-1869,
							3041
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05914000",
						"GEN": "Hagen"
					}
				},
				{
					"arcs": [
						[
							-1574,
							3042,
							-1572,
							3043,
							3044,
							-2613,
							3045,
							3046,
							3047,
							3048,
							3049,
							-2689,
							3050,
							-172,
							3051,
							-2436,
							3052
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170012",
						"GEN": "Hamminkeln"
					}
				},
				{
					"arcs": [
						[
							-2662,
							3053,
							3054,
							-2326,
							3055,
							-1209,
							3056,
							3057
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958008",
						"GEN": "Bestwig"
					}
				},
				{
					"arcs": [
						[
							3058,
							-2239,
							3059,
							-2413,
							3060,
							3061,
							3062,
							3063
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770020",
						"GEN": "Lübbecke"
					}
				},
				{
					"arcs": [
						[
							3064,
							3065,
							-382,
							3066
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566048",
						"GEN": "Lotte"
					}
				},
				{
					"arcs": [
						[
							3067,
							-1309,
							3068,
							-1307,
							3069,
							3070,
							3071,
							3072,
							3073,
							-317,
							3074,
							-1096
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358028",
						"GEN": "Kreuzau"
					}
				},
				{
					"arcs": [
						[
							-2633,
							3075,
							-2631,
							-2869,
							3076,
							-2867,
							3077,
							-882,
							3078,
							3079,
							3080
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566076",
						"GEN": "Rheine"
					}
				},
				{
					"arcs": [
						[
							-2697,
							3081,
							3082,
							3083,
							3084,
							3085,
							3086,
							3087,
							3088,
							-2699,
							3089
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170044",
						"GEN": "Voerde (Niederrhein)"
					}
				},
				{
					"arcs": [
						[
							-2071,
							3090,
							-2892,
							3091,
							-723,
							3092,
							-1861,
							3093,
							-1859,
							3094,
							-1857,
							3095,
							-2372,
							3096,
							3097,
							3098
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962048",
						"GEN": "Neuenrade"
					}
				},
				{
					"arcs": [
						[
							-2031,
							3099,
							-2776,
							3100,
							3101,
							3102,
							3103,
							-2033,
							3104
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566052",
						"GEN": "Metelen"
					}
				},
				{
					"arcs": [
						[
							3105,
							3106,
							3107,
							-1814,
							3108,
							-1812,
							3109,
							3110,
							3111,
							3112,
							3113,
							3114,
							3115,
							3116,
							3117,
							3118,
							3119,
							3120,
							3121,
							3122,
							3123,
							3124,
							3125
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570004",
						"GEN": "Ahlen"
					}
				},
				{
					"arcs": [
						[
							3126,
							3127,
							3128,
							-351,
							3129,
							3130,
							-1817,
							3131,
							-814,
							3132
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158036",
						"GEN": "Wülfrath"
					}
				},
				{
					"arcs": [
						[
							3133,
							3134,
							3135,
							3136,
							3137,
							3138,
							-2038,
							3139,
							3140,
							-2008,
							3141
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754052",
						"GEN": "Werther (Westf.)"
					}
				},
				{
					"arcs": [
						[
							-2969,
							3142,
							-2982,
							3143,
							-2980,
							3144,
							3145,
							-2973,
							3146,
							-2971,
							3147
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762008",
						"GEN": "Beverungen"
					}
				},
				{
					"arcs": [
						[
							-507,
							3148,
							-2423,
							3149,
							3150,
							3151,
							3152,
							3153,
							3154,
							3155,
							-509,
							3156
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570040",
						"GEN": "Sendenhorst"
					}
				},
				{
					"arcs": [
						[
							-2235,
							3157,
							-2245,
							3158,
							-735,
							3159
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770040",
						"GEN": "Rahden"
					}
				},
				{
					"arcs": [
						[
							3160,
							-1516,
							3161,
							-2714,
							3162,
							-1322,
							3163,
							-1331,
							3164,
							-1100,
							3165,
							-159,
							3166,
							3167,
							3168,
							3169
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362032",
						"GEN": "Kerpen"
					}
				},
				{
					"arcs": [
						[
							-1397,
							3170,
							3171,
							3172,
							-3168,
							3173,
							-1436,
							3174,
							-2156,
							3175,
							3176,
							3177,
							3178
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362016",
						"GEN": "Elsdorf"
					}
				},
				{
					"arcs": [
						[
							3179,
							-321,
							3180,
							3181,
							3182,
							-777,
							3183,
							3184,
							3185
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358032",
						"GEN": "Langerwehe"
					}
				},
				{
					"arcs": [
						[
							-2785,
							3186,
							3187,
							-809,
							3188,
							3189,
							3190,
							3191,
							3192,
							3193,
							3194
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558012",
						"GEN": "Coesfeld"
					}
				},
				{
					"arcs": [
						[
							-2701,
							3195,
							3196,
							3197,
							-2600,
							3198,
							3199,
							3200,
							-1368,
							3201,
							-1682,
							3202,
							-2703,
							3203
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170032",
						"GEN": "Rheinberg"
					}
				},
				{
					"arcs": [
						[
							3204,
							3205,
							3206,
							3207,
							3208,
							-2585,
							3209,
							3210,
							-3087,
							3211,
							3212,
							3213
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170008",
						"GEN": "Dinslaken"
					}
				},
				{
					"arcs": [
						[
							3214,
							-231,
							-67,
							3215
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566044",
						"GEN": "Lienen"
					}
				},
				{
					"arcs": [
						[
							-955,
							3216,
							3217,
							-2430,
							3218,
							-2471,
							3219,
							-1039,
							3220,
							-2790,
							3221,
							-150,
							3222,
							3223,
							-2278,
							3224
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05513000",
						"GEN": "Gelsenkirchen"
					}
				},
				{
					"arcs": [
						[
							3225,
							3226,
							3227,
							3228,
							-546,
							3229,
							3230,
							3231,
							3232,
							3233,
							3234,
							3235,
							3236
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974004",
						"GEN": "Anröchte"
					}
				},
				{
					"arcs": [
						[
							-2556,
							3237,
							-2788,
							3238,
							3239,
							-3194,
							3240,
							3241,
							3242,
							3243,
							3244,
							-2773,
							3245
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558040",
						"GEN": "Rosendahl"
					}
				},
				{
					"arcs": [
						[
							3246,
							3247,
							3248,
							3249,
							3250,
							3251,
							3252,
							3253,
							3254,
							-3084,
							3255,
							-2694,
							3256,
							-2692,
							3257,
							3258
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170016",
						"GEN": "Hünxe"
					}
				},
				{
					"arcs": [
						[
							3259,
							3260,
							-537,
							3261,
							-535,
							3262,
							3263,
							3264,
							-2491,
							3265,
							-2496,
							3266,
							-492,
							3267,
							-499,
							3268,
							-2709,
							3269,
							-2717,
							3270,
							-1512,
							3271,
							-11,
							3272,
							3273,
							3274,
							3275,
							3276
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05315000",
						"GEN": "Köln"
					}
				},
				{
					"arcs": [
						[
							-2801,
							3277,
							-800,
							3278,
							3279,
							-2589,
							3280,
							3281,
							3282
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05117000",
						"GEN": "Mülheim an der Ruhr"
					}
				},
				{
					"arcs": [
						[
							-2861,
							3283,
							-2859,
							3284,
							3285,
							3286,
							3287,
							3288,
							3289,
							-235,
							3290,
							-256,
							-1131,
							3291,
							-501,
							3292,
							-524,
							3293,
							3294,
							3295,
							3296,
							3297,
							3298
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566012",
						"GEN": "Greven"
					}
				},
				{
					"arcs": [
						[
							-3116,
							3299,
							-3114,
							3300,
							3301,
							3302,
							-474,
							3303,
							3304,
							3305,
							-1878,
							3306,
							-1876,
							3307,
							3308,
							3309,
							3310,
							3311,
							3312,
							3313,
							3314,
							3315,
							-2819,
							3316,
							3317,
							3318,
							-3118,
							3319
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05915000",
						"GEN": "Hamm"
					}
				},
				{
					"arcs": [
						[
							-260,
							3320,
							3321,
							-878,
							3322,
							-2729,
							3323,
							-2736,
							3324,
							-1598,
							3325,
							3326
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554004",
						"GEN": "Ahaus"
					}
				},
				{
					"arcs": [
						[
							3327,
							-18,
							3328,
							-16,
							3329,
							3330,
							3331,
							-766,
							3332,
							3333
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162028",
						"GEN": "Rommerskirchen"
					}
				},
				{
					"arcs": [
						[
							3334,
							-1305,
							3335,
							-245,
							3336,
							-137,
							3337,
							-148,
							3338,
							-2757,
							3339,
							3340,
							3341,
							3342,
							3343,
							-3071
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358044",
						"GEN": "Nideggen"
					}
				},
				{
					"arcs": [
						[
							3344,
							-1702,
							3345,
							-187,
							3346,
							-185,
							-97,
							3347,
							3348,
							-2465,
							3349,
							3350,
							-1626,
							3351,
							-1624,
							3352
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05562004",
						"GEN": "Castrop-Rauxel"
					}
				},
				{
					"arcs": [
						[
							3353,
							3354,
							-2914,
							3355,
							3356,
							3357,
							-443,
							3358,
							-441,
							3359,
							-439,
							3360,
							-456,
							3361,
							-3010,
							3362,
							-2761,
							3363,
							-142
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366036",
						"GEN": "Schleiden"
					}
				},
				{
					"arcs": [
						[
							-1549,
							3364,
							-1933,
							3365,
							3366,
							3367,
							3368,
							-1928,
							3369,
							3370,
							-718,
							3371,
							3372,
							-1357,
							3373,
							3374,
							-1993,
							3375,
							3376,
							-331,
							3377,
							-1551,
							3378
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374036",
						"GEN": "Radevormwald"
					}
				},
				{
					"arcs": [
						[
							3379,
							-3315,
							3380,
							-3313,
							3381,
							3382,
							-2838,
							3383,
							-2836,
							3384,
							-2834,
							3385,
							3386,
							3387,
							3388,
							-2964,
							3389,
							-2823,
							3390,
							-2821
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05978040",
						"GEN": "Werne"
					}
				},
				{
					"arcs": [
						[
							-2094,
							3391,
							3392,
							3393,
							-552,
							3394,
							3395,
							3396,
							3397,
							3398,
							-2936,
							-2096,
							3399
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974032",
						"GEN": "Möhnesee"
					}
				},
				{
					"arcs": [
						[
							-2389,
							3400,
							3401,
							3402,
							-2847,
							3403,
							3404,
							-2178,
							3405,
							-2118,
							3406,
							-2127,
							3407,
							-1458,
							3408,
							-2684,
							3409,
							-3138,
							3410,
							-3136,
							3411,
							3412,
							3413
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05711000",
						"GEN": "Bielefeld"
					}
				},
				{
					"arcs": [
						[
							-431,
							3414,
							-2678,
							3415,
							-2058,
							3416,
							-2056,
							3417,
							-2054,
							3418,
							-301,
							3419,
							-57,
							3420
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774040",
						"GEN": "Bad Wünnenberg"
					}
				},
				{
					"arcs": [
						[
							3421,
							-111,
							3422,
							-449,
							3423,
							-447,
							3424,
							-445,
							3425,
							-3357,
							3426,
							3427,
							-2911
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366024",
						"GEN": "Kall"
					}
				},
				{
					"arcs": [
						[
							3428,
							3429,
							3430,
							3431,
							3432,
							-3242,
							3433,
							-3323,
							-877,
							3434
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554036",
						"GEN": "Legden"
					}
				},
				{
					"arcs": [
						[
							3435,
							3436,
							-1995,
							3437,
							-2006,
							3438,
							-219,
							3439,
							3440,
							-2394,
							3441,
							3442,
							3443,
							-3062,
							3444
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770016",
						"GEN": "Hüllhorst"
					}
				},
				{
					"arcs": [
						[
							3445,
							3446,
							3447,
							3448,
							3449,
							-3226,
							3450,
							-3236,
							3451,
							-3234,
							3452,
							3453,
							3454,
							3455,
							3456,
							3457,
							3458
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974016",
						"GEN": "Erwitte"
					}
				},
				{
					"arcs": [
						[
							3459,
							3460,
							-1530,
							3461,
							-1538,
							3462,
							-2120,
							3463
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05754036",
						"GEN": "Schloß Holte-Stukenbrock"
					}
				},
				{
					"arcs": [
						[
							-1071,
							3464,
							-1170,
							3465,
							-1265,
							3466,
							3467,
							-1916,
							3468,
							-1198,
							3469,
							3470
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05374048",
						"GEN": "Wiehl"
					}
				},
				{
					"arcs": [
						[
							-1151,
							3471,
							3472,
							3473,
							-2416,
							3474,
							3475,
							-2317,
							3476,
							-1671,
							3477,
							-1659,
							3478,
							3479
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05314000",
						"GEN": "Bonn"
					}
				},
				{
					"arcs": [
						[
							-2456,
							3480,
							3481,
							3482,
							-2064,
							3483,
							-1318,
							3484,
							-1316,
							3485,
							-1314,
							3486,
							-1312,
							3487
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154032",
						"GEN": "Kevelaer"
					}
				},
				{
					"arcs": [
						[
							3488,
							-585,
							3489,
							3490,
							-921,
							3491,
							3492,
							-939,
							3493,
							3494,
							-2301,
							3495,
							-2299,
							3496,
							3497,
							-2192,
							3498
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370040",
						"GEN": "Wegberg"
					}
				},
				{
					"arcs": [
						[
							3499,
							-402,
							3500,
							-1686,
							-1739,
							3501,
							-3482,
							3502,
							-2454,
							3503,
							3504
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170040",
						"GEN": "Sonsbeck"
					}
				},
				{
					"arcs": [
						[
							3505,
							-3276,
							3506,
							-3274,
							3507,
							-3328,
							3508,
							-763,
							3509,
							-1384,
							3510
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162004",
						"GEN": "Dormagen"
					}
				},
				{
					"arcs": [
						[
							3511,
							3512,
							3513,
							3514,
							-2949,
							3515,
							-2814,
							3516,
							-572,
							3517,
							3518,
							3519
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166036",
						"GEN": "Willich"
					}
				},
				{
					"arcs": [
						[
							3520,
							3521,
							-3456,
							3522,
							-3454,
							3523,
							-3232,
							3524,
							-3393,
							3525,
							-2092,
							3526,
							-2090,
							3527,
							3528,
							3529,
							3530
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974008",
						"GEN": "Bad Sassendorf"
					}
				},
				{
					"arcs": [
						[
							3531,
							3532,
							-2578,
							3533,
							-353,
							3534,
							-3129,
							3535,
							-3127,
							3536,
							-812,
							3537,
							-2797,
							3538,
							-2795,
							3539,
							-2581
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05158032",
						"GEN": "Velbert"
					}
				},
				{
					"arcs": [
						[
							3540,
							3541,
							-2596,
							3542,
							-2594,
							3543,
							3544,
							3545,
							3546,
							3547,
							-3512,
							3548,
							-2247,
							3549,
							-2954,
							3550,
							-2921
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05114000",
						"GEN": "Krefeld"
					}
				},
				{
					"arcs": [
						[
							3551,
							-2945,
							3552,
							-2951,
							3553,
							-3514,
							3554,
							-3547,
							3555,
							3556,
							3557
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05162022",
						"GEN": "Meerbusch"
					}
				},
				{
					"arcs": [
						[
							-1343,
							3558,
							-1341,
							3559,
							3560,
							3561,
							3562,
							3563,
							-3264,
							3564,
							-533,
							3565
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378028",
						"GEN": "Rösrath"
					}
				},
				{
					"arcs": [
						[
							-516,
							3566,
							-2827,
							3567,
							-1135,
							3568,
							-1133,
							3569,
							3570,
							3571,
							3572,
							3573,
							-2877,
							3574
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558044",
						"GEN": "Senden"
					}
				},
				{
					"arcs": [
						[
							-665,
							3575,
							3576,
							3577,
							3578,
							-783,
							3579,
							-2260,
							3580
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334002",
						"GEN": "Aachen"
					}
				},
				{
					"arcs": [
						[
							3581,
							3582,
							-1802,
							3583,
							-1495,
							3584,
							3585,
							3586,
							3587,
							3588
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762032",
						"GEN": "Steinheim"
					}
				},
				{
					"arcs": [
						[
							-1848,
							3589,
							3590,
							3591,
							-3586,
							3592,
							3593,
							3594,
							3595,
							3596,
							3597,
							-2210,
							3598,
							3599,
							-1964,
							3600,
							-1962,
							3601,
							-1850,
							3602
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766032",
						"GEN": "Horn-Bad Meinberg"
					}
				},
				{
					"arcs": [
						[
							-929,
							3603,
							-2162,
							3604,
							-1423,
							3605,
							-1421,
							3606,
							3607,
							-2141,
							3608,
							3609,
							3610,
							3611,
							-1592,
							3612
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358036",
						"GEN": "Linnich"
					}
				},
				{
					"arcs": [
						[
							3613,
							3614,
							-1989,
							3615,
							3616,
							3617,
							3618,
							3619,
							3620,
							3621,
							3622,
							3623,
							-852,
							3624,
							3625,
							3626
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378032",
						"GEN": "Wermelskirchen"
					}
				},
				{
					"arcs": [
						[
							-1234,
							3627,
							-917,
							3628,
							3629,
							-1249,
							3630,
							3631,
							3632,
							-1205,
							3633,
							-1081,
							3634,
							-40,
							3635,
							3636
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05962036",
						"GEN": "Meinerzhagen"
					}
				},
				{
					"arcs": [
						[
							3637,
							-2169,
							3638,
							-635,
							3639,
							3640,
							3641,
							3642
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05166004",
						"GEN": "Brüggen"
					}
				},
				{
					"arcs": [
						[
							-2002,
							3643,
							-1747,
							3644,
							3645,
							3646,
							-3402,
							3647,
							-2387,
							3648,
							-2621,
							3649
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758012",
						"GEN": "Herford"
					}
				},
				{
					"arcs": [
						[
							-177,
							3650
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154008",
						"GEN": "Emmerich am Rhein"
					}
				},
				{
					"arcs": [
						[
							-389,
							3651,
							-387,
							3652,
							3653,
							3654,
							3655,
							-2404,
							3656,
							-391,
							3657
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566056",
						"GEN": "Mettingen"
					}
				},
				{
					"arcs": [
						[
							3658,
							3659,
							3660,
							3661,
							-2644,
							3662,
							3663,
							-1816,
							3664,
							-3107,
							3665,
							3666,
							-3125,
							3667,
							3668,
							3669,
							3670,
							3671,
							3672,
							3673
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570020",
						"GEN": "Ennigerloh"
					}
				},
				{
					"arcs": [
						[
							-688,
							3674,
							-2028,
							3675,
							-3185,
							3676,
							-775,
							3677,
							3678,
							3679,
							3680,
							3681,
							3682,
							-690,
							3683
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334012",
						"GEN": "Eschweiler"
					}
				},
				{
					"arcs": [
						[
							-2323,
							3684,
							-2321,
							3685,
							3686,
							3687,
							3688,
							3689,
							3690,
							3691,
							-214,
							3692,
							-1673
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382048",
						"GEN": "Rheinbach"
					}
				},
				{
					"arcs": [
						[
							-1535,
							3693,
							-134,
							3694,
							3695,
							3696,
							3697,
							3698,
							3699,
							3700,
							3701,
							-2441,
							3702,
							3703
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774020",
						"GEN": "Delbrück"
					}
				},
				{
					"arcs": [
						[
							-2212,
							3704,
							3705,
							3706,
							3707,
							-117,
							3708,
							-1532,
							3709,
							3710
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774008",
						"GEN": "Bad Lippspringe"
					}
				},
				{
					"arcs": [
						[
							3711,
							3712,
							3713,
							3714,
							3715,
							-1165,
							3716,
							3717,
							-2933,
							3718,
							-983,
							3719,
							-981,
							3720,
							-2201,
							3721
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554064",
						"GEN": "Velen"
					}
				},
				{
					"arcs": [
						[
							-3331,
							3722,
							-14,
							-1518,
							3723,
							-3170,
							3724,
							-3172,
							3725,
							-1395,
							3726,
							-1393,
							3727
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05362008",
						"GEN": "Bergheim"
					}
				},
				{
					"arcs": [
						[
							-1594,
							3728,
							-3611,
							3729,
							-2148,
							3730,
							-942,
							3731,
							-947,
							-1974,
							3732,
							-675,
							3733,
							-673,
							3734
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05370012",
						"GEN": "Geilenkirchen"
					}
				},
				{
					"arcs": [
						[
							-2133,
							3735,
							3736,
							-60,
							3737,
							3738,
							-2663,
							-3058,
							3739,
							-548,
							3740,
							-3228,
							3741,
							-3449,
							3742
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974036",
						"GEN": "Rüthen"
					}
				},
				{
					"arcs": [
						[
							3743,
							-1810,
							3744,
							-1808,
							3745,
							3746,
							-1640,
							3747,
							3748,
							3749,
							3750,
							3751,
							-3529,
							3752,
							-2088,
							3753,
							-467,
							3754,
							-465,
							3755,
							3756,
							3757
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974024",
						"GEN": "Lippetal"
					}
				},
				{
					"arcs": [
						[
							-2881,
							3758,
							-2879,
							3759,
							-3573,
							3760,
							-801,
							3761,
							-810,
							-3188,
							3762,
							-2783,
							3763
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05558032",
						"GEN": "Nottuln"
					}
				},
				{
					"arcs": [
						[
							-335,
							3764,
							-333,
							3765,
							3766,
							-1991,
							3767,
							-3614,
							3768,
							-3626,
							3769,
							3770,
							-849,
							3771,
							-340,
							3772,
							-338,
							3773,
							3774
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05120000",
						"GEN": "Remscheid"
					}
				},
				{
					"arcs": [
						[
							3775,
							-5,
							3776,
							-422,
							3777,
							-424,
							3778,
							-3473,
							3779,
							-1149,
							3780
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382024",
						"GEN": "Königswinter"
					}
				},
				{
					"arcs": [
						[
							3781,
							3782,
							3783,
							-3289,
							3784,
							3785,
							-3286,
							3786,
							-2857,
							3787,
							3788
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566080",
						"GEN": "Saerbeck"
					}
				},
				{
					"arcs": [
						[
							-628,
							3789,
							3790
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154040",
						"GEN": "Kranenburg"
					}
				},
				{
					"arcs": [
						[
							-740,
							3791,
							-2241,
							-3064,
							3792,
							-3443,
							3793,
							-742,
							3794
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770036",
						"GEN": "Preußisch Oldendorf"
					}
				},
				{
					"arcs": [
						[
							-1712,
							3795,
							-1710,
							3796,
							-2284,
							3797,
							3798,
							3799,
							-3249,
							3800,
							-3247,
							3801,
							3802,
							3803
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05170036",
						"GEN": "Schermbeck"
					}
				},
				{
					"arcs": [
						[
							-1566,
							3804,
							-2959,
							3805,
							3806,
							-2725,
							3807,
							-377,
							3808
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154060",
						"GEN": "Wachtendonk"
					}
				},
				{
					"arcs": [
						[
							-3102,
							3809,
							-2774,
							3810,
							-3244,
							3811,
							3812,
							-3431,
							3813,
							-3429,
							3814,
							3815,
							-874,
							3816
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554052",
						"GEN": "Schöppingen"
					}
				},
				{
					"arcs": [
						[
							-2537,
							3817,
							3818,
							3819,
							-2458,
							3820,
							-1320,
							3821,
							3822,
							-626,
							3823,
							-2539,
							3824
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05154016",
						"GEN": "Goch"
					}
				},
				{
					"arcs": [
						[
							-1339,
							3825,
							-1301,
							-1120,
							3826,
							3827,
							3828,
							-3562,
							3829,
							3830
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382028",
						"GEN": "Lohmar"
					}
				},
				{
					"arcs": [
						[
							-458,
							3831,
							-1828,
							3832,
							3833,
							-2999,
							3834,
							-2997,
							3835
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958020",
						"GEN": "Hallenberg"
					}
				},
				{
					"arcs": [
						[
							3836,
							3837,
							3838,
							3839,
							-1117,
							3840,
							-1153,
							3841,
							-2492,
							3842
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05382068",
						"GEN": "Troisdorf"
					}
				},
				{
					"arcs": [
						[
							-3695,
							3843,
							-132,
							3844,
							-130,
							3845,
							3846,
							-435,
							3847,
							-433,
							3848,
							-55,
							3849,
							-64,
							3850,
							-2129,
							3851,
							3852,
							3853,
							3854,
							3855,
							3856,
							-3697,
							3857
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774036",
						"GEN": "Salzkotten"
					}
				},
				{
					"arcs": [
						[
							-1844,
							3858,
							3859,
							-607,
							3860,
							-605,
							3861,
							-829,
							3862,
							-3582,
							3863,
							-3588,
							3864,
							-3591,
							3865,
							-1846,
							3866
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766060",
						"GEN": "Schieder-Schwalenberg"
					}
				},
				{
					"arcs": [
						[
							-2405,
							-3656,
							3867,
							-3654,
							3868,
							-385,
							3869,
							3870,
							-3783,
							3871,
							-2627,
							3872
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566028",
						"GEN": "Ibbenbüren"
					}
				},
				{
					"arcs": [
						[
							3873,
							3874,
							-2508,
							3875,
							-2506,
							3876,
							-1618,
							3877,
							-1616,
							3878,
							-2839,
							3879,
							3880,
							-3646,
							3881,
							-1745
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05766008",
						"GEN": "Bad Salzuflen"
					}
				},
				{
					"arcs": [
						[
							3882,
							3883,
							-3154,
							3884,
							3885,
							-3120,
							3886,
							-3318,
							3887,
							3888,
							-2816,
							3889,
							-514,
							3890,
							-512,
							3891
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570016",
						"GEN": "Drensteinfurt"
					}
				},
				{
					"arcs": [
						[
							-3065,
							3892,
							-65,
							3893,
							-72,
							3894,
							3895,
							-3870,
							-384
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566088",
						"GEN": "Tecklenburg"
					}
				},
				{
					"arcs": [
						[
							-3596,
							3896,
							-3594,
							3897,
							-1493,
							3898,
							-1491,
							-2683,
							3899,
							-120,
							3900,
							3901,
							-3707,
							3902
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05774004",
						"GEN": "Altenbeken"
					}
				},
				{
					"arcs": [
						[
							-2186,
							3903,
							-2315,
							3904,
							-3659,
							3905,
							3906,
							-3672,
							3907,
							-3670,
							3908,
							-2421,
							3909,
							3910,
							-1123,
							3911,
							-252,
							3912
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05570052",
						"GEN": "Warendorf"
					}
				},
				{
					"arcs": [
						[
							-3619,
							3913,
							-703,
							-528,
							3914,
							-526,
							3915,
							3916,
							3917,
							3918
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05378020",
						"GEN": "Odenthal"
					}
				},
				{
					"arcs": [
						[
							3919,
							-201,
							3920,
							-199,
							3921,
							-216,
							3922,
							-3692,
							3923,
							-3690,
							3924,
							-3688,
							3925,
							-2264,
							3926,
							-2270,
							3927,
							-2906,
							3928,
							-240,
							3929
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05366016",
						"GEN": "Euskirchen"
					}
				},
				{
					"arcs": [
						[
							-659,
							3930,
							-1431,
							3931,
							-3681,
							3932,
							-3577,
							3933,
							3934,
							-662,
							3935,
							3936
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05334036",
						"GEN": "Würselen"
					}
				},
				{
					"arcs": [
						[
							3937,
							-2803,
							3938,
							-3282,
							3939,
							-2587,
							3940,
							-3208,
							3941,
							-3206,
							3942,
							3943
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05119000",
						"GEN": "Oberhausen"
					}
				},
				{
					"arcs": [
						[
							-1487,
							3944,
							-1788,
							-2992,
							3945,
							-2990,
							3946,
							-2988,
							3947,
							-2986,
							3948,
							3949,
							3950,
							-2670,
							3951,
							-2668,
							-1489,
							3952
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762040",
						"GEN": "Willebadessen"
					}
				},
				{
					"arcs": [
						[
							-3950,
							3953,
							-2984,
							3954,
							-2051,
							3955,
							-2675,
							3956,
							3957,
							-2672,
							3958
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05762036",
						"GEN": "Warburg"
					}
				},
				{
					"arcs": [
						[
							-2938,
							3959,
							-3398,
							3960,
							-3396,
							3961,
							-1224,
							3962,
							-1222,
							3963,
							-2896,
							3964,
							3965,
							-833,
							3966,
							-3021,
							3967,
							3968,
							-3018,
							3969
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05958004",
						"GEN": "Arnsberg"
					}
				},
				{
					"arcs": [
						[
							-2400,
							3970,
							-2392,
							3971,
							3972,
							3973,
							3974,
							-3134,
							3975
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05758032",
						"GEN": "Spenge"
					}
				},
				{
					"arcs": [
						[
							3976,
							-1556,
							3977,
							-1554,
							3978,
							-328,
							3979,
							-326,
							3980,
							-1905
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954024",
						"GEN": "Schwelm"
					}
				},
				{
					"arcs": [
						[
							-92,
							3981,
							-1874,
							3982,
							3983,
							3984,
							-1901,
							3985,
							3986,
							-2574,
							-1032,
							3987,
							-1030,
							3988
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954036",
						"GEN": "Witten"
					}
				},
				{
					"arcs": [
						[
							3989,
							3990,
							-1871,
							3991,
							-3040,
							3992,
							-2739,
							3993,
							3994,
							-2744,
							-1902,
							-3985,
							3995
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05954032",
						"GEN": "Wetter (Ruhr)"
					}
				},
				{
					"arcs": [
						[
							-543,
							3996,
							-541,
							3997,
							-3917,
							3998,
							-3260,
							3999,
							4000,
							-415,
							4001,
							4002,
							4003
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05316000",
						"GEN": "Leverkusen"
					}
				},
				{
					"arcs": [
						[
							-3192,
							4004,
							4005,
							-3714,
							4006,
							-3712,
							4007,
							4008,
							-2731,
							4009
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05554016",
						"GEN": "Gescher"
					}
				},
				{
					"arcs": [
						[
							-2863,
							4010,
							-3298,
							4011,
							4012,
							4013,
							4014,
							4015,
							4016,
							4017,
							4018,
							4019
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566064",
						"GEN": "Nordwalde"
					}
				},
				{
					"arcs": [
						[
							4020,
							-3699,
							4021,
							-3856,
							4022,
							-3854,
							4023,
							-2138,
							4024,
							4025,
							4026,
							4027,
							-3446,
							4028,
							-3458,
							4029,
							-3521,
							4030,
							-3750,
							4031,
							4032,
							4033,
							-1637,
							4034,
							-1635,
							4035,
							-2356,
							4036
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05974028",
						"GEN": "Lippstadt"
					}
				},
				{
					"arcs": [
						[
							-2281,
							4037,
							-155,
							4038,
							-153,
							4039,
							-2805,
							4040,
							-3944,
							4041,
							4042,
							4043,
							4044,
							4045
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05512000",
						"GEN": "Bottrop"
					}
				},
				{
					"arcs": [
						[
							4046,
							4047,
							-4014,
							4048,
							-3295,
							4049,
							4050,
							-521,
							4051,
							-2873,
							4052,
							4053,
							-2779,
							4054,
							-2552,
							4055,
							-4017
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05566004",
						"GEN": "Altenberge"
					}
				},
				{
					"arcs": [
						[
							-319,
							4056,
							-3073,
							4057,
							-3343,
							4058,
							4059,
							4060,
							-2755,
							4061,
							-2768,
							4062,
							-779,
							4063,
							-3182,
							4064
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05358016",
						"GEN": "Hürtgenwald"
					}
				},
				{
					"arcs": [
						[
							4065,
							-371,
							4066,
							-1750,
							4067,
							4068,
							-1998,
							4069,
							4070,
							-3436,
							4071
						]
					],
					"type": "Polygon",
					"properties": {
						"AGS": "05770004",
						"GEN": "Bad Oeynhausen"
					}
				}
			]
		}
	},
	"crs": {
		"type": "name",
		"properties": {
			"name": "urn:ogc:def:crs:OGC:1.3:CRS84"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/data/nrw.topo.json
// module id = 39
// module chunks = 0